import './style.css';
import { jsx as h, jsxs as I, Fragment as os } from "react/jsx-runtime";
import * as Qt from "react";
import W, { forwardRef as Ur, useImperativeHandle as ss, useState as ye, useContext as $e, Children as Lc, useEffect as ne, useRef as se, useMemo as Pe, useLayoutEffect as Yn, useReducer as Ai, useCallback as Tr, Fragment as Et, isValidElement as $c, cloneElement as Ic, createElement as kc, createContext as Ye, createRef as ta } from "react";
import { createPortal as ol } from "react-dom";
var or = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, $o = { exports: {} };
(function(t, e) {
  var r = 200, n = "__lodash_hash_undefined__", i = 9007199254740991, o = "[object Arguments]", s = "[object Array]", a = "[object Boolean]", u = "[object Date]", c = "[object Error]", d = "[object Function]", f = "[object GeneratorFunction]", v = "[object Map]", g = "[object Number]", y = "[object Object]", E = "[object Promise]", S = "[object RegExp]", _ = "[object Set]", O = "[object String]", T = "[object Symbol]", P = "[object WeakMap]", x = "[object ArrayBuffer]", M = "[object DataView]", H = "[object Float32Array]", R = "[object Float64Array]", q = "[object Int8Array]", K = "[object Int16Array]", k = "[object Int32Array]", V = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", re = "[object Uint16Array]", ve = "[object Uint32Array]", Y = /[\\^$.*+?()[\]{}|]/g, le = /\w*$/, j = /^\[object .+?Constructor\]$/, N = /^(?:0|[1-9]\d*)$/, w = {};
  w[o] = w[s] = w[x] = w[M] = w[a] = w[u] = w[H] = w[R] = w[q] = w[K] = w[k] = w[v] = w[g] = w[y] = w[S] = w[_] = w[O] = w[T] = w[V] = w[Q] = w[re] = w[ve] = !0, w[c] = w[d] = w[P] = !1;
  var $ = typeof or == "object" && or && or.Object === Object && or, F = typeof self == "object" && self && self.Object === Object && self, z = $ || F || Function("return this")(), G = e && !e.nodeType && e, X = G && !0 && t && !t.nodeType && t, J = X && X.exports === G;
  function te(l, m) {
    return l.set(m[0], m[1]), l;
  }
  function ae(l, m) {
    return l.add(m), l;
  }
  function oe(l, m) {
    for (var b = -1, L = l ? l.length : 0; ++b < L && m(l[b], b, l) !== !1; )
      ;
    return l;
  }
  function ie(l, m) {
    for (var b = -1, L = m.length, he = l.length; ++b < L; )
      l[he + b] = m[b];
    return l;
  }
  function Ne(l, m, b, L) {
    var he = -1, ge = l ? l.length : 0;
    for (L && ge && (b = l[++he]); ++he < ge; )
      b = m(b, l[he], he, l);
    return b;
  }
  function B(l, m) {
    for (var b = -1, L = Array(l); ++b < l; )
      L[b] = m(b);
    return L;
  }
  function je(l, m) {
    return l == null ? void 0 : l[m];
  }
  function Qe(l) {
    var m = !1;
    if (l != null && typeof l.toString != "function")
      try {
        m = !!(l + "");
      } catch {
      }
    return m;
  }
  function ct(l) {
    var m = -1, b = Array(l.size);
    return l.forEach(function(L, he) {
      b[++m] = [he, L];
    }), b;
  }
  function kt(l, m) {
    return function(b) {
      return l(m(b));
    };
  }
  function Pt(l) {
    var m = -1, b = Array(l.size);
    return l.forEach(function(L) {
      b[++m] = L;
    }), b;
  }
  var Lr = Array.prototype, $r = Function.prototype, dt = Object.prototype, yt = z["__core-js_shared__"], Zt = function() {
    var l = /[^.]+$/.exec(yt && yt.keys && yt.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), er = $r.toString, Ie = dt.hasOwnProperty, wt = dt.toString, Kr = RegExp(
    "^" + er.call(Ie).replace(Y, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), jt = J ? z.Buffer : void 0, pr = z.Symbol, hr = z.Uint8Array, Xr = kt(Object.getPrototypeOf, Object), Mt = Object.create, Ir = dt.propertyIsEnumerable, Zr = Lr.splice, mr = Object.getOwnPropertySymbols, kr = jt ? jt.isBuffer : void 0, en = kt(Object.keys, Object), At = ee(z, "DataView"), tt = ee(z, "Map"), ft = ee(z, "Promise"), Nt = ee(z, "Set"), Rt = ee(z, "WeakMap"), Be = ee(Object, "create"), vr = Ue(At), gr = Ue(tt), tn = Ue(ft), rn = Ue(Nt), nn = Ue(Rt), Dt = pr ? pr.prototype : void 0, yr = Dt ? Dt.valueOf : void 0;
  function De(l) {
    var m = -1, b = l ? l.length : 0;
    for (this.clear(); ++m < b; ) {
      var L = l[m];
      this.set(L[0], L[1]);
    }
  }
  function on() {
    this.__data__ = Be ? Be(null) : {};
  }
  function sn(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function an(l) {
    var m = this.__data__;
    if (Be) {
      var b = m[l];
      return b === n ? void 0 : b;
    }
    return Ie.call(m, l) ? m[l] : void 0;
  }
  function ln(l) {
    var m = this.__data__;
    return Be ? m[l] !== void 0 : Ie.call(m, l);
  }
  function un(l, m) {
    var b = this.__data__;
    return b[l] = Be && m === void 0 ? n : m, this;
  }
  De.prototype.clear = on, De.prototype.delete = sn, De.prototype.get = an, De.prototype.has = ln, De.prototype.set = un;
  function Re(l) {
    var m = -1, b = l ? l.length : 0;
    for (this.clear(); ++m < b; ) {
      var L = l[m];
      this.set(L[0], L[1]);
    }
  }
  function cn() {
    this.__data__ = [];
  }
  function Je(l) {
    var m = this.__data__, b = pt(m, l);
    if (b < 0)
      return !1;
    var L = m.length - 1;
    return b == L ? m.pop() : Zr.call(m, b, 1), !0;
  }
  function dn(l) {
    var m = this.__data__, b = pt(m, l);
    return b < 0 ? void 0 : m[b][1];
  }
  function fn(l) {
    return pt(this.__data__, l) > -1;
  }
  function pn(l, m) {
    var b = this.__data__, L = pt(b, l);
    return L < 0 ? b.push([l, m]) : b[L][1] = m, this;
  }
  Re.prototype.clear = cn, Re.prototype.delete = Je, Re.prototype.get = dn, Re.prototype.has = fn, Re.prototype.set = pn;
  function We(l) {
    var m = -1, b = l ? l.length : 0;
    for (this.clear(); ++m < b; ) {
      var L = l[m];
      this.set(L[0], L[1]);
    }
  }
  function hn() {
    this.__data__ = {
      hash: new De(),
      map: new (tt || Re)(),
      string: new De()
    };
  }
  function mn(l) {
    return Z(this, l).delete(l);
  }
  function vn(l) {
    return Z(this, l).get(l);
  }
  function gn(l) {
    return Z(this, l).has(l);
  }
  function yn(l, m) {
    return Z(this, l).set(l, m), this;
  }
  We.prototype.clear = hn, We.prototype.delete = mn, We.prototype.get = vn, We.prototype.has = gn, We.prototype.set = yn;
  function Ge(l) {
    this.__data__ = new Re(l);
  }
  function wr() {
    this.__data__ = new Re();
  }
  function jr(l) {
    return this.__data__.delete(l);
  }
  function wn(l) {
    return this.__data__.get(l);
  }
  function bn(l) {
    return this.__data__.has(l);
  }
  function Dr(l, m) {
    var b = this.__data__;
    if (b instanceof Re) {
      var L = b.__data__;
      if (!tt || L.length < r - 1)
        return L.push([l, m]), this;
      b = this.__data__ = new We(L);
    }
    return b.set(l, m), this;
  }
  Ge.prototype.clear = wr, Ge.prototype.delete = jr, Ge.prototype.get = wn, Ge.prototype.has = bn, Ge.prototype.set = Dr;
  function xn(l, m) {
    var b = br(l) || so(l) ? B(l.length, String) : [], L = b.length, he = !!L;
    for (var ge in l)
      (m || Ie.call(l, ge)) && !(he && (ge == "length" || Ke(ge, L))) && b.push(ge);
    return b;
  }
  function tr(l, m, b) {
    var L = l[m];
    (!(Ie.call(l, m) && An(L, b)) || b === void 0 && !(m in l)) && (l[m] = b);
  }
  function pt(l, m) {
    for (var b = l.length; b--; )
      if (An(l[b][0], m))
        return b;
    return -1;
  }
  function Fr(l, m) {
    return l && D(m, xr(m), l);
  }
  function Ft(l, m, b, L, he, ge, Ce) {
    var _e;
    if (L && (_e = ge ? L(l, he, ge, Ce) : L(l)), _e !== void 0)
      return _e;
    if (!Vt(l))
      return l;
    var Ln = br(l);
    if (Ln) {
      if (_e = ze(l), !m)
        return A(l, _e);
    } else {
      var rt = xe(l), $n = rt == d || rt == f;
      if (lo(l))
        return En(l, m);
      if (rt == y || rt == o || $n && !ge) {
        if (Qe(l))
          return ge ? l : {};
        if (_e = Fe($n ? {} : l), !m)
          return U(l, Fr(_e, l));
      } else {
        if (!w[rt])
          return ge ? l : {};
        _e = bt(l, rt, Ft, m);
      }
    }
    Ce || (Ce = new Ge());
    var In = Ce.get(l);
    if (In)
      return In;
    if (Ce.set(l, _e), !Ln)
      var kn = b ? de(l) : xr(l);
    return oe(kn || l, function(_r, Ht) {
      kn && (Ht = _r, _r = l[Ht]), tr(_e, Ht, Ft(_r, m, b, L, Ht, l, Ce));
    }), _e;
  }
  function zr(l) {
    return Vt(l) ? Mt(l) : {};
  }
  function Vr(l, m, b) {
    var L = m(l);
    return br(l) ? L : ie(L, b(l));
  }
  function _n(l) {
    return wt.call(l);
  }
  function Sn(l) {
    if (!Vt(l) || Br(l))
      return !1;
    var m = Rn(l) || Qe(l) ? Kr : j;
    return m.test(Ue(l));
  }
  function Hr(l) {
    if (!rr(l))
      return en(l);
    var m = [];
    for (var b in Object(l))
      Ie.call(l, b) && b != "constructor" && m.push(b);
    return m;
  }
  function En(l, m) {
    if (m)
      return l.slice();
    var b = new l.constructor(l.length);
    return l.copy(b), b;
  }
  function zt(l) {
    var m = new l.constructor(l.byteLength);
    return new hr(m).set(new hr(l)), m;
  }
  function Tn(l, m) {
    var b = m ? zt(l.buffer) : l.buffer;
    return new l.constructor(b, l.byteOffset, l.byteLength);
  }
  function Cn(l, m, b) {
    var L = m ? b(ct(l), !0) : ct(l);
    return Ne(L, te, new l.constructor());
  }
  function On(l) {
    var m = new l.constructor(l.source, le.exec(l));
    return m.lastIndex = l.lastIndex, m;
  }
  function Pn(l, m, b) {
    var L = m ? b(Pt(l), !0) : Pt(l);
    return Ne(L, ae, new l.constructor());
  }
  function p(l) {
    return yr ? Object(yr.call(l)) : {};
  }
  function C(l, m) {
    var b = m ? zt(l.buffer) : l.buffer;
    return new l.constructor(b, l.byteOffset, l.length);
  }
  function A(l, m) {
    var b = -1, L = l.length;
    for (m || (m = Array(L)); ++b < L; )
      m[b] = l[b];
    return m;
  }
  function D(l, m, b, L) {
    b || (b = {});
    for (var he = -1, ge = m.length; ++he < ge; ) {
      var Ce = m[he], _e = L ? L(b[Ce], l[Ce], Ce, b, l) : void 0;
      tr(b, Ce, _e === void 0 ? l[Ce] : _e);
    }
    return b;
  }
  function U(l, m) {
    return D(l, Oe(l), m);
  }
  function de(l) {
    return Vr(l, xr, Oe);
  }
  function Z(l, m) {
    var b = l.__data__;
    return Mn(m) ? b[typeof m == "string" ? "string" : "hash"] : b.map;
  }
  function ee(l, m) {
    var b = je(l, m);
    return Sn(b) ? b : void 0;
  }
  var Oe = mr ? kt(mr, Object) : fo, xe = _n;
  (At && xe(new At(new ArrayBuffer(1))) != M || tt && xe(new tt()) != v || ft && xe(ft.resolve()) != E || Nt && xe(new Nt()) != _ || Rt && xe(new Rt()) != P) && (xe = function(l) {
    var m = wt.call(l), b = m == y ? l.constructor : void 0, L = b ? Ue(b) : void 0;
    if (L)
      switch (L) {
        case vr:
          return M;
        case gr:
          return v;
        case tn:
          return E;
        case rn:
          return _;
        case nn:
          return P;
      }
    return m;
  });
  function ze(l) {
    var m = l.length, b = l.constructor(m);
    return m && typeof l[0] == "string" && Ie.call(l, "index") && (b.index = l.index, b.input = l.input), b;
  }
  function Fe(l) {
    return typeof l.constructor == "function" && !rr(l) ? zr(Xr(l)) : {};
  }
  function bt(l, m, b, L) {
    var he = l.constructor;
    switch (m) {
      case x:
        return zt(l);
      case a:
      case u:
        return new he(+l);
      case M:
        return Tn(l, L);
      case H:
      case R:
      case q:
      case K:
      case k:
      case V:
      case Q:
      case re:
      case ve:
        return C(l, L);
      case v:
        return Cn(l, L, b);
      case g:
      case O:
        return new he(l);
      case S:
        return On(l);
      case _:
        return Pn(l, L, b);
      case T:
        return p(l);
    }
  }
  function Ke(l, m) {
    return m = m ?? i, !!m && (typeof l == "number" || N.test(l)) && l > -1 && l % 1 == 0 && l < m;
  }
  function Mn(l) {
    var m = typeof l;
    return m == "string" || m == "number" || m == "symbol" || m == "boolean" ? l !== "__proto__" : l === null;
  }
  function Br(l) {
    return !!Zt && Zt in l;
  }
  function rr(l) {
    var m = l && l.constructor, b = typeof m == "function" && m.prototype || dt;
    return l === b;
  }
  function Ue(l) {
    if (l != null) {
      try {
        return er.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function oo(l) {
    return Ft(l, !0, !0);
  }
  function An(l, m) {
    return l === m || l !== l && m !== m;
  }
  function so(l) {
    return ao(l) && Ie.call(l, "callee") && (!Ir.call(l, "callee") || wt.call(l) == o);
  }
  var br = Array.isArray;
  function Nn(l) {
    return l != null && uo(l.length) && !Rn(l);
  }
  function ao(l) {
    return co(l) && Nn(l);
  }
  var lo = kr || po;
  function Rn(l) {
    var m = Vt(l) ? wt.call(l) : "";
    return m == d || m == f;
  }
  function uo(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= i;
  }
  function Vt(l) {
    var m = typeof l;
    return !!l && (m == "object" || m == "function");
  }
  function co(l) {
    return !!l && typeof l == "object";
  }
  function xr(l) {
    return Nn(l) ? xn(l) : Hr(l);
  }
  function fo() {
    return [];
  }
  function po() {
    return !1;
  }
  t.exports = oo;
})($o, $o.exports);
var Cr = $o.exports, Hn = function() {
  return Hn = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, Hn.apply(this, arguments);
};
function jc(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(s) {
      s(o);
    });
  }
  return new (r || (r = Promise))(function(o, s) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        c(n.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function c(d) {
      d.done ? o(d.value) : i(d.value).then(a, u);
    }
    c((n = n.apply(t, e || [])).next());
  });
}
function Dc(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(c) {
    return function(d) {
      return u([c, d]);
    };
  }
  function u(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, c[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = c;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(c);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = e.call(t, r);
      } catch (d) {
        c = [6, d], i = 0;
      } finally {
        n = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function gi(t, e, r, n, i) {
  return jc(this, void 0, void 0, function() {
    var o, s;
    return Dc(this, function(a) {
      switch (a.label) {
        case 0:
          if (r === void 0)
            return [
              2
              /*return*/
            ];
          s = 0, a.label = 1;
        case 1:
          return s < r.length ? [4, r[s](t, e, n, i, r)] : [3, 4];
        case 2:
          if (o = a.sent(), o === "canceled")
            return [3, 4];
          a.label = 3;
        case 3:
          return s++, [3, 1];
        case 4:
          return o !== "canceled" ? [2, o] : [
            2
            /*return*/
          ];
      }
    });
  });
}
var Io = function(t, e) {
  return e === void 0 && (e = {}), t ? {
    trackedAnalytics: Hn({ sdkCode: t.sdkCode, sdkSemver: t.sdkSemver, techVersion: t.techVersion }, e)
  } : null;
}, Fc = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      var o = this;
      this.isMounted = !0, this.imgElement = e, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var s = Cr(r);
      gi(e, s, n, this.htmlPluginState, i).then(function(a) {
        if (o.isMounted) {
          o.htmlPluginState.pluginEventSubscription.forEach(function(c) {
            c();
          });
          var u = Io(i, a);
          o.imgElement.setAttribute("src", s.toURL(u));
        }
      });
    }
    return t.prototype.update = function(e, r, n) {
      var i = this, o = Cr(e);
      gi(this.imgElement, o, r, this.htmlPluginState).then(function(s) {
        if (i.isMounted) {
          var a = Io(n, s);
          i.imgElement.setAttribute("src", o.toURL(a));
        }
      });
    }, t.prototype.unmount = function() {
      this.isMounted = !1;
    }, t;
  }()
);
class Me {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(e) {
    this.values = [], this.delimiter = ":", this.hasValue(e) && this.addValue(e);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(e) {
    return typeof e < "u" && e !== null && e !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(e) {
    return Array.isArray(e) ? this.values = this.values.concat(e) : this.values.push(e), this.values = this.values.filter((r) => this.hasValue(r)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(e) {
    return this.delimiter = e, this;
  }
}
class zc extends Error {
  constructor(e = "Unsupported") {
    super(e);
  }
}
function as(t) {
  return new zc(t);
}
function Vc() {
  return this._qualifierModel || { error: as(`unsupported qualifier ${this.constructor.name}`) };
}
class Hc {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return Vc.apply(this);
  }
}
class ue extends Hc {
  constructor(e, r) {
    super(), this.delimiter = "_", this.key = e, r instanceof Me ? this.qualifierValue = r : (this.qualifierValue = new Me(), this.qualifierValue.addValue(r));
  }
  toString() {
    const { key: e, delimiter: r, qualifierValue: n } = this;
    return `${e}${r}${n.toString()}`;
  }
  addValue(e) {
    return this.qualifierValue.addValue(e), this;
  }
}
class mt extends ue {
  constructor(e, r) {
    let n;
    r ? n = new Me([e, `${r}`]).setDelimiter(":") : n = e, super("fl", n), this.flagValue = r;
  }
  toString() {
    return super.toString().replace(/\./, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function Bc(t, e) {
  const r = Array.from(t.entries());
  return e.forEach((n) => {
    r.push(["fl", n]);
  }), r.sort().map((n) => n[1]);
}
function Wc() {
  var t, e, r;
  const n = this._actionModel && Object.keys(this._actionModel).length, i = (r = (e = (t = this._actionModel) === null || t === void 0 ? void 0 : t.source) === null || e === void 0 ? void 0 : e.transformation) === null || r === void 0 ? void 0 : r.error;
  return i && i instanceof Error ? { error: i } : n ? this._actionModel : { error: as(`unsupported action ${this.constructor.name}`) };
}
class Gc {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return Wc.apply(this);
  }
}
class gt extends Gc {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(e) {
    return this.actionTag = e, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), Bc(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(e) {
    if (typeof e == "string") {
      const [r, n] = e.toLowerCase().split("_");
      r === "fl" ? this.flags.push(new mt(n)) : this.qualifiers.set(r, new ue(r, n));
    } else
      this.qualifiers.set(e.key, e);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(e) {
    return typeof e == "string" ? this.flags.push(new mt(e)) : e instanceof mt && this.flags.push(e), this;
  }
  addValueToQualifier(e, r) {
    return this.qualifiers.get(e).addValue(r), this;
  }
}
class ls extends gt {
  constructor(e) {
    super(), this.regionType = e, this._actionModel.regionType = e;
  }
}
class Ni extends ls {
  constructor() {
    super("custom");
  }
  /**
   * @description The x position in pixels.
   * @param {number | string} x
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ue("x", e)), this;
  }
  /**
   * @description The y position in pixels.
   * @param {number | string} y
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ue("y", e)), this;
  }
  /**
   * @description The width of the region in pixels.
   * @param {number | string} width
   */
  width(e) {
    return this._actionModel.width = e, this.addQualifier(new ue("w", e)), this;
  }
  /**
   * @description The height of the region in pixels.
   * @param {number | string} height
   */
  height(e) {
    return this._actionModel.height = e, this.addQualifier(new ue("h", e)), this;
  }
  static fromJson(e) {
    const r = new Ni();
    return e.width && r.width(e.width), e.height && r.height(e.height), e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function Uc() {
  return new Ni();
}
function sl() {
  return new ls("faces");
}
function qc() {
  return new ls("ocr_text");
}
class Yc extends gt {
  constructor(e) {
    super(), this._actionModel = {}, this._strength = e, this._actionModel.actionType = "blur", this._actionModel.strength = e;
  }
  /**
   * @description Specifies the region to blur.
   * @param {NamedRegion} blurRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = e.toJson(), this;
  }
  /**
   * @description Sets the strength of the blur effect.
   * @param {number | string} strength
   */
  strength(e) {
    return this._strength = e, this._actionModel.strength = e, this;
  }
  prepareQualifiers() {
    const e = this._strength ? `:${this._strength}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((n) => this.addQualifier(n)), this._region.regionType === "custom" && this.addQualifier(new ue("e", `blur_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new ue("e", `blur_region${e}`)), this.addQualifier(new ue("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new ue("e", `blur_faces${e}`))) : this.addQualifier(new ue("e", `blur${e}`));
  }
  static fromJson(e) {
    const { strength: r, region: n } = e, i = new this(r);
    return r && i.strength(r), n && n.regionType === "faces" && i.region(sl()), n && n.regionType === "ocr_text" && i.region(qc()), n && n.regionType === "custom" && i.region(Ni.fromJson(n)), i;
  }
}
function Mr(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    e[t[r]] = r;
  }), e;
}
const al = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad"
}, Qc = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, ll = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, ul = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, Jc = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, cl = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, Kc = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
}, Xc = Mr(cl);
Mr(Kc);
const Zc = Mr(al), ed = Mr(Qc), dl = Mr(ll);
Mr(ul);
Mr(Jc);
class fl extends gt {
  constructor(e, r) {
    super(), this._actionModel = {}, this._actionModel.actionType = dl[e] || e;
    const n = this.createEffectQualifier(e, r);
    this.addQualifier(n);
  }
  createEffectQualifier(e, r) {
    let n;
    return r ? n = new Me([e, `${r}`]).setDelimiter(":") : n = new Me(e), new ue("e", n);
  }
  static fromJson(e) {
    const { actionType: r, level: n, strength: i } = e, o = ll[r] || r;
    return new this(o, n || i);
  }
}
class td extends fl {
  constructor(e, r) {
    super(e, r), this.LEVEL_NAME = "level", this._actionModel = {}, this.effectType = e, this._actionModel.actionType = dl[e] || e, r && this.setLevel(r);
  }
  /**
   *
   * @description Sets the effect level for the action
   * @param {string | number} level - The strength of the effect
   * @protected
   */
  setLevel(e) {
    this._actionModel[this.LEVEL_NAME] = e;
    const r = this.createEffectQualifier(this.effectType, e);
    return this.addQualifier(r), this;
  }
}
function Ri(t) {
  return t && (t.match(/^#/) ? `rgb:${t.substr(1)}` : t);
}
class rd extends gt {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "vectorize";
  }
  /**
   * @description The number of colors. (Range: 2 to 30, Server default: 10)
   * @param {number | string} num
   * @return {this}
   */
  numOfColors(e) {
    return this._actionModel.numOfColors = e, this._numOfColors = e, this;
  }
  /**
   * @description The level of detail. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 1000). (Server default: 300)
   * @param {number | string} num
   * @return {this}
   */
  detailsLevel(e) {
    return this._actionModel.detailLevel = e, this._detailsLevel = e, this;
  }
  /**
   * @description The size of speckles to suppress. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 100, Server default: 2)
   * @param {number | string} num
   * @return {this}
   */
  despeckleLevel(e) {
    return this._actionModel.despeckleLevel = e, this._despeckleLevel = e, this;
  }
  /**
   * @description The corner threshold. Specify 100 for no smoothing (polygon corners), 0 for completely smooth corners. (Range: 0 to 100, Default: 25)
   * @param {number | string} num
   * @return {this}
   */
  cornersLevel(e) {
    return this._actionModel.cornersLevel = e, this._cornersLevel = e, this;
  }
  /**
   * @description The optimization value. Specify 100 for least optimization and the largest file. (Range: 0 to 100, Server default: 100).
   * @param {number} num
   * @return {this}
   */
  paths(e) {
    return this._actionModel.paths = e, this._paths = e, this;
  }
  prepareQualifiers() {
    let e = "vectorize";
    this._numOfColors && (e += `:${new Me(`colors:${this._numOfColors}`).toString()}`), this._detailsLevel && (e += `:${new Me(`detail:${this._detailsLevel}`).toString()}`), this._despeckleLevel && (e += `:${new Me(`despeckle:${this._despeckleLevel}`).toString()}`), this._paths && (e += `:${new Me(`paths:${this._paths}`).toString()}`), this._cornersLevel && (e += `:${new Me(`corners:${this._cornersLevel}`).toString()}`), this.addQualifier(new ue("e", e));
  }
  static fromJson(e) {
    const { actionType: r, paths: n, cornersLevel: i, despeckleLevel: o, detailLevel: s, numOfColors: a } = e, u = new this();
    return n && u.paths(n), i && u.cornersLevel(i), o && u.despeckleLevel(o), s && u.detailsLevel(s), a && u.numOfColors(a), u;
  }
}
class nd extends td {
  level(e) {
    return this._actionModel.level = e, this.setLevel(e);
  }
}
class id extends gt {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "assistColorblind", this.addQualifier(new ue("e", new Me("assist_colorblind")));
  }
  /**
   * @description Replaces problematic colors with colors that are easier to differentiate.
   * @return {this}
   */
  xray() {
    return this._actionModel.type = "xray", this.addQualifier(new ue("e", new Me(["assist_colorblind", "xray"]).setDelimiter(":")));
  }
  /**
   * @description Applies stripes of the specified intensity to help people with common color blind conditions to differentiate between colors that are similar for them.
   * @param {number | string} strength The intensity of the stripes. (Range: 1 to 100, Server default: 10)
   * @return {this}
   */
  stripesStrength(e) {
    return this._actionModel.type = "stripes", this._actionModel.stripesStrength = e, this.addQualifier(new ue("e", new Me(["assist_colorblind", e]).setDelimiter(":")));
  }
  static fromJson(e) {
    const { actionType: r, type: n, stripesStrength: i } = e, o = new this();
    return n === "xray" && o.xray(), n === "stripes" && i && o.stripesStrength(i), o;
  }
}
class od extends nd {
  /**
   * @description The color to use for colorization. Specify HTML name or RGB hex code. (Server default: gray)
   * @param {string} color HTML name(red, green, etc.) or RGB hex code. (Server default: gray)
   * @return {this}
   */
  color(e) {
    return this._actionModel.color = e, this.addQualifier(new ue("co", new Me(Ri(e))));
  }
  static fromJson(e) {
    const { actionType: r, level: n, color: i } = e, o = new this(r, n);
    return i && o.color(i), o;
  }
}
class sd extends gt {
  constructor(e) {
    super(), this._actionModel = {}, this._squareSize = e, this._actionModel.actionType = "pixelate", this._actionModel.squareSize = e;
  }
  /**
   * @description Specifies the region to piexlate.
   * @param {NamedRegion} pixelateRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = { regionType: this._region.regionType }, this;
  }
  /**
   * @description Sets the squareSize of the pixelate effect.
   * @param {number | string} squareSize
   */
  squareSize(e) {
    return this._squareSize = e, this._actionModel.squareSize = e, this;
  }
  prepareQualifiers() {
    const e = this._squareSize ? `:${this._squareSize}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((n) => this.addQualifier(n)), this._region.regionType === "custom" && this.addQualifier(new ue("e", `pixelate_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new ue("e", `pixelate_region${e}`)), this.addQualifier(new ue("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new ue("e", `pixelate_faces${e}`))) : this.addQualifier(new ue("e", `pixelate${e}`));
  }
  static fromJson(e) {
    const { region: r, squareSize: n } = e, i = new this(n);
    return n && i.squareSize(n), r && r.regionType === "faces" && i.region(sl()), r && r.regionType === "custom" && i.region(Uc()), i;
  }
}
function ad(t) {
  return new Yc(t);
}
function ld() {
  return new fl("grayscale");
}
function ra(t) {
  return new od("colorize", t);
}
function ud() {
  return new rd();
}
function cd() {
  return new id();
}
function dd(t) {
  return new sd(t);
}
class fd extends gt {
  constructor(e) {
    super(), this._actionModel = {}, this.addQualifier(new ue("b", new Me(Ri(e)).setDelimiter("_"))), this._actionModel.color = e, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(e) {
    const { color: r } = e;
    return new this(r);
  }
}
class na {
  constructor(e) {
    this.raw = e;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: as(`unsupported action ${this.constructor.name}`) };
  }
}
function pd(t) {
  const e = t;
  return "error" in e && !!e.error;
}
function hd() {
  return new mt("ignore_aspect_ratio");
}
function md() {
  return new mt("lossy");
}
function vd() {
  return new mt("preserve_transparency");
}
function gd(t) {
  return new mt("progressive", t);
}
function yd() {
  return new mt("region_relative");
}
function wd() {
  return new mt("relative");
}
class us extends Me {
  constructor(e) {
    super(e), this.val = e;
  }
  getValue() {
    return this.val;
  }
}
class pl extends gt {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(e, r, n) {
    super(), this._actionModel = {};
    let i;
    r instanceof us ? i = r.getValue() : i = r, this._actionModel.actionType = ed[e], this._actionModel[n] = i, this.addQualifier(new ue(e, r));
  }
}
class bd extends mt {
  constructor(e) {
    super("progressive", e);
  }
}
class ko extends pl {
  constructor(e, r) {
    super(e, r, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(md()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(e) {
    return e instanceof bd ? (this._actionModel.progressive = { mode: e.getFlagValue() }, this.addFlag(e)) : (this._actionModel.progressive = { mode: e }, this.addFlag(gd(e))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(vd()), this;
  }
  static fromJson(e) {
    const { formatType: r, lossy: n, progressive: i, preserveTransparency: o } = e;
    let s;
    return r ? s = new this("f", r) : s = new this("f"), i && (i.mode ? s.progressive(i.mode) : s.progressive()), n && s.lossy(), o && s.preserveTransparency(), s;
  }
}
class qr {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    let r;
    if (typeof e == "string") {
      if (e.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      r = new na(e);
    } else
      r = e;
    return this.actions.push(r), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(e) {
    return e instanceof qr ? this.actions = this.actions.concat(e.actions) : this.actions.push(new na(e)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((e) => e.toString()).filter((e) => e).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(e) {
    return this.addAction(e);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(e) {
    return this.addAction(e);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(e) {
    return this.addAction(e);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new ko("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new ko("f", e)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(e) {
    return e.setLayerType("u"), this.addAction(e);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.addAction(e);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(e) {
    return this.addAction(e);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.addAction(e);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.addAction(new fd(e));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(e) {
    return this.addAction(e);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    const r = new gt();
    let n = e;
    return typeof e == "string" && (n = new mt(e)), r.addQualifier(n), this.addAction(r);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(e) {
    return this.addAction(e);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(e) {
    return this.addAction(e);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(e) {
    return this.addAction(e);
  }
  toJson() {
    const e = [];
    for (const r of this.actions) {
      const n = r.toJson();
      if (pd(n))
        return n;
      e.push(n);
    }
    return { actions: e };
  }
}
function ia(t) {
  const e = t.toString();
  return e.match(/[A-Z]/gi) || e.length > 1 && e[0] === "0" ? e : !isNaN(parseFloat(e)) && e.indexOf(":") === -1 && e.indexOf(".") === -1 ? `${e}.0` : e;
}
class xd extends Me {
}
class hl extends gt {
  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  constructor(e, r, n) {
    super(), this._actionModel = { dimensions: {} }, this._actionModel.actionType = Zc[e] || e, this.addQualifier(new ue("c", e)), r && this.width(r), n && this.height(n);
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  height(e) {
    return this._actionModel.dimensions.height = e, this.addQualifier(new ue("h", e));
  }
  /**
   * @description Sets the width of the resize
   * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  width(e) {
    return this._actionModel.dimensions.width = e, this.addQualifier(new ue("w", e));
  }
  /**
   * @description Sets the aspect ratio of the asset.
   * For a list of supported types see {@link Qualifiers.AspectRatio|
    * AspectRatio values}
   * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
   * @return {this}
   */
  aspectRatio(e) {
    if (e instanceof xd)
      return this._actionModel.dimensions.aspectRatio = `${e}`, this.addQualifier(new ue("ar", e));
    if (typeof e == "number" || typeof e == "string")
      return this._actionModel.dimensions.aspectRatio = ia(e), this.addQualifier(new ue("ar", ia(e)));
    if (e instanceof mt)
      return this._actionModel.dimensions.aspectRatio = `${e.qualifierValue}`, this.addFlag(e);
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
   * @return {this}
   */
  relative() {
    return this._actionModel.relative = !0, this.addFlag(wd());
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
   * @return {this}
   */
  regionRelative() {
    return this._actionModel.regionRelative = !0, this.addFlag(yd());
  }
  static fromJson(e) {
    const { actionType: r, dimensions: n, relative: i, regionRelative: o } = e, { aspectRatio: s, width: a, height: u } = n, c = al[r] || r, d = new this(c, a, u);
    return s && d.aspectRatio(s === "ignore_aspect_ratio" ? hd() : s), i && d.relative(), o && d.regionRelative(), d;
  }
}
class Li extends ue {
  /**
   * @param value, an array containing (GravityObject | AutoGravity | string) or a string;
   */
  constructor(e) {
    super("g", new Me(e));
  }
}
class ml extends Li {
  constructor() {
    super("auto");
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */
  autoFocus(...e) {
    return this.addValue(e), this;
  }
}
class vl extends Li {
  constructor(e) {
    super(e);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */
  fallbackGravity(e) {
    return this.addValue(e.qualifierValue), this;
  }
}
class gl extends Li {
  constructor(e) {
    super(e);
  }
}
function _d(t) {
  return new gl(t);
}
function yl(...t) {
  const e = [...t];
  return new vl(e);
}
function wl() {
  return new ml();
}
class $i extends Me {
  constructor(e) {
    super(), this.name = e;
  }
  toString() {
    return this.name;
  }
}
function Sd() {
  return new $i("ocr_text");
}
function Ed(t) {
  return t && `${t}`.split(":")[0] === "auto";
}
function Td(t) {
  const e = cs(t);
  return ["north", "center", "east", "west", "south", "north_west", "south_east", "south_west", "north_east"].includes(e);
}
function cs(t) {
  return `${t}`.replace("g_", "");
}
function Cd(t) {
  return {
    compass: cs(t),
    gravityType: "direction"
  };
}
function Od(t) {
  return cs(t) === "ocr_text";
}
function Pd() {
  return {
    gravityType: "ocr"
  };
}
function Md(t) {
  return `${t.qualifierValue}`.split(":")[0] === "auto";
}
function Ad(t) {
  const r = t.toString().split("_"), n = {
    object: r[0]
  };
  return r.length > 1 && (r[1] === "avoid" ? n.avoid = !0 : n.weight = +r[1]), n;
}
function bl(t) {
  let e;
  const r = t === "auto" ? new ml() : t;
  return `${t}`.startsWith("auto:") ? e = `${t}`.split(":").filter((i) => i !== "auto") : e = r.qualifierValue.values.filter((i) => i !== "auto"), {
    gravityType: "auto",
    autoFocus: e.map(Ad)
  };
}
function Nd(t) {
  const e = `${t}`.split(":").includes("auto"), r = t.qualifierValue.values, i = {
    gravityType: "object",
    focusOnObjects: (e ? r.slice(0, r.length - 1) : r).map((o) => `${o}`)
  };
  if (e) {
    const o = r[r.length - 1].values.slice(1), s = wl().autoFocus(...o);
    i.fallbackGravity = bl(s);
  }
  return i;
}
function Rd(t) {
  const r = t.split(":").map((n) => new $i(n));
  return new vl(r);
}
function Ld(t) {
  return Td(t) ? Cd(t) : Od(t) ? Pd() : Ed(t) || Md(t) ? bl(t) : Nd(typeof t == "string" ? Rd(t) : t);
}
class ds extends Me {
  constructor(e, r) {
    super(), this._weight = r, this.focusOn = e, this.shouldAvoid = !1;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */
  static focusOn(e, r) {
    return new ds(e, r);
  }
  shouldAddWeight() {
    return typeof this._weight == "number" || typeof this._weight == "string" || this.shouldAvoid;
  }
  /**
   * @summary qualifier
   * @desc Get the name of the of the object
   */
  getName() {
    return this.focusOn.name;
  }
  /**
   * @summary qualifier
   * @desc Get the weight for the object
   */
  getWeight() {
    return this.shouldAvoid ? "avoid" : this._weight;
  }
  /**
   * @summary qualifier
   * @desc Return the string representation of this QualifierValue
   */
  toString() {
    return this.shouldAddWeight() ? `${this.getName()}_${this.getWeight()}` : `${this.getName()}`;
  }
  /**
   * @summary qualifier
   * @description Sets the importance level of the object within the automatic gravity algorithm
   * @param {numebr} w The focus weight for the object
   * @return {this}
   */
  weight(e) {
    return this._weight = e, this;
  }
  /**
   * @summary qualifier
   * @description Attempts to avoid the detected object in the image
   * @return {this}
   */
  avoid() {
    return this.shouldAvoid = !0, this;
  }
}
class xl extends Me {
  constructor(e) {
    super(), this.val = e;
  }
  toString() {
    return this.val;
  }
}
function $d(t) {
  return t.gravityType === "direction";
}
function Id(t) {
  return t.gravityType === "ocr";
}
function kd(t) {
  return t.gravityType === "auto";
}
function jd(t) {
  const { object: e, weight: r, avoid: n } = t, i = new ds(new $i(e));
  return (r || r === 0) && i.weight(r), n && i.avoid(), i;
}
function _l(t) {
  const r = (t.autoFocus || []).map(jd);
  return wl().autoFocus(...r);
}
function Dd(t) {
  const e = (t.focusOnObjects || []).map((n) => new $i(n)), r = yl(...e);
  if (t.fallbackGravity) {
    const n = _l(t.fallbackGravity);
    r.fallbackGravity(n);
  }
  return r;
}
function Fd(t) {
  return $d(t) ? new gl(new xl(t.compass)) : Id(t) ? yl(Sd()) : kd(t) ? _l(t) : Dd(t);
}
class fs extends hl {
  /**
   * @description Which part of the original image to include.
   * @param {Qualifiers.Gravity} gravity
   */
  gravity(e) {
    this._actionModel.gravity = Ld(e);
    const r = typeof e == "string" ? new ue("g", e) : e;
    return this.addQualifier(r);
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.gravity && r.gravity(Fd(e.gravity)), r;
  }
}
class Qn extends ue {
  constructor(e) {
    super("b"), e && this.addValue(e);
  }
}
const Sl = 100, zd = 0;
class Vd extends Qn {
  /**
   * @description Sets the intensity of the blur.
   * @param {number} value - The intensity of the blur.
   */
  intensity(e) {
    return this.intensityLevel = e, this;
  }
  /**
   * @description Sets the brightness of the background.
   * @param {number} value - The brightness of the background.
   */
  brightness(e) {
    return this.brightnessLevel = e, this;
  }
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function
   */
  toString() {
    const e = this.intensityLevel !== void 0 ? `:${this.intensityLevel}` : "", r = this.brightnessLevel !== void 0 ? this.intensityLevel !== void 0 ? `:${this.brightnessLevel}` : `:${Sl}:${this.brightnessLevel}` : "";
    return `b_blurred${e}${r}`;
  }
}
var El = Vd;
class ps extends Qn {
  constructor() {
    super(), this._palette = [];
  }
  /**
   * @description Selects the strongest contrasting color to use for padding.
   * @return {this}
   */
  contrast() {
    return this._contrast = !0, this;
  }
  /**
   * @description Defines the custom colors to use when resizing using content-aware padding.
   * @param {...string} colors One or more colors - Example: palette('green', 'red', blue')
   * @return {this}
   */
  palette(...e) {
    return this._palette = e.map((r) => Ri(r)), this;
  }
}
class Tl extends ps {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Cl extends ps {
  /**
   *
   * @description Sets the number of predominant colors to use (2 or 4).
   * @param {number} num
   * @return {this}
   */
  gradientColors(e) {
    return this._gradientColors = e, this;
  }
  /**
   * @description Sets the direction for a background gradient fade effect.
   * @param {Qualifiers.GradientDirection | GradientDirectionType | string} direction Use one of these functions
   * provided by {@link Qualifiers.GradientDirection|GradientDirection}
   * @return {this}
   */
  gradientDirection(e) {
    return this._gradientDirection = e, this;
  }
}
class Ol extends Cl {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Pl extends Cl {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Ml extends ps {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Al extends Qn {
  constructor() {
    super("gen_fill"), this._backgroundType = "generativeFill";
  }
  prompt(e) {
    return this._prompt = e, this;
  }
  getPrompt() {
    return this._prompt;
  }
  getBackgroundType() {
    return this._backgroundType;
  }
  /**
   * @description
   * Override the toString() function to explicitly stringify the qualifier.
   */
  toString() {
    return `b_gen_fill${this._prompt ? `:prompt_${this._prompt}` : ""}`;
  }
}
function Nl(t) {
  return `${t}`.replace("b_", "");
}
function Hd() {
  return { backgroundType: "auto" };
}
function Bd(t) {
  const { intensityLevel: e, brightnessLevel: r } = t, n = {
    backgroundType: "blurred"
  };
  return (e || e === 0) && (n.intensity = e), (r || r === 0) && (n.brightness = r), n;
}
function hs(t) {
  const e = t._contrast, r = t._palette, n = {
    backgroundType: ""
  };
  return e && (n.contrast = !0), r && (n.palette = r), n;
}
function Wd(t) {
  return Object.assign(Object.assign({}, hs(t)), { backgroundType: "border" });
}
function Rl(t) {
  const e = t._gradientColors, r = `${t._gradientDirection}`, n = hs(t);
  return e && (n.gradientColors = e), r && (n.gradientDirection = r), n;
}
function Gd(t) {
  return Object.assign(Object.assign({}, Rl(t)), { backgroundType: "borderGradient" });
}
function Ud(t) {
  return {
    backgroundType: "color",
    color: Nl(t)
  };
}
function qd(t) {
  return Object.assign(Object.assign({}, hs(t)), { backgroundType: "predominant" });
}
function Yd(t) {
  return Object.assign(Object.assign({}, Rl(t)), { backgroundType: "predominantGradient" });
}
function Qd(t) {
  return Object.assign({ backgroundType: t.getBackgroundType() }, t.getPrompt() ? { prompt: t.getPrompt() } : {});
}
function Jd(t) {
  return Nl(t) === "auto" ? Hd() : t instanceof El ? Bd(t) : t instanceof Tl ? Wd(t) : t instanceof Ol ? Gd(t) : t instanceof Ml ? qd(t) : t instanceof Pl ? Yd(t) : t instanceof Al ? Qd(t) : Ud(t);
}
function Kd() {
  return new us("svg");
}
function ms() {
  return new us("auto");
}
function Ll() {
  return new Tl();
}
function $l() {
  return new Qn("auto");
}
function Il() {
  return new Ol();
}
function kl() {
  return new Pl();
}
function jl() {
  return new Ml();
}
function Dl(t) {
  return new Qn(Ri(t));
}
function Xd() {
  return new El();
}
function Fl() {
  return new Al();
}
const zl = {
  auto: $l,
  border: Ll,
  borderGradient: Il,
  predominantGradient: kl,
  predominant: jl,
  color: Dl,
  blurred: Xd,
  generativeFill: Fl
};
function Zd(t) {
  const { brightness: e, intensity: r } = t, n = zl.blurred();
  return n.brightness(e ?? zd), n.intensity(r ?? Sl), n;
}
function oa(t, e) {
  const { gradientColors: r, gradientDirection: n, contrast: i, palette: o } = e;
  return i && t.contrast(), o && t.palette(...o), r && t.gradientColors(+r), n && t.gradientDirection(n), t;
}
function sa(t, e) {
  const { contrast: r, palette: n } = e;
  return r && t.contrast(), n && t.palette(...n), t;
}
function ef(t, e) {
  const { prompt: r } = e;
  return r && t.prompt(r), t;
}
function tf(t) {
  const { backgroundType: e } = t;
  switch (e) {
    case "auto":
      return $l();
    case "blurred":
      return Zd(t);
    case "border":
      return sa(Ll(), t);
    case "borderGradient":
      return oa(Il(), t);
    case "predominant":
      return sa(jl(), t);
    case "predominantGradient":
      return oa(kl(), t);
    case "generativeFill":
      return ef(Fl(), t);
    default:
      return Dl(t.color);
  }
}
class rf extends fs {
  /**
   * @description Sets the background.
   * @param {Qualifiers.Background} backgroundQualifier Defines the background color to use instead of
   * transparent background areas or when resizing with padding.
   */
  background(e) {
    return this._actionModel.background = Jd(e), this.addQualifier(e);
  }
  /**
   * @description Horizontal position for custom-coordinates based padding.
   * @param {number} x The x position.
   */
  offsetX(e) {
    return this._actionModel.x = e, this.addQualifier(new ue("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based padding
   * @param {number} y The y position.
   */
  offsetY(e) {
    return this._actionModel.y = e, this.addQualifier(new ue("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.background && r.background(tf(e.background)), e.x && r.offsetX(e.x), e.y && r.offsetY(e.y), e.zoom && r.zoom(e.zoom), r;
  }
}
class nf extends hl {
  /**
   * @description Changes the aspect ratio of an image while retaining all important content and avoiding unnatural
   * distortions.
   * @return {this}
   */
  liquidRescaling() {
    return this.addQualifier(new Li("liquid"));
  }
}
class of extends fs {
  /**
   * @description Horizontal position for custom-coordinates based cropping.
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ue("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based cropping
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ue("y", e));
  }
  /**
   * @description Controls how much of the original image surrounding the face to keep when using either the 'crop' or 'thumb' cropping modes with face detection.
   * @param {number | string} z The zoom factor. (Default: 1.0)
   */
  zoom(e) {
    return this._actionModel.zoom = e, this.addQualifier(new ue("z", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), e.zoom && r.zoom(e.zoom), r;
  }
}
class sf extends fs {
  /**
   * @description Absolute X position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ue("x", e));
  }
  /**
   * @description Absolute Y position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ue("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function af(t, e) {
  return new nf("scale", t, e);
}
function lf(t, e) {
  return new of("crop", t, e);
}
function uf(t, e) {
  return new sf("fill", t, e);
}
function cf(t, e) {
  return new rf("pad", t, e);
}
class df extends pl {
  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  constructor(e) {
    super("q", e.toString(), "level");
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_optimization#toggle_chroma_subsampling|Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */
  chromaSubSampling(e) {
    this._actionModel.chromaSubSampling = cl[e];
    const r = new Me([this._actionModel.level, e]);
    return r.setDelimiter(":"), this.addQualifier(new ue("q", r));
  }
  /**
   * Controls the final quality by setting a maximum quantization percentage
   * @param {number} val
   */
  quantization(e) {
    this._actionModel.quantization = e;
    const r = new Me([this._actionModel.level, `qmax_${e}`]).setDelimiter(":");
    return this.addQualifier(new ue("q", r));
  }
  static fromJson(e) {
    const { level: r, chromaSubSampling: n, quantization: i } = e, o = ul[r] || r, s = new this(o);
    if (n) {
      const a = Xc[n.toUpperCase()];
      a && s.chromaSubSampling(+a);
    }
    return i && s.quantization(i), s;
  }
}
function Ii(t) {
  return new ko("f", t);
}
function ki(t) {
  return new df(t);
}
function ff() {
  return new xl("north_east");
}
ra(70).color("black"), ra(40).color("white"), ld(), cd();
new qr().effect(ud()).delivery(ki("auto")).delivery(Ii(Kd()));
new qr().effect(dd()).delivery(ki("auto")).delivery(Ii(ms()));
new qr().effect(ad(2e3)).delivery(ki("auto")).delivery(Ii(ms()));
new qr().resize(cf("iw_div_2").aspectRatio(1).background(zl.auto())).resize(lf(1, 1).gravity(_d(ff()))).resize(uf().height("ih").width("iw")).delivery(ki("auto")).delivery(Ii(ms()));
var aa = {
  flv: "x-flv",
  "3gp": "3gpp",
  mov: "quicktime",
  mpg: "mpeg",
  avi: "x-msvideo",
  wmv: "x-ms-wmv",
  ogv: "ogg",
  webm: "webm",
  mp4: "mp4"
}, la = "?_a=", pf = (
  /** @class */
  function() {
    function t(e, r, n, i, o, s, a) {
      var u = this;
      this.mimeType = "video", this.mimeSubTypes = aa, this.videoElement = e, this.originalVideo = r, this.videoOptions = a, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var c = Cr(r);
      gi(e, r, i, this.htmlPluginState).then(function() {
        u.htmlPluginState.pluginEventSubscription.forEach(function(d) {
          d();
        }), u.setVideoAttributes(o, s), u.handleSourceToVideo(c, n);
      });
    }
    return t.prototype.handleSourceToVideo = function(e, r) {
      var n = this;
      if (r)
        this.generateUserSources(e, r);
      else {
        var i = ["webm", "mp4", "ogv"];
        i.forEach(function(o) {
          n.appendSourceTag(Cr(e), o);
        });
      }
    }, t.prototype.generateUserSources = function(e, r) {
      var n = this;
      r.map(function(i) {
        var o = i.type, s = i.codecs, a = i.transcode;
        return n.appendSourceTag(Cr(e).transcode(a), o, n.buildMimeType(o, s));
      });
    }, t.prototype.appendSourceTag = function(e, r, n) {
      var i, o = document.createElement("source"), s = (i = this.videoOptions) === null || i === void 0 ? void 0 : i.useFetchFormat;
      s && e.format(r);
      var a = e.toURL(), u = a.split(la), c = u[1] ? "".concat(la).concat(u[1]) : "", d = s ? "" : ".".concat(r);
      o.src = "".concat(u[0]).concat(d).concat(c), o.type = n || "video/".concat(aa[r] || r), this.videoElement.appendChild(o);
    }, t.prototype.buildMimeType = function(e, r) {
      var n = "".concat(this.mimeType, "/").concat(this.mimeSubTypes[e] || e);
      return r && (n += "; codecs=" + (Array.isArray(r) ? r.join(", ") : r)), n;
    }, t.prototype.setVideoAttributes = function(e, r) {
      var n;
      if (e === void 0 && (e = {}), r === "auto") {
        var i = Cr(this.originalVideo);
        e.poster = i.quality("auto").format("jpg").addTransformation("so_auto").toURL();
      } else
        r && (e.poster = (n = r.toURL) === null || n === void 0 ? void 0 : n.call(r));
      for (var o = 0, s = Object.entries(e); o < s.length; o++) {
        var a = s[o], u = a[0], c = a[1];
        c && this.videoElement.setAttribute(u, u === "poster" ? c : "");
      }
    }, t.prototype.update = function(e, r, n, i, o) {
      var s = this;
      if (e !== this.originalVideo) {
        for (var a = this.videoElement.getElementsByTagName("SOURCE"); a[0]; )
          a[0].parentNode.removeChild(a[0]);
        gi(this.videoElement, e, n, this.htmlPluginState).then(function() {
          s.setVideoAttributes(i, o), s.handleSourceToVideo(e, r), s.videoElement.load();
        });
      }
    }, t;
  }()
), hf = "Expected a function", ua = 0 / 0, mf = "[object Symbol]", vf = /^\s+|\s+$/g, gf = /^[-+]0x[0-9a-f]+$/i, yf = /^0b[01]+$/i, wf = /^0o[0-7]+$/i, bf = parseInt, xf = typeof or == "object" && or && or.Object === Object && or, _f = typeof self == "object" && self && self.Object === Object && self, Sf = xf || _f || Function("return this")(), Ef = Object.prototype, Tf = Ef.toString, Cf = Math.max, Of = Math.min, ho = function() {
  return Sf.Date.now();
};
function Pf(t, e, r) {
  var n, i, o, s, a, u, c = 0, d = !1, f = !1, v = !0;
  if (typeof t != "function")
    throw new TypeError(hf);
  e = ca(e) || 0, jo(r) && (d = !!r.leading, f = "maxWait" in r, o = f ? Cf(ca(r.maxWait) || 0, e) : o, v = "trailing" in r ? !!r.trailing : v);
  function g(M) {
    var H = n, R = i;
    return n = i = void 0, c = M, s = t.apply(R, H), s;
  }
  function y(M) {
    return c = M, a = setTimeout(_, e), d ? g(M) : s;
  }
  function E(M) {
    var H = M - u, R = M - c, q = e - H;
    return f ? Of(q, o - R) : q;
  }
  function S(M) {
    var H = M - u, R = M - c;
    return u === void 0 || H >= e || H < 0 || f && R >= o;
  }
  function _() {
    var M = ho();
    if (S(M))
      return O(M);
    a = setTimeout(_, E(M));
  }
  function O(M) {
    return a = void 0, v && n ? g(M) : (n = i = void 0, s);
  }
  function T() {
    a !== void 0 && clearTimeout(a), c = 0, n = u = i = a = void 0;
  }
  function P() {
    return a === void 0 ? s : O(ho());
  }
  function x() {
    var M = ho(), H = S(M);
    if (n = arguments, i = this, u = M, H) {
      if (a === void 0)
        return y(u);
      if (f)
        return a = setTimeout(_, e), g(u);
    }
    return a === void 0 && (a = setTimeout(_, e)), s;
  }
  return x.cancel = T, x.flush = P, x;
}
function jo(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function Mf(t) {
  return !!t && typeof t == "object";
}
function Af(t) {
  return typeof t == "symbol" || Mf(t) && Tf.call(t) == mf;
}
function ca(t) {
  if (typeof t == "number")
    return t;
  if (Af(t))
    return ua;
  if (jo(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = jo(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(vf, "");
  var r = yf.test(t);
  return r || wf.test(t) ? bf(t.slice(2), r ? 2 : 8) : gf.test(t) ? ua : +t;
}
var Nf = Pf;
function Rf(t) {
  return typeof t == "number";
}
function Vl() {
  return typeof window < "u";
}
function Lf(t) {
  return t instanceof HTMLImageElement;
}
var $f = {
  accessibility: !1,
  lazyload: !1,
  placeholder: !1,
  responsive: !1
}, If = function(t) {
  return t.replace("bound ", "").replace("Plugin", "");
}, kf = function(t, e) {
  t === void 0 && (t = []);
  var r = t.reduce(function(n, i) {
    var o, s = i.name;
    return Hn(Hn({}, n), (o = {}, o[If(s)] = !0, o));
  }, $f);
  return r[e];
};
function st(t) {
  var e = t === void 0 ? {} : t, r = e.steps;
  return jf.bind(null, r);
}
function jf(t, e, r, n, i, o) {
  if (!Vl())
    return !0;
  if (Lf(e))
    return new Promise(function(s) {
      n.cleanupCallbacks.push(function() {
        window.removeEventListener("resize", c), s("canceled");
      });
      var a = Io(i, { responsive: !0 });
      r.addAction(new gt().setActionTag("responsive"));
      var u = !kf(o, "placeholder");
      u ? da(t, e, r, a) : Hl(t, e, r);
      var c;
      n.pluginEventSubscription.push(function() {
        window.addEventListener("resize", c = Nf(function() {
          da(t, e, r, a);
        }, 100));
      }), s({ responsive: !0 });
    });
}
function da(t, e, r, n) {
  Hl(t, e, r), e.src = r.toURL(n);
}
function Hl(t, e, r) {
  var n = e.parentElement.clientWidth;
  if (Rf(t)) {
    var i = t;
    n = Math.ceil(n / i) * i;
  } else
    Array.isArray(t) && (n = t.reduce(function(o, s) {
      return Math.abs(s - n) < Math.abs(o - n) ? s : o;
    }));
  r.transformation.actions.forEach(function(o, s) {
    o instanceof gt && o.getActionTag() === "responsive" && (r.transformation.actions[s] = af(n).setActionTag("responsive"));
  });
}
function Df(t, e, r) {
  var n = Cr(e);
  if (t)
    for (var i = 0; i < t.length; i++) {
      var o = t[i](null, n);
      if (!o)
        break;
    }
  return n.toURL(r ? { trackedAnalytics: r } : null);
}
function yi(t) {
  t.cleanupCallbacks.forEach(function(e) {
    e();
  });
}
var Do = function(t, e) {
  return Do = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Do(t, e);
};
function Bl(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Do(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var Bn = function() {
  return Bn = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, Bn.apply(this, arguments);
};
function Wl(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
}
var Wn = { exports: {} }, Te = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var fa = Object.getOwnPropertySymbols, Ff = Object.prototype.hasOwnProperty, zf = Object.prototype.propertyIsEnumerable;
function Vf(t) {
  if (t == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}
function Hf() {
  try {
    if (!Object.assign)
      return !1;
    var t = new String("abc");
    if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5")
      return !1;
    for (var e = {}, r = 0; r < 10; r++)
      e["_" + String.fromCharCode(r)] = r;
    var n = Object.getOwnPropertyNames(e).map(function(o) {
      return e[o];
    });
    if (n.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(o) {
      i[o] = o;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var Gl = Hf() ? Object.assign : function(t, e) {
  for (var r, n = Vf(t), i, o = 1; o < arguments.length; o++) {
    r = Object(arguments[o]);
    for (var s in r)
      Ff.call(r, s) && (n[s] = r[s]);
    if (fa) {
      i = fa(r);
      for (var a = 0; a < i.length; a++)
        zf.call(r, i[a]) && (n[i[a]] = r[i[a]]);
    }
  }
  return n;
};
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vs = Gl, Ot = typeof Symbol == "function" && Symbol.for, Jn = Ot ? Symbol.for("react.element") : 60103, Bf = Ot ? Symbol.for("react.portal") : 60106, Wf = Ot ? Symbol.for("react.fragment") : 60107, Gf = Ot ? Symbol.for("react.strict_mode") : 60108, Uf = Ot ? Symbol.for("react.profiler") : 60114, qf = Ot ? Symbol.for("react.provider") : 60109, Yf = Ot ? Symbol.for("react.context") : 60110, Qf = Ot ? Symbol.for("react.forward_ref") : 60112, Jf = Ot ? Symbol.for("react.suspense") : 60113, Kf = Ot ? Symbol.for("react.memo") : 60115, Xf = Ot ? Symbol.for("react.lazy") : 60116, pa = typeof Symbol == "function" && Symbol.iterator;
function Kn(t) {
  for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, r = 1; r < arguments.length; r++)
    e += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var Ul = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, ql = {};
function Yr(t, e, r) {
  this.props = t, this.context = e, this.refs = ql, this.updater = r || Ul;
}
Yr.prototype.isReactComponent = {};
Yr.prototype.setState = function(t, e) {
  if (typeof t != "object" && typeof t != "function" && t != null)
    throw Error(Kn(85));
  this.updater.enqueueSetState(this, t, e, "setState");
};
Yr.prototype.forceUpdate = function(t) {
  this.updater.enqueueForceUpdate(this, t, "forceUpdate");
};
function Yl() {
}
Yl.prototype = Yr.prototype;
function gs(t, e, r) {
  this.props = t, this.context = e, this.refs = ql, this.updater = r || Ul;
}
var ys = gs.prototype = new Yl();
ys.constructor = gs;
vs(ys, Yr.prototype);
ys.isPureReactComponent = !0;
var ws = { current: null }, Ql = Object.prototype.hasOwnProperty, Jl = { key: !0, ref: !0, __self: !0, __source: !0 };
function Kl(t, e, r) {
  var n, i = {}, o = null, s = null;
  if (e != null)
    for (n in e.ref !== void 0 && (s = e.ref), e.key !== void 0 && (o = "" + e.key), e)
      Ql.call(e, n) && !Jl.hasOwnProperty(n) && (i[n] = e[n]);
  var a = arguments.length - 2;
  if (a === 1)
    i.children = r;
  else if (1 < a) {
    for (var u = Array(a), c = 0; c < a; c++)
      u[c] = arguments[c + 2];
    i.children = u;
  }
  if (t && t.defaultProps)
    for (n in a = t.defaultProps, a)
      i[n] === void 0 && (i[n] = a[n]);
  return { $$typeof: Jn, type: t, key: o, ref: s, props: i, _owner: ws.current };
}
function Zf(t, e) {
  return { $$typeof: Jn, type: t.type, key: e, ref: t.ref, props: t.props, _owner: t._owner };
}
function bs(t) {
  return typeof t == "object" && t !== null && t.$$typeof === Jn;
}
function ep(t) {
  var e = { "=": "=0", ":": "=2" };
  return "$" + ("" + t).replace(/[=:]/g, function(r) {
    return e[r];
  });
}
var Xl = /\/+/g, wi = [];
function Zl(t, e, r, n) {
  if (wi.length) {
    var i = wi.pop();
    return i.result = t, i.keyPrefix = e, i.func = r, i.context = n, i.count = 0, i;
  }
  return { result: t, keyPrefix: e, func: r, context: n, count: 0 };
}
function eu(t) {
  t.result = null, t.keyPrefix = null, t.func = null, t.context = null, t.count = 0, 10 > wi.length && wi.push(t);
}
function Fo(t, e, r, n) {
  var i = typeof t;
  (i === "undefined" || i === "boolean") && (t = null);
  var o = !1;
  if (t === null)
    o = !0;
  else
    switch (i) {
      case "string":
      case "number":
        o = !0;
        break;
      case "object":
        switch (t.$$typeof) {
          case Jn:
          case Bf:
            o = !0;
        }
    }
  if (o)
    return r(n, t, e === "" ? "." + mo(t, 0) : e), 1;
  if (o = 0, e = e === "" ? "." : e + ":", Array.isArray(t))
    for (var s = 0; s < t.length; s++) {
      i = t[s];
      var a = e + mo(i, s);
      o += Fo(i, a, r, n);
    }
  else if (t === null || typeof t != "object" ? a = null : (a = pa && t[pa] || t["@@iterator"], a = typeof a == "function" ? a : null), typeof a == "function")
    for (t = a.call(t), s = 0; !(i = t.next()).done; )
      i = i.value, a = e + mo(i, s++), o += Fo(i, a, r, n);
  else if (i === "object")
    throw r = "" + t, Error(Kn(31, r === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, ""));
  return o;
}
function zo(t, e, r) {
  return t == null ? 0 : Fo(t, "", e, r);
}
function mo(t, e) {
  return typeof t == "object" && t !== null && t.key != null ? ep(t.key) : e.toString(36);
}
function tp(t, e) {
  t.func.call(t.context, e, t.count++);
}
function rp(t, e, r) {
  var n = t.result, i = t.keyPrefix;
  t = t.func.call(t.context, e, t.count++), Array.isArray(t) ? Vo(t, n, r, function(o) {
    return o;
  }) : t != null && (bs(t) && (t = Zf(t, i + (!t.key || e && e.key === t.key ? "" : ("" + t.key).replace(Xl, "$&/") + "/") + r)), n.push(t));
}
function Vo(t, e, r, n, i) {
  var o = "";
  r != null && (o = ("" + r).replace(Xl, "$&/") + "/"), e = Zl(e, o, n, i), zo(t, rp, e), eu(e);
}
var tu = { current: null };
function Xt() {
  var t = tu.current;
  if (t === null)
    throw Error(Kn(321));
  return t;
}
var np = { ReactCurrentDispatcher: tu, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: ws, IsSomeRendererActing: { current: !1 }, assign: vs };
Te.Children = { map: function(t, e, r) {
  if (t == null)
    return t;
  var n = [];
  return Vo(t, n, null, e, r), n;
}, forEach: function(t, e, r) {
  if (t == null)
    return t;
  e = Zl(null, null, e, r), zo(t, tp, e), eu(e);
}, count: function(t) {
  return zo(t, function() {
    return null;
  }, null);
}, toArray: function(t) {
  var e = [];
  return Vo(t, e, null, function(r) {
    return r;
  }), e;
}, only: function(t) {
  if (!bs(t))
    throw Error(Kn(143));
  return t;
} };
Te.Component = Yr;
Te.Fragment = Wf;
Te.Profiler = Uf;
Te.PureComponent = gs;
Te.StrictMode = Gf;
Te.Suspense = Jf;
Te.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = np;
Te.cloneElement = function(t, e, r) {
  if (t == null)
    throw Error(Kn(267, t));
  var n = vs({}, t.props), i = t.key, o = t.ref, s = t._owner;
  if (e != null) {
    if (e.ref !== void 0 && (o = e.ref, s = ws.current), e.key !== void 0 && (i = "" + e.key), t.type && t.type.defaultProps)
      var a = t.type.defaultProps;
    for (u in e)
      Ql.call(e, u) && !Jl.hasOwnProperty(u) && (n[u] = e[u] === void 0 && a !== void 0 ? a[u] : e[u]);
  }
  var u = arguments.length - 2;
  if (u === 1)
    n.children = r;
  else if (1 < u) {
    a = Array(u);
    for (var c = 0; c < u; c++)
      a[c] = arguments[c + 2];
    n.children = a;
  }
  return {
    $$typeof: Jn,
    type: t.type,
    key: i,
    ref: o,
    props: n,
    _owner: s
  };
};
Te.createContext = function(t, e) {
  return e === void 0 && (e = null), t = { $$typeof: Yf, _calculateChangedBits: e, _currentValue: t, _currentValue2: t, _threadCount: 0, Provider: null, Consumer: null }, t.Provider = { $$typeof: qf, _context: t }, t.Consumer = t;
};
Te.createElement = Kl;
Te.createFactory = function(t) {
  var e = Kl.bind(null, t);
  return e.type = t, e;
};
Te.createRef = function() {
  return { current: null };
};
Te.forwardRef = function(t) {
  return { $$typeof: Qf, render: t };
};
Te.isValidElement = bs;
Te.lazy = function(t) {
  return { $$typeof: Xf, _ctor: t, _status: -1, _result: null };
};
Te.memo = function(t, e) {
  return { $$typeof: Kf, type: t, compare: e === void 0 ? null : e };
};
Te.useCallback = function(t, e) {
  return Xt().useCallback(t, e);
};
Te.useContext = function(t, e) {
  return Xt().useContext(t, e);
};
Te.useDebugValue = function() {
};
Te.useEffect = function(t, e) {
  return Xt().useEffect(t, e);
};
Te.useImperativeHandle = function(t, e, r) {
  return Xt().useImperativeHandle(t, e, r);
};
Te.useLayoutEffect = function(t, e) {
  return Xt().useLayoutEffect(t, e);
};
Te.useMemo = function(t, e) {
  return Xt().useMemo(t, e);
};
Te.useReducer = function(t, e, r) {
  return Xt().useReducer(t, e, r);
};
Te.useRef = function(t) {
  return Xt().useRef(t);
};
Te.useState = function(t) {
  return Xt().useState(t);
};
Te.version = "16.14.0";
var Se = {}, ip = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", op = ip, sp = Function.call.bind(Object.prototype.hasOwnProperty), Ho = function() {
};
if (process.env.NODE_ENV !== "production") {
  var ap = op, Bo = {}, lp = sp;
  Ho = function(t) {
    var e = "Warning: " + t;
    typeof console < "u" && console.error(e);
    try {
      throw new Error(e);
    } catch {
    }
  };
}
function ru(t, e, r, n, i) {
  if (process.env.NODE_ENV !== "production") {
    for (var o in t)
      if (lp(t, o)) {
        var s;
        try {
          if (typeof t[o] != "function") {
            var a = Error(
              (n || "React class") + ": " + r + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
            );
            throw a.name = "Invariant Violation", a;
          }
          s = t[o](e, o, n, r, null, ap);
        } catch (c) {
          s = c;
        }
        if (s && !(s instanceof Error) && Ho(
          (n || "React class") + ": type specification of " + r + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
        ), s instanceof Error && !(s.message in Bo)) {
          Bo[s.message] = !0;
          var u = i ? i() : "";
          Ho(
            "Failed " + r + " type: " + s.message + (u ?? "")
          );
        }
      }
  }
}
ru.resetWarningCache = function() {
  process.env.NODE_ENV !== "production" && (Bo = {});
};
var up = ru;
/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
process.env.NODE_ENV !== "production" && function() {
  var t = Gl, e = up, r = "16.14.0", n = typeof Symbol == "function" && Symbol.for, i = n ? Symbol.for("react.element") : 60103, o = n ? Symbol.for("react.portal") : 60106, s = n ? Symbol.for("react.fragment") : 60107, a = n ? Symbol.for("react.strict_mode") : 60108, u = n ? Symbol.for("react.profiler") : 60114, c = n ? Symbol.for("react.provider") : 60109, d = n ? Symbol.for("react.context") : 60110, f = n ? Symbol.for("react.concurrent_mode") : 60111, v = n ? Symbol.for("react.forward_ref") : 60112, g = n ? Symbol.for("react.suspense") : 60113, y = n ? Symbol.for("react.suspense_list") : 60120, E = n ? Symbol.for("react.memo") : 60115, S = n ? Symbol.for("react.lazy") : 60116, _ = n ? Symbol.for("react.block") : 60121, O = n ? Symbol.for("react.fundamental") : 60117, T = n ? Symbol.for("react.responder") : 60118, P = n ? Symbol.for("react.scope") : 60119, x = typeof Symbol == "function" && Symbol.iterator, M = "@@iterator";
  function H(p) {
    if (p === null || typeof p != "object")
      return null;
    var C = x && p[x] || p[M];
    return typeof C == "function" ? C : null;
  }
  var R = {
    /**
     * @internal
     * @type {ReactComponent}
     */
    current: null
  }, q = {
    suspense: null
  }, K = {
    /**
     * @internal
     * @type {ReactComponent}
     */
    current: null
  }, k = /^(.*)[\\\/]/;
  function V(p, C, A) {
    var D = "";
    if (C) {
      var U = C.fileName, de = U.replace(k, "");
      if (/^index\./.test(de)) {
        var Z = U.match(k);
        if (Z) {
          var ee = Z[1];
          if (ee) {
            var Oe = ee.replace(k, "");
            de = Oe + "/" + de;
          }
        }
      }
      D = " (at " + de + ":" + C.lineNumber + ")";
    } else
      A && (D = " (created by " + A + ")");
    return `
    in ` + (p || "Unknown") + D;
  }
  var Q = 1;
  function re(p) {
    return p._status === Q ? p._result : null;
  }
  function ve(p, C, A) {
    var D = C.displayName || C.name || "";
    return p.displayName || (D !== "" ? A + "(" + D + ")" : A);
  }
  function Y(p) {
    if (p == null)
      return null;
    if (typeof p.tag == "number" && z("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof p == "function")
      return p.displayName || p.name || null;
    if (typeof p == "string")
      return p;
    switch (p) {
      case s:
        return "Fragment";
      case o:
        return "Portal";
      case u:
        return "Profiler";
      case a:
        return "StrictMode";
      case g:
        return "Suspense";
      case y:
        return "SuspenseList";
    }
    if (typeof p == "object")
      switch (p.$$typeof) {
        case d:
          return "Context.Consumer";
        case c:
          return "Context.Provider";
        case v:
          return ve(p, p.render, "ForwardRef");
        case E:
          return Y(p.type);
        case _:
          return Y(p.render);
        case S: {
          var C = p, A = re(C);
          if (A)
            return Y(A);
          break;
        }
      }
    return null;
  }
  var le = {}, j = null;
  function N(p) {
    j = p;
  }
  le.getCurrentStack = null, le.getStackAddendum = function() {
    var p = "";
    if (j) {
      var C = Y(j.type), A = j._owner;
      p += V(C, j._source, A && Y(A.type));
    }
    var D = le.getCurrentStack;
    return D && (p += D() || ""), p;
  };
  var w = {
    current: !1
  }, $ = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: q,
    ReactCurrentOwner: K,
    IsSomeRendererActing: w,
    // Used by renderers to avoid bundling object-assign twice in UMD bundles:
    assign: t
  };
  t($, {
    // These should not be included in production.
    ReactDebugCurrentFrame: le,
    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
    // TODO: remove in React 17.0.
    ReactComponentTreeHook: {}
  });
  function F(p) {
    {
      for (var C = arguments.length, A = new Array(C > 1 ? C - 1 : 0), D = 1; D < C; D++)
        A[D - 1] = arguments[D];
      G("warn", p, A);
    }
  }
  function z(p) {
    {
      for (var C = arguments.length, A = new Array(C > 1 ? C - 1 : 0), D = 1; D < C; D++)
        A[D - 1] = arguments[D];
      G("error", p, A);
    }
  }
  function G(p, C, A) {
    {
      var D = A.length > 0 && typeof A[A.length - 1] == "string" && A[A.length - 1].indexOf(`
    in`) === 0;
      if (!D) {
        var U = $.ReactDebugCurrentFrame, de = U.getStackAddendum();
        de !== "" && (C += "%s", A = A.concat([de]));
      }
      var Z = A.map(function(xe) {
        return "" + xe;
      });
      Z.unshift("Warning: " + C), Function.prototype.apply.call(console[p], console, Z);
      try {
        var ee = 0, Oe = "Warning: " + C.replace(/%s/g, function() {
          return A[ee++];
        });
        throw new Error(Oe);
      } catch {
      }
    }
  }
  var X = {};
  function J(p, C) {
    {
      var A = p.constructor, D = A && (A.displayName || A.name) || "ReactClass", U = D + "." + C;
      if (X[U])
        return;
      z("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", C, D), X[U] = !0;
    }
  }
  var te = {
    /**
     * Checks whether or not this composite component is mounted.
     * @param {ReactClass} publicInstance The instance we want to test.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function(p) {
      return !1;
    },
    /**
     * Forces an update. This should only be invoked when it is known with
     * certainty that we are **not** in a DOM transaction.
     *
     * You may want to call this when you know that some deeper aspect of the
     * component's state has changed but `setState` was not called.
     *
     * This will not invoke `shouldComponentUpdate`, but it will invoke
     * `componentWillUpdate` and `componentDidUpdate`.
     *
     * @param {ReactClass} publicInstance The instance that should rerender.
     * @param {?function} callback Called after component is updated.
     * @param {?string} callerName name of the calling function in the public API.
     * @internal
     */
    enqueueForceUpdate: function(p, C, A) {
      J(p, "forceUpdate");
    },
    /**
     * Replaces all of the state. Always use this or `setState` to mutate state.
     * You should treat `this.state` as immutable.
     *
     * There is no guarantee that `this.state` will be immediately updated, so
     * accessing `this.state` after calling this method may return the old value.
     *
     * @param {ReactClass} publicInstance The instance that should rerender.
     * @param {object} completeState Next state.
     * @param {?function} callback Called after component is updated.
     * @param {?string} callerName name of the calling function in the public API.
     * @internal
     */
    enqueueReplaceState: function(p, C, A, D) {
      J(p, "replaceState");
    },
    /**
     * Sets a subset of the state. This only exists because _pendingState is
     * internal. This provides a merging strategy that is not available to deep
     * properties which is confusing. TODO: Expose pendingState or don't use it
     * during the merge.
     *
     * @param {ReactClass} publicInstance The instance that should rerender.
     * @param {object} partialState Next partial state to be merged with state.
     * @param {?function} callback Called after component is updated.
     * @param {?string} Name of the calling function in the public API.
     * @internal
     */
    enqueueSetState: function(p, C, A, D) {
      J(p, "setState");
    }
  }, ae = {};
  Object.freeze(ae);
  function oe(p, C, A) {
    this.props = p, this.context = C, this.refs = ae, this.updater = A || te;
  }
  oe.prototype.isReactComponent = {}, oe.prototype.setState = function(p, C) {
    if (!(typeof p == "object" || typeof p == "function" || p == null))
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, p, C, "setState");
  }, oe.prototype.forceUpdate = function(p) {
    this.updater.enqueueForceUpdate(this, p, "forceUpdate");
  };
  {
    var ie = {
      isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
      replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
    }, Ne = function(p, C) {
      Object.defineProperty(oe.prototype, p, {
        get: function() {
          F("%s(...) is deprecated in plain JavaScript React classes. %s", C[0], C[1]);
        }
      });
    };
    for (var B in ie)
      ie.hasOwnProperty(B) && Ne(B, ie[B]);
  }
  function je() {
  }
  je.prototype = oe.prototype;
  function Qe(p, C, A) {
    this.props = p, this.context = C, this.refs = ae, this.updater = A || te;
  }
  var ct = Qe.prototype = new je();
  ct.constructor = Qe, t(ct, oe.prototype), ct.isPureReactComponent = !0;
  function kt() {
    var p = {
      current: null
    };
    return Object.seal(p), p;
  }
  var Pt = Object.prototype.hasOwnProperty, Lr = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  }, $r, dt, yt;
  yt = {};
  function Zt(p) {
    if (Pt.call(p, "ref")) {
      var C = Object.getOwnPropertyDescriptor(p, "ref").get;
      if (C && C.isReactWarning)
        return !1;
    }
    return p.ref !== void 0;
  }
  function er(p) {
    if (Pt.call(p, "key")) {
      var C = Object.getOwnPropertyDescriptor(p, "key").get;
      if (C && C.isReactWarning)
        return !1;
    }
    return p.key !== void 0;
  }
  function Ie(p, C) {
    var A = function() {
      $r || ($r = !0, z("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", C));
    };
    A.isReactWarning = !0, Object.defineProperty(p, "key", {
      get: A,
      configurable: !0
    });
  }
  function wt(p, C) {
    var A = function() {
      dt || (dt = !0, z("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", C));
    };
    A.isReactWarning = !0, Object.defineProperty(p, "ref", {
      get: A,
      configurable: !0
    });
  }
  function Kr(p) {
    if (typeof p.ref == "string" && K.current && p.__self && K.current.stateNode !== p.__self) {
      var C = Y(K.current.type);
      yt[C] || (z('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref', Y(K.current.type), p.ref), yt[C] = !0);
    }
  }
  var jt = function(p, C, A, D, U, de, Z) {
    var ee = {
      // This tag allows us to uniquely identify this as a React Element
      $$typeof: i,
      // Built-in properties that belong on the element
      type: p,
      key: C,
      ref: A,
      props: Z,
      // Record the component responsible for creating this element.
      _owner: de
    };
    return ee._store = {}, Object.defineProperty(ee._store, "validated", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: !1
    }), Object.defineProperty(ee, "_self", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: D
    }), Object.defineProperty(ee, "_source", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: U
    }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
  };
  function pr(p, C, A) {
    var D, U = {}, de = null, Z = null, ee = null, Oe = null;
    if (C != null) {
      Zt(C) && (Z = C.ref, Kr(C)), er(C) && (de = "" + C.key), ee = C.__self === void 0 ? null : C.__self, Oe = C.__source === void 0 ? null : C.__source;
      for (D in C)
        Pt.call(C, D) && !Lr.hasOwnProperty(D) && (U[D] = C[D]);
    }
    var xe = arguments.length - 2;
    if (xe === 1)
      U.children = A;
    else if (xe > 1) {
      for (var ze = Array(xe), Fe = 0; Fe < xe; Fe++)
        ze[Fe] = arguments[Fe + 2];
      Object.freeze && Object.freeze(ze), U.children = ze;
    }
    if (p && p.defaultProps) {
      var bt = p.defaultProps;
      for (D in bt)
        U[D] === void 0 && (U[D] = bt[D]);
    }
    if (de || Z) {
      var Ke = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
      de && Ie(U, Ke), Z && wt(U, Ke);
    }
    return jt(p, de, Z, ee, Oe, K.current, U);
  }
  function hr(p, C) {
    var A = jt(p.type, C, p.ref, p._self, p._source, p._owner, p.props);
    return A;
  }
  function Xr(p, C, A) {
    if (p == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + p + ".");
    var D, U = t({}, p.props), de = p.key, Z = p.ref, ee = p._self, Oe = p._source, xe = p._owner;
    if (C != null) {
      Zt(C) && (Z = C.ref, xe = K.current), er(C) && (de = "" + C.key);
      var ze;
      p.type && p.type.defaultProps && (ze = p.type.defaultProps);
      for (D in C)
        Pt.call(C, D) && !Lr.hasOwnProperty(D) && (C[D] === void 0 && ze !== void 0 ? U[D] = ze[D] : U[D] = C[D]);
    }
    var Fe = arguments.length - 2;
    if (Fe === 1)
      U.children = A;
    else if (Fe > 1) {
      for (var bt = Array(Fe), Ke = 0; Ke < Fe; Ke++)
        bt[Ke] = arguments[Ke + 2];
      U.children = bt;
    }
    return jt(p.type, de, Z, ee, Oe, xe, U);
  }
  function Mt(p) {
    return typeof p == "object" && p !== null && p.$$typeof === i;
  }
  var Ir = ".", Zr = ":";
  function mr(p) {
    var C = /[=:]/g, A = {
      "=": "=0",
      ":": "=2"
    }, D = ("" + p).replace(C, function(U) {
      return A[U];
    });
    return "$" + D;
  }
  var kr = !1, en = /\/+/g;
  function At(p) {
    return ("" + p).replace(en, "$&/");
  }
  var tt = 10, ft = [];
  function Nt(p, C, A, D) {
    if (ft.length) {
      var U = ft.pop();
      return U.result = p, U.keyPrefix = C, U.func = A, U.context = D, U.count = 0, U;
    } else
      return {
        result: p,
        keyPrefix: C,
        func: A,
        context: D,
        count: 0
      };
  }
  function Rt(p) {
    p.result = null, p.keyPrefix = null, p.func = null, p.context = null, p.count = 0, ft.length < tt && ft.push(p);
  }
  function Be(p, C, A, D) {
    var U = typeof p;
    (U === "undefined" || U === "boolean") && (p = null);
    var de = !1;
    if (p === null)
      de = !0;
    else
      switch (U) {
        case "string":
        case "number":
          de = !0;
          break;
        case "object":
          switch (p.$$typeof) {
            case i:
            case o:
              de = !0;
          }
      }
    if (de)
      return A(
        D,
        p,
        // If it's the only child, treat the name as if it was wrapped in an array
        // so that it's consistent if the number of children grows.
        C === "" ? Ir + gr(p, 0) : C
      ), 1;
    var Z, ee, Oe = 0, xe = C === "" ? Ir : C + Zr;
    if (Array.isArray(p))
      for (var ze = 0; ze < p.length; ze++)
        Z = p[ze], ee = xe + gr(Z, ze), Oe += Be(Z, ee, A, D);
    else {
      var Fe = H(p);
      if (typeof Fe == "function") {
        Fe === p.entries && (kr || F("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead."), kr = !0);
        for (var bt = Fe.call(p), Ke, Mn = 0; !(Ke = bt.next()).done; )
          Z = Ke.value, ee = xe + gr(Z, Mn++), Oe += Be(Z, ee, A, D);
      } else if (U === "object") {
        var Br = "";
        Br = " If you meant to render a collection of children, use an array instead." + le.getStackAddendum();
        var rr = "" + p;
        throw Error("Objects are not valid as a React child (found: " + (rr === "[object Object]" ? "object with keys {" + Object.keys(p).join(", ") + "}" : rr) + ")." + Br);
      }
    }
    return Oe;
  }
  function vr(p, C, A) {
    return p == null ? 0 : Be(p, "", C, A);
  }
  function gr(p, C) {
    return typeof p == "object" && p !== null && p.key != null ? mr(p.key) : C.toString(36);
  }
  function tn(p, C, A) {
    var D = p.func, U = p.context;
    D.call(U, C, p.count++);
  }
  function rn(p, C, A) {
    if (p == null)
      return p;
    var D = Nt(null, null, C, A);
    vr(p, tn, D), Rt(D);
  }
  function nn(p, C, A) {
    var D = p.result, U = p.keyPrefix, de = p.func, Z = p.context, ee = de.call(Z, C, p.count++);
    Array.isArray(ee) ? Dt(ee, D, A, function(Oe) {
      return Oe;
    }) : ee != null && (Mt(ee) && (ee = hr(
      ee,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      U + (ee.key && (!C || C.key !== ee.key) ? At(ee.key) + "/" : "") + A
    )), D.push(ee));
  }
  function Dt(p, C, A, D, U) {
    var de = "";
    A != null && (de = At(A) + "/");
    var Z = Nt(C, de, D, U);
    vr(p, nn, Z), Rt(Z);
  }
  function yr(p, C, A) {
    if (p == null)
      return p;
    var D = [];
    return Dt(p, D, null, C, A), D;
  }
  function De(p) {
    return vr(p, function() {
      return null;
    }, null);
  }
  function on(p) {
    var C = [];
    return Dt(p, C, null, function(A) {
      return A;
    }), C;
  }
  function sn(p) {
    if (!Mt(p))
      throw Error("React.Children.only expected to receive a single React element child.");
    return p;
  }
  function an(p, C) {
    C === void 0 ? C = null : C !== null && typeof C != "function" && z("createContext: Expected the optional second argument to be a function. Instead received: %s", C);
    var A = {
      $$typeof: d,
      _calculateChangedBits: C,
      // As a workaround to support multiple concurrent renderers, we categorize
      // some renderers as primary and others as secondary. We only expect
      // there to be two concurrent renderers at most: React Native (primary) and
      // Fabric (secondary); React DOM (primary) and React ART (secondary).
      // Secondary renderers store their context values on separate fields.
      _currentValue: p,
      _currentValue2: p,
      // Used to track how many concurrent renderers this context currently
      // supports within in a single renderer. Such as parallel server rendering.
      _threadCount: 0,
      // These are circular
      Provider: null,
      Consumer: null
    };
    A.Provider = {
      $$typeof: c,
      _context: A
    };
    var D = !1, U = !1;
    {
      var de = {
        $$typeof: d,
        _context: A,
        _calculateChangedBits: A._calculateChangedBits
      };
      Object.defineProperties(de, {
        Provider: {
          get: function() {
            return U || (U = !0, z("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), A.Provider;
          },
          set: function(Z) {
            A.Provider = Z;
          }
        },
        _currentValue: {
          get: function() {
            return A._currentValue;
          },
          set: function(Z) {
            A._currentValue = Z;
          }
        },
        _currentValue2: {
          get: function() {
            return A._currentValue2;
          },
          set: function(Z) {
            A._currentValue2 = Z;
          }
        },
        _threadCount: {
          get: function() {
            return A._threadCount;
          },
          set: function(Z) {
            A._threadCount = Z;
          }
        },
        Consumer: {
          get: function() {
            return D || (D = !0, z("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), A.Consumer;
          }
        }
      }), A.Consumer = de;
    }
    return A._currentRenderer = null, A._currentRenderer2 = null, A;
  }
  function ln(p) {
    var C = {
      $$typeof: S,
      _ctor: p,
      // React uses these fields to store the result.
      _status: -1,
      _result: null
    };
    {
      var A, D;
      Object.defineProperties(C, {
        defaultProps: {
          configurable: !0,
          get: function() {
            return A;
          },
          set: function(U) {
            z("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), A = U, Object.defineProperty(C, "defaultProps", {
              enumerable: !0
            });
          }
        },
        propTypes: {
          configurable: !0,
          get: function() {
            return D;
          },
          set: function(U) {
            z("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), D = U, Object.defineProperty(C, "propTypes", {
              enumerable: !0
            });
          }
        }
      });
    }
    return C;
  }
  function un(p) {
    return p != null && p.$$typeof === E ? z("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof p != "function" ? z("forwardRef requires a render function but was given %s.", p === null ? "null" : typeof p) : p.length !== 0 && p.length !== 2 && z("forwardRef render functions accept exactly two parameters: props and ref. %s", p.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), p != null && (p.defaultProps != null || p.propTypes != null) && z("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"), {
      $$typeof: v,
      render: p
    };
  }
  function Re(p) {
    return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
    p === s || p === f || p === u || p === a || p === g || p === y || typeof p == "object" && p !== null && (p.$$typeof === S || p.$$typeof === E || p.$$typeof === c || p.$$typeof === d || p.$$typeof === v || p.$$typeof === O || p.$$typeof === T || p.$$typeof === P || p.$$typeof === _);
  }
  function cn(p, C) {
    return Re(p) || z("memo: The first argument must be a component. Instead received: %s", p === null ? "null" : typeof p), {
      $$typeof: E,
      type: p,
      compare: C === void 0 ? null : C
    };
  }
  function Je() {
    var p = R.current;
    if (p === null)
      throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.`);
    return p;
  }
  function dn(p, C) {
    var A = Je();
    if (C !== void 0 && z("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", C, typeof C == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks` : ""), p._context !== void 0) {
      var D = p._context;
      D.Consumer === p ? z("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : D.Provider === p && z("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
    }
    return A.useContext(p, C);
  }
  function fn(p) {
    var C = Je();
    return C.useState(p);
  }
  function pn(p, C, A) {
    var D = Je();
    return D.useReducer(p, C, A);
  }
  function We(p) {
    var C = Je();
    return C.useRef(p);
  }
  function hn(p, C) {
    var A = Je();
    return A.useEffect(p, C);
  }
  function mn(p, C) {
    var A = Je();
    return A.useLayoutEffect(p, C);
  }
  function vn(p, C) {
    var A = Je();
    return A.useCallback(p, C);
  }
  function gn(p, C) {
    var A = Je();
    return A.useMemo(p, C);
  }
  function yn(p, C, A) {
    var D = Je();
    return D.useImperativeHandle(p, C, A);
  }
  function Ge(p, C) {
    {
      var A = Je();
      return A.useDebugValue(p, C);
    }
  }
  var wr;
  wr = !1;
  function jr() {
    if (K.current) {
      var p = Y(K.current.type);
      if (p)
        return `

Check the render method of \`` + p + "`.";
    }
    return "";
  }
  function wn(p) {
    if (p !== void 0) {
      var C = p.fileName.replace(/^.*[\\\/]/, ""), A = p.lineNumber;
      return `

Check your code at ` + C + ":" + A + ".";
    }
    return "";
  }
  function bn(p) {
    return p != null ? wn(p.__source) : "";
  }
  var Dr = {};
  function xn(p) {
    var C = jr();
    if (!C) {
      var A = typeof p == "string" ? p : p.displayName || p.name;
      A && (C = `

Check the top-level render call using <` + A + ">.");
    }
    return C;
  }
  function tr(p, C) {
    if (!(!p._store || p._store.validated || p.key != null)) {
      p._store.validated = !0;
      var A = xn(C);
      if (!Dr[A]) {
        Dr[A] = !0;
        var D = "";
        p && p._owner && p._owner !== K.current && (D = " It was passed a child from " + Y(p._owner.type) + "."), N(p), z('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', A, D), N(null);
      }
    }
  }
  function pt(p, C) {
    if (typeof p == "object") {
      if (Array.isArray(p))
        for (var A = 0; A < p.length; A++) {
          var D = p[A];
          Mt(D) && tr(D, C);
        }
      else if (Mt(p))
        p._store && (p._store.validated = !0);
      else if (p) {
        var U = H(p);
        if (typeof U == "function" && U !== p.entries)
          for (var de = U.call(p), Z; !(Z = de.next()).done; )
            Mt(Z.value) && tr(Z.value, C);
      }
    }
  }
  function Fr(p) {
    {
      var C = p.type;
      if (C == null || typeof C == "string")
        return;
      var A = Y(C), D;
      if (typeof C == "function")
        D = C.propTypes;
      else if (typeof C == "object" && (C.$$typeof === v || // Note: Memo only checks outer props here.
      // Inner props are checked in the reconciler.
      C.$$typeof === E))
        D = C.propTypes;
      else
        return;
      D ? (N(p), e(D, p.props, "prop", A, le.getStackAddendum), N(null)) : C.PropTypes !== void 0 && !wr && (wr = !0, z("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown")), typeof C.getDefaultProps == "function" && !C.getDefaultProps.isReactClassApproved && z("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  function Ft(p) {
    {
      N(p);
      for (var C = Object.keys(p.props), A = 0; A < C.length; A++) {
        var D = C[A];
        if (D !== "children" && D !== "key") {
          z("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", D);
          break;
        }
      }
      p.ref !== null && z("Invalid attribute `ref` supplied to `React.Fragment`."), N(null);
    }
  }
  function zr(p, C, A) {
    var D = Re(p);
    if (!D) {
      var U = "";
      (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (U += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
      var de = bn(C);
      de ? U += de : U += jr();
      var Z;
      p === null ? Z = "null" : Array.isArray(p) ? Z = "array" : p !== void 0 && p.$$typeof === i ? (Z = "<" + (Y(p.type) || "Unknown") + " />", U = " Did you accidentally export a JSX literal instead of a component?") : Z = typeof p, z("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Z, U);
    }
    var ee = pr.apply(this, arguments);
    if (ee == null)
      return ee;
    if (D)
      for (var Oe = 2; Oe < arguments.length; Oe++)
        pt(arguments[Oe], p);
    return p === s ? Ft(ee) : Fr(ee), ee;
  }
  var Vr = !1;
  function _n(p) {
    var C = zr.bind(null, p);
    return C.type = p, Vr || (Vr = !0, F("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(C, "type", {
      enumerable: !1,
      get: function() {
        return F("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
          value: p
        }), p;
      }
    }), C;
  }
  function Sn(p, C, A) {
    for (var D = Xr.apply(this, arguments), U = 2; U < arguments.length; U++)
      pt(arguments[U], D.type);
    return Fr(D), D;
  }
  try {
    var Hr = Object.freeze({}), En = /* @__PURE__ */ new Map([[Hr, null]]), zt = /* @__PURE__ */ new Set([Hr]);
    En.set(0, 0), zt.add(0);
  } catch {
  }
  var Tn = zr, Cn = Sn, On = _n, Pn = {
    map: yr,
    forEach: rn,
    count: De,
    toArray: on,
    only: sn
  };
  Se.Children = Pn, Se.Component = oe, Se.Fragment = s, Se.Profiler = u, Se.PureComponent = Qe, Se.StrictMode = a, Se.Suspense = g, Se.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $, Se.cloneElement = Cn, Se.createContext = an, Se.createElement = Tn, Se.createFactory = On, Se.createRef = kt, Se.forwardRef = un, Se.isValidElement = Mt, Se.lazy = ln, Se.memo = cn, Se.useCallback = vn, Se.useContext = dn, Se.useDebugValue = Ge, Se.useEffect = hn, Se.useImperativeHandle = yn, Se.useLayoutEffect = mn, Se.useMemo = gn, Se.useReducer = pn, Se.useRef = We, Se.useState = fn, Se.version = r;
}();
process.env.NODE_ENV === "production" ? Wn.exports = Te : Wn.exports = Se;
var Wr = Wn.exports, vo = {
  sdkSemver: "1.13.0",
  techVersion: Wr.version,
  sdkCode: "J"
};
(function(t) {
  Bl(e, t);
  function e(r) {
    var n = t.call(this, r) || this;
    return n.imageRef = Wr.createRef(), n;
  }
  return e.prototype.componentDidMount = function() {
    this.htmlLayerInstance = new Fc(this.imageRef.current, this.props.cldImg, this.props.plugins, vo);
  }, e.prototype.componentDidUpdate = function() {
    yi(this.htmlLayerInstance.htmlPluginState), this.htmlLayerInstance.update(this.props.cldImg, this.props.plugins, vo);
  }, e.prototype.componentWillUnmount = function() {
    yi(this.htmlLayerInstance.htmlPluginState), this.htmlLayerInstance.unmount();
  }, e.prototype.render = function() {
    var r = this.props;
    r.cldImg, r.plugins;
    var n = Wl(r, ["cldImg", "plugins"]);
    if (Vl())
      return Wr.createElement("img", Bn({ suppressHydrationWarning: !0 }, n, { ref: this.imageRef }));
    var i = Df(this.props.plugins, this.props.cldImg, vo);
    return Wr.createElement("img", Bn({}, n, { src: i }));
  }, e;
})(Wr.Component);
var cp = ["controls", "loop", "muted", "poster", "preload", "autoplay", "playsinline"];
(function(t) {
  Bl(e, t);
  function e(r) {
    var n = t.call(this, r) || this;
    return n.videoRef = Wn.exports.createRef(), n.attachRef = n.attachRef.bind(n), n;
  }
  return e.prototype.componentDidMount = function() {
    this.htmlVideoLayerInstance = new pf(this.videoRef && this.videoRef.current, this.props.cldVid, this.props.sources, this.props.plugins, this.getVideoAttributes(), this.props.cldPoster, {
      useFetchFormat: this.props.useFetchFormat
    });
  }, e.prototype.componentDidUpdate = function() {
    yi(this.htmlVideoLayerInstance.htmlPluginState), this.htmlVideoLayerInstance.update(this.props.cldVid, this.props.sources, this.props.plugins, this.getVideoAttributes(), this.props.cldPoster);
  }, e.prototype.componentWillUnmount = function() {
    yi(this.htmlVideoLayerInstance.htmlPluginState);
  }, e.prototype.getVideoAttributes = function() {
    var r = this, n = {};
    return cp.forEach(function(i) {
      i in r.props && (n[i] = r.props[i]);
    }), n;
  }, e.prototype.attachRef = function(r) {
    this.videoRef.current = r;
    var n = this.props.innerRef;
    n && (n instanceof Function ? n(r) : n.current = r);
  }, e.prototype.render = function() {
    var r = this.props;
    r.cldVid, r.cldPoster, r.plugins, r.sources, r.innerRef, r.useFetchFormat;
    var n = Wl(r, ["cldVid", "cldPoster", "plugins", "sources", "innerRef", "useFetchFormat"]);
    return Wr.createElement("video", Bn({}, n, { ref: this.attachRef }));
  }, e;
})(Wn.exports.Component);
function nu(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var dp = function t(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var n, i, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length)
        return !1;
      for (i = n; i-- !== 0; )
        if (!t(e[i], r[i]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(r).length)
      return !1;
    for (i = n; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[i]))
        return !1;
    for (i = n; i-- !== 0; ) {
      var s = o[i];
      if (!t(e[s], r[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
};
const fp = /* @__PURE__ */ nu(dp);
function pp(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function hp(t) {
  var e = pp(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Jt() {
  return Jt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Jt.apply(this, arguments);
}
function Xn(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
const Gt = {
  NOT_LOADED: "NOT_LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  FAILED: "FAILED",
  AUTH_FAILURE: "AUTH_FAILURE"
}, mp = "https://maps.googleapis.com/maps/api/js";
class bi {
  /**
   * Loads the Google Maps API with the specified parameters.
   * Since the Maps library can only be loaded once per page, this will
   * produce a warning when called multiple times with different
   * parameters.
   *
   * The returned promise resolves when loading completes
   * and rejects in case of an error or when the loading was aborted.
   */
  static async load(e, r) {
    var n;
    const i = e.libraries ? e.libraries.split(",") : [], o = this.serializeParams(e);
    (n = window.google) != null && (n = n.maps) != null && n.importLibrary ? (this.serializedApiParams || (this.loadingStatus = Gt.LOADED), r(this.loadingStatus)) : (this.serializedApiParams = o, this.initImportLibrary(e, r)), this.serializedApiParams && this.serializedApiParams !== o && console.warn("The maps API has already been loaded with different parameters and will not be loaded again. Refresh the page for new values to have effect.");
    for (const s of ["maps", ...i])
      await google.maps.importLibrary(s);
  }
  static serializeParams(e) {
    return [e.v, e.key, e.language, e.region, e.authReferrerPolicy, e.solutionChannel].join("/");
  }
  static initImportLibrary(e, r) {
    if (window.google || (window.google = {}), window.google.maps || (window.google.maps = {}), window.google.maps.importLibrary) {
      console.warn("initImportLibrary can only be called once.", e);
      return;
    }
    let n = null;
    const i = (o) => n || (n = new Promise((s, a) => {
      var u;
      const c = document.createElement("script"), d = new URLSearchParams();
      for (const [f, v] of Object.entries(e)) {
        const g = f.replace(/[A-Z]/g, (y) => "_" + y[0].toLowerCase());
        d.set(g, v);
      }
      d.set("libraries", o), d.set("loading", "async"), d.set("callback", "__googleMapsCallback__"), c.async = !0, c.src = mp + "?" + d.toString(), window.__googleMapsCallback__ = () => {
        this.loadingStatus = Gt.LOADED, r(this.loadingStatus), s();
      }, window.gm_authFailure = () => {
        this.loadingStatus = Gt.AUTH_FAILURE, r(this.loadingStatus);
      }, c.onerror = () => {
        this.loadingStatus = Gt.FAILED, r(this.loadingStatus), a(new Error("The Google Maps JavaScript API could not load."));
      }, c.nonce = ((u = document.querySelector("script[nonce]")) == null ? void 0 : u.nonce) || "", this.loadingStatus = Gt.LOADING, r(this.loadingStatus), document.head.append(c);
    }), n);
    google.maps.importLibrary = (o) => i(o).then(() => google.maps.importLibrary(o));
  }
}
bi.loadingStatus = Gt.NOT_LOADED;
bi.serializedApiParams = void 0;
const vp = ["onLoad", "apiKey", "version", "libraries"], gp = ["children"], ji = W.createContext(null);
function yp() {
  const [t, e] = ye({});
  return {
    mapInstances: t,
    addMapInstance: (r, n = "default") => {
      e((i) => Jt({}, i, {
        [n]: r
      }));
    },
    removeMapInstance: (r = "default") => {
      e((n) => Xn(n, [r].map(hp)));
    },
    clearMapInstances: () => {
      e({});
    }
  };
}
function wp(t) {
  const {
    onLoad: e,
    apiKey: r,
    version: n,
    libraries: i = []
  } = t, o = Xn(t, vp), [s, a] = ye(bi.loadingStatus), [u, c] = Ai((g, y) => Jt({}, g, {
    [y.name]: y.value
  }), {}), d = Pe(() => i == null ? void 0 : i.join(","), [i]), f = Pe(() => JSON.stringify(Jt({
    apiKey: r,
    version: n
  }, o)), [r, n, o]), v = Tr(async (g) => {
    var y;
    if (u[g])
      return u[g];
    if (!((y = google) != null && (y = y.maps) != null && y.importLibrary))
      throw new Error("[api-provider-internal] importLibrary was called before google.maps.importLibrary was defined.");
    const E = await window.google.maps.importLibrary(g);
    return c({
      name: g,
      value: E
    }), E;
  }, [u]);
  return ne(
    () => {
      (async () => {
        try {
          const g = Jt({
            key: r
          }, o);
          n && (g.v = n), (d == null ? void 0 : d.length) > 0 && (g.libraries = d), await bi.load(g, (y) => a(y));
          for (const y of ["core", "maps", ...i])
            await v(y);
          e && e();
        } catch (g) {
          console.error("<ApiProvider> failed to load Google Maps API", g);
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, f]
  ), {
    status: s,
    loadedLibraries: u,
    importLibrary: v
  };
}
const bp = (t) => {
  const {
    children: e
  } = t, r = Xn(t, gp), {
    mapInstances: n,
    addMapInstance: i,
    removeMapInstance: o,
    clearMapInstances: s
  } = yp(), {
    status: a,
    loadedLibraries: u,
    importLibrary: c
  } = wp(r);
  return /* @__PURE__ */ W.createElement(ji.Provider, {
    value: {
      mapInstances: n,
      addMapInstance: i,
      removeMapInstance: o,
      clearMapInstances: s,
      status: a,
      loadedLibraries: u,
      importLibrary: c
    }
  }, e);
};
function xp(t, e) {
  for (const r of Tp) {
    const n = e[r], i = iu[r];
    ne(() => {
      if (!t || !n)
        return;
      const o = google.maps.event.addListener(t, i, (s) => {
        n(_p(i, t, s));
      });
      return () => o.remove();
    }, [t, i, n]);
  }
}
function _p(t, e, r) {
  const n = {
    type: t,
    map: e,
    detail: {},
    stoppable: !1,
    stop: () => {
    }
  };
  if (Sp.includes(t)) {
    const o = n, s = e.getCenter(), a = e.getZoom(), u = e.getHeading() || 0, c = e.getTilt() || 0, d = e.getBounds();
    return (!s || !d || !Number.isFinite(a)) && console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), o.detail = {
      center: (s == null ? void 0 : s.toJSON()) || {
        lat: 0,
        lng: 0
      },
      zoom: a || 0,
      heading: u,
      tilt: c,
      bounds: (d == null ? void 0 : d.toJSON()) || {
        north: 90,
        east: 180,
        south: -90,
        west: -180
      }
    }, o;
  } else if (Ep.includes(t)) {
    var i;
    if (!r)
      throw new Error("[createEvent] mouse events must provide a srcEvent");
    const o = n;
    return o.domEvent = r.domEvent, o.stoppable = !0, o.stop = () => r.stop(), o.detail = {
      latLng: ((i = r.latLng) == null ? void 0 : i.toJSON()) || null,
      placeId: r.placeId
    }, o;
  }
  return n;
}
const iu = {
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onContextmenu: "contextmenu",
  onDblclick: "dblclick",
  onDrag: "drag",
  onDragend: "dragend",
  onDragstart: "dragstart",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onIsFractionalZoomEnabledChanged: "isfractionalzoomenabled_changed",
  onMapCapabilitiesChanged: "mapcapabilities_changed",
  onMapTypeIdChanged: "maptypeid_changed",
  onMousemove: "mousemove",
  onMouseout: "mouseout",
  onMouseover: "mouseover",
  onProjectionChanged: "projection_changed",
  onRenderingTypeChanged: "renderingtype_changed",
  onTilesLoaded: "tilesloaded",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
  // note: onCameraChanged is an alias for the bounds_changed event,
  // since that is going to be fired in every situation where the camera is
  // updated.
  onCameraChanged: "bounds_changed"
}, Sp = ["bounds_changed", "center_changed", "heading_changed", "projection_changed", "tilt_changed", "zoom_changed"], Ep = ["click", "contextmenu", "dblclick", "mousemove", "mouseout", "mouseover"], Tp = Object.keys(iu);
function Cp(t, e) {
  const r = se(void 0);
  (!r.current || !fp(e, r.current)) && (r.current = e), ne(t, r.current);
}
const Op = /* @__PURE__ */ new Set(["backgroundColor", "clickableIcons", "controlSize", "disableDefaultUI", "disableDoubleClickZoom", "draggable", "draggableCursor", "draggingCursor", "fullscreenControl", "fullscreenControlOptions", "gestureHandling", "isFractionalZoomEnabled", "keyboardShortcuts", "mapTypeControl", "mapTypeControlOptions", "mapTypeId", "maxZoom", "minZoom", "noClear", "panControl", "panControlOptions", "restriction", "rotateControl", "rotateControlOptions", "scaleControl", "scaleControlOptions", "scrollwheel", "streetView", "streetViewControl", "streetViewControlOptions", "styles", "zoomControl", "zoomControlOptions"]);
function Pp(t, e) {
  const r = {}, n = Object.keys(e);
  for (const i of n)
    Op.has(i) && (r[i] = e[i]);
  Cp(() => {
    t && t.setOptions(r);
  }, [r]);
}
function ou() {
  var t;
  return ((t = $e(ji)) == null ? void 0 : t.status) || Gt.NOT_LOADED;
}
function Mp(t, e) {
  const {
    viewport: r,
    viewState: n
  } = e, i = !!r;
  return Yn(() => {
    if (!t || !n)
      return;
    const {
      latitude: o,
      longitude: s,
      bearing: a,
      pitch: u,
      zoom: c
    } = n;
    t.moveCamera({
      center: {
        lat: o,
        lng: s
      },
      heading: a,
      tilt: u,
      zoom: c + 1
    });
  }, [t, n]), i;
}
function Ap(t) {
  return !t || typeof t != "object" || !("lat" in t && "lng" in t) ? !1 : Number.isFinite(t.lat) && Number.isFinite(t.lng);
}
function Np(t, e) {
  if (!t || !e)
    return !1;
  const r = xi(t), n = xi(e);
  return !(r.lat !== n.lat || r.lng !== n.lng);
}
function xi(t) {
  return Ap(t) ? t : t.toJSON();
}
function Rp(t, e, r) {
  const n = r.center ? xi(r.center) : null;
  let i = null, o = null;
  n && Number.isFinite(n.lat) && Number.isFinite(n.lng) && (i = n.lat, o = n.lng);
  const s = Number.isFinite(r.zoom) ? r.zoom : null, a = Number.isFinite(r.heading) ? r.heading : null, u = Number.isFinite(r.tilt) ? r.tilt : null;
  Yn(() => {
    if (!t)
      return;
    const c = {};
    let d = !1;
    i !== null && o !== null && (e.current.center.lat !== i || e.current.center.lng !== o) && (c.center = {
      lat: i,
      lng: o
    }, d = !0), s !== null && e.current.zoom !== s && (c.zoom = s, d = !0), a !== null && e.current.heading !== a && (c.heading = a, d = !0), u !== null && e.current.tilt !== u && (c.tilt = u, d = !0), d && t.moveCamera(c);
  });
}
const Lp = () => {
  const t = {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999,
    display: "flex",
    flexFlow: "column nowrap",
    textAlign: "center",
    justifyContent: "center",
    fontSize: ".8rem",
    color: "rgba(0,0,0,0.6)",
    background: "#dddddd",
    padding: "1rem 1.5rem"
  };
  return /* @__PURE__ */ W.createElement("div", {
    style: t
  }, /* @__PURE__ */ W.createElement("h2", null, "Error: AuthFailure"), /* @__PURE__ */ W.createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", /* @__PURE__ */ W.createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function $p() {
  const [t, e] = ye(null), r = Tr((n) => e(n), [e]);
  return [t, r];
}
function su() {
  return ou() === Gt.LOADED;
}
function Ip() {
  const [, t] = Ai((e) => e + 1, 0);
  return t;
}
function kp(t, e) {
  const r = t.getCenter(), n = t.getZoom(), i = t.getHeading() || 0, o = t.getTilt() || 0, s = t.getBounds();
  (!r || !s || !Number.isFinite(n)) && console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), Object.assign(e.current, {
    center: (r == null ? void 0 : r.toJSON()) || {
      lat: 0,
      lng: 0
    },
    zoom: n || 0,
    heading: i,
    tilt: o
  });
}
function jp(t) {
  const e = Ip(), r = se({
    center: {
      lat: 0,
      lng: 0
    },
    heading: 0,
    tilt: 0,
    zoom: 0
  });
  return ne(() => {
    if (!t)
      return;
    const n = google.maps.event.addListener(t, "bounds_changed", () => {
      kp(t, r), e();
    });
    return () => n.remove();
  }, [t, e]), r;
}
const Dp = ["id", "defaultBounds", "defaultCenter", "defaultZoom", "defaultHeading", "defaultTilt"];
function Fp(t, e) {
  const r = su(), [n, i] = ye(null), [o, s] = $p(), a = jp(n), {
    id: u,
    defaultBounds: c,
    defaultCenter: d,
    defaultZoom: f,
    defaultHeading: v,
    defaultTilt: g
  } = t, y = Xn(t, Dp);
  !y.center && d && (y.center = d), !y.zoom && Number.isFinite(f) && (y.zoom = f), !y.heading && Number.isFinite(v) && (y.heading = v), !y.tilt && Number.isFinite(g) && (y.tilt = g);
  for (const S of Object.keys(y))
    y[S] === void 0 && delete y[S];
  const E = se();
  return ne(
    () => {
      if (!o || !r)
        return;
      const {
        addMapInstance: S,
        removeMapInstance: _
      } = e, O = t.mapId, T = new google.maps.Map(o, y);
      if (i(T), S(T, u), c && T.fitBounds(c), E.current) {
        const {
          mapId: P,
          cameraState: x
        } = E.current;
        P !== O && T.setOptions(x);
      }
      return () => {
        E.current = {
          mapId: O,
          // eslint-disable-next-line react-hooks/exhaustive-deps
          cameraState: a.current
        }, google.maps.event.clearInstanceListeners(T), i(null), _(u);
      };
    },
    // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o, r, u, t.mapId]
  ), [n, s, a];
}
const Di = W.createContext(null), au = (t) => {
  const {
    children: e,
    id: r,
    className: n,
    style: i
  } = t, o = $e(ji), s = ou();
  if (!o)
    throw new Error("<Map> can only be used inside an <ApiProvider> component.");
  const [a, u, c] = Fp(t, o);
  Rp(a, c, t), xp(a, t), Pp(a, t);
  const d = Mp(a, t), f = !!t.controlled;
  ne(() => {
    if (a)
      return d && a.setOptions({
        disableDefaultUI: !0
      }), (d || f) && a.setOptions({
        gestureHandling: "none",
        keyboardShortcuts: !1
      }), () => {
        a.setOptions({
          gestureHandling: t.gestureHandling,
          keyboardShortcuts: t.keyboardShortcuts
        });
      };
  }, [a, d, f, t.gestureHandling, t.keyboardShortcuts]);
  const v = t.center ? xi(t.center) : null;
  let g = null, y = null;
  v && Number.isFinite(v.lat) && Number.isFinite(v.lng) && (g = v.lat, y = v.lng);
  const E = Pe(() => {
    var _, O, T, P, x;
    return {
      center: {
        lat: (_ = g) != null ? _ : 0,
        lng: (O = y) != null ? O : 0
      },
      zoom: (T = t.zoom) != null ? T : 0,
      heading: (P = t.heading) != null ? P : 0,
      tilt: (x = t.tilt) != null ? x : 0
    };
  }, [g, y, t.zoom, t.heading, t.tilt]);
  Yn(() => {
    if (!a || !f)
      return;
    a.moveCamera(E);
    const _ = a.addListener("bounds_changed", () => {
      a.moveCamera(E);
    });
    return () => _.remove();
  }, [a, f, E]);
  const S = Pe(() => Jt({
    width: "100%",
    height: "100%",
    // when using deckgl, the map should be sent to the back
    zIndex: d ? -1 : 0
  }, i), [i, d]);
  return s === Gt.AUTH_FAILURE ? /* @__PURE__ */ W.createElement("div", {
    style: Jt({
      position: "relative"
    }, n ? {} : S),
    className: n
  }, /* @__PURE__ */ W.createElement(Lp, null)) : /* @__PURE__ */ W.createElement("div", Jt({
    ref: u,
    "data-testid": "map",
    style: n ? void 0 : S,
    className: n
  }, r ? {
    id: r
  } : {}), a ? /* @__PURE__ */ W.createElement(Di.Provider, {
    value: {
      map: a
    }
  }, e) : null);
};
au.deckGLViewProps = !0;
function zp(t) {
  const e = su(), r = $e(ji);
  return ne(() => {
    !e || !r || r.importLibrary(t);
  }, [e, r, t]), (r == null ? void 0 : r.loadedLibraries[t]) || null;
}
const Vp = W.createContext(null);
function Hp(t) {
  var e;
  const [r, n] = ye(null), [i, o] = ye(null), s = (e = $e(Di)) == null ? void 0 : e.map, a = zp("marker"), {
    children: u,
    className: c,
    onClick: d,
    onDrag: f,
    onDragStart: v,
    onDragEnd: g,
    collisionBehavior: y,
    draggable: E,
    position: S,
    title: _,
    zIndex: O
  } = t, T = Lc.count(u);
  return ne(() => {
    if (!s || !a)
      return;
    const P = new a.AdvancedMarkerElement();
    if (P.map = s, n(P), T > 0) {
      const x = document.createElement("div");
      c && (x.className = c), P.content = x, o(x);
    }
    return () => {
      P.map = null, n(null), o(null);
    };
  }, [s, a, T]), ne(() => {
    i && (i.className = c ?? "");
  }, [i, c]), ne(() => {
    if (!r)
      return;
    const P = google.maps.event;
    d && P.addListener(r, "click", d), f && P.addListener(r, "drag", f), v && P.addListener(r, "dragstart", v), g && P.addListener(r, "dragend", g), (f || v || g) && !E && console.warn("You need to set the marker to draggable to listen to drag-events.");
    const x = r;
    return () => {
      P.clearInstanceListeners(x);
    };
  }, [r, E, d, v, f, g]), ne(() => {
    r && (S !== void 0 && (r.position = S), E !== void 0 && (r.gmpDraggable = E), y !== void 0 && (r.collisionBehavior = y), O !== void 0 && (r.zIndex = O), typeof _ == "string" && (r.title = _));
  }, [r, S, E, y, O, _]), [r, i];
}
Ur((t, e) => {
  const {
    children: r
  } = t, [n, i] = Hp(t);
  return ss(e, () => n, [n]), n ? /* @__PURE__ */ W.createElement(Vp.Provider, {
    value: {
      marker: n
    }
  }, i !== null && ol(r, i)) : null;
});
const Bp = ["onClick", "onDrag", "onDragStart", "onDragEnd", "onMouseOver", "onMouseOut"];
function Wp(t) {
  var e;
  const [r, n] = ye(null), i = (e = $e(Di)) == null ? void 0 : e.map, {
    onClick: o,
    onDrag: s,
    onDragStart: a,
    onDragEnd: u,
    onMouseOver: c,
    onMouseOut: d
  } = t, f = Xn(t, Bp), {
    position: v,
    draggable: g
  } = f;
  return ne(() => {
    if (!i) {
      i === void 0 && console.error("<Marker> has to be inside a Map component.");
      return;
    }
    const y = new google.maps.Marker(f);
    return y.setMap(i), n(y), () => {
      y.setMap(null), n(null);
    };
  }, [i]), ne(() => {
    if (!r)
      return;
    const y = r, E = google.maps.event;
    return o && E.addListener(y, "click", o), s && E.addListener(y, "drag", s), a && E.addListener(y, "dragstart", a), u && E.addListener(y, "dragend", u), c && E.addListener(y, "mouseover", c), d && E.addListener(y, "mouseout", d), r.setDraggable(!!g), () => {
      E.clearInstanceListeners(y);
    };
  }, [r, g, o, s, a, u, c, d]), ne(() => {
    r && f && r.setOptions(f);
  }, [r, f]), ne(() => {
    g || !v || !r || r.setPosition(v);
  }, [g, v, r]), r;
}
const Gp = Ur((t, e) => {
  const r = Wp(t);
  return ss(e, () => r, [r]), /* @__PURE__ */ W.createElement(W.Fragment, null);
});
var lu = {}, uu = { exports: {} };
(function(t) {
  var e = function(r) {
    var n = Object.prototype, i = n.hasOwnProperty, o, s = typeof Symbol == "function" ? Symbol : {}, a = s.iterator || "@@iterator", u = s.asyncIterator || "@@asyncIterator", c = s.toStringTag || "@@toStringTag";
    function d(j, N, w) {
      return Object.defineProperty(j, N, {
        value: w,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), j[N];
    }
    try {
      d({}, "");
    } catch {
      d = function(j, N, w) {
        return j[N] = w;
      };
    }
    function f(j, N, w, $) {
      var F = N && N.prototype instanceof O ? N : O, z = Object.create(F.prototype), G = new ve($ || []);
      return z._invoke = k(j, w, G), z;
    }
    r.wrap = f;
    function v(j, N, w) {
      try {
        return { type: "normal", arg: j.call(N, w) };
      } catch ($) {
        return { type: "throw", arg: $ };
      }
    }
    var g = "suspendedStart", y = "suspendedYield", E = "executing", S = "completed", _ = {};
    function O() {
    }
    function T() {
    }
    function P() {
    }
    var x = {};
    x[a] = function() {
      return this;
    };
    var M = Object.getPrototypeOf, H = M && M(M(Y([])));
    H && H !== n && i.call(H, a) && (x = H);
    var R = P.prototype = O.prototype = Object.create(x);
    T.prototype = R.constructor = P, P.constructor = T, T.displayName = d(
      P,
      c,
      "GeneratorFunction"
    );
    function q(j) {
      ["next", "throw", "return"].forEach(function(N) {
        d(j, N, function(w) {
          return this._invoke(N, w);
        });
      });
    }
    r.isGeneratorFunction = function(j) {
      var N = typeof j == "function" && j.constructor;
      return N ? N === T || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (N.displayName || N.name) === "GeneratorFunction" : !1;
    }, r.mark = function(j) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(j, P) : (j.__proto__ = P, d(j, c, "GeneratorFunction")), j.prototype = Object.create(R), j;
    }, r.awrap = function(j) {
      return { __await: j };
    };
    function K(j, N) {
      function w(z, G, X, J) {
        var te = v(j[z], j, G);
        if (te.type === "throw")
          J(te.arg);
        else {
          var ae = te.arg, oe = ae.value;
          return oe && typeof oe == "object" && i.call(oe, "__await") ? N.resolve(oe.__await).then(function(ie) {
            w("next", ie, X, J);
          }, function(ie) {
            w("throw", ie, X, J);
          }) : N.resolve(oe).then(function(ie) {
            ae.value = ie, X(ae);
          }, function(ie) {
            return w("throw", ie, X, J);
          });
        }
      }
      var $;
      function F(z, G) {
        function X() {
          return new N(function(J, te) {
            w(z, G, J, te);
          });
        }
        return $ = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        $ ? $.then(
          X,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          X
        ) : X();
      }
      this._invoke = F;
    }
    q(K.prototype), K.prototype[u] = function() {
      return this;
    }, r.AsyncIterator = K, r.async = function(j, N, w, $, F) {
      F === void 0 && (F = Promise);
      var z = new K(
        f(j, N, w, $),
        F
      );
      return r.isGeneratorFunction(N) ? z : z.next().then(function(G) {
        return G.done ? G.value : z.next();
      });
    };
    function k(j, N, w) {
      var $ = g;
      return function(F, z) {
        if ($ === E)
          throw new Error("Generator is already running");
        if ($ === S) {
          if (F === "throw")
            throw z;
          return le();
        }
        for (w.method = F, w.arg = z; ; ) {
          var G = w.delegate;
          if (G) {
            var X = V(G, w);
            if (X) {
              if (X === _)
                continue;
              return X;
            }
          }
          if (w.method === "next")
            w.sent = w._sent = w.arg;
          else if (w.method === "throw") {
            if ($ === g)
              throw $ = S, w.arg;
            w.dispatchException(w.arg);
          } else
            w.method === "return" && w.abrupt("return", w.arg);
          $ = E;
          var J = v(j, N, w);
          if (J.type === "normal") {
            if ($ = w.done ? S : y, J.arg === _)
              continue;
            return {
              value: J.arg,
              done: w.done
            };
          } else
            J.type === "throw" && ($ = S, w.method = "throw", w.arg = J.arg);
        }
      };
    }
    function V(j, N) {
      var w = j.iterator[N.method];
      if (w === o) {
        if (N.delegate = null, N.method === "throw") {
          if (j.iterator.return && (N.method = "return", N.arg = o, V(j, N), N.method === "throw"))
            return _;
          N.method = "throw", N.arg = new TypeError(
            "The iterator does not provide a 'throw' method"
          );
        }
        return _;
      }
      var $ = v(w, j.iterator, N.arg);
      if ($.type === "throw")
        return N.method = "throw", N.arg = $.arg, N.delegate = null, _;
      var F = $.arg;
      if (!F)
        return N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, _;
      if (F.done)
        N[j.resultName] = F.value, N.next = j.nextLoc, N.method !== "return" && (N.method = "next", N.arg = o);
      else
        return F;
      return N.delegate = null, _;
    }
    q(R), d(R, c, "Generator"), R[a] = function() {
      return this;
    }, R.toString = function() {
      return "[object Generator]";
    };
    function Q(j) {
      var N = { tryLoc: j[0] };
      1 in j && (N.catchLoc = j[1]), 2 in j && (N.finallyLoc = j[2], N.afterLoc = j[3]), this.tryEntries.push(N);
    }
    function re(j) {
      var N = j.completion || {};
      N.type = "normal", delete N.arg, j.completion = N;
    }
    function ve(j) {
      this.tryEntries = [{ tryLoc: "root" }], j.forEach(Q, this), this.reset(!0);
    }
    r.keys = function(j) {
      var N = [];
      for (var w in j)
        N.push(w);
      return N.reverse(), function $() {
        for (; N.length; ) {
          var F = N.pop();
          if (F in j)
            return $.value = F, $.done = !1, $;
        }
        return $.done = !0, $;
      };
    };
    function Y(j) {
      if (j) {
        var N = j[a];
        if (N)
          return N.call(j);
        if (typeof j.next == "function")
          return j;
        if (!isNaN(j.length)) {
          var w = -1, $ = function F() {
            for (; ++w < j.length; )
              if (i.call(j, w))
                return F.value = j[w], F.done = !1, F;
            return F.value = o, F.done = !0, F;
          };
          return $.next = $;
        }
      }
      return { next: le };
    }
    r.values = Y;
    function le() {
      return { value: o, done: !0 };
    }
    return ve.prototype = {
      constructor: ve,
      reset: function(j) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = o, this.done = !1, this.delegate = null, this.method = "next", this.arg = o, this.tryEntries.forEach(re), !j)
          for (var N in this)
            N.charAt(0) === "t" && i.call(this, N) && !isNaN(+N.slice(1)) && (this[N] = o);
      },
      stop: function() {
        this.done = !0;
        var j = this.tryEntries[0], N = j.completion;
        if (N.type === "throw")
          throw N.arg;
        return this.rval;
      },
      dispatchException: function(j) {
        if (this.done)
          throw j;
        var N = this;
        function w(J, te) {
          return z.type = "throw", z.arg = j, N.next = J, te && (N.method = "next", N.arg = o), !!te;
        }
        for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
          var F = this.tryEntries[$], z = F.completion;
          if (F.tryLoc === "root")
            return w("end");
          if (F.tryLoc <= this.prev) {
            var G = i.call(F, "catchLoc"), X = i.call(F, "finallyLoc");
            if (G && X) {
              if (this.prev < F.catchLoc)
                return w(F.catchLoc, !0);
              if (this.prev < F.finallyLoc)
                return w(F.finallyLoc);
            } else if (G) {
              if (this.prev < F.catchLoc)
                return w(F.catchLoc, !0);
            } else if (X) {
              if (this.prev < F.finallyLoc)
                return w(F.finallyLoc);
            } else
              throw new Error("try statement without catch or finally");
          }
        }
      },
      abrupt: function(j, N) {
        for (var w = this.tryEntries.length - 1; w >= 0; --w) {
          var $ = this.tryEntries[w];
          if ($.tryLoc <= this.prev && i.call($, "finallyLoc") && this.prev < $.finallyLoc) {
            var F = $;
            break;
          }
        }
        F && (j === "break" || j === "continue") && F.tryLoc <= N && N <= F.finallyLoc && (F = null);
        var z = F ? F.completion : {};
        return z.type = j, z.arg = N, F ? (this.method = "next", this.next = F.finallyLoc, _) : this.complete(z);
      },
      complete: function(j, N) {
        if (j.type === "throw")
          throw j.arg;
        return j.type === "break" || j.type === "continue" ? this.next = j.arg : j.type === "return" ? (this.rval = this.arg = j.arg, this.method = "return", this.next = "end") : j.type === "normal" && N && (this.next = N), _;
      },
      finish: function(j) {
        for (var N = this.tryEntries.length - 1; N >= 0; --N) {
          var w = this.tryEntries[N];
          if (w.finallyLoc === j)
            return this.complete(w.completion, w.afterLoc), re(w), _;
        }
      },
      catch: function(j) {
        for (var N = this.tryEntries.length - 1; N >= 0; --N) {
          var w = this.tryEntries[N];
          if (w.tryLoc === j) {
            var $ = w.completion;
            if ($.type === "throw") {
              var F = $.arg;
              re(w);
            }
            return F;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(j, N, w) {
        return this.delegate = {
          iterator: Y(j),
          resultName: N,
          nextLoc: w
        }, this.method === "next" && (this.arg = o), _;
      }
    }, r;
  }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    t.exports
  );
  try {
    regeneratorRuntime = e;
  } catch {
    Function("r", "regeneratorRuntime = r")(e);
  }
})(uu);
var Up = uu.exports;
(function(t) {
  var e = Up;
  function r(y, E, S, _, O, T, P) {
    try {
      var x = y[T](P), M = x.value;
    } catch (H) {
      return void S(H);
    }
    x.done ? E(M) : Promise.resolve(M).then(_, O);
  }
  function n(y) {
    return function() {
      var E = this, S = arguments;
      return new Promise(function(_, O) {
        var T = y.apply(E, S);
        function P(M) {
          r(T, _, O, P, x, "next", M);
        }
        function x(M) {
          r(T, _, O, P, x, "throw", M);
        }
        P(void 0);
      });
    };
  }
  Object.defineProperty(t, "__esModule", { value: !0 }), t.default = void 0;
  var i = !1, o = null, s = "en", a = null, u = null, c = "https://maps.googleapis.com/maps/api/geocode/json";
  function d(y) {
    var E = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    i && (E ? console.warn(y) : console.log(y));
  }
  function f(y) {
    return v.apply(this, arguments);
  }
  function v() {
    return (v = n(e.mark(function y(E) {
      var S, _;
      return e.wrap(function(O) {
        for (; ; )
          switch (O.prev = O.next) {
            case 0:
              return O.next = 2, fetch(E).catch(function() {
                return Promise.reject(new Error("Error fetching data"));
              });
            case 2:
              return S = O.sent, O.next = 5, S.json().catch(function() {
                return d("Error parsing server response"), Promise.reject(new Error("Error parsing server response"));
              });
            case 5:
              if ((_ = O.sent).status !== "OK") {
                O.next = 9;
                break;
              }
              return d(_), O.abrupt("return", _);
            case 9:
              return d("".concat(_.error_message, `.
Server returned status code `).concat(_.status), !0), O.abrupt("return", Promise.reject(new Error("".concat(_.error_message, `.
Server returned status code `).concat(_.status))));
            case 11:
            case "end":
              return O.stop();
          }
      }, y);
    }))).apply(this, arguments);
  }
  var g = { setApiKey: function(y) {
    o = y;
  }, setLanguage: function(y) {
    s = y;
  }, setRegion: function(y) {
    a = y;
  }, setLocationType: function(y) {
    u = y;
  }, enableDebug: function() {
    var y = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    i = y;
  }, fromLatLng: function(y, E, S, _, O, T) {
    return n(e.mark(function P() {
      var x, M;
      return e.wrap(function(H) {
        for (; ; )
          switch (H.prev = H.next) {
            case 0:
              if (y && E) {
                H.next = 3;
                break;
              }
              return d("Provided coordinates are invalid", !0), H.abrupt("return", Promise.reject(new Error("Provided coordinates are invalid")));
            case 3:
              return x = "".concat(y, ",").concat(E), M = "".concat(c, "?latlng=").concat(encodeURIComponent(x)), (S || o) && (M += "&key=".concat(o = S || o)), (_ || s) && (M += "&language=".concat(s = _ || s)), (O || a) && (a = O || a, M += "&region=".concat(encodeURIComponent(a))), (T || u) && (u = T || u, M += "&location_type=".concat(encodeURIComponent(u))), H.abrupt("return", f(M));
            case 9:
            case "end":
              return H.stop();
          }
      }, P);
    }))();
  }, fromAddress: function(y, E, S, _) {
    return n(e.mark(function O() {
      var T;
      return e.wrap(function(P) {
        for (; ; )
          switch (P.prev = P.next) {
            case 0:
              if (y) {
                P.next = 3;
                break;
              }
              return d("Provided address is invalid", !0), P.abrupt("return", Promise.reject(new Error("Provided address is invalid")));
            case 3:
              return T = "".concat(c, "?address=").concat(encodeURIComponent(y)), (E || o) && (T += "&key=".concat(o = E || o)), (S || s) && (T += "&language=".concat(s = S || s)), (_ || a) && (a = _ || a, T += "&region=".concat(encodeURIComponent(a))), P.abrupt("return", f(T));
            case 8:
            case "end":
              return P.stop();
          }
      }, O);
    }))();
  } };
  t.default = g;
})(lu);
const ha = /* @__PURE__ */ nu(lu);
function qp(t) {
  var e;
  const {
    onClick: r,
    onDrag: n,
    onDragStart: i,
    onDragEnd: o,
    onMouseOver: s,
    onMouseOut: a,
    onRadiusChanged: u,
    onCenterChanged: c,
    radius: d,
    center: f,
    ...v
  } = t, g = se({});
  Object.assign(g.current, {
    onClick: r,
    onDrag: n,
    onDragStart: i,
    onDragEnd: o,
    onMouseOver: s,
    onMouseOut: a,
    onRadiusChanged: u,
    onCenterChanged: c
  });
  const y = se(new google.maps.Circle()).current;
  y.setOptions(v), ne(() => {
    f && (Np(f, y.getCenter()) || y.setCenter(f));
  }, [f]), ne(() => {
    d != null && d !== y.getRadius() && y.setRadius(d);
  }, [d]);
  const E = (e = $e(Di)) == null ? void 0 : e.map;
  return ne(() => {
    if (!E) {
      E === void 0 && console.error("<Circle> has to be inside a Map component.");
      return;
    }
    return y.setMap(E), () => {
      y.setMap(null);
    };
  }, [E]), ne(() => {
    if (!y)
      return;
    const S = google.maps.event;
    return [
      ["click", "onClick"],
      ["drag", "onDrag"],
      ["dragstart", "onDragStart"],
      ["dragend", "onDragEnd"],
      ["mouseover", "onMouseOver"],
      ["mouseout", "onMouseOut"]
    ].forEach(([_, O]) => {
      S.addListener(y, _, (T) => {
        const P = g.current[O];
        P && P(T);
      });
    }), S.addListener(y, "radius_changed", () => {
      var _, O;
      const T = y.getRadius();
      (O = (_ = g.current).onRadiusChanged) == null || O.call(_, T);
    }), S.addListener(y, "center_changed", () => {
      var _, O;
      const T = y.getCenter();
      (O = (_ = g.current).onCenterChanged) == null || O.call(_, T);
    }), () => {
      S.clearInstanceListeners(y);
    };
  }, [y]), y;
}
const Yp = Ur((t, e) => {
  const r = qp(t);
  return ss(e, () => r), null;
}), Qp = (t) => t * 1609.344, Jp = ({ containerStyle: t, locations: e, serviceArea: r, hideLocation: n, className: i }) => {
  const o = process.env.PUBLIC_GOOGLE_MAPS_API_KEY || "NO API KEY DETECTED", s = `w-full h-full overflow-hidden ${i}`, [a, u] = ye({
    center: { lat: 40.7, lng: -74 },
    zoom: 9.5
  }), [c, d] = ye({
    lat: 0,
    lng: 0
  }), f = (v) => u(v.detail);
  return ne(() => {
    const v = e == null ? void 0 : e[0], g = (v == null ? void 0 : v.streetAddress) + "," + (v == null ? void 0 : v.city) + "," + (v == null ? void 0 : v.state) + "," + (v == null ? void 0 : v.postalCode);
    (ha.fromAddress || ha.default.fromAddress)(g, o).then((y) => {
      const { lat: E, lng: S } = y.results[0].geometry.location;
      u({
        center: {
          lat: E,
          lng: S
        },
        zoom: 9.5
      }), d({
        lat: E,
        lng: S
      });
    });
  }, [o, e]), /* @__PURE__ */ h(
    "div",
    {
      style: {
        width: "64rem",
        maxWidth: "100%",
        height: "500px",
        borderRadius: "10px",
        ...t
      },
      children: /* @__PURE__ */ h(bp, { apiKey: o, children: /* @__PURE__ */ I(au, { ...a, onCameraChanged: f, className: s, children: [
        n && /* @__PURE__ */ h(Gp, { position: { lat: c.lat, lng: c.lng } }),
        /* @__PURE__ */ h(
          Yp,
          {
            radius: Qp(Number.parseInt(r || "25")),
            center: {
              lat: c.lat,
              lng: c.lng
            },
            draggable: !1,
            strokeColor: "black",
            strokeOpacity: 1,
            strokeWeight: 3,
            fillColor: "black",
            fillOpacity: 0.3
          }
        )
      ] }) })
    }
  );
}, Kp = async (t, e, r) => {
  const n = {
    "x-api-key": (process.env.PUBLIC_SEND_EMAIL_LAMBDA_API_KEY ?? (r == null ? void 0 : r.email_lambda_api_key)) || "NO API KEY DETECTED"
  }, i = e, o = process.env.PUBLIC_SEND_EMAIL_URL ?? (r == null ? void 0 : r.email_url), s = {
    to: `${i}`,
    body: {
      name: t.name,
      phoneNumber: t.phoneNumber,
      businessName: t.businessName,
      to: "TO",
      website: t.website,
      email: t.email,
      message: t.message
    },
    subject: "Request Quote",
    templateName: "request_quote"
  };
  return await fetch(o || "NO URL DETECTED", {
    method: "POST",
    body: JSON.stringify(s),
    headers: n
  });
}, Xp = async (t, e, r) => Kp(t, e, r), St = (t) => {
  const e = ("" + t).replace(/\D/g, "").match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
  return e ? (e[1] ? "+1 " : "") + "(" + e[2] + ") " + e[3] + "-" + e[4] : t;
}, Zp = (t) => t.split(/\s+/).map((e) => e.charAt(0)).join("");
function cu(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number")
    n += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (r = cu(t[e])) && (n && (n += " "), n += r);
    else
      for (e in t)
        t[e] && (n && (n += " "), n += e);
  return n;
}
const ht = (...t) => {
  for (var e = 0, r, n, i = ""; e < t.length; )
    (r = t[e++]) && (n = cu(r)) && (i && (i += " "), i += n);
  return i;
}, du = ({ businessEmail: t, businessName: e }) => {
  const [r, n] = ye(!1), [i, o] = ye(!1), [s, a] = ye(!1), [u, c] = ye({
    name: "",
    phoneNumber: "",
    email: "",
    businessName: e,
    website: "",
    message: ""
  });
  ne(() => {
    c((f) => ({ ...f, website: window.location.href }));
  }, []);
  const d = (f) => {
    c({ ...u, [f.target.name]: f.target.value });
  };
  return ne(() => {
    i && setTimeout(() => {
      o(!1);
    }, 5e3);
  }, [i]), ne(() => {
    s && setTimeout(() => {
      a(!1);
    }, 5e3);
  }, [s]), { form: u, handleChange: d, onSubmit: (f) => {
    f.preventDefault(), n(!0), Xp(u, t).then((v) => {
      v.ok ? (o(!0), n(!1)) : (o(!1), n(!1), a(!0));
    });
  }, isLoading: r, isSuccess: i, isError: s };
};
var sr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Wo = { exports: {} };
(function(t, e) {
  var r = 200, n = "__lodash_hash_undefined__", i = 9007199254740991, o = "[object Arguments]", s = "[object Array]", a = "[object Boolean]", u = "[object Date]", c = "[object Error]", d = "[object Function]", f = "[object GeneratorFunction]", v = "[object Map]", g = "[object Number]", y = "[object Object]", E = "[object Promise]", S = "[object RegExp]", _ = "[object Set]", O = "[object String]", T = "[object Symbol]", P = "[object WeakMap]", x = "[object ArrayBuffer]", M = "[object DataView]", H = "[object Float32Array]", R = "[object Float64Array]", q = "[object Int8Array]", K = "[object Int16Array]", k = "[object Int32Array]", V = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", re = "[object Uint16Array]", ve = "[object Uint32Array]", Y = /[\\^$.*+?()[\]{}|]/g, le = /\w*$/, j = /^\[object .+?Constructor\]$/, N = /^(?:0|[1-9]\d*)$/, w = {};
  w[o] = w[s] = w[x] = w[M] = w[a] = w[u] = w[H] = w[R] = w[q] = w[K] = w[k] = w[v] = w[g] = w[y] = w[S] = w[_] = w[O] = w[T] = w[V] = w[Q] = w[re] = w[ve] = !0, w[c] = w[d] = w[P] = !1;
  var $ = typeof sr == "object" && sr && sr.Object === Object && sr, F = typeof self == "object" && self && self.Object === Object && self, z = $ || F || Function("return this")(), G = e && !e.nodeType && e, X = G && !0 && t && !t.nodeType && t, J = X && X.exports === G;
  function te(l, m) {
    return l.set(m[0], m[1]), l;
  }
  function ae(l, m) {
    return l.add(m), l;
  }
  function oe(l, m) {
    for (var b = -1, L = l ? l.length : 0; ++b < L && m(l[b], b, l) !== !1; )
      ;
    return l;
  }
  function ie(l, m) {
    for (var b = -1, L = m.length, he = l.length; ++b < L; )
      l[he + b] = m[b];
    return l;
  }
  function Ne(l, m, b, L) {
    var he = -1, ge = l ? l.length : 0;
    for (L && ge && (b = l[++he]); ++he < ge; )
      b = m(b, l[he], he, l);
    return b;
  }
  function B(l, m) {
    for (var b = -1, L = Array(l); ++b < l; )
      L[b] = m(b);
    return L;
  }
  function je(l, m) {
    return l == null ? void 0 : l[m];
  }
  function Qe(l) {
    var m = !1;
    if (l != null && typeof l.toString != "function")
      try {
        m = !!(l + "");
      } catch {
      }
    return m;
  }
  function ct(l) {
    var m = -1, b = Array(l.size);
    return l.forEach(function(L, he) {
      b[++m] = [he, L];
    }), b;
  }
  function kt(l, m) {
    return function(b) {
      return l(m(b));
    };
  }
  function Pt(l) {
    var m = -1, b = Array(l.size);
    return l.forEach(function(L) {
      b[++m] = L;
    }), b;
  }
  var Lr = Array.prototype, $r = Function.prototype, dt = Object.prototype, yt = z["__core-js_shared__"], Zt = function() {
    var l = /[^.]+$/.exec(yt && yt.keys && yt.keys.IE_PROTO || "");
    return l ? "Symbol(src)_1." + l : "";
  }(), er = $r.toString, Ie = dt.hasOwnProperty, wt = dt.toString, Kr = RegExp(
    "^" + er.call(Ie).replace(Y, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), jt = J ? z.Buffer : void 0, pr = z.Symbol, hr = z.Uint8Array, Xr = kt(Object.getPrototypeOf, Object), Mt = Object.create, Ir = dt.propertyIsEnumerable, Zr = Lr.splice, mr = Object.getOwnPropertySymbols, kr = jt ? jt.isBuffer : void 0, en = kt(Object.keys, Object), At = ee(z, "DataView"), tt = ee(z, "Map"), ft = ee(z, "Promise"), Nt = ee(z, "Set"), Rt = ee(z, "WeakMap"), Be = ee(Object, "create"), vr = Ue(At), gr = Ue(tt), tn = Ue(ft), rn = Ue(Nt), nn = Ue(Rt), Dt = pr ? pr.prototype : void 0, yr = Dt ? Dt.valueOf : void 0;
  function De(l) {
    var m = -1, b = l ? l.length : 0;
    for (this.clear(); ++m < b; ) {
      var L = l[m];
      this.set(L[0], L[1]);
    }
  }
  function on() {
    this.__data__ = Be ? Be(null) : {};
  }
  function sn(l) {
    return this.has(l) && delete this.__data__[l];
  }
  function an(l) {
    var m = this.__data__;
    if (Be) {
      var b = m[l];
      return b === n ? void 0 : b;
    }
    return Ie.call(m, l) ? m[l] : void 0;
  }
  function ln(l) {
    var m = this.__data__;
    return Be ? m[l] !== void 0 : Ie.call(m, l);
  }
  function un(l, m) {
    var b = this.__data__;
    return b[l] = Be && m === void 0 ? n : m, this;
  }
  De.prototype.clear = on, De.prototype.delete = sn, De.prototype.get = an, De.prototype.has = ln, De.prototype.set = un;
  function Re(l) {
    var m = -1, b = l ? l.length : 0;
    for (this.clear(); ++m < b; ) {
      var L = l[m];
      this.set(L[0], L[1]);
    }
  }
  function cn() {
    this.__data__ = [];
  }
  function Je(l) {
    var m = this.__data__, b = pt(m, l);
    if (b < 0)
      return !1;
    var L = m.length - 1;
    return b == L ? m.pop() : Zr.call(m, b, 1), !0;
  }
  function dn(l) {
    var m = this.__data__, b = pt(m, l);
    return b < 0 ? void 0 : m[b][1];
  }
  function fn(l) {
    return pt(this.__data__, l) > -1;
  }
  function pn(l, m) {
    var b = this.__data__, L = pt(b, l);
    return L < 0 ? b.push([l, m]) : b[L][1] = m, this;
  }
  Re.prototype.clear = cn, Re.prototype.delete = Je, Re.prototype.get = dn, Re.prototype.has = fn, Re.prototype.set = pn;
  function We(l) {
    var m = -1, b = l ? l.length : 0;
    for (this.clear(); ++m < b; ) {
      var L = l[m];
      this.set(L[0], L[1]);
    }
  }
  function hn() {
    this.__data__ = {
      hash: new De(),
      map: new (tt || Re)(),
      string: new De()
    };
  }
  function mn(l) {
    return Z(this, l).delete(l);
  }
  function vn(l) {
    return Z(this, l).get(l);
  }
  function gn(l) {
    return Z(this, l).has(l);
  }
  function yn(l, m) {
    return Z(this, l).set(l, m), this;
  }
  We.prototype.clear = hn, We.prototype.delete = mn, We.prototype.get = vn, We.prototype.has = gn, We.prototype.set = yn;
  function Ge(l) {
    this.__data__ = new Re(l);
  }
  function wr() {
    this.__data__ = new Re();
  }
  function jr(l) {
    return this.__data__.delete(l);
  }
  function wn(l) {
    return this.__data__.get(l);
  }
  function bn(l) {
    return this.__data__.has(l);
  }
  function Dr(l, m) {
    var b = this.__data__;
    if (b instanceof Re) {
      var L = b.__data__;
      if (!tt || L.length < r - 1)
        return L.push([l, m]), this;
      b = this.__data__ = new We(L);
    }
    return b.set(l, m), this;
  }
  Ge.prototype.clear = wr, Ge.prototype.delete = jr, Ge.prototype.get = wn, Ge.prototype.has = bn, Ge.prototype.set = Dr;
  function xn(l, m) {
    var b = br(l) || so(l) ? B(l.length, String) : [], L = b.length, he = !!L;
    for (var ge in l)
      (m || Ie.call(l, ge)) && !(he && (ge == "length" || Ke(ge, L))) && b.push(ge);
    return b;
  }
  function tr(l, m, b) {
    var L = l[m];
    (!(Ie.call(l, m) && An(L, b)) || b === void 0 && !(m in l)) && (l[m] = b);
  }
  function pt(l, m) {
    for (var b = l.length; b--; )
      if (An(l[b][0], m))
        return b;
    return -1;
  }
  function Fr(l, m) {
    return l && D(m, xr(m), l);
  }
  function Ft(l, m, b, L, he, ge, Ce) {
    var _e;
    if (L && (_e = ge ? L(l, he, ge, Ce) : L(l)), _e !== void 0)
      return _e;
    if (!Vt(l))
      return l;
    var Ln = br(l);
    if (Ln) {
      if (_e = ze(l), !m)
        return A(l, _e);
    } else {
      var rt = xe(l), $n = rt == d || rt == f;
      if (lo(l))
        return En(l, m);
      if (rt == y || rt == o || $n && !ge) {
        if (Qe(l))
          return ge ? l : {};
        if (_e = Fe($n ? {} : l), !m)
          return U(l, Fr(_e, l));
      } else {
        if (!w[rt])
          return ge ? l : {};
        _e = bt(l, rt, Ft, m);
      }
    }
    Ce || (Ce = new Ge());
    var In = Ce.get(l);
    if (In)
      return In;
    if (Ce.set(l, _e), !Ln)
      var kn = b ? de(l) : xr(l);
    return oe(kn || l, function(_r, Ht) {
      kn && (Ht = _r, _r = l[Ht]), tr(_e, Ht, Ft(_r, m, b, L, Ht, l, Ce));
    }), _e;
  }
  function zr(l) {
    return Vt(l) ? Mt(l) : {};
  }
  function Vr(l, m, b) {
    var L = m(l);
    return br(l) ? L : ie(L, b(l));
  }
  function _n(l) {
    return wt.call(l);
  }
  function Sn(l) {
    if (!Vt(l) || Br(l))
      return !1;
    var m = Rn(l) || Qe(l) ? Kr : j;
    return m.test(Ue(l));
  }
  function Hr(l) {
    if (!rr(l))
      return en(l);
    var m = [];
    for (var b in Object(l))
      Ie.call(l, b) && b != "constructor" && m.push(b);
    return m;
  }
  function En(l, m) {
    if (m)
      return l.slice();
    var b = new l.constructor(l.length);
    return l.copy(b), b;
  }
  function zt(l) {
    var m = new l.constructor(l.byteLength);
    return new hr(m).set(new hr(l)), m;
  }
  function Tn(l, m) {
    var b = m ? zt(l.buffer) : l.buffer;
    return new l.constructor(b, l.byteOffset, l.byteLength);
  }
  function Cn(l, m, b) {
    var L = m ? b(ct(l), !0) : ct(l);
    return Ne(L, te, new l.constructor());
  }
  function On(l) {
    var m = new l.constructor(l.source, le.exec(l));
    return m.lastIndex = l.lastIndex, m;
  }
  function Pn(l, m, b) {
    var L = m ? b(Pt(l), !0) : Pt(l);
    return Ne(L, ae, new l.constructor());
  }
  function p(l) {
    return yr ? Object(yr.call(l)) : {};
  }
  function C(l, m) {
    var b = m ? zt(l.buffer) : l.buffer;
    return new l.constructor(b, l.byteOffset, l.length);
  }
  function A(l, m) {
    var b = -1, L = l.length;
    for (m || (m = Array(L)); ++b < L; )
      m[b] = l[b];
    return m;
  }
  function D(l, m, b, L) {
    b || (b = {});
    for (var he = -1, ge = m.length; ++he < ge; ) {
      var Ce = m[he], _e = L ? L(b[Ce], l[Ce], Ce, b, l) : void 0;
      tr(b, Ce, _e === void 0 ? l[Ce] : _e);
    }
    return b;
  }
  function U(l, m) {
    return D(l, Oe(l), m);
  }
  function de(l) {
    return Vr(l, xr, Oe);
  }
  function Z(l, m) {
    var b = l.__data__;
    return Mn(m) ? b[typeof m == "string" ? "string" : "hash"] : b.map;
  }
  function ee(l, m) {
    var b = je(l, m);
    return Sn(b) ? b : void 0;
  }
  var Oe = mr ? kt(mr, Object) : fo, xe = _n;
  (At && xe(new At(new ArrayBuffer(1))) != M || tt && xe(new tt()) != v || ft && xe(ft.resolve()) != E || Nt && xe(new Nt()) != _ || Rt && xe(new Rt()) != P) && (xe = function(l) {
    var m = wt.call(l), b = m == y ? l.constructor : void 0, L = b ? Ue(b) : void 0;
    if (L)
      switch (L) {
        case vr:
          return M;
        case gr:
          return v;
        case tn:
          return E;
        case rn:
          return _;
        case nn:
          return P;
      }
    return m;
  });
  function ze(l) {
    var m = l.length, b = l.constructor(m);
    return m && typeof l[0] == "string" && Ie.call(l, "index") && (b.index = l.index, b.input = l.input), b;
  }
  function Fe(l) {
    return typeof l.constructor == "function" && !rr(l) ? zr(Xr(l)) : {};
  }
  function bt(l, m, b, L) {
    var he = l.constructor;
    switch (m) {
      case x:
        return zt(l);
      case a:
      case u:
        return new he(+l);
      case M:
        return Tn(l, L);
      case H:
      case R:
      case q:
      case K:
      case k:
      case V:
      case Q:
      case re:
      case ve:
        return C(l, L);
      case v:
        return Cn(l, L, b);
      case g:
      case O:
        return new he(l);
      case S:
        return On(l);
      case _:
        return Pn(l, L, b);
      case T:
        return p(l);
    }
  }
  function Ke(l, m) {
    return m = m ?? i, !!m && (typeof l == "number" || N.test(l)) && l > -1 && l % 1 == 0 && l < m;
  }
  function Mn(l) {
    var m = typeof l;
    return m == "string" || m == "number" || m == "symbol" || m == "boolean" ? l !== "__proto__" : l === null;
  }
  function Br(l) {
    return !!Zt && Zt in l;
  }
  function rr(l) {
    var m = l && l.constructor, b = typeof m == "function" && m.prototype || dt;
    return l === b;
  }
  function Ue(l) {
    if (l != null) {
      try {
        return er.call(l);
      } catch {
      }
      try {
        return l + "";
      } catch {
      }
    }
    return "";
  }
  function oo(l) {
    return Ft(l, !0, !0);
  }
  function An(l, m) {
    return l === m || l !== l && m !== m;
  }
  function so(l) {
    return ao(l) && Ie.call(l, "callee") && (!Ir.call(l, "callee") || wt.call(l) == o);
  }
  var br = Array.isArray;
  function Nn(l) {
    return l != null && uo(l.length) && !Rn(l);
  }
  function ao(l) {
    return co(l) && Nn(l);
  }
  var lo = kr || po;
  function Rn(l) {
    var m = Vt(l) ? wt.call(l) : "";
    return m == d || m == f;
  }
  function uo(l) {
    return typeof l == "number" && l > -1 && l % 1 == 0 && l <= i;
  }
  function Vt(l) {
    var m = typeof l;
    return !!l && (m == "object" || m == "function");
  }
  function co(l) {
    return !!l && typeof l == "object";
  }
  function xr(l) {
    return Nn(l) ? xn(l) : Hr(l);
  }
  function fo() {
    return [];
  }
  function po() {
    return !1;
  }
  t.exports = oo;
})(Wo, Wo.exports);
var Go = Wo.exports, Uo = function() {
  return Uo = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Uo.apply(this, arguments);
};
function eh(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(s) {
      s(o);
    });
  }
  return new (r || (r = Promise))(function(o, s) {
    function a(d) {
      try {
        c(n.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        c(n.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function c(d) {
      d.done ? o(d.value) : i(d.value).then(a, u);
    }
    c((n = n.apply(t, e || [])).next());
  });
}
function th(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(c) {
    return function(d) {
      return u([c, d]);
    };
  }
  function u(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, c[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = c;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(c);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = e.call(t, r);
      } catch (d) {
        c = [6, d], i = 0;
      } finally {
        n = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function ma(t, e, r, n, i) {
  return eh(this, void 0, void 0, function() {
    var o, s;
    return th(this, function(a) {
      switch (a.label) {
        case 0:
          if (r === void 0)
            return [
              2
              /*return*/
            ];
          s = 0, a.label = 1;
        case 1:
          return s < r.length ? [4, r[s](t, e, n, i, r)] : [3, 4];
        case 2:
          if (o = a.sent(), o === "canceled")
            return [3, 4];
          a.label = 3;
        case 3:
          return s++, [3, 1];
        case 4:
          return o !== "canceled" ? [2, o] : [
            2
            /*return*/
          ];
      }
    });
  });
}
var va = function(t, e) {
  return e === void 0 && (e = {}), t ? {
    trackedAnalytics: Uo({ sdkCode: t.sdkCode, sdkSemver: t.sdkSemver, techVersion: t.techVersion }, e)
  } : null;
}, rh = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      var o = this;
      this.isMounted = !0, this.imgElement = e, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var s = Go(r);
      ma(e, s, n, this.htmlPluginState, i).then(function(a) {
        if (o.isMounted) {
          o.htmlPluginState.pluginEventSubscription.forEach(function(c) {
            c();
          });
          var u = va(i, a);
          o.imgElement.setAttribute("src", s.toURL(u));
        }
      });
    }
    return t.prototype.update = function(e, r, n) {
      var i = this, o = Go(e);
      ma(this.imgElement, o, r, this.htmlPluginState).then(function(s) {
        if (i.isMounted) {
          var a = va(n, s);
          i.imgElement.setAttribute("src", o.toURL(a));
        }
      });
    }, t.prototype.unmount = function() {
      this.isMounted = !1;
    }, t;
  }()
);
let Ae = class {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(e) {
    this.values = [], this.delimiter = ":", this.hasValue(e) && this.addValue(e);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(e) {
    return typeof e < "u" && e !== null && e !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(e) {
    return Array.isArray(e) ? this.values = this.values.concat(e) : this.values.push(e), this.values = this.values.filter((r) => this.hasValue(r)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(e) {
    return this.delimiter = e, this;
  }
}, nh = class extends Error {
  constructor(t = "Unsupported") {
    super(t);
  }
};
function xs(t) {
  return new nh(t);
}
function ih() {
  return this._qualifierModel || { error: xs(`unsupported qualifier ${this.constructor.name}`) };
}
let oh = class {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return ih.apply(this);
  }
}, ce = class extends oh {
  constructor(e, r) {
    super(), this.delimiter = "_", this.key = e, r instanceof Ae ? this.qualifierValue = r : (this.qualifierValue = new Ae(), this.qualifierValue.addValue(r));
  }
  toString() {
    const { key: e, delimiter: r, qualifierValue: n } = this;
    return `${e}${r}${n.toString()}`;
  }
  addValue(e) {
    return this.qualifierValue.addValue(e), this;
  }
}, vt = class extends ce {
  constructor(e, r) {
    let n;
    r ? n = new Ae([e, `${r}`]).setDelimiter(":") : n = e, super("fl", n), this.flagValue = r;
  }
  toString() {
    return super.toString().replace(/\./, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
};
function sh(t, e) {
  const r = Array.from(t.entries());
  return e.forEach((n) => {
    r.push(["fl", n]);
  }), r.sort().map((n) => n[1]);
}
function ah() {
  var t, e, r;
  const n = this._actionModel && Object.keys(this._actionModel).length, i = (r = (e = (t = this._actionModel) === null || t === void 0 ? void 0 : t.source) === null || e === void 0 ? void 0 : e.transformation) === null || r === void 0 ? void 0 : r.error;
  return i && i instanceof Error ? { error: i } : n ? this._actionModel : { error: xs(`unsupported action ${this.constructor.name}`) };
}
let lh = class {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return ah.apply(this);
  }
}, It = class extends lh {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(t) {
    return this.actionTag = t, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), sh(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(t) {
    if (typeof t == "string") {
      const [e, r] = t.toLowerCase().split("_");
      e === "fl" ? this.flags.push(new vt(r)) : this.qualifiers.set(e, new ce(e, r));
    } else
      this.qualifiers.set(t.key, t);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(t) {
    return typeof t == "string" ? this.flags.push(new vt(t)) : t instanceof vt && this.flags.push(t), this;
  }
  addValueToQualifier(t, e) {
    return this.qualifiers.get(t).addValue(e), this;
  }
};
class _s extends It {
  constructor(e) {
    super(), this.regionType = e, this._actionModel.regionType = e;
  }
}
class Fi extends _s {
  constructor() {
    super("custom");
  }
  /**
   * @description The x position in pixels.
   * @param {number | string} x
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ce("x", e)), this;
  }
  /**
   * @description The y position in pixels.
   * @param {number | string} y
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ce("y", e)), this;
  }
  /**
   * @description The width of the region in pixels.
   * @param {number | string} width
   */
  width(e) {
    return this._actionModel.width = e, this.addQualifier(new ce("w", e)), this;
  }
  /**
   * @description The height of the region in pixels.
   * @param {number | string} height
   */
  height(e) {
    return this._actionModel.height = e, this.addQualifier(new ce("h", e)), this;
  }
  static fromJson(e) {
    const r = new Fi();
    return e.width && r.width(e.width), e.height && r.height(e.height), e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function uh() {
  return new Fi();
}
function fu() {
  return new _s("faces");
}
function ch() {
  return new _s("ocr_text");
}
class dh extends It {
  constructor(e) {
    super(), this._actionModel = {}, this._strength = e, this._actionModel.actionType = "blur", this._actionModel.strength = e;
  }
  /**
   * @description Specifies the region to blur.
   * @param {NamedRegion} blurRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = e.toJson(), this;
  }
  /**
   * @description Sets the strength of the blur effect.
   * @param {number | string} strength
   */
  strength(e) {
    return this._strength = e, this._actionModel.strength = e, this;
  }
  prepareQualifiers() {
    const e = this._strength ? `:${this._strength}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((r) => this.addQualifier(r)), this._region.regionType === "custom" && this.addQualifier(new ce("e", `blur_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new ce("e", `blur_region${e}`)), this.addQualifier(new ce("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new ce("e", `blur_faces${e}`))) : this.addQualifier(new ce("e", `blur${e}`));
  }
  static fromJson(e) {
    const { strength: r, region: n } = e, i = new this(r);
    return r && i.strength(r), n && n.regionType === "faces" && i.region(fu()), n && n.regionType === "ocr_text" && i.region(ch()), n && n.regionType === "custom" && i.region(Fi.fromJson(n)), i;
  }
}
function Ar(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    e[t[r]] = r;
  }), e;
}
const pu = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad"
}, fh = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, hu = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, mu = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, ph = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, vu = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, hh = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
}, mh = Ar(vu);
Ar(hh);
const vh = Ar(pu), gh = Ar(fh), gu = Ar(hu);
Ar(mu);
Ar(ph);
class yu extends It {
  constructor(e, r) {
    super(), this._actionModel = {}, this._actionModel.actionType = gu[e] || e;
    const n = this.createEffectQualifier(e, r);
    this.addQualifier(n);
  }
  createEffectQualifier(e, r) {
    let n;
    return r ? n = new Ae([e, `${r}`]).setDelimiter(":") : n = new Ae(e), new ce("e", n);
  }
  static fromJson(e) {
    const { actionType: r, level: n, strength: i } = e, o = hu[r] || r;
    return new this(o, n || i);
  }
}
class yh extends yu {
  constructor(e, r) {
    super(e, r), this.LEVEL_NAME = "level", this._actionModel = {}, this.effectType = e, this._actionModel.actionType = gu[e] || e, r && this.setLevel(r);
  }
  /**
   *
   * @description Sets the effect level for the action
   * @param {string | number} level - The strength of the effect
   * @protected
   */
  setLevel(e) {
    this._actionModel[this.LEVEL_NAME] = e;
    const r = this.createEffectQualifier(this.effectType, e);
    return this.addQualifier(r), this;
  }
}
function zi(t) {
  return t && (t.match(/^#/) ? `rgb:${t.substr(1)}` : t);
}
class wh extends It {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "vectorize";
  }
  /**
   * @description The number of colors. (Range: 2 to 30, Server default: 10)
   * @param {number | string} num
   * @return {this}
   */
  numOfColors(e) {
    return this._actionModel.numOfColors = e, this._numOfColors = e, this;
  }
  /**
   * @description The level of detail. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 1000). (Server default: 300)
   * @param {number | string} num
   * @return {this}
   */
  detailsLevel(e) {
    return this._actionModel.detailLevel = e, this._detailsLevel = e, this;
  }
  /**
   * @description The size of speckles to suppress. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 100, Server default: 2)
   * @param {number | string} num
   * @return {this}
   */
  despeckleLevel(e) {
    return this._actionModel.despeckleLevel = e, this._despeckleLevel = e, this;
  }
  /**
   * @description The corner threshold. Specify 100 for no smoothing (polygon corners), 0 for completely smooth corners. (Range: 0 to 100, Default: 25)
   * @param {number | string} num
   * @return {this}
   */
  cornersLevel(e) {
    return this._actionModel.cornersLevel = e, this._cornersLevel = e, this;
  }
  /**
   * @description The optimization value. Specify 100 for least optimization and the largest file. (Range: 0 to 100, Server default: 100).
   * @param {number} num
   * @return {this}
   */
  paths(e) {
    return this._actionModel.paths = e, this._paths = e, this;
  }
  prepareQualifiers() {
    let e = "vectorize";
    this._numOfColors && (e += `:${new Ae(`colors:${this._numOfColors}`).toString()}`), this._detailsLevel && (e += `:${new Ae(`detail:${this._detailsLevel}`).toString()}`), this._despeckleLevel && (e += `:${new Ae(`despeckle:${this._despeckleLevel}`).toString()}`), this._paths && (e += `:${new Ae(`paths:${this._paths}`).toString()}`), this._cornersLevel && (e += `:${new Ae(`corners:${this._cornersLevel}`).toString()}`), this.addQualifier(new ce("e", e));
  }
  static fromJson(e) {
    const { actionType: r, paths: n, cornersLevel: i, despeckleLevel: o, detailLevel: s, numOfColors: a } = e, u = new this();
    return n && u.paths(n), i && u.cornersLevel(i), o && u.despeckleLevel(o), s && u.detailsLevel(s), a && u.numOfColors(a), u;
  }
}
class bh extends yh {
  level(e) {
    return this._actionModel.level = e, this.setLevel(e);
  }
}
class xh extends It {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "assistColorblind", this.addQualifier(new ce("e", new Ae("assist_colorblind")));
  }
  /**
   * @description Replaces problematic colors with colors that are easier to differentiate.
   * @return {this}
   */
  xray() {
    return this._actionModel.type = "xray", this.addQualifier(new ce("e", new Ae(["assist_colorblind", "xray"]).setDelimiter(":")));
  }
  /**
   * @description Applies stripes of the specified intensity to help people with common color blind conditions to differentiate between colors that are similar for them.
   * @param {number | string} strength The intensity of the stripes. (Range: 1 to 100, Server default: 10)
   * @return {this}
   */
  stripesStrength(e) {
    return this._actionModel.type = "stripes", this._actionModel.stripesStrength = e, this.addQualifier(new ce("e", new Ae(["assist_colorblind", e]).setDelimiter(":")));
  }
  static fromJson(e) {
    const { actionType: r, type: n, stripesStrength: i } = e, o = new this();
    return n === "xray" && o.xray(), n === "stripes" && i && o.stripesStrength(i), o;
  }
}
class _h extends bh {
  /**
   * @description The color to use for colorization. Specify HTML name or RGB hex code. (Server default: gray)
   * @param {string} color HTML name(red, green, etc.) or RGB hex code. (Server default: gray)
   * @return {this}
   */
  color(e) {
    return this._actionModel.color = e, this.addQualifier(new ce("co", new Ae(zi(e))));
  }
  static fromJson(e) {
    const { actionType: r, level: n, color: i } = e, o = new this(r, n);
    return i && o.color(i), o;
  }
}
class Sh extends It {
  constructor(e) {
    super(), this._actionModel = {}, this._squareSize = e, this._actionModel.actionType = "pixelate", this._actionModel.squareSize = e;
  }
  /**
   * @description Specifies the region to piexlate.
   * @param {NamedRegion} pixelateRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = { regionType: this._region.regionType }, this;
  }
  /**
   * @description Sets the squareSize of the pixelate effect.
   * @param {number | string} squareSize
   */
  squareSize(e) {
    return this._squareSize = e, this._actionModel.squareSize = e, this;
  }
  prepareQualifiers() {
    const e = this._squareSize ? `:${this._squareSize}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((r) => this.addQualifier(r)), this._region.regionType === "custom" && this.addQualifier(new ce("e", `pixelate_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new ce("e", `pixelate_region${e}`)), this.addQualifier(new ce("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new ce("e", `pixelate_faces${e}`))) : this.addQualifier(new ce("e", `pixelate${e}`));
  }
  static fromJson(e) {
    const { region: r, squareSize: n } = e, i = new this(n);
    return n && i.squareSize(n), r && r.regionType === "faces" && i.region(fu()), r && r.regionType === "custom" && i.region(uh()), i;
  }
}
function Eh(t) {
  return new dh(t);
}
function Th() {
  return new yu("grayscale");
}
function ga(t) {
  return new _h("colorize", t);
}
function Ch() {
  return new wh();
}
function Oh() {
  return new xh();
}
function Ph(t) {
  return new Sh(t);
}
let Mh = class extends It {
  constructor(t) {
    super(), this._actionModel = {}, this.addQualifier(new ce("b", new Ae(zi(t)).setDelimiter("_"))), this._actionModel.color = t, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(t) {
    const { color: e } = t;
    return new this(e);
  }
}, ya = class {
  constructor(t) {
    this.raw = t;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: xs(`unsupported action ${this.constructor.name}`) };
  }
};
function Ah(t) {
  const e = t;
  return "error" in e && !!e.error;
}
function Nh() {
  return new vt("ignore_aspect_ratio");
}
function Rh() {
  return new vt("lossy");
}
function Lh() {
  return new vt("preserve_transparency");
}
function $h(t) {
  return new vt("progressive", t);
}
function Ih() {
  return new vt("region_relative");
}
function kh() {
  return new vt("relative");
}
let Ss = class extends Ae {
  constructor(e) {
    super(e), this.val = e;
  }
  getValue() {
    return this.val;
  }
}, wu = class extends It {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(t, e, r) {
    super(), this._actionModel = {};
    let n;
    e instanceof Ss ? n = e.getValue() : n = e, this._actionModel.actionType = gh[t], this._actionModel[r] = n, this.addQualifier(new ce(t, e));
  }
}, jh = class extends vt {
  constructor(t) {
    super("progressive", t);
  }
}, qo = class extends wu {
  constructor(e, r) {
    super(e, r, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(Rh()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(e) {
    return e instanceof jh ? (this._actionModel.progressive = { mode: e.getFlagValue() }, this.addFlag(e)) : (this._actionModel.progressive = { mode: e }, this.addFlag($h(e))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(Lh()), this;
  }
  static fromJson(e) {
    const { formatType: r, lossy: n, progressive: i, preserveTransparency: o } = e;
    let s;
    return r ? s = new this("f", r) : s = new this("f"), i && (i.mode ? s.progressive(i.mode) : s.progressive()), n && s.lossy(), o && s.preserveTransparency(), s;
  }
}, Vi = class bu {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    let r;
    if (typeof e == "string") {
      if (e.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      r = new ya(e);
    } else
      r = e;
    return this.actions.push(r), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(e) {
    return e instanceof bu ? this.actions = this.actions.concat(e.actions) : this.actions.push(new ya(e)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((e) => e.toString()).filter((e) => e).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(e) {
    return this.addAction(e);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(e) {
    return this.addAction(e);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(e) {
    return this.addAction(e);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new qo("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new qo("f", e)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(e) {
    return e.setLayerType("u"), this.addAction(e);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.addAction(e);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(e) {
    return this.addAction(e);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.addAction(e);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.addAction(new Mh(e));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(e) {
    return this.addAction(e);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    const r = new It();
    let n = e;
    return typeof e == "string" && (n = new vt(e)), r.addQualifier(n), this.addAction(r);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(e) {
    return this.addAction(e);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(e) {
    return this.addAction(e);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(e) {
    return this.addAction(e);
  }
  toJson() {
    const e = [];
    for (const r of this.actions) {
      const n = r.toJson();
      if (Ah(n))
        return n;
      e.push(n);
    }
    return { actions: e };
  }
};
function wa(t) {
  const e = t.toString();
  return e.match(/[A-Z]/gi) || e.length > 1 && e[0] === "0" ? e : !isNaN(parseFloat(e)) && e.indexOf(":") === -1 && e.indexOf(".") === -1 ? `${e}.0` : e;
}
class Dh extends Ae {
}
class Fh extends It {
  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  constructor(e, r, n) {
    super(), this._actionModel = { dimensions: {} }, this._actionModel.actionType = vh[e] || e, this.addQualifier(new ce("c", e)), r && this.width(r), n && this.height(n);
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  height(e) {
    return this._actionModel.dimensions.height = e, this.addQualifier(new ce("h", e));
  }
  /**
   * @description Sets the width of the resize
   * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  width(e) {
    return this._actionModel.dimensions.width = e, this.addQualifier(new ce("w", e));
  }
  /**
   * @description Sets the aspect ratio of the asset.
   * For a list of supported types see {@link Qualifiers.AspectRatio|
    * AspectRatio values}
   * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
   * @return {this}
   */
  aspectRatio(e) {
    if (e instanceof Dh)
      return this._actionModel.dimensions.aspectRatio = `${e}`, this.addQualifier(new ce("ar", e));
    if (typeof e == "number" || typeof e == "string")
      return this._actionModel.dimensions.aspectRatio = wa(e), this.addQualifier(new ce("ar", wa(e)));
    if (e instanceof vt)
      return this._actionModel.dimensions.aspectRatio = `${e.qualifierValue}`, this.addFlag(e);
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
   * @return {this}
   */
  relative() {
    return this._actionModel.relative = !0, this.addFlag(kh());
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
   * @return {this}
   */
  regionRelative() {
    return this._actionModel.regionRelative = !0, this.addFlag(Ih());
  }
  static fromJson(e) {
    const { actionType: r, dimensions: n, relative: i, regionRelative: o } = e, { aspectRatio: s, width: a, height: u } = n, c = pu[r] || r, d = new this(c, a, u);
    return s && d.aspectRatio(s === "ignore_aspect_ratio" ? Nh() : s), i && d.relative(), o && d.regionRelative(), d;
  }
}
let Es = class extends ce {
  /**
   * @param value, an array containing (GravityObject | AutoGravity | string) or a string;
   */
  constructor(e) {
    super("g", new Ae(e));
  }
};
class xu extends Es {
  constructor() {
    super("auto");
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */
  autoFocus(...e) {
    return this.addValue(e), this;
  }
}
class _u extends Es {
  constructor(e) {
    super(e);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */
  fallbackGravity(e) {
    return this.addValue(e.qualifierValue), this;
  }
}
class Su extends Es {
  constructor(e) {
    super(e);
  }
}
function zh(t) {
  return new Su(t);
}
function Eu(...t) {
  const e = [...t];
  return new _u(e);
}
function Tu() {
  return new xu();
}
class Hi extends Ae {
  constructor(e) {
    super(), this.name = e;
  }
  toString() {
    return this.name;
  }
}
function Vh() {
  return new Hi("ocr_text");
}
function Hh(t) {
  return t && `${t}`.split(":")[0] === "auto";
}
function Bh(t) {
  const e = Ts(t);
  return ["north", "center", "east", "west", "south", "north_west", "south_east", "south_west", "north_east"].includes(e);
}
function Ts(t) {
  return `${t}`.replace("g_", "");
}
function Wh(t) {
  return {
    compass: Ts(t),
    gravityType: "direction"
  };
}
function Gh(t) {
  return Ts(t) === "ocr_text";
}
function Uh() {
  return {
    gravityType: "ocr"
  };
}
function qh(t) {
  return `${t.qualifierValue}`.split(":")[0] === "auto";
}
function Yh(t) {
  const e = t.toString().split("_"), r = {
    object: e[0]
  };
  return e.length > 1 && (e[1] === "avoid" ? r.avoid = !0 : r.weight = +e[1]), r;
}
function Cu(t) {
  let e;
  const r = t === "auto" ? new xu() : t;
  return `${t}`.startsWith("auto:") ? e = `${t}`.split(":").filter((n) => n !== "auto") : e = r.qualifierValue.values.filter((n) => n !== "auto"), {
    gravityType: "auto",
    autoFocus: e.map(Yh)
  };
}
function Qh(t) {
  const e = `${t}`.split(":").includes("auto"), r = t.qualifierValue.values, n = {
    gravityType: "object",
    focusOnObjects: (e ? r.slice(0, r.length - 1) : r).map((i) => `${i}`)
  };
  if (e) {
    const i = r[r.length - 1].values.slice(1), o = Tu().autoFocus(...i);
    n.fallbackGravity = Cu(o);
  }
  return n;
}
function Jh(t) {
  const e = t.split(":").map((r) => new Hi(r));
  return new _u(e);
}
function Kh(t) {
  return Bh(t) ? Wh(t) : Gh(t) ? Uh() : Hh(t) || qh(t) ? Cu(t) : Qh(typeof t == "string" ? Jh(t) : t);
}
class Cs extends Ae {
  constructor(e, r) {
    super(), this._weight = r, this.focusOn = e, this.shouldAvoid = !1;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */
  static focusOn(e, r) {
    return new Cs(e, r);
  }
  shouldAddWeight() {
    return typeof this._weight == "number" || typeof this._weight == "string" || this.shouldAvoid;
  }
  /**
   * @summary qualifier
   * @desc Get the name of the of the object
   */
  getName() {
    return this.focusOn.name;
  }
  /**
   * @summary qualifier
   * @desc Get the weight for the object
   */
  getWeight() {
    return this.shouldAvoid ? "avoid" : this._weight;
  }
  /**
   * @summary qualifier
   * @desc Return the string representation of this QualifierValue
   */
  toString() {
    return this.shouldAddWeight() ? `${this.getName()}_${this.getWeight()}` : `${this.getName()}`;
  }
  /**
   * @summary qualifier
   * @description Sets the importance level of the object within the automatic gravity algorithm
   * @param {numebr} w The focus weight for the object
   * @return {this}
   */
  weight(e) {
    return this._weight = e, this;
  }
  /**
   * @summary qualifier
   * @description Attempts to avoid the detected object in the image
   * @return {this}
   */
  avoid() {
    return this.shouldAvoid = !0, this;
  }
}
class Ou extends Ae {
  constructor(e) {
    super(), this.val = e;
  }
  toString() {
    return this.val;
  }
}
function Xh(t) {
  return t.gravityType === "direction";
}
function Zh(t) {
  return t.gravityType === "ocr";
}
function em(t) {
  return t.gravityType === "auto";
}
function tm(t) {
  const { object: e, weight: r, avoid: n } = t, i = new Cs(new Hi(e));
  return (r || r === 0) && i.weight(r), n && i.avoid(), i;
}
function Pu(t) {
  const e = (t.autoFocus || []).map(tm);
  return Tu().autoFocus(...e);
}
function rm(t) {
  const e = (t.focusOnObjects || []).map((n) => new Hi(n)), r = Eu(...e);
  if (t.fallbackGravity) {
    const n = Pu(t.fallbackGravity);
    r.fallbackGravity(n);
  }
  return r;
}
function nm(t) {
  return Xh(t) ? new Su(new Ou(t.compass)) : Zh(t) ? Eu(Vh()) : em(t) ? Pu(t) : rm(t);
}
let Os = class extends Fh {
  /**
   * @description Which part of the original image to include.
   * @param {Qualifiers.Gravity} gravity
   */
  gravity(e) {
    this._actionModel.gravity = Kh(e);
    const r = typeof e == "string" ? new ce("g", e) : e;
    return this.addQualifier(r);
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.gravity && r.gravity(nm(e.gravity)), r;
  }
};
class Zn extends ce {
  constructor(e) {
    super("b"), e && this.addValue(e);
  }
}
const Mu = 100, im = 0;
class om extends Zn {
  /**
   * @description Sets the intensity of the blur.
   * @param {number} value - The intensity of the blur.
   */
  intensity(e) {
    return this.intensityLevel = e, this;
  }
  /**
   * @description Sets the brightness of the background.
   * @param {number} value - The brightness of the background.
   */
  brightness(e) {
    return this.brightnessLevel = e, this;
  }
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function
   */
  toString() {
    const e = this.intensityLevel !== void 0 ? `:${this.intensityLevel}` : "", r = this.brightnessLevel !== void 0 ? this.intensityLevel !== void 0 ? `:${this.brightnessLevel}` : `:${Mu}:${this.brightnessLevel}` : "";
    return `b_blurred${e}${r}`;
  }
}
var Au = om;
let Ps = class extends Zn {
  constructor() {
    super(), this._palette = [];
  }
  /**
   * @description Selects the strongest contrasting color to use for padding.
   * @return {this}
   */
  contrast() {
    return this._contrast = !0, this;
  }
  /**
   * @description Defines the custom colors to use when resizing using content-aware padding.
   * @param {...string} colors One or more colors - Example: palette('green', 'red', blue')
   * @return {this}
   */
  palette(...e) {
    return this._palette = e.map((r) => zi(r)), this;
  }
};
class Nu extends Ps {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Ru extends Ps {
  /**
   *
   * @description Sets the number of predominant colors to use (2 or 4).
   * @param {number} num
   * @return {this}
   */
  gradientColors(e) {
    return this._gradientColors = e, this;
  }
  /**
   * @description Sets the direction for a background gradient fade effect.
   * @param {Qualifiers.GradientDirection | GradientDirectionType | string} direction Use one of these functions
   * provided by {@link Qualifiers.GradientDirection|GradientDirection}
   * @return {this}
   */
  gradientDirection(e) {
    return this._gradientDirection = e, this;
  }
}
class Lu extends Ru {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class $u extends Ru {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Iu extends Ps {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class ku extends Zn {
  constructor() {
    super("gen_fill"), this._backgroundType = "generativeFill";
  }
  prompt(e) {
    return this._prompt = e, this;
  }
  getPrompt() {
    return this._prompt;
  }
  getBackgroundType() {
    return this._backgroundType;
  }
  /**
   * @description
   * Override the toString() function to explicitly stringify the qualifier.
   */
  toString() {
    return `b_gen_fill${this._prompt ? `:prompt_${this._prompt}` : ""}`;
  }
}
function ju(t) {
  return `${t}`.replace("b_", "");
}
function sm() {
  return { backgroundType: "auto" };
}
function am(t) {
  const { intensityLevel: e, brightnessLevel: r } = t, n = {
    backgroundType: "blurred"
  };
  return (e || e === 0) && (n.intensity = e), (r || r === 0) && (n.brightness = r), n;
}
function Ms(t) {
  const e = t._contrast, r = t._palette, n = {
    backgroundType: ""
  };
  return e && (n.contrast = !0), r && (n.palette = r), n;
}
function lm(t) {
  return Object.assign(Object.assign({}, Ms(t)), { backgroundType: "border" });
}
function Du(t) {
  const e = t._gradientColors, r = `${t._gradientDirection}`, n = Ms(t);
  return e && (n.gradientColors = e), r && (n.gradientDirection = r), n;
}
function um(t) {
  return Object.assign(Object.assign({}, Du(t)), { backgroundType: "borderGradient" });
}
function cm(t) {
  return {
    backgroundType: "color",
    color: ju(t)
  };
}
function dm(t) {
  return Object.assign(Object.assign({}, Ms(t)), { backgroundType: "predominant" });
}
function fm(t) {
  return Object.assign(Object.assign({}, Du(t)), { backgroundType: "predominantGradient" });
}
function pm(t) {
  return Object.assign({ backgroundType: t.getBackgroundType() }, t.getPrompt() ? { prompt: t.getPrompt() } : {});
}
function hm(t) {
  return ju(t) === "auto" ? sm() : t instanceof Au ? am(t) : t instanceof Nu ? lm(t) : t instanceof Lu ? um(t) : t instanceof Iu ? dm(t) : t instanceof $u ? fm(t) : t instanceof ku ? pm(t) : cm(t);
}
function mm() {
  return new Ss("svg");
}
function As() {
  return new Ss("auto");
}
function Fu() {
  return new Nu();
}
function zu() {
  return new Zn("auto");
}
function Vu() {
  return new Lu();
}
function Hu() {
  return new $u();
}
function Bu() {
  return new Iu();
}
function Wu(t) {
  return new Zn(zi(t));
}
function vm() {
  return new Au();
}
function Gu() {
  return new ku();
}
const Uu = {
  auto: zu,
  border: Fu,
  borderGradient: Vu,
  predominantGradient: Hu,
  predominant: Bu,
  color: Wu,
  blurred: vm,
  generativeFill: Gu
};
function gm(t) {
  const { brightness: e, intensity: r } = t, n = Uu.blurred();
  return n.brightness(e ?? im), n.intensity(r ?? Mu), n;
}
function ba(t, e) {
  const { gradientColors: r, gradientDirection: n, contrast: i, palette: o } = e;
  return i && t.contrast(), o && t.palette(...o), r && t.gradientColors(+r), n && t.gradientDirection(n), t;
}
function xa(t, e) {
  const { contrast: r, palette: n } = e;
  return r && t.contrast(), n && t.palette(...n), t;
}
function ym(t, e) {
  const { prompt: r } = e;
  return r && t.prompt(r), t;
}
function wm(t) {
  const { backgroundType: e } = t;
  switch (e) {
    case "auto":
      return zu();
    case "blurred":
      return gm(t);
    case "border":
      return xa(Fu(), t);
    case "borderGradient":
      return ba(Vu(), t);
    case "predominant":
      return xa(Bu(), t);
    case "predominantGradient":
      return ba(Hu(), t);
    case "generativeFill":
      return ym(Gu(), t);
    default:
      return Wu(t.color);
  }
}
let bm = class extends Os {
  /**
   * @description Sets the background.
   * @param {Qualifiers.Background} backgroundQualifier Defines the background color to use instead of
   * transparent background areas or when resizing with padding.
   */
  background(e) {
    return this._actionModel.background = hm(e), this.addQualifier(e);
  }
  /**
   * @description Horizontal position for custom-coordinates based padding.
   * @param {number} x The x position.
   */
  offsetX(e) {
    return this._actionModel.x = e, this.addQualifier(new ce("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based padding
   * @param {number} y The y position.
   */
  offsetY(e) {
    return this._actionModel.y = e, this.addQualifier(new ce("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.background && r.background(wm(e.background)), e.x && r.offsetX(e.x), e.y && r.offsetY(e.y), e.zoom && r.zoom(e.zoom), r;
  }
};
class xm extends Os {
  /**
   * @description Horizontal position for custom-coordinates based cropping.
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ce("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based cropping
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ce("y", e));
  }
  /**
   * @description Controls how much of the original image surrounding the face to keep when using either the 'crop' or 'thumb' cropping modes with face detection.
   * @param {number | string} z The zoom factor. (Default: 1.0)
   */
  zoom(e) {
    return this._actionModel.zoom = e, this.addQualifier(new ce("z", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), e.zoom && r.zoom(e.zoom), r;
  }
}
class _m extends Os {
  /**
   * @description Absolute X position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ce("x", e));
  }
  /**
   * @description Absolute Y position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ce("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function Sm(t, e) {
  return new xm("crop", t, e);
}
function Em(t, e) {
  return new _m("fill", t, e);
}
function Tm(t, e) {
  return new bm("pad", t, e);
}
class Cm extends wu {
  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  constructor(e) {
    super("q", e.toString(), "level");
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_optimization#toggle_chroma_subsampling|Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */
  chromaSubSampling(e) {
    this._actionModel.chromaSubSampling = vu[e];
    const r = new Ae([this._actionModel.level, e]);
    return r.setDelimiter(":"), this.addQualifier(new ce("q", r));
  }
  /**
   * Controls the final quality by setting a maximum quantization percentage
   * @param {number} val
   */
  quantization(e) {
    this._actionModel.quantization = e;
    const r = new Ae([this._actionModel.level, `qmax_${e}`]).setDelimiter(":");
    return this.addQualifier(new ce("q", r));
  }
  static fromJson(e) {
    const { level: r, chromaSubSampling: n, quantization: i } = e, o = mu[r] || r, s = new this(o);
    if (n) {
      const a = mh[n.toUpperCase()];
      a && s.chromaSubSampling(+a);
    }
    return i && s.quantization(i), s;
  }
}
function Bi(t) {
  return new qo("f", t);
}
function Wi(t) {
  return new Cm(t);
}
function Om() {
  return new Ou("north_east");
}
ga(70).color("black"), ga(40).color("white"), Th(), Oh();
new Vi().effect(Ch()).delivery(Wi("auto")).delivery(Bi(mm()));
new Vi().effect(Ph()).delivery(Wi("auto")).delivery(Bi(As()));
new Vi().effect(Eh(2e3)).delivery(Wi("auto")).delivery(Bi(As()));
new Vi().resize(Tm("iw_div_2").aspectRatio(1).background(Uu.auto())).resize(Sm(1, 1).gravity(zh(Om()))).resize(Em().height("ih").width("iw")).delivery(Wi("auto")).delivery(Bi(As()));
var Pm = typeof sr == "object" && sr && sr.Object === Object && sr, Mm = typeof self == "object" && self && self.Object === Object && self;
Pm || Mm || Function("return this")();
function Am() {
  return typeof window < "u";
}
function Nm(t, e, r) {
  var n = Go(e);
  if (t)
    for (var i = 0; i < t.length; i++) {
      var o = t[i](null, n);
      if (!o)
        break;
    }
  return n.toURL(r ? { trackedAnalytics: r } : null);
}
function _a(t) {
  t.cleanupCallbacks.forEach(function(e) {
    e();
  });
}
const Xe = ({ cldImg: t, plugins: e, src: r, ...n }) => {
  const i = se(null), o = se(null);
  if (ne(() => (i.current && (o.current = new rh(i.current, t, e)), () => {
    o.current && (_a(o.current.htmlPluginState), o.current.unmount());
  }), [t, e]), ne(() => {
    o.current && (_a(o.current.htmlPluginState), o.current.update(t, e));
  }, [t, e]), Am())
    return /* @__PURE__ */ h("img", { suppressHydrationWarning: !0, ...n, src: r == null ? void 0 : r.toURL(), ref: i });
  {
    const s = Nm(e, t);
    return /* @__PURE__ */ h("img", { ...n, src: s });
  }
};
function Rm(t) {
  return !(typeof t != "object" || t instanceof Array);
}
class Lm {
  filterOutNonSupportedKeys(e, r) {
    const n = /* @__PURE__ */ Object.create({});
    return Rm(e) ? (Object.keys(e).forEach((i) => {
      r.indexOf(i) >= 0 ? n[i] = e[i] : console.warn("Warning - unsupported key provided to configuration: ", i);
    }), n) : /* @__PURE__ */ Object.create({});
  }
}
const $m = Lm, Sa = [
  "cname",
  "secureDistribution",
  "privateCdn",
  "signUrl",
  "longUrlSignature",
  "shorten",
  "useRootPath",
  "secure",
  "forceVersion",
  "analytics",
  "queryParams"
];
class Ns extends $m {
  /**
   * @param {IURLConfig} userURLConfig
   */
  constructor(e) {
    super();
    const r = this.filterOutNonSupportedKeys(e, Sa);
    Object.assign(this, {
      secure: !0
    }, r);
  }
  extend(e) {
    const r = this.filterOutNonSupportedKeys(e, Sa);
    return new Ns(Object.assign({}, this, r));
  }
  /**
   * @param {string} value Sets the cname
   */
  setCname(e) {
    return this.cname = e, this;
  }
  /**
   * @param {string} value Sets the secureDistribution
   */
  setSecureDistribution(e) {
    return this.secureDistribution = e, this;
  }
  /**
   * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
   */
  setPrivateCdn(e) {
    return this.privateCdn = e, this;
  }
  /**
   * @param value Sets whether or not to sign the URL
   */
  setSignUrl(e) {
    return this.signUrl = e, this;
  }
  /**
   * @param value Sets whether or not to use a long signature
   */
  setLongUrlSignature(e) {
    return this.longUrlSignature = e, this;
  }
  /**
   * @param value Sets whether or not to shorten the URL
   */
  setShorten(e) {
    return this.shorten = e, this;
  }
  /**
   * @param value Sets whether or not to use a root path
   */
  setUseRootPath(e) {
    return this.useRootPath = e, this;
  }
  /**
   * @param value Sets whether or not to deliver the asset through https
   */
  setSecure(e) {
    return this.secure = e, this;
  }
  /**
   * @param value Sets whether to force a version in the URL
   */
  setForceVersion(e) {
    return this.forceVersion = e, this;
  }
  /**
   * @param params Sets additional params
   */
  setQueryParams(e) {
    return this.queryParams = e, this;
  }
}
const Im = Ns;
class Gn {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(e) {
    this.values = [], this.delimiter = ":", this.hasValue(e) && this.addValue(e);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(e) {
    return typeof e < "u" && e !== null && e !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(e) {
    return Array.isArray(e) ? this.values = this.values.concat(e) : this.values.push(e), this.values = this.values.filter((r) => this.hasValue(r)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(e) {
    return this.delimiter = e, this;
  }
}
class km extends Error {
  constructor(e = "Unsupported") {
    super(e);
  }
}
function Rs(t) {
  return new km(t);
}
function jm() {
  return this._qualifierModel || { error: Rs(`unsupported qualifier ${this.constructor.name}`) };
}
class Dm {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return jm.apply(this);
  }
}
class Gi extends Dm {
  constructor(e, r) {
    super(), this.delimiter = "_", this.key = e, r instanceof Gn ? this.qualifierValue = r : (this.qualifierValue = new Gn(), this.qualifierValue.addValue(r));
  }
  toString() {
    const { key: e, delimiter: r, qualifierValue: n } = this;
    return `${e}${r}${n.toString()}`;
  }
  addValue(e) {
    return this.qualifierValue.addValue(e), this;
  }
}
class cr extends Gi {
  constructor(e, r) {
    let n;
    r ? n = new Gn([e, `${r}`]).setDelimiter(":") : n = e, super("fl", n), this.flagValue = r;
  }
  toString() {
    return super.toString().replace(/\./g, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function Fm(t, e) {
  const r = Array.from(t.entries());
  return e.forEach((n) => {
    r.push(["fl", n]);
  }), r.sort().map((n) => n[1]);
}
function zm() {
  var t, e, r;
  const n = this._actionModel && Object.keys(this._actionModel).length, i = (r = (e = (t = this._actionModel) === null || t === void 0 ? void 0 : t.source) === null || e === void 0 ? void 0 : e.transformation) === null || r === void 0 ? void 0 : r.error;
  return i && i instanceof Error ? { error: i } : n ? this._actionModel : { error: Rs(`unsupported action ${this.constructor.name}`) };
}
class Vm {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return zm.apply(this);
  }
}
let Ls = class extends Vm {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(e) {
    return this.actionTag = e, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), Fm(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(e) {
    if (typeof e == "string") {
      const [r, n] = e.toLowerCase().split("_");
      r === "fl" ? this.flags.push(new cr(n)) : this.qualifiers.set(r, new Gi(r, n));
    } else
      this.qualifiers.set(e.key, e);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(e) {
    return typeof e == "string" ? this.flags.push(new cr(e)) : e instanceof cr && this.flags.push(e), this;
  }
  addValueToQualifier(e, r) {
    return this.qualifiers.get(e).addValue(r), this;
  }
};
function Hm(t) {
  return t && (t.match(/^#/) ? `rgb:${t.substr(1)}` : t);
}
class Bm extends Ls {
  constructor(e) {
    super(), this._actionModel = {}, this.addQualifier(new Gi("b", new Gn(Hm(e)).setDelimiter("_"))), this._actionModel.color = e, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(e) {
    const { color: r } = e;
    return new this(r);
  }
}
class Ea {
  constructor(e) {
    this.raw = e;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: Rs(`unsupported action ${this.constructor.name}`) };
  }
}
function Wm(t) {
  const e = t;
  return "error" in e && !!e.error;
}
function Gm() {
  return new cr("lossy");
}
function Um() {
  return new cr("preserve_transparency");
}
function qm(t) {
  return new cr("progressive", t);
}
class Ym extends Gn {
  constructor(e) {
    super(e), this.val = e;
  }
  getValue() {
    return this.val;
  }
}
function Nr(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    e[t[r]] = r;
  }), e;
}
const Qm = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad",
  autoPad: "auto_pad"
}, Jm = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, Km = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, Xm = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, Zm = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, ev = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, tv = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
};
Nr(ev);
Nr(tv);
Nr(Qm);
const rv = Nr(Jm);
Nr(Km);
Nr(Xm);
Nr(Zm);
class nv extends Ls {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(e, r, n) {
    super(), this._actionModel = {};
    let i;
    r instanceof Ym ? i = r.getValue() : i = r, this._actionModel.actionType = rv[e], this._actionModel[n] = i, this.addQualifier(new Gi(e, r));
  }
}
class iv extends cr {
  constructor(e) {
    super("progressive", e);
  }
}
class _i extends nv {
  constructor(e, r) {
    super(e, r, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(Gm()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(e) {
    return e instanceof iv ? (this._actionModel.progressive = { mode: e.getFlagValue() }, this.addFlag(e)) : (this._actionModel.progressive = { mode: e }, this.addFlag(qm(e))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(Um()), this;
  }
  static fromJson(e) {
    const { formatType: r, lossy: n, progressive: i, preserveTransparency: o } = e;
    let s;
    return r ? s = new this("f", r) : s = new this("f"), i && (i.mode ? s.progressive(i.mode) : s.progressive()), n && s.lossy(), o && s.preserveTransparency(), s;
  }
}
class Ui {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    let r;
    if (typeof e == "string") {
      if (e.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      r = new Ea(e);
    } else
      r = e;
    return this.actions.push(r), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(e) {
    return e instanceof Ui ? this.actions = this.actions.concat(e.actions) : this.actions.push(new Ea(e)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((e) => e.toString()).filter((e) => e).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(e) {
    return this.addAction(e);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(e) {
    return this.addAction(e);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(e) {
    return this.addAction(e);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new _i("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new _i("f", e)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(e) {
    return e.setLayerType("u"), this.addAction(e);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.addAction(e);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(e) {
    return this.addAction(e);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.addAction(e);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.addAction(new Bm(e));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(e) {
    return this.addAction(e);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    const r = new Ls();
    let n = e;
    return typeof e == "string" && (n = new cr(e)), r.addQualifier(n), this.addAction(r);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(e) {
    return this.addAction(e);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(e) {
    return this.addAction(e);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(e) {
    return this.addAction(e);
  }
  toJson() {
    const e = [];
    for (const r of this.actions) {
      const n = r.toJson();
      if (Wm(n))
        return n;
      e.push(n);
    }
    return { actions: e };
  }
}
class ov extends Ui {
}
class sv extends Ui {
}
function av(t) {
  return t.match(/^https?:\//);
}
function lv(t) {
  return t.indexOf("/") < 0;
}
function uv(t) {
  return t.match(/^v[0-9]+/);
}
function cv(t, e) {
  const r = e.secure, n = e.privateCdn, i = e.cname, o = e.secureDistribution;
  return !r && !i ? `http://res.cloudinary.com/${t}` : r && !o && n ? `https://${t}-res.cloudinary.com` : r && !o ? `https://res.cloudinary.com/${t}` : r && o && n ? `https://${o}` : r && o ? `https://${o}/${t}` : !r && i ? `http://${i}/${t}` : "ERROR";
}
function dv(t) {
  return t || "image";
}
function fv(t) {
  return t || "upload";
}
function pv(t, e, r) {
  const n = r !== !1;
  return e ? `v${e}` : uv(t) || av(t) || lv(t) ? "" : n ? "v1" : "";
}
function $s(t, e, r) {
  let n = e >> 0, i = String(typeof r < "u" ? r : " ");
  return t.length > n ? String(t) : (n = n - t.length, n > i.length && (i += hv(i, n / i.length)), i.slice(0, n) + String(t));
}
function hv(t, e) {
  let r = e, n = "";
  for (; r > 0; )
    n += t, r--;
  return n;
}
const mv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Si = {};
let Ta = 0;
mv.split("").forEach((t) => {
  let e = Ta.toString(2);
  e = $s(e, 6, "0"), Si[e] = t, Ta++;
});
function vv(t) {
  if (t.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return t.split(".").reverse().join(".");
}
function gv(t) {
  if (t.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return t.split(".").map((e) => {
    const r = +e;
    if (isNaN(r) || r < 0)
      throw "Invalid version number provided";
    return $s(e, 2, "0");
  }).join(".");
}
function Ca(t) {
  let e = "";
  const r = t.split(".").length * 6, n = vv(t), i = gv(n);
  let o = parseInt(i.split(".").join("")).toString(2);
  if (o = $s(o, r, "0"), o.length % 6 !== 0)
    throw "Version must be smaller than 43.21.26)";
  return o.match(/.{1,6}/g).forEach((s) => {
    e += Si[s];
  }), e;
}
function yv(t) {
  const e = {
    sdkSemver: t.sdkSemver,
    techVersion: t.techVersion,
    sdkCode: t.sdkCode,
    product: t.product,
    feature: "0",
    osType: t.osType,
    osVersion: t.osVersion
  };
  return t.accessibility && (e.feature = "D"), t.lazyload && (e.feature = "C"), t.responsive && (e.feature = "A"), t.placeholder && (e.feature = "B"), e;
}
const wv = "1.16.1";
function bv(t) {
  const [e, r] = t.split("."), n = parseInt(e).toString(2), i = parseInt(r).toString(2), o = n.padStart(6, "0"), s = i.padStart(6, "0");
  return Si[o] + Si[s];
}
function xv() {
  const t = "0.0.0";
  if (typeof window < "u")
    return t;
  try {
    return process.versions.node || t;
  } catch {
    return t;
  }
}
function _v(t) {
  const e = {
    techVersion: xv(),
    sdkCode: "T",
    sdkSemver: wv.split("-")[0],
    product: "A",
    osType: "Z",
    osVersion: "0.0",
    responsive: !1,
    placeholder: !1,
    lazyload: !1,
    accessibility: !1
  };
  return t ? Object.assign(Object.assign({}, e), t) : e;
}
function Oa(t) {
  const e = _v(t), r = yv(e);
  try {
    const n = Sv(r.techVersion), i = Ca(r.sdkSemver), o = Ca(n), s = bv(r.osVersion), a = r.feature, u = r.sdkCode, { product: c, osType: d } = r;
    return `D${c}${u}${i}${o}${d}${s}${a}`;
  } catch {
    return "E";
  }
}
function Sv(t) {
  const e = t.split(".");
  return `${e[0]}.${e[1]}`;
}
const Pa = {
  "image/upload": "images",
  "image/private": "private_images",
  "image/authenticated": "authenticated_images",
  "raw/upload": "files",
  "video/upload": "videos"
};
class Ev {
  constructor(e, r = {}, n) {
    this.setPublicID(e), this.setCloudConfig(r), this.setURLConfig(n);
  }
  /**
   * @description Sets the URL Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setURLConfig(e) {
    return this.urlConfig = new Im(e), this;
  }
  /**
   * @description Sets the Cloud Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setCloudConfig(e) {
    return this.cloudName = e.cloudName, this.apiKey = e.apiKey, this.apiSecret = e.apiSecret, this.authToken = e.authToken, this;
  }
  /**
   * @description Sets the public ID of the asset.
   * @param {string} publicID The public ID of the asset.
   * @return {this}
   */
  setPublicID(e) {
    return this.publicID = e ? e.toString() : "", this;
  }
  /**
   * @description Sets the delivery type of the asset.
   * @param {DELIVERY_TYPE | string} newType The type of the asset.
   * @return {this}
   */
  setDeliveryType(e) {
    return this.deliveryType = e, this;
  }
  /**
   * @description Sets the URL SEO suffix of the asset.
   * @param {string} newSuffix The SEO suffix.
   * @return {this}
   */
  setSuffix(e) {
    return this.suffix = e, this;
  }
  /**
   * @description Sets the signature of the asset.
   * @param {string} signature The signature.
   * @return {this}
   */
  setSignature(e) {
    return this.signature = e, this;
  }
  /**
   * @description Sets the version of the asset.
   * @param {string} newVersion The version of the asset.
   * @return {this}
   */
  setVersion(e) {
    return e && (this.version = e), this;
  }
  /**
   * @description Sets the asset type.
   * @param {string} newType The type of the asset.
   * @return {this}
   */
  setAssetType(e) {
    return e && (this.assetType = e), this;
  }
  sign() {
    return this;
  }
  /**
   * @description Serializes to URL string
   * @param overwriteOptions
   */
  toURL(e = {}) {
    return this.createCloudinaryURL(null, e.trackedAnalytics);
  }
  /**
   * @description Validate various options before attempting to create a URL
   * The function will throw in case a violation
   * @throws Validation errors
   */
  validateAssetForURLCreation() {
    if (typeof this.cloudName > "u")
      throw "You must supply a cloudName when initializing the asset";
    const e = this.suffix && this.suffix.indexOf(".") >= 0, r = this.suffix && this.suffix.indexOf("/") >= 0;
    if (e || r)
      throw "`suffix`` should not include . or /";
  }
  /**
   * @description return an SEO friendly name for a combination of asset/delivery, some examples:
   * * image/upload -> images
   * * video/upload -> videos
   * If no match is found, return `{asset}/{delivery}`
   */
  getResourceType() {
    const e = dv(this.assetType), r = fv(this.deliveryType), n = !!this.suffix, i = `${e}/${r}`, o = Pa[`${e}/${r}`], s = this.urlConfig.useRootPath, a = this.urlConfig.shorten;
    if (s) {
      if (i === "image/upload")
        return "";
      throw new Error(`useRootPath can only be used with assetType: 'image' and deliveryType: 'upload'. Provided: ${i} instead`);
    }
    if (a && i === "image/upload")
      return "iu";
    if (n) {
      if (o)
        return o;
      throw new Error(`URL Suffix only supported for ${Object.keys(Pa).join(", ")}, Provided: ${i} instead`);
    }
    return i;
  }
  getSignature() {
    return this.signature ? `s--${this.signature}--` : "";
  }
  /**
   *
   * @description Creates a fully qualified CloudinaryURL
   * @return {string} CloudinaryURL
   * @throws Validation Errors
   */
  createCloudinaryURL(e, r) {
    if (!this.publicID)
      return "";
    this.validateAssetForURLCreation();
    const n = cv(this.cloudName, this.urlConfig), i = e ? e.toString() : "", o = pv(this.publicID, this.version, this.urlConfig.forceVersion), s = this.publicID;
    if (typeof e == "string")
      return [n, this.getResourceType(), this.getSignature(), i, o, s.replace(/,/g, "%2C"), this.suffix].filter((a) => a).join("/");
    {
      const a = [
        encodeURI(n),
        this.getResourceType(),
        this.getSignature(),
        encodeURI(i),
        o,
        encodeURI(s).replace(/,/g, "%2C"),
        this.suffix && encodeURI(this.suffix)
      ].filter((d) => d).join("/").replace(/\?/g, "%3F").replace(/=/g, "%3D"), u = this.urlConfig.analytics !== !1 && !s.includes("?");
      let c = "";
      if (typeof this.urlConfig.queryParams == "object")
        try {
          const d = new URLSearchParams(this.urlConfig.queryParams);
          u && d.set("_a", Oa(r)), c = d.toString();
        } catch {
          console.error("Error: URLSearchParams is not available so the queryParams object cannot be parsed, please try passing as an already parsed string");
        }
      else
        c = this.urlConfig.queryParams || "", u && (c += `${c.length > 0 ? "&" : ""}_a=${Oa(r)}`);
      return c ? `${a}?${c}` : a;
    }
  }
}
class qu extends Ev {
  constructor(e, r, n, i) {
    super(e, r, n), this.transformation = i;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Animated} animated
   * @return {this}
   */
  animated(e) {
    return this.transformation.animated(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Border} border
   * @return {this}
   */
  border(e) {
    return this.transformation.border(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Reshape} reshape
   * @return {this}
   */
  reshape(e) {
    return this.transformation.reshape(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Resize} resize
   * @return {this}
   */
  resize(e) {
    return this.transformation.resize(e), this;
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new _i("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new _i("f", e)), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.RoundCorners} roundCorners
   * @return {this}
   */
  roundCorners(e) {
    return this.transformation.roundCorners(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  overlay(e) {
    return this.transformation.overlay(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Variable} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.transformation.addVariable(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Condition} conditionalAction
   * @return {this}
   */
  conditional(e) {
    return this.transformation.conditional(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Effect} effect
   * @return {this}
   */
  effect(e) {
    return this.transformation.effect(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Adjust} action
   * @return {this}
   */
  adjust(e) {
    return this.transformation.adjust(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Rotate} rotate
   * @return {this}
   */
  rotate(e) {
    return this.transformation.rotate(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.transformation.namedTransformation(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Delivery} deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.transformation.delivery(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.transformation.backgroundColor(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.PSDTools} action
   * @return {this}
   */
  psdTools(e) {
    return this.transformation.psdTools(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Extract} action
   * @return {this}
   */
  extract(e) {
    return this.transformation.extract(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    return this.transformation.addFlag(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.CustomFunction} customFunction
   * @return {this}
   */
  customFunction(e) {
    return this.transformation.customFunction(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    return this.transformation.addAction(e), this;
  }
  /**
   * @description Extend your transformation with another transformation
   * @param { string | SDK.Transformation } tx
   */
  addTransformation(e) {
    return this.transformation.addTransformation(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {string}
   */
  toString() {
    return this.transformation.toString();
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  underlay(e) {
    return this.transformation.underlay(e), this;
  }
  toURL(e = {}) {
    return this.createCloudinaryURL(this.transformation, e == null ? void 0 : e.trackedAnalytics);
  }
}
class Tv extends qu {
  constructor(e, r, n) {
    super(e, r, n, new ov());
  }
}
class Cv extends qu {
  constructor(e, r, n) {
    super(e, r, n, new sv()), this.assetType = "video";
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Transcode} action
   * @return {this}
   */
  transcode(e) {
    return this.transformation.transcode(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.VideoEdit} action
   * @return {this}
   */
  videoEdit(e) {
    return this.transformation.videoEdit(e), this;
  }
}
class Yu {
  constructor(e) {
    e && (this.cloudinaryConfig = e);
  }
  image(e) {
    return new Tv(e, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  video(e) {
    return new Cv(e, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  setConfig(e) {
    return this.cloudinaryConfig = e, this;
  }
  getConfig() {
    return this.cloudinaryConfig;
  }
  extendConfig() {
  }
}
const Ze = (t) => {
  const e = new Yu({ cloud: { cloudName: "trades-org" } }), r = "w_500,c_auto,g_auto,f_auto,q_auto:low,e_blur:1000/e_art:audrey", n = t;
  return e.image(n).addTransformation(r).setDeliveryType("fetch");
}, He = (t) => {
  const e = new Yu({ cloud: { cloudName: "trades-org" } }), r = "c_auto,g_auto,f_auto,q_auto", n = t;
  return e.image(n).addTransformation(r).setDeliveryType("fetch");
}, Qu = ({ state: t, city: e, postalCode: r, streetAddress: n }) => {
  const i = [n, e, t, r].filter(Boolean).join("+");
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(i)}`;
}, Ju = ({ state: t, city: e, postalCode: r, streetAddress: n }) => [n, e, t, r].filter(Boolean).join(", "), U1 = ({
  sectionHeader: t = "About Us",
  sectionTagline: e = "What We Do",
  shortDescription: r,
  longDescription: n,
  images: i
}) => {
  const [o, s] = ye(!0);
  return /* @__PURE__ */ h("div", { "data-testid": "about-us", id: "about-us", children: /* @__PURE__ */ I("div", { className: "px-6 md:px-24 py-14 md:py-16 xl:py-20 w-full flex-wrap lg:flex-nowrap flex items-start gap-5 h-full font-inter", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-start gap-4 w-full", children: [
      /* @__PURE__ */ h("div", { className: "flex-col flex items-start gap-4 font-medium", children: /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
        /* @__PURE__ */ h("div", { className: "font-medium text-primary-500 text-heading6 font-inter", children: "About Us" }),
        /* @__PURE__ */ h("div", { className: "text-heading5 md:text-heading3 leading-[48px] text-neutral-900 font-inter", children: t })
      ] }) }),
      /* @__PURE__ */ h("div", { className: " text-neutral-900 text-caption1 sm:text-body1 font-inter", children: n && n.length > 1200 && o ? n.slice(0, 1200) : n }),
      /* @__PURE__ */ h("div", { className: " text-neutral-900 text-caption1 sm:text-body1 font-inter", children: r }),
      n && n.length > 1200 && /* @__PURE__ */ h(
        "button",
        {
          onClick: () => s(!o),
          className: "text-primary-500 font-medium text-body1 font-inter",
          children: o ? "Read More" : "Read Less"
        }
      ),
      /* @__PURE__ */ h("div", { className: "font-medium text-primary-500 text-heading6 font-inter", children: e })
    ] }),
    /* @__PURE__ */ h("div", { className: "grid grid-cols-2 gap-[11px] w-full", children: i == null ? void 0 : i.map((a, u) => /* @__PURE__ */ h("div", { className: `${u === 0 ? "col-span-2" : ""}`, children: /* @__PURE__ */ h(
      Xe,
      {
        alt: a.title,
        className: u === 0 ? "h-96 w-full object-cover rounded-xl" : "rounded-xl object-cover max-h-56 h-full w-full",
        src: Ze(a.url),
        cldImg: He(a.url),
        plugins: [st()]
      }
    ) }, `about-us-${u}`)) })
  ] }) });
}, q1 = ({
  sectionHeader: t = "Create a your future best project with us!",
  sectionDescription: e = "Be prepared to be amazed to take the next steps towards your next project.",
  promotionTitle: r,
  promotionDescription: n,
  actionButtonText: i = "Call Us",
  phoneNumber: o
}) => /* @__PURE__ */ h("div", { "data-testid": "cta", id: "cta", children: /* @__PURE__ */ h("div", { className: "w-full bg-white  px-4 sm:px-6 2xl:px-24  py-14 md:py-16 xl:py-20 font-inter", children: /* @__PURE__ */ h("div", { className: "w-full flex justify-center p-10 bg-primary-600 rounded-3xl", children: /* @__PURE__ */ I("div", { className: "w-full md:w-2/3 flex flex-col items-center", children: [
  /* @__PURE__ */ h("h2", { className: "font-medium text-white text-heading5 md:text-heading3 text-center mb-4 font-inter", children: r ?? t }),
  /* @__PURE__ */ h("h2", { className: "font-medium text-white text-body2 text-center mb-6 font-inter", children: n ?? e }),
  /* @__PURE__ */ h(
    "a",
    {
      href: `tel:${St(o)}`,
      className: "min-w-[186px] min-h-10 px-4 py-2 rounded-xl text-base font-medium text-white  bg-secondary-500 hover:bg-secondary-700 text-center font-inter",
      children: i
    }
  )
] }) }) }) });
var Ov = Object.defineProperty, Pv = (t, e, r) => e in t ? Ov(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, go = (t, e, r) => (Pv(t, typeof e != "symbol" ? e + "" : e, r), r);
let Mv = class {
  constructor() {
    go(this, "current", this.detect()), go(this, "handoffState", "pending"), go(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Kt = new Mv(), Ct = (t, e) => {
  Kt.isServer ? ne(t, e) : Yn(t, e);
};
function Tt(t) {
  let e = se(t);
  return Ct(() => {
    e.current = t;
  }, [t]), e;
}
let me = function(t) {
  let e = Tt(t);
  return W.useCallback((...r) => e.current(...r), [e]);
};
function Ku(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function ei() {
  let t = [], e = { addEventListener(r, n, i, o) {
    return r.addEventListener(n, i, o), e.add(() => r.removeEventListener(n, i, o));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return e.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return e.requestAnimationFrame(() => e.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return e.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return Ku(() => {
      n.current && r[0]();
    }), e.add(() => {
      n.current = !1;
    });
  }, style(r, n, i) {
    let o = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: i }), this.add(() => {
      Object.assign(r.style, { [n]: o });
    });
  }, group(r) {
    let n = ei();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return t.push(r), () => {
      let n = t.indexOf(r);
      if (n >= 0)
        for (let i of t.splice(n, 1))
          i();
    };
  }, dispose() {
    for (let r of t.splice(0))
      r();
  } };
  return e;
}
function Xu() {
  let [t] = ye(ei);
  return ne(() => () => t.dispose(), [t]), t;
}
function Av() {
  let t = typeof document > "u";
  return "useSyncExternalStore" in Qt ? ((e) => e.useSyncExternalStore)(Qt)(() => () => {
  }, () => !1, () => !t) : !1;
}
function qi() {
  let t = Av(), [e, r] = Qt.useState(Kt.isHandoffComplete);
  return e && Kt.isHandoffComplete === !1 && r(!1), Qt.useEffect(() => {
    e !== !0 && r(!0);
  }, [e]), Qt.useEffect(() => Kt.handoff(), []), t ? !1 : e;
}
var Ma;
let dr = (Ma = W.useId) != null ? Ma : function() {
  let t = qi(), [e, r] = W.useState(t ? () => Kt.nextId() : null);
  return Ct(() => {
    e === null && r(Kt.nextId());
  }, [e]), e != null ? "" + e : void 0;
};
function Le(t, e, ...r) {
  if (t in e) {
    let i = e[t];
    return typeof i == "function" ? i(...r) : i;
  }
  let n = new Error(`Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, Le), n;
}
function Yi(t) {
  return Kt.isServer ? null : t instanceof Node ? t.ownerDocument : t != null && t.hasOwnProperty("current") && t.current instanceof Node ? t.current.ownerDocument : document;
}
let Yo = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((t) => `${t}:not([tabindex='-1'])`).join(",");
var Ut = ((t) => (t[t.First = 1] = "First", t[t.Previous = 2] = "Previous", t[t.Next = 4] = "Next", t[t.Last = 8] = "Last", t[t.WrapAround = 16] = "WrapAround", t[t.NoScroll = 32] = "NoScroll", t))(Ut || {}), Ei = ((t) => (t[t.Error = 0] = "Error", t[t.Overflow = 1] = "Overflow", t[t.Success = 2] = "Success", t[t.Underflow = 3] = "Underflow", t))(Ei || {}), Nv = ((t) => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(Nv || {});
function Qi(t = document.body) {
  return t == null ? [] : Array.from(t.querySelectorAll(Yo)).sort((e, r) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Is = ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(Is || {});
function Zu(t, e = 0) {
  var r;
  return t === ((r = Yi(t)) == null ? void 0 : r.body) ? !1 : Le(e, { [0]() {
    return t.matches(Yo);
  }, [1]() {
    let n = t;
    for (; n !== null; ) {
      if (n.matches(Yo))
        return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
var Rv = ((t) => (t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(Rv || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (t) => {
  t.metaKey || t.altKey || t.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (t) => {
  t.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : t.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let Lv = ["textarea", "input"].join(",");
function $v(t) {
  var e, r;
  return (r = (e = t == null ? void 0 : t.matches) == null ? void 0 : e.call(t, Lv)) != null ? r : !1;
}
function Iv(t, e = (r) => r) {
  return t.slice().sort((r, n) => {
    let i = e(r), o = e(n);
    if (i === null || o === null)
      return 0;
    let s = i.compareDocumentPosition(o);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Or(t, e, { sorted: r = !0, relativeTo: n = null, skipElements: i = [] } = {}) {
  let o = Array.isArray(t) ? t.length > 0 ? t[0].ownerDocument : document : t.ownerDocument, s = Array.isArray(t) ? r ? Iv(t) : t : Qi(t);
  i.length > 0 && s.length > 1 && (s = s.filter((g) => !i.includes(g))), n = n ?? o.activeElement;
  let a = (() => {
    if (e & 5)
      return 1;
    if (e & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (e & 1)
      return 0;
    if (e & 2)
      return Math.max(0, s.indexOf(n)) - 1;
    if (e & 4)
      return Math.max(0, s.indexOf(n)) + 1;
    if (e & 8)
      return s.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = e & 32 ? { preventScroll: !0 } : {}, d = 0, f = s.length, v;
  do {
    if (d >= f || d + f <= 0)
      return 0;
    let g = u + d;
    if (e & 16)
      g = (g + f) % f;
    else {
      if (g < 0)
        return 3;
      if (g >= f)
        return 1;
    }
    v = s[g], v == null || v.focus(c), d += a;
  } while (v !== o.activeElement);
  return e & 6 && $v(v) && v.select(), 2;
}
function kv() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function jv() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Dv() {
  return kv() || jv();
}
function si(t, e, r) {
  let n = Tt(e);
  ne(() => {
    function i(o) {
      n.current(o);
    }
    return document.addEventListener(t, i, r), () => document.removeEventListener(t, i, r);
  }, [t, r]);
}
function ec(t, e, r) {
  let n = Tt(e);
  ne(() => {
    function i(o) {
      n.current(o);
    }
    return window.addEventListener(t, i, r), () => window.removeEventListener(t, i, r);
  }, [t, r]);
}
function Fv(t, e, r = !0) {
  let n = se(!1);
  ne(() => {
    requestAnimationFrame(() => {
      n.current = r;
    });
  }, [r]);
  function i(s, a) {
    if (!n.current || s.defaultPrevented)
      return;
    let u = a(s);
    if (u === null || !u.getRootNode().contains(u) || !u.isConnected)
      return;
    let c = function d(f) {
      return typeof f == "function" ? d(f()) : Array.isArray(f) || f instanceof Set ? f : [f];
    }(t);
    for (let d of c) {
      if (d === null)
        continue;
      let f = d instanceof HTMLElement ? d : d.current;
      if (f != null && f.contains(u) || s.composed && s.composedPath().includes(f))
        return;
    }
    return !Zu(u, Is.Loose) && u.tabIndex !== -1 && s.preventDefault(), e(s, u);
  }
  let o = se(null);
  si("pointerdown", (s) => {
    var a, u;
    n.current && (o.current = ((u = (a = s.composedPath) == null ? void 0 : a.call(s)) == null ? void 0 : u[0]) || s.target);
  }, !0), si("mousedown", (s) => {
    var a, u;
    n.current && (o.current = ((u = (a = s.composedPath) == null ? void 0 : a.call(s)) == null ? void 0 : u[0]) || s.target);
  }, !0), si("click", (s) => {
    Dv() || o.current && (i(s, () => o.current), o.current = null);
  }, !0), si("touchend", (s) => i(s, () => s.target instanceof HTMLElement ? s.target : null), !0), ec("blur", (s) => i(s, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Qr(...t) {
  return Pe(() => Yi(...t), [...t]);
}
function Aa(t) {
  var e;
  if (t.type)
    return t.type;
  let r = (e = t.as) != null ? e : "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function tc(t, e) {
  let [r, n] = ye(() => Aa(t));
  return Ct(() => {
    n(Aa(t));
  }, [t.type, t.as]), Ct(() => {
    r || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && n("button");
  }, [r, e]), r;
}
let rc = Symbol();
function ks(t, e = !0) {
  return Object.assign(t, { [rc]: e });
}
function at(...t) {
  let e = se(t);
  ne(() => {
    e.current = t;
  }, [t]);
  let r = me((n) => {
    for (let i of e.current)
      i != null && (typeof i == "function" ? i(n) : i.current = n);
  });
  return t.every((n) => n == null || (n == null ? void 0 : n[rc])) ? void 0 : r;
}
function Ti(...t) {
  return Array.from(new Set(t.flatMap((e) => typeof e == "string" ? e.split(" ") : []))).filter(Boolean).join(" ");
}
var fr = ((t) => (t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static", t))(fr || {}), ar = ((t) => (t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))(ar || {});
function lt({ ourProps: t, theirProps: e, slot: r, defaultTag: n, features: i, visible: o = !0, name: s, mergeRefs: a }) {
  a = a ?? zv;
  let u = nc(e, t);
  if (o)
    return ai(u, r, n, s, a);
  let c = i ?? 0;
  if (c & 2) {
    let { static: d = !1, ...f } = u;
    if (d)
      return ai(f, r, n, s, a);
  }
  if (c & 1) {
    let { unmount: d = !0, ...f } = u;
    return Le(d ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return ai({ ...f, hidden: !0, style: { display: "none" } }, r, n, s, a);
    } });
  }
  return ai(u, r, n, s, a);
}
function ai(t, e = {}, r, n, i) {
  let { as: o = r, children: s, refName: a = "ref", ...u } = yo(t, ["unmount", "static"]), c = t.ref !== void 0 ? { [a]: t.ref } : {}, d = typeof s == "function" ? s(e) : s;
  "className" in u && u.className && typeof u.className == "function" && (u.className = u.className(e));
  let f = {};
  if (e) {
    let v = !1, g = [];
    for (let [y, E] of Object.entries(e))
      typeof E == "boolean" && (v = !0), E === !0 && g.push(y);
    v && (f["data-headlessui-state"] = g.join(" "));
  }
  if (o === Et && Object.keys(Na(u)).length > 0) {
    if (!$c(d) || Array.isArray(d) && d.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(u).map((E) => `  - ${E}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((E) => `  - ${E}`).join(`
`)].join(`
`));
    let v = d.props, g = typeof (v == null ? void 0 : v.className) == "function" ? (...E) => Ti(v == null ? void 0 : v.className(...E), u.className) : Ti(v == null ? void 0 : v.className, u.className), y = g ? { className: g } : {};
    return Ic(d, Object.assign({}, nc(d.props, Na(yo(u, ["ref"]))), f, c, { ref: i(d.ref, c.ref) }, y));
  }
  return kc(o, Object.assign({}, yo(u, ["ref"]), o !== Et && c, o !== Et && f), d);
}
function js() {
  let t = se([]), e = Tr((r) => {
    for (let n of t.current)
      n != null && (typeof n == "function" ? n(r) : n.current = r);
  }, []);
  return (...r) => {
    if (!r.every((n) => n == null))
      return t.current = r, e;
  };
}
function zv(...t) {
  return t.every((e) => e == null) ? void 0 : (e) => {
    for (let r of t)
      r != null && (typeof r == "function" ? r(e) : r.current = e);
  };
}
function nc(...t) {
  if (t.length === 0)
    return {};
  if (t.length === 1)
    return t[0];
  let e = {}, r = {};
  for (let n of t)
    for (let i in n)
      i.startsWith("on") && typeof n[i] == "function" ? (r[i] != null || (r[i] = []), r[i].push(n[i])) : e[i] = n[i];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r)
    Object.assign(e, { [n](i, ...o) {
      let s = r[n];
      for (let a of s) {
        if ((i instanceof Event || (i == null ? void 0 : i.nativeEvent) instanceof Event) && i.defaultPrevented)
          return;
        a(i, ...o);
      }
    } });
  return e;
}
function et(t) {
  var e;
  return Object.assign(Ur(t), { displayName: (e = t.displayName) != null ? e : t.name });
}
function Na(t) {
  let e = Object.assign({}, t);
  for (let r in e)
    e[r] === void 0 && delete e[r];
  return e;
}
function yo(t, e = []) {
  let r = Object.assign({}, t);
  for (let n of e)
    n in r && delete r[n];
  return r;
}
let Vv = "div";
var Gr = ((t) => (t[t.None = 1] = "None", t[t.Focusable = 2] = "Focusable", t[t.Hidden = 4] = "Hidden", t))(Gr || {});
function Hv(t, e) {
  var r;
  let { features: n = 1, ...i } = t, o = { ref: e, "aria-hidden": (n & 2) === 2 ? !0 : (r = i["aria-hidden"]) != null ? r : void 0, hidden: (n & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return lt({ ourProps: o, theirProps: i, slot: {}, defaultTag: Vv, name: "Hidden" });
}
let Un = et(Hv), Ds = Ye(null);
Ds.displayName = "OpenClosedContext";
var ke = ((t) => (t[t.Open = 1] = "Open", t[t.Closed = 2] = "Closed", t[t.Closing = 4] = "Closing", t[t.Opening = 8] = "Opening", t))(ke || {});
function ti() {
  return $e(Ds);
}
function Fs({ value: t, children: e }) {
  return W.createElement(Ds.Provider, { value: t }, e);
}
function zs(t) {
  let e = t.parentElement, r = null;
  for (; e && !(e instanceof HTMLFieldSetElement); )
    e instanceof HTMLLegendElement && (r = e), e = e.parentElement;
  let n = (e == null ? void 0 : e.getAttribute("disabled")) === "";
  return n && Bv(r) ? !1 : n;
}
function Bv(t) {
  if (!t)
    return !1;
  let e = t.previousElementSibling;
  for (; e !== null; ) {
    if (e instanceof HTMLLegendElement)
      return !1;
    e = e.previousElementSibling;
  }
  return !0;
}
var it = ((t) => (t.Space = " ", t.Enter = "Enter", t.Escape = "Escape", t.Backspace = "Backspace", t.Delete = "Delete", t.ArrowLeft = "ArrowLeft", t.ArrowUp = "ArrowUp", t.ArrowRight = "ArrowRight", t.ArrowDown = "ArrowDown", t.Home = "Home", t.End = "End", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Tab = "Tab", t))(it || {});
function Wv(t, e, r, n) {
  let i = Tt(r);
  ne(() => {
    t = t ?? window;
    function o(s) {
      i.current(s);
    }
    return t.addEventListener(e, o, n), () => t.removeEventListener(e, o, n);
  }, [t, e, n]);
}
function Vs() {
  let t = se(!1);
  return Ct(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function Gv(t) {
  let e = me(t), r = se(!1);
  ne(() => (r.current = !1, () => {
    r.current = !0, Ku(() => {
      r.current && e();
    });
  }), [e]);
}
var qt = ((t) => (t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))(qt || {});
function ic() {
  let t = se(0);
  return ec("keydown", (e) => {
    e.key === "Tab" && (t.current = e.shiftKey ? 1 : 0);
  }, !0), t;
}
let Uv = Ye(!1);
function qv() {
  return $e(Uv);
}
function Yv(t) {
  let e = qv(), r = $e(oc), n = Qr(t), [i, o] = ye(() => {
    if (!e && r !== null || Kt.isServer)
      return null;
    let s = n == null ? void 0 : n.getElementById("headlessui-portal-root");
    if (s)
      return s;
    if (n === null)
      return null;
    let a = n.createElement("div");
    return a.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(a);
  });
  return ne(() => {
    i !== null && (n != null && n.body.contains(i) || n == null || n.body.appendChild(i));
  }, [i, n]), ne(() => {
    e || r !== null && o(r.current);
  }, [r, o, e]), i;
}
let Qv = Et;
function Jv(t, e) {
  let r = t, n = se(null), i = at(ks((d) => {
    n.current = d;
  }), e), o = Qr(n), s = Yv(n), [a] = ye(() => {
    var d;
    return Kt.isServer ? null : (d = o == null ? void 0 : o.createElement("div")) != null ? d : null;
  }), u = $e(Qo), c = qi();
  return Ct(() => {
    !s || !a || s.contains(a) || (a.setAttribute("data-headlessui-portal", ""), s.appendChild(a));
  }, [s, a]), Ct(() => {
    if (a && u)
      return u.register(a);
  }, [u, a]), Gv(() => {
    var d;
    !s || !a || (a instanceof Node && s.contains(a) && s.removeChild(a), s.childNodes.length <= 0 && ((d = s.parentElement) == null || d.removeChild(s)));
  }), c ? !s || !a ? null : ol(lt({ ourProps: { ref: i }, theirProps: r, defaultTag: Qv, name: "Portal" }), a) : null;
}
let Kv = Et, oc = Ye(null);
function Xv(t, e) {
  let { target: r, ...n } = t, i = { ref: at(e) };
  return W.createElement(oc.Provider, { value: r }, lt({ ourProps: i, theirProps: n, defaultTag: Kv, name: "Popover.Group" }));
}
let Qo = Ye(null);
function Zv() {
  let t = $e(Qo), e = se([]), r = me((o) => (e.current.push(o), t && t.register(o), () => n(o))), n = me((o) => {
    let s = e.current.indexOf(o);
    s !== -1 && e.current.splice(s, 1), t && t.unregister(o);
  }), i = Pe(() => ({ register: r, unregister: n, portals: e }), [r, n, e]);
  return [e, Pe(() => function({ children: o }) {
    return W.createElement(Qo.Provider, { value: i }, o);
  }, [i])];
}
let eg = et(Jv), tg = et(Xv);
Object.assign(eg, { Group: tg });
function rg({ defaultContainers: t = [], portals: e, mainTreeNodeRef: r } = {}) {
  var n;
  let i = se((n = r == null ? void 0 : r.current) != null ? n : null), o = Qr(i), s = me(() => {
    var a, u, c;
    let d = [];
    for (let f of t)
      f !== null && (f instanceof HTMLElement ? d.push(f) : "current" in f && f.current instanceof HTMLElement && d.push(f.current));
    if (e != null && e.current)
      for (let f of e.current)
        d.push(f);
    for (let f of (a = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? a : [])
      f !== document.body && f !== document.head && f instanceof HTMLElement && f.id !== "headlessui-portal-root" && (f.contains(i.current) || f.contains((c = (u = i.current) == null ? void 0 : u.getRootNode()) == null ? void 0 : c.host) || d.some((v) => f.contains(v)) || d.push(f));
    return d;
  });
  return { resolveContainers: s, contains: me((a) => s().some((u) => u.contains(a))), mainTreeNodeRef: i, MainTreeNode: Pe(() => function() {
    return r != null ? null : W.createElement(Un, { features: Gr.Hidden, ref: i });
  }, [i, r]) };
}
function ng() {
  let t = se(null);
  return { mainTreeNodeRef: t, MainTreeNode: Pe(() => function() {
    return W.createElement(Un, { features: Gr.Hidden, ref: t });
  }, [t]) };
}
var Ra;
let ig = (Ra = W.startTransition) != null ? Ra : function(t) {
  t();
};
var og = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(og || {}), sg = ((t) => (t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))(sg || {});
let ag = { [0]: (t) => ({ ...t, disclosureState: Le(t.disclosureState, { [0]: 1, [1]: 0 }) }), [1]: (t) => t.disclosureState === 1 ? t : { ...t, disclosureState: 1 }, [4](t) {
  return t.linkedPanel === !0 ? t : { ...t, linkedPanel: !0 };
}, [5](t) {
  return t.linkedPanel === !1 ? t : { ...t, linkedPanel: !1 };
}, [2](t, e) {
  return t.buttonId === e.buttonId ? t : { ...t, buttonId: e.buttonId };
}, [3](t, e) {
  return t.panelId === e.panelId ? t : { ...t, panelId: e.panelId };
} }, Hs = Ye(null);
Hs.displayName = "DisclosureContext";
function Bs(t) {
  let e = $e(Hs);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Bs), r;
  }
  return e;
}
let Ws = Ye(null);
Ws.displayName = "DisclosureAPIContext";
function sc(t) {
  let e = $e(Ws);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, sc), r;
  }
  return e;
}
let Gs = Ye(null);
Gs.displayName = "DisclosurePanelContext";
function lg() {
  return $e(Gs);
}
function ug(t, e) {
  return Le(e.type, ag, t, e);
}
let cg = Et;
function dg(t, e) {
  let { defaultOpen: r = !1, ...n } = t, i = se(null), o = at(e, ks((S) => {
    i.current = S;
  }, t.as === void 0 || t.as === Et)), s = se(null), a = se(null), u = Ai(ug, { disclosureState: r ? 0 : 1, linkedPanel: !1, buttonRef: a, panelRef: s, buttonId: null, panelId: null }), [{ disclosureState: c, buttonId: d }, f] = u, v = me((S) => {
    f({ type: 1 });
    let _ = Yi(i);
    if (!_ || !d)
      return;
    let O = (() => S ? S instanceof HTMLElement ? S : S.current instanceof HTMLElement ? S.current : _.getElementById(d) : _.getElementById(d))();
    O == null || O.focus();
  }), g = Pe(() => ({ close: v }), [v]), y = Pe(() => ({ open: c === 0, close: v }), [c, v]), E = { ref: o };
  return W.createElement(Hs.Provider, { value: u }, W.createElement(Ws.Provider, { value: g }, W.createElement(Fs, { value: Le(c, { [0]: ke.Open, [1]: ke.Closed }) }, lt({ ourProps: E, theirProps: n, slot: y, defaultTag: cg, name: "Disclosure" }))));
}
let fg = "button";
function pg(t, e) {
  let r = dr(), { id: n = `headlessui-disclosure-button-${r}`, ...i } = t, [o, s] = Bs("Disclosure.Button"), a = lg(), u = a === null ? !1 : a === o.panelId, c = se(null), d = at(c, e, u ? null : o.buttonRef), f = js();
  ne(() => {
    if (!u)
      return s({ type: 2, buttonId: n }), () => {
        s({ type: 2, buttonId: null });
      };
  }, [n, s, u]);
  let v = me((O) => {
    var T;
    if (u) {
      if (o.disclosureState === 1)
        return;
      switch (O.key) {
        case it.Space:
        case it.Enter:
          O.preventDefault(), O.stopPropagation(), s({ type: 0 }), (T = o.buttonRef.current) == null || T.focus();
          break;
      }
    } else
      switch (O.key) {
        case it.Space:
        case it.Enter:
          O.preventDefault(), O.stopPropagation(), s({ type: 0 });
          break;
      }
  }), g = me((O) => {
    switch (O.key) {
      case it.Space:
        O.preventDefault();
        break;
    }
  }), y = me((O) => {
    var T;
    zs(O.currentTarget) || t.disabled || (u ? (s({ type: 0 }), (T = o.buttonRef.current) == null || T.focus()) : s({ type: 0 }));
  }), E = Pe(() => ({ open: o.disclosureState === 0 }), [o]), S = tc(t, c), _ = u ? { ref: d, type: S, onKeyDown: v, onClick: y } : { ref: d, id: n, type: S, "aria-expanded": o.disclosureState === 0, "aria-controls": o.linkedPanel ? o.panelId : void 0, onKeyDown: v, onKeyUp: g, onClick: y };
  return lt({ mergeRefs: f, ourProps: _, theirProps: i, slot: E, defaultTag: fg, name: "Disclosure.Button" });
}
let hg = "div", mg = fr.RenderStrategy | fr.Static;
function vg(t, e) {
  let r = dr(), { id: n = `headlessui-disclosure-panel-${r}`, ...i } = t, [o, s] = Bs("Disclosure.Panel"), { close: a } = sc("Disclosure.Panel"), u = js(), c = at(e, o.panelRef, (y) => {
    ig(() => s({ type: y ? 4 : 5 }));
  });
  ne(() => (s({ type: 3, panelId: n }), () => {
    s({ type: 3, panelId: null });
  }), [n, s]);
  let d = ti(), f = (() => d !== null ? (d & ke.Open) === ke.Open : o.disclosureState === 0)(), v = Pe(() => ({ open: o.disclosureState === 0, close: a }), [o, a]), g = { ref: c, id: n };
  return W.createElement(Gs.Provider, { value: o.panelId }, lt({ mergeRefs: u, ourProps: g, theirProps: i, slot: v, defaultTag: hg, features: mg, visible: f, name: "Disclosure.Panel" }));
}
let gg = et(dg), yg = et(pg), wg = et(vg), wo = Object.assign(gg, { Button: yg, Panel: wg });
var bg = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(bg || {}), xg = ((t) => (t[t.TogglePopover = 0] = "TogglePopover", t[t.ClosePopover = 1] = "ClosePopover", t[t.SetButton = 2] = "SetButton", t[t.SetButtonId = 3] = "SetButtonId", t[t.SetPanel = 4] = "SetPanel", t[t.SetPanelId = 5] = "SetPanelId", t))(xg || {});
let _g = { [0]: (t) => {
  let e = { ...t, popoverState: Le(t.popoverState, { [0]: 1, [1]: 0 }) };
  return e.popoverState === 0 && (e.__demoMode = !1), e;
}, [1](t) {
  return t.popoverState === 1 ? t : { ...t, popoverState: 1 };
}, [2](t, e) {
  return t.button === e.button ? t : { ...t, button: e.button };
}, [3](t, e) {
  return t.buttonId === e.buttonId ? t : { ...t, buttonId: e.buttonId };
}, [4](t, e) {
  return t.panel === e.panel ? t : { ...t, panel: e.panel };
}, [5](t, e) {
  return t.panelId === e.panelId ? t : { ...t, panelId: e.panelId };
} }, Us = Ye(null);
Us.displayName = "PopoverContext";
function Ji(t) {
  let e = $e(Us);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ji), r;
  }
  return e;
}
let qs = Ye(null);
qs.displayName = "PopoverAPIContext";
function Ys(t) {
  let e = $e(qs);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ys), r;
  }
  return e;
}
let Qs = Ye(null);
Qs.displayName = "PopoverGroupContext";
function ac() {
  return $e(Qs);
}
let Ki = Ye(null);
Ki.displayName = "PopoverPanelContext";
function Sg() {
  return $e(Ki);
}
function Eg(t, e) {
  return Le(e.type, _g, t, e);
}
let Tg = "div";
function Cg(t, e) {
  var r;
  let { __demoMode: n = !1, ...i } = t, o = se(null), s = at(e, ks((Y) => {
    o.current = Y;
  })), a = se([]), u = Ai(Eg, { __demoMode: n, popoverState: n ? 0 : 1, buttons: a, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: ta(), afterPanelSentinel: ta() }), [{ popoverState: c, button: d, buttonId: f, panel: v, panelId: g, beforePanelSentinel: y, afterPanelSentinel: E }, S] = u, _ = Qr((r = o.current) != null ? r : d), O = Pe(() => {
    if (!d || !v)
      return !1;
    for (let F of document.querySelectorAll("body > *"))
      if (Number(F == null ? void 0 : F.contains(d)) ^ Number(F == null ? void 0 : F.contains(v)))
        return !0;
    let Y = Qi(), le = Y.indexOf(d), j = (le + Y.length - 1) % Y.length, N = (le + 1) % Y.length, w = Y[j], $ = Y[N];
    return !v.contains(w) && !v.contains($);
  }, [d, v]), T = Tt(f), P = Tt(g), x = Pe(() => ({ buttonId: T, panelId: P, close: () => S({ type: 1 }) }), [T, P, S]), M = ac(), H = M == null ? void 0 : M.registerPopover, R = me(() => {
    var Y;
    return (Y = M == null ? void 0 : M.isFocusWithinPopoverGroup()) != null ? Y : (_ == null ? void 0 : _.activeElement) && ((d == null ? void 0 : d.contains(_.activeElement)) || (v == null ? void 0 : v.contains(_.activeElement)));
  });
  ne(() => H == null ? void 0 : H(x), [H, x]);
  let [q, K] = Zv(), k = rg({ mainTreeNodeRef: M == null ? void 0 : M.mainTreeNodeRef, portals: q, defaultContainers: [d, v] });
  Wv(_ == null ? void 0 : _.defaultView, "focus", (Y) => {
    var le, j, N, w;
    Y.target !== window && Y.target instanceof HTMLElement && c === 0 && (R() || d && v && (k.contains(Y.target) || (j = (le = y.current) == null ? void 0 : le.contains) != null && j.call(le, Y.target) || (w = (N = E.current) == null ? void 0 : N.contains) != null && w.call(N, Y.target) || S({ type: 1 })));
  }, !0), Fv(k.resolveContainers, (Y, le) => {
    S({ type: 1 }), Zu(le, Is.Loose) || (Y.preventDefault(), d == null || d.focus());
  }, c === 0);
  let V = me((Y) => {
    S({ type: 1 });
    let le = (() => Y ? Y instanceof HTMLElement ? Y : "current" in Y && Y.current instanceof HTMLElement ? Y.current : d : d)();
    le == null || le.focus();
  }), Q = Pe(() => ({ close: V, isPortalled: O }), [V, O]), re = Pe(() => ({ open: c === 0, close: V }), [c, V]), ve = { ref: s };
  return W.createElement(Ki.Provider, { value: null }, W.createElement(Us.Provider, { value: u }, W.createElement(qs.Provider, { value: Q }, W.createElement(Fs, { value: Le(c, { [0]: ke.Open, [1]: ke.Closed }) }, W.createElement(K, null, lt({ ourProps: ve, theirProps: i, slot: re, defaultTag: Tg, name: "Popover" }), W.createElement(k.MainTreeNode, null))))));
}
let Og = "button";
function Pg(t, e) {
  let r = dr(), { id: n = `headlessui-popover-button-${r}`, ...i } = t, [o, s] = Ji("Popover.Button"), { isPortalled: a } = Ys("Popover.Button"), u = se(null), c = `headlessui-focus-sentinel-${dr()}`, d = ac(), f = d == null ? void 0 : d.closeOthers, v = Sg() !== null;
  ne(() => {
    if (!v)
      return s({ type: 3, buttonId: n }), () => {
        s({ type: 3, buttonId: null });
      };
  }, [v, n, s]);
  let [g] = ye(() => Symbol()), y = at(u, e, v ? null : (k) => {
    if (k)
      o.buttons.current.push(g);
    else {
      let V = o.buttons.current.indexOf(g);
      V !== -1 && o.buttons.current.splice(V, 1);
    }
    o.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), k && s({ type: 2, button: k });
  }), E = at(u, e), S = Qr(u), _ = me((k) => {
    var V, Q, re;
    if (v) {
      if (o.popoverState === 1)
        return;
      switch (k.key) {
        case it.Space:
        case it.Enter:
          k.preventDefault(), (Q = (V = k.target).click) == null || Q.call(V), s({ type: 1 }), (re = o.button) == null || re.focus();
          break;
      }
    } else
      switch (k.key) {
        case it.Space:
        case it.Enter:
          k.preventDefault(), k.stopPropagation(), o.popoverState === 1 && (f == null || f(o.buttonId)), s({ type: 0 });
          break;
        case it.Escape:
          if (o.popoverState !== 0)
            return f == null ? void 0 : f(o.buttonId);
          if (!u.current || S != null && S.activeElement && !u.current.contains(S.activeElement))
            return;
          k.preventDefault(), k.stopPropagation(), s({ type: 1 });
          break;
      }
  }), O = me((k) => {
    v || k.key === it.Space && k.preventDefault();
  }), T = me((k) => {
    var V, Q;
    zs(k.currentTarget) || t.disabled || (v ? (s({ type: 1 }), (V = o.button) == null || V.focus()) : (k.preventDefault(), k.stopPropagation(), o.popoverState === 1 && (f == null || f(o.buttonId)), s({ type: 0 }), (Q = o.button) == null || Q.focus()));
  }), P = me((k) => {
    k.preventDefault(), k.stopPropagation();
  }), x = o.popoverState === 0, M = Pe(() => ({ open: x }), [x]), H = tc(t, u), R = v ? { ref: E, type: H, onKeyDown: _, onClick: T } : { ref: y, id: o.buttonId, type: H, "aria-expanded": o.popoverState === 0, "aria-controls": o.panel ? o.panelId : void 0, onKeyDown: _, onKeyUp: O, onClick: T, onMouseDown: P }, q = ic(), K = me(() => {
    let k = o.panel;
    if (!k)
      return;
    function V() {
      Le(q.current, { [qt.Forwards]: () => Or(k, Ut.First), [qt.Backwards]: () => Or(k, Ut.Last) }) === Ei.Error && Or(Qi().filter((Q) => Q.dataset.headlessuiFocusGuard !== "true"), Le(q.current, { [qt.Forwards]: Ut.Next, [qt.Backwards]: Ut.Previous }), { relativeTo: o.button });
    }
    V();
  });
  return W.createElement(W.Fragment, null, lt({ ourProps: R, theirProps: i, slot: M, defaultTag: Og, name: "Popover.Button" }), x && !v && a && W.createElement(Un, { id: c, features: Gr.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: K }));
}
let Mg = "div", Ag = fr.RenderStrategy | fr.Static;
function Ng(t, e) {
  let r = dr(), { id: n = `headlessui-popover-overlay-${r}`, ...i } = t, [{ popoverState: o }, s] = Ji("Popover.Overlay"), a = at(e), u = ti(), c = (() => u !== null ? (u & ke.Open) === ke.Open : o === 0)(), d = me((v) => {
    if (zs(v.currentTarget))
      return v.preventDefault();
    s({ type: 1 });
  }), f = Pe(() => ({ open: o === 0 }), [o]);
  return lt({ ourProps: { ref: a, id: n, "aria-hidden": !0, onClick: d }, theirProps: i, slot: f, defaultTag: Mg, features: Ag, visible: c, name: "Popover.Overlay" });
}
let Rg = "div", Lg = fr.RenderStrategy | fr.Static;
function $g(t, e) {
  let r = dr(), { id: n = `headlessui-popover-panel-${r}`, focus: i = !1, ...o } = t, [s, a] = Ji("Popover.Panel"), { close: u, isPortalled: c } = Ys("Popover.Panel"), d = `headlessui-focus-sentinel-before-${dr()}`, f = `headlessui-focus-sentinel-after-${dr()}`, v = se(null), g = at(v, e, (R) => {
    a({ type: 4, panel: R });
  }), y = Qr(v), E = js();
  Ct(() => (a({ type: 5, panelId: n }), () => {
    a({ type: 5, panelId: null });
  }), [n, a]);
  let S = ti(), _ = (() => S !== null ? (S & ke.Open) === ke.Open : s.popoverState === 0)(), O = me((R) => {
    var q;
    switch (R.key) {
      case it.Escape:
        if (s.popoverState !== 0 || !v.current || y != null && y.activeElement && !v.current.contains(y.activeElement))
          return;
        R.preventDefault(), R.stopPropagation(), a({ type: 1 }), (q = s.button) == null || q.focus();
        break;
    }
  });
  ne(() => {
    var R;
    t.static || s.popoverState === 1 && ((R = t.unmount) == null || R) && a({ type: 4, panel: null });
  }, [s.popoverState, t.unmount, t.static, a]), ne(() => {
    if (s.__demoMode || !i || s.popoverState !== 0 || !v.current)
      return;
    let R = y == null ? void 0 : y.activeElement;
    v.current.contains(R) || Or(v.current, Ut.First);
  }, [s.__demoMode, i, v, s.popoverState]);
  let T = Pe(() => ({ open: s.popoverState === 0, close: u }), [s, u]), P = { ref: g, id: n, onKeyDown: O, onBlur: i && s.popoverState === 0 ? (R) => {
    var q, K, k, V, Q;
    let re = R.relatedTarget;
    re && v.current && ((q = v.current) != null && q.contains(re) || (a({ type: 1 }), ((k = (K = s.beforePanelSentinel.current) == null ? void 0 : K.contains) != null && k.call(K, re) || (Q = (V = s.afterPanelSentinel.current) == null ? void 0 : V.contains) != null && Q.call(V, re)) && re.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1 }, x = ic(), M = me(() => {
    let R = v.current;
    if (!R)
      return;
    function q() {
      Le(x.current, { [qt.Forwards]: () => {
        var K;
        Or(R, Ut.First) === Ei.Error && ((K = s.afterPanelSentinel.current) == null || K.focus());
      }, [qt.Backwards]: () => {
        var K;
        (K = s.button) == null || K.focus({ preventScroll: !0 });
      } });
    }
    q();
  }), H = me(() => {
    let R = v.current;
    if (!R)
      return;
    function q() {
      Le(x.current, { [qt.Forwards]: () => {
        var K;
        if (!s.button)
          return;
        let k = Qi(), V = k.indexOf(s.button), Q = k.slice(0, V + 1), re = [...k.slice(V + 1), ...Q];
        for (let ve of re.slice())
          if (ve.dataset.headlessuiFocusGuard === "true" || (K = s.panel) != null && K.contains(ve)) {
            let Y = re.indexOf(ve);
            Y !== -1 && re.splice(Y, 1);
          }
        Or(re, Ut.First, { sorted: !1 });
      }, [qt.Backwards]: () => {
        var K;
        Or(R, Ut.Previous) === Ei.Error && ((K = s.button) == null || K.focus());
      } });
    }
    q();
  });
  return W.createElement(Ki.Provider, { value: n }, _ && c && W.createElement(Un, { id: d, ref: s.beforePanelSentinel, features: Gr.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: M }), lt({ mergeRefs: E, ourProps: P, theirProps: o, slot: T, defaultTag: Rg, features: Lg, visible: _, name: "Popover.Panel" }), _ && c && W.createElement(Un, { id: f, ref: s.afterPanelSentinel, features: Gr.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: H }));
}
let Ig = "div";
function kg(t, e) {
  let r = se(null), n = at(r, e), [i, o] = ye([]), s = ng(), a = me((E) => {
    o((S) => {
      let _ = S.indexOf(E);
      if (_ !== -1) {
        let O = S.slice();
        return O.splice(_, 1), O;
      }
      return S;
    });
  }), u = me((E) => (o((S) => [...S, E]), () => a(E))), c = me(() => {
    var E;
    let S = Yi(r);
    if (!S)
      return !1;
    let _ = S.activeElement;
    return (E = r.current) != null && E.contains(_) ? !0 : i.some((O) => {
      var T, P;
      return ((T = S.getElementById(O.buttonId.current)) == null ? void 0 : T.contains(_)) || ((P = S.getElementById(O.panelId.current)) == null ? void 0 : P.contains(_));
    });
  }), d = me((E) => {
    for (let S of i)
      S.buttonId.current !== E && S.close();
  }), f = Pe(() => ({ registerPopover: u, unregisterPopover: a, isFocusWithinPopoverGroup: c, closeOthers: d, mainTreeNodeRef: s.mainTreeNodeRef }), [u, a, c, d, s.mainTreeNodeRef]), v = Pe(() => ({}), []), g = t, y = { ref: n };
  return W.createElement(Qs.Provider, { value: f }, lt({ ourProps: y, theirProps: g, slot: v, defaultTag: Ig, name: "Popover.Group" }), W.createElement(s.MainTreeNode, null));
}
let jg = et(Cg), Dg = et(Pg), Fg = et(Ng), zg = et($g), Vg = et(kg), jn = Object.assign(jg, { Button: Dg, Overlay: Fg, Panel: zg, Group: Vg });
function Hg(t = 0) {
  let [e, r] = ye(t), n = Vs(), i = Tr((u) => {
    n.current && r((c) => c | u);
  }, [e, n]), o = Tr((u) => !!(e & u), [e]), s = Tr((u) => {
    n.current && r((c) => c & ~u);
  }, [r, n]), a = Tr((u) => {
    n.current && r((c) => c ^ u);
  }, [r]);
  return { flags: e, addFlag: i, hasFlag: o, removeFlag: s, toggleFlag: a };
}
function Bg(t) {
  let e = { called: !1 };
  return (...r) => {
    if (!e.called)
      return e.called = !0, t(...r);
  };
}
function bo(t, ...e) {
  t && e.length > 0 && t.classList.add(...e);
}
function xo(t, ...e) {
  t && e.length > 0 && t.classList.remove(...e);
}
function Wg(t, e) {
  let r = ei();
  if (!t)
    return r.dispose;
  let { transitionDuration: n, transitionDelay: i } = getComputedStyle(t), [o, s] = [n, i].map((u) => {
    let [c = 0] = u.split(",").filter(Boolean).map((d) => d.includes("ms") ? parseFloat(d) : parseFloat(d) * 1e3).sort((d, f) => f - d);
    return c;
  }), a = o + s;
  if (a !== 0) {
    r.group((c) => {
      c.setTimeout(() => {
        e(), c.dispose();
      }, a), c.addEventListener(t, "transitionrun", (d) => {
        d.target === d.currentTarget && c.dispose();
      });
    });
    let u = r.addEventListener(t, "transitionend", (c) => {
      c.target === c.currentTarget && (e(), u());
    });
  } else
    e();
  return r.add(() => e()), r.dispose;
}
function Gg(t, e, r, n) {
  let i = r ? "enter" : "leave", o = ei(), s = n !== void 0 ? Bg(n) : () => {
  };
  i === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  let a = Le(i, { enter: () => e.enter, leave: () => e.leave }), u = Le(i, { enter: () => e.enterTo, leave: () => e.leaveTo }), c = Le(i, { enter: () => e.enterFrom, leave: () => e.leaveFrom });
  return xo(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), bo(t, ...e.base, ...a, ...c), o.nextFrame(() => {
    xo(t, ...e.base, ...a, ...c), bo(t, ...e.base, ...a, ...u), Wg(t, () => (xo(t, ...e.base, ...a), bo(t, ...e.base, ...e.entered), s()));
  }), o.dispose;
}
function Ug({ immediate: t, container: e, direction: r, classes: n, onStart: i, onStop: o }) {
  let s = Vs(), a = Xu(), u = Tt(r);
  Ct(() => {
    t && (u.current = "enter");
  }, [t]), Ct(() => {
    let c = ei();
    a.add(c.dispose);
    let d = e.current;
    if (d && u.current !== "idle" && s.current)
      return c.dispose(), i.current(u.current), c.add(Gg(d, n.current, u.current === "enter", () => {
        c.dispose(), o.current(u.current);
      })), c.dispose;
  }, [r]);
}
function nr(t = "") {
  return t.split(/\s+/).filter((e) => e.length > 1);
}
let Xi = Ye(null);
Xi.displayName = "TransitionContext";
var qg = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(qg || {});
function Yg() {
  let t = $e(Xi);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function Qg() {
  let t = $e(Zi);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
let Zi = Ye(null);
Zi.displayName = "NestingContext";
function eo(t) {
  return "children" in t ? eo(t.children) : t.current.filter(({ el: e }) => e.current !== null).filter(({ state: e }) => e === "visible").length > 0;
}
function lc(t, e) {
  let r = Tt(t), n = se([]), i = Vs(), o = Xu(), s = me((g, y = ar.Hidden) => {
    let E = n.current.findIndex(({ el: S }) => S === g);
    E !== -1 && (Le(y, { [ar.Unmount]() {
      n.current.splice(E, 1);
    }, [ar.Hidden]() {
      n.current[E].state = "hidden";
    } }), o.microTask(() => {
      var S;
      !eo(n) && i.current && ((S = r.current) == null || S.call(r));
    }));
  }), a = me((g) => {
    let y = n.current.find(({ el: E }) => E === g);
    return y ? y.state !== "visible" && (y.state = "visible") : n.current.push({ el: g, state: "visible" }), () => s(g, ar.Unmount);
  }), u = se([]), c = se(Promise.resolve()), d = se({ enter: [], leave: [], idle: [] }), f = me((g, y, E) => {
    u.current.splice(0), e && (e.chains.current[y] = e.chains.current[y].filter(([S]) => S !== g)), e == null || e.chains.current[y].push([g, new Promise((S) => {
      u.current.push(S);
    })]), e == null || e.chains.current[y].push([g, new Promise((S) => {
      Promise.all(d.current[y].map(([_, O]) => O)).then(() => S());
    })]), y === "enter" ? c.current = c.current.then(() => e == null ? void 0 : e.wait.current).then(() => E(y)) : E(y);
  }), v = me((g, y, E) => {
    Promise.all(d.current[y].splice(0).map(([S, _]) => _)).then(() => {
      var S;
      (S = u.current.shift()) == null || S();
    }).then(() => E(y));
  });
  return Pe(() => ({ children: n, register: a, unregister: s, onStart: f, onStop: v, wait: c, chains: d }), [a, s, n, f, v, d, c]);
}
function Jg() {
}
let Kg = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function La(t) {
  var e;
  let r = {};
  for (let n of Kg)
    r[n] = (e = t[n]) != null ? e : Jg;
  return r;
}
function Xg(t) {
  let e = se(La(t));
  return ne(() => {
    e.current = La(t);
  }, [t]), e;
}
let Zg = "div", uc = fr.RenderStrategy;
function ey(t, e) {
  var r, n;
  let { beforeEnter: i, afterEnter: o, beforeLeave: s, afterLeave: a, enter: u, enterFrom: c, enterTo: d, entered: f, leave: v, leaveFrom: g, leaveTo: y, ...E } = t, S = se(null), _ = at(S, e), O = (r = E.unmount) == null || r ? ar.Unmount : ar.Hidden, { show: T, appear: P, initial: x } = Yg(), [M, H] = ye(T ? "visible" : "hidden"), R = Qg(), { register: q, unregister: K } = R;
  ne(() => q(S), [q, S]), ne(() => {
    if (O === ar.Hidden && S.current) {
      if (T && M !== "visible") {
        H("visible");
        return;
      }
      return Le(M, { hidden: () => K(S), visible: () => q(S) });
    }
  }, [M, S, q, K, T, O]);
  let k = Tt({ base: nr(E.className), enter: nr(u), enterFrom: nr(c), enterTo: nr(d), entered: nr(f), leave: nr(v), leaveFrom: nr(g), leaveTo: nr(y) }), V = Xg({ beforeEnter: i, afterEnter: o, beforeLeave: s, afterLeave: a }), Q = qi();
  ne(() => {
    if (Q && M === "visible" && S.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [S, M, Q]);
  let re = x && !P, ve = P && T && x, Y = (() => !Q || re ? "idle" : T ? "enter" : "leave")(), le = Hg(0), j = me((G) => Le(G, { enter: () => {
    le.addFlag(ke.Opening), V.current.beforeEnter();
  }, leave: () => {
    le.addFlag(ke.Closing), V.current.beforeLeave();
  }, idle: () => {
  } })), N = me((G) => Le(G, { enter: () => {
    le.removeFlag(ke.Opening), V.current.afterEnter();
  }, leave: () => {
    le.removeFlag(ke.Closing), V.current.afterLeave();
  }, idle: () => {
  } })), w = lc(() => {
    H("hidden"), K(S);
  }, R), $ = se(!1);
  Ug({ immediate: ve, container: S, classes: k, direction: Y, onStart: Tt((G) => {
    $.current = !0, w.onStart(S, G, j);
  }), onStop: Tt((G) => {
    $.current = !1, w.onStop(S, G, N), G === "leave" && !eo(w) && (H("hidden"), K(S));
  }) });
  let F = E, z = { ref: _ };
  return ve ? F = { ...F, className: Ti(E.className, ...k.current.enter, ...k.current.enterFrom) } : $.current && (F.className = Ti(E.className, (n = S.current) == null ? void 0 : n.className), F.className === "" && delete F.className), W.createElement(Zi.Provider, { value: w }, W.createElement(Fs, { value: Le(M, { visible: ke.Open, hidden: ke.Closed }) | le.flags }, lt({ ourProps: z, theirProps: F, defaultTag: Zg, features: uc, visible: M === "visible", name: "Transition.Child" })));
}
function ty(t, e) {
  let { show: r, appear: n = !1, unmount: i = !0, ...o } = t, s = se(null), a = at(s, e);
  qi();
  let u = ti();
  if (r === void 0 && u !== null && (r = (u & ke.Open) === ke.Open), ![!0, !1].includes(r))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [c, d] = ye(r ? "visible" : "hidden"), f = lc(() => {
    d("hidden");
  }), [v, g] = ye(!0), y = se([r]);
  Ct(() => {
    v !== !1 && y.current[y.current.length - 1] !== r && (y.current.push(r), g(!1));
  }, [y, r]);
  let E = Pe(() => ({ show: r, appear: n, initial: v }), [r, n, v]);
  ne(() => {
    if (r)
      d("visible");
    else if (!eo(f))
      d("hidden");
    else {
      let T = s.current;
      if (!T)
        return;
      let P = T.getBoundingClientRect();
      P.x === 0 && P.y === 0 && P.width === 0 && P.height === 0 && d("hidden");
    }
  }, [r, f]);
  let S = { unmount: i }, _ = me(() => {
    var T;
    v && g(!1), (T = t.beforeEnter) == null || T.call(t);
  }), O = me(() => {
    var T;
    v && g(!1), (T = t.beforeLeave) == null || T.call(t);
  });
  return W.createElement(Zi.Provider, { value: f }, W.createElement(Xi.Provider, { value: E }, lt({ ourProps: { ...S, as: Et, children: W.createElement(cc, { ref: a, ...S, ...o, beforeEnter: _, beforeLeave: O }) }, theirProps: {}, defaultTag: Et, features: uc, visible: c === "visible", name: "Transition" })));
}
function ry(t, e) {
  let r = $e(Xi) !== null, n = ti() !== null;
  return W.createElement(W.Fragment, null, !r && n ? W.createElement(Jo, { ref: e, ...t }) : W.createElement(cc, { ref: e, ...t }));
}
let Jo = et(ty), cc = et(ey), ny = et(ry), mi = Object.assign(Jo, { Child: ny, Root: Jo });
const Q1 = ({
  sectionHeader: t = "Frequently Asked Questions",
  sectionDescription: e = "We’ve compiled a list of frequently asked questions to help you get the most out of our products and services. If you have a question that’s not listed here, please don’t hesitate to contact us.",
  sectionImage: r,
  faqs: n
}) => {
  if (!n || n.length === 0)
    return null;
  const i = !!(r != null && r.url);
  return /* @__PURE__ */ h("div", { "data-testid": "faq", id: "faq", children: /* @__PURE__ */ h("div", { className: "bg-white flex-col  flex items-start gap-2.5 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 w-full mx-auto", children: /* @__PURE__ */ I("div", { className: "flex items-start gap-5 flex-col xl:flex-row w-full", children: [
    /* @__PURE__ */ I(
      "div",
      {
        className: ht(i ? "flex-col  w-full" : "w-full lg:flex-row flex-col", "flex items-start gap-6"),
        children: [
          /* @__PURE__ */ I("div", { className: "flex-col h-1/3 flex items-start gap-4 font-medium font-Inter", children: [
            /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
              /* @__PURE__ */ h("div", { className: "text-primary-600 text-heading6 font-inter", children: "FAQs" }),
              /* @__PURE__ */ h("div", { className: "text-heading5 md:text-heading3 text-neutral-900 font-inter", children: t })
            ] }),
            /* @__PURE__ */ h("div", { className: " text-neutral-900 text-body2 font-inter", children: e })
          ] }),
          /* @__PURE__ */ h("div", { className: "w-full flex-col flex items-start gap-3", children: n.map((o, s) => /* @__PURE__ */ h("div", { className: "w-full", children: /* @__PURE__ */ h(wo, { children: ({ open: a }) => /* @__PURE__ */ I(os, { children: [
            /* @__PURE__ */ I(
              wo.Button,
              {
                className: ht(
                  a && "bg-neutral-50",
                  "flex w-full items-center gap-2 pb-2 pt-5 px-5 rounded-t-xl"
                ),
                children: [
                  /* @__PURE__ */ h(
                    "div",
                    {
                      className: ht(
                        "flex justify-center items-center  transition-all",
                        a ? "transform rotate-180" : "transform rotate-0"
                      ),
                      children: a ? /* @__PURE__ */ h(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "20",
                          height: "20",
                          viewBox: "0 0 20 20",
                          fill: "none",
                          children: /* @__PURE__ */ h(
                            "path",
                            {
                              d: "M10 7.5V10M10 10V12.5M10 10H12.5M10 10H7.5M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z",
                              stroke: "#808C91",
                              strokeWidth: "2",
                              strokeLinecap: "round",
                              strokeLinejoin: "round"
                            }
                          )
                        }
                      ) : /* @__PURE__ */ h(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          strokeWidth: "1.5",
                          stroke: "#808C91",
                          width: "20",
                          height: "20",
                          children: /* @__PURE__ */ h(
                            "path",
                            {
                              stroke: "#808C91",
                              strokeWidth: "2",
                              strokeLinecap: "round",
                              strokeLinejoin: "round",
                              d: "M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                            }
                          )
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ h("h4", { className: "inline-flex w-full order-2 text-left text-body2 font-medium tracking-wide text-neutral-900 font-inter", children: o.question })
                ]
              }
            ),
            /* @__PURE__ */ h(
              mi,
              {
                enter: "transition duration-100 ease-out",
                enterFrom: "transform scale-95 opacity-0",
                enterTo: "transform scale-100 opacity-100",
                leave: "transition duration-75 ease-out",
                leaveFrom: "transform scale-100 opacity-100",
                leaveTo: "transform scale-95 opacity-0",
                children: /* @__PURE__ */ h(
                  wo.Panel,
                  {
                    className: ht(a && "bg-neutral-50", "w-full px-4 sm:px-8 pb-5 rounded-b-xl"),
                    children: /* @__PURE__ */ h("p", { className: "inline-flex text-left text-caption1 font-light leading-relaxed tracking-wide text-neutral-500 font-inter", children: o.answer })
                  }
                )
              }
            )
          ] }) }) }, `faq-${o.question}-${s}`)) })
        ]
      }
    ),
    i && /* @__PURE__ */ h(
      Xe,
      {
        alt: "sectionImage",
        className: "max-h-[36rem] w-full object-cover rounded-xl xl:max-w-3xl",
        src: Ze(r == null ? void 0 : r.url),
        cldImg: He(r == null ? void 0 : r.url),
        plugins: [st()]
      }
    )
  ] }) }) });
}, J1 = ({
  orgLinks: t,
  logoImage: e,
  businessName: r,
  shortDescription: n,
  businessLinks: i,
  phones: o,
  emails: s,
  locations: a,
  hideLocation: u = !1
}) => {
  const c = o && (o == null ? void 0 : o.length) > 0 || s && (s == null ? void 0 : s.length) > 0, d = t && (t == null ? void 0 : t.length) > 0 || i && (i == null ? void 0 : i.length) > 0 || c, f = !!(e != null && e.url);
  return /* @__PURE__ */ h("div", { "data-testid": "footer", className: "bg-neutral-50", id: "footer", children: /* @__PURE__ */ I(
    "div",
    {
      className: ht(
        "flex-col flex items-start gap-16  py-8 mx-auto w-full max-w-[95rem] px-6 sm:px-10 lg:px-24 mt-9",
        d ? "gap-16" : "gap-6"
      ),
      children: [
        /* @__PURE__ */ I("div", { className: "w-full flex items-start flex-col md:flex-row gap-10  md:gap-16", children: [
          /* @__PURE__ */ I("div", { className: "flex-col flex gap-2  text-neutral-900 font-inter", children: [
            /* @__PURE__ */ I("div", { className: "flex flex-row gap-2 flex-wrap", children: [
              f ? /* @__PURE__ */ h(
                Xe,
                {
                  className: "h-6 w-6",
                  alt: "logoImageFooter",
                  src: Ze(e == null ? void 0 : e.url),
                  cldImg: He(e == null ? void 0 : e.url),
                  plugins: [st()]
                }
              ) : /* @__PURE__ */ h("div", { className: "h-6 w-6 rounded-full bg-neutral-700" }),
              /* @__PURE__ */ h("span", { className: "text-heading6 font-inter", children: r })
            ] }),
            /* @__PURE__ */ h("span", { className: "text-caption1 font-inter", children: n })
          ] }),
          i && (i == null ? void 0 : i.length) > 0 && /* @__PURE__ */ I("div", { className: "flex-col md:w-1/5 flex items-start gap-4 font-medium font-inter", children: [
            /* @__PURE__ */ h("span", { className: "text-heading6 text-neutral-900 font-inter", children: "Social" }),
            /* @__PURE__ */ h("div", { className: "flex-col flex items-start gap-3 text-neutral-500 text-body2 font-inter", children: i == null ? void 0 : i.map((v, g) => /* @__PURE__ */ h("a", { href: v.url, children: v.label }, `business-link-${g}`)) })
          ] }),
          c && /* @__PURE__ */ I("div", { className: "flex-col md:w-1/5 flex items-start gap-4 font-medium ", children: [
            /* @__PURE__ */ h("span", { className: "text-heading6 text-neutral-900 font-inter", children: "Contact Us" }),
            /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-2.5 text-body2 text-neutral-500 font-inter", children: [
              s == null ? void 0 : s.map((v, g) => /* @__PURE__ */ I("a", { href: `mailto:${v.email}`, children: [
                v.label,
                " ",
                v.email
              ] }, `email-footer-${g}`)),
              o == null ? void 0 : o.map((v, g) => /* @__PURE__ */ h("a", { href: `tel:${St(v.phoneNumber)}`, children: St(v.phoneNumber) }, `phone-footer-${g}`))
            ] })
          ] }),
          a && (a == null ? void 0 : a.length) > 0 && !u && /* @__PURE__ */ I("div", { className: "flex-col md:w-1/5 flex items-start gap-4 text-neutral-900 font-inter", children: [
            /* @__PURE__ */ h("span", { className: "text-heading6 font-medium font-inter", children: "Address" }),
            /* @__PURE__ */ h("div", { className: "w-full flex-col flex items-start gap-2.5 text-body2 font-inter", children: a == null ? void 0 : a.map(({ state: v, city: g, postalCode: y, streetAddress: E }, S) => /* @__PURE__ */ h(
              "a",
              {
                href: Qu({ streetAddress: E, city: g, state: v, postalCode: y }),
                className: "flex flex-col gap-1",
                children: Ju({ streetAddress: E, city: g, state: v, postalCode: y })
              },
              `location-footer-${S}`
            )) })
          ] })
        ] }),
        /* @__PURE__ */ I("div", { className: "w-full flex gap-2.5 flex-wrap justify-between items-end text-body2 font-medium text-neutral-500 font-inter", children: [
          /* @__PURE__ */ I("div", { className: "flex gap-2.5 flex-wrap", children: [
            /* @__PURE__ */ h("a", { target: "_blank", href: "https://www.trades.org/trade-pro/privacy", rel: "noreferrer", children: "Privacy Policy" }),
            /* @__PURE__ */ h("a", { target: "_blank", href: "https://www.trades.org/trade-pro/terms", rel: "noreferrer", children: "Terms of Service" })
          ] }),
          /* @__PURE__ */ h("a", { target: "_blank", href: "https://www.trades.org/", rel: "noreferrer", children: "Powered by trades.org" })
        ] })
      ]
    }
  ) });
}, K1 = ({ sectionHeader: t = "Our Guarantees", sectionImage: e, guarantees: r }) => {
  var i, o;
  if (!r || ((i = r == null ? void 0 : r.guaranteeDescriptions) == null ? void 0 : i.length) === 0)
    return null;
  const n = !!(e != null && e.url);
  return /* @__PURE__ */ h("div", { "data-testid": "guarantees", id: "guarantees", children: /* @__PURE__ */ I("div", { className: "bg-white flex-col lg:flex-row flex justify-center items-start gap-5 px-4 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 w-full", children: [
    /* @__PURE__ */ I(
      "div",
      {
        className: ht(
          "h-full flex-1 flex lg:items-start gap-6 max-lg:self-center w-full",
          n ? "flex-col" : "flex-row max-md:flex-wrap"
        ),
        children: [
          /* @__PURE__ */ I("div", { className: "flex-col flex items-start gap-4 font-medium w-full", children: [
            /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
              /* @__PURE__ */ h("span", { className: "text-xl text-primary-600 font-inter", children: "GUARANTEES" }),
              /* @__PURE__ */ h("h2", { className: " text-neutral-900 text-heading5 md:text-heading3font-inter", children: t })
            ] }),
            /* @__PURE__ */ h("span", { className: " text-neutral-900 text-body2 font-inter", children: r == null ? void 0 : r.title })
          ] }),
          /* @__PURE__ */ h("div", { className: "flex-col flex items-start gap-4 w-full", children: (o = r == null ? void 0 : r.guaranteeDescriptions) == null ? void 0 : o.map((s, a) => /* @__PURE__ */ I("div", { className: "w-full flex items-start gap-1 rounded-xl h-fit", children: [
            /* @__PURE__ */ h("svg", { width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.02717 2.52797C8.05638 2.4458 9.03343 2.04098 9.81917 1.37117C10.7066 0.615317 11.8343 0.200195 13 0.200195C14.1657 0.200195 15.2933 0.615317 16.1808 1.37117C16.9665 2.04098 17.9436 2.4458 18.9728 2.52797C20.1351 2.62086 21.2263 3.12471 22.0507 3.9492C22.8752 4.77368 23.3791 5.86488 23.472 7.02717C23.5536 8.05597 23.9584 9.03357 24.6288 9.81917C25.3846 10.7066 25.7997 11.8343 25.7997 13C25.7997 14.1657 25.3846 15.2933 24.6288 16.1808C23.959 16.9665 23.5541 17.9436 23.472 18.9728C23.3791 20.1351 22.8752 21.2263 22.0507 22.0507C21.2263 22.8752 20.1351 23.3791 18.9728 23.472C17.9436 23.5541 16.9665 23.959 16.1808 24.6288C15.2933 25.3846 14.1657 25.7997 13 25.7997C11.8343 25.7997 10.7066 25.3846 9.81917 24.6288C9.03343 23.959 8.05638 23.5541 7.02717 23.472C5.86488 23.3791 4.77368 22.8752 3.9492 22.0507C3.12471 21.2263 2.62086 20.1351 2.52797 18.9728C2.4458 17.9436 2.04098 16.9665 1.37117 16.1808C0.615317 15.2933 0.200195 14.1657 0.200195 13C0.200195 11.8343 0.615317 10.7066 1.37117 9.81917C2.04098 9.03343 2.4458 8.05638 2.52797 7.02717C2.62086 5.86488 3.12471 4.77368 3.9492 3.9492C4.77368 3.12471 5.86488 2.62086 7.02717 2.52797ZM18.9312 10.9312C19.2226 10.6294 19.3839 10.2252 19.3802 9.80573C19.3766 9.38622 19.2083 8.98491 18.9117 8.68826C18.615 8.39161 18.2137 8.22334 17.7942 8.21969C17.3747 8.21605 16.9705 8.37732 16.6688 8.66877L11.4 13.9376L9.33117 11.8688C9.02941 11.5773 8.62524 11.416 8.20573 11.4197C7.78621 11.4233 7.38491 11.5916 7.08826 11.8883C6.79161 12.1849 6.62334 12.5862 6.61969 13.0057C6.61605 13.4252 6.77732 13.8294 7.06877 14.1312L10.2688 17.3312C10.5688 17.6311 10.9757 17.7996 11.4 17.7996C11.8242 17.7996 12.2311 17.6311 12.5312 17.3312L18.9312 10.9312Z",
                fill: "#64C575"
              }
            ) }),
            /* @__PURE__ */ I("div", { className: "flex-1 flex-col flex justify-center items-start gap-2 ", children: [
              /* @__PURE__ */ h("span", { className: " text-neutral-900 text-body2 font-inter", children: s == null ? void 0 : s.title }),
              /* @__PURE__ */ h("p", { className: "font-medium text-neutral-500  text-body2 font-inter", children: s == null ? void 0 : s.description })
            ] })
          ] }, `guarantee-${a}`)) })
        ]
      }
    ),
    n && /* @__PURE__ */ h(
      Xe,
      {
        alt: e == null ? void 0 : e.title,
        className: "h-full lg:max-h-[40rem] lg:max-w-[610px] w-full mx-auto object-cover rounded-xl",
        src: Ze(e == null ? void 0 : e.url),
        cldImg: He(e == null ? void 0 : e.url),
        plugins: [st()]
      }
    )
  ] }) });
};
function iy({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ Qt.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ Qt.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ Qt.createElement("path", {
    fillRule: "evenodd",
    d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}
const oy = Qt.forwardRef(iy), sy = oy, X1 = ({ logoImage: t, actionButtonText: e = "Contact Us", phoneNumber: r }) => {
  const n = !!(t != null && t.url);
  return /* @__PURE__ */ h("div", { "data-testid": "header", id: "header", children: /* @__PURE__ */ h("div", { className: "relative", children: /* @__PURE__ */ I("div", { className: "flex-col flex items-start ", children: [
    /* @__PURE__ */ I(
      "a",
      {
        href: `tel:${St(r)}`,
        className: "bg-primary-500 flex flex-row justify-center items-center gap-3 py-3 h-fit w-full",
        children: [
          /* @__PURE__ */ h("div", { className: "text-base font-medium text-white font-inter", children: "Call us now!" }),
          /* @__PURE__ */ h("svg", { width: "7", height: "6", viewBox: "0 0 7 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h("circle", { cx: "3.5", cy: "3", r: "3", fill: "white" }) }),
          /* @__PURE__ */ I("div", { className: "flex justify-center items-center gap-1", children: [
            /* @__PURE__ */ h("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h(
              "path",
              {
                d: "M2.5 3C2.5 2.73478 2.60536 2.48043 2.79289 2.29289C2.98043 2.10536 3.23478 2 3.5 2H5.653C5.88971 2.00011 6.1187 2.08418 6.29924 2.23726C6.47979 2.39034 6.60018 2.6025 6.639 2.836L7.379 7.271C7.41436 7.48222 7.38097 7.69921 7.28376 7.89003C7.18655 8.08085 7.03065 8.23543 6.839 8.331L5.291 9.104C5.84611 10.4797 6.67283 11.7293 7.72178 12.7782C8.77072 13.8272 10.0203 14.6539 11.396 15.209L12.17 13.661C12.2655 13.4695 12.4199 13.3138 12.6106 13.2166C12.8012 13.1194 13.0179 13.0859 13.229 13.121L17.664 13.861C17.8975 13.8998 18.1097 14.0202 18.2627 14.2008C18.4158 14.3813 18.4999 14.6103 18.5 14.847V17C18.5 17.2652 18.3946 17.5196 18.2071 17.7071C18.0196 17.8946 17.7652 18 17.5 18H15.5C8.32 18 2.5 12.18 2.5 5V3Z",
                fill: "white"
              }
            ) }),
            /* @__PURE__ */ h("div", { className: "text-base font-medium text-white font-inter", children: St(r) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ h("div", { className: "bg-white w-full flex justify-between items-center max-w-[85rem] mx-auto px-6 lg:px-10  py-2.5", children: /* @__PURE__ */ I("div", { className: "flex-1 flex justify-between items-center", children: [
      /* @__PURE__ */ h("div", { className: "text-xl font-semibold text-center font-inter", children: /* @__PURE__ */ h("a", { href: "/", className: "text-primary-500 font-inter", children: n ? /* @__PURE__ */ h(
        Xe,
        {
          className: "h-10 w-10",
          alt: "logoImageHeader",
          src: Ze(t == null ? void 0 : t.url),
          cldImg: He(t == null ? void 0 : t.url),
          plugins: [st()]
        }
      ) : /* @__PURE__ */ h("div", { className: "h-6 w-6 rounded-full bg-neutral-700" }) }) }),
      /* @__PURE__ */ I("div", { className: "flex-1 justify-center items-center gap-7 lg:flex hidden", children: [
        /* @__PURE__ */ h(
          "a",
          {
            href: "/",
            className: "flex justify-center items-center  text-base font-medium hover:text-primary-600 font-inter",
            children: "Home"
          }
        ),
        /* @__PURE__ */ h(
          "a",
          {
            href: "#about-us",
            className: "flex justify-center items-center  text-base font-medium hover:text-primary-600 font-inter",
            children: "About us"
          }
        ),
        /* @__PURE__ */ h(
          "a",
          {
            href: "#services",
            className: "flex justify-center items-center  text-base font-medium hover:text-primary-600 font-inter",
            children: "Services"
          }
        ),
        /* @__PURE__ */ h(
          "a",
          {
            href: "#faq",
            className: "flex justify-center items-center  text-base font-medium hover:text-primary-600 font-inter",
            children: "FAQs"
          }
        )
      ] }),
      /* @__PURE__ */ h(
        "a",
        {
          href: `tel:${St(r)}`,
          className: "text-button lg:flex hidden rounded-xl hover:bg-primary-100  text-primary-600 active:ring-primary-500 active:ring-1 active:bg-primary-100 bg-primary-50 focus:outline-none  font-medium  px-5 py-2.5 text-center font-inter",
          children: e
        }
      ),
      /* @__PURE__ */ I(jn, { children: [
        /* @__PURE__ */ h(jn.Button, { className: "lg:hidden", children: /* @__PURE__ */ I("svg", { width: "44", height: "44", viewBox: "0 0 44 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ h("path", { d: "M8 13.3043H35.8261", stroke: "#0C212C", strokeWidth: "3", strokeLinecap: "round" }),
          /* @__PURE__ */ h("path", { d: "M8 22H35.8261", stroke: "#0C212C", strokeWidth: "3", strokeLinecap: "round" }),
          /* @__PURE__ */ h("path", { d: "M8 30.6957H35.8261", stroke: "#0C212C", strokeWidth: "3", strokeLinecap: "round" })
        ] }) }),
        /* @__PURE__ */ I(mi.Root, { children: [
          /* @__PURE__ */ h(
            mi.Child,
            {
              as: Et,
              enter: "duration-150 ease-out",
              enterFrom: "opacity-0",
              enterTo: "opacity-100",
              leave: "duration-150 ease-in",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /* @__PURE__ */ h(jn.Overlay, { className: "fixed inset-0 z-30 bg-black opacity-30 lg:hidden" })
            }
          ),
          /* @__PURE__ */ h(
            mi.Child,
            {
              as: Et,
              enter: "duration-150 ease-out",
              enterFrom: "opacity-0 scale-95",
              enterTo: "opacity-100 scale-100",
              leave: "duration-150 ease-in",
              leaveFrom: "opacity-100 scale-100",
              leaveTo: "opacity-0 scale-95",
              children: /* @__PURE__ */ h(jn.Panel, { className: "fixed z-50 inset-x-0 h-full top-0 origin-top-right transform transition lg:hidden", children: /* @__PURE__ */ I("div", { className: "divide-y-2 divide-gray-50  bg-white shadow-lg ring-1 ring-black ring-opacity-5 w-full h-full", children: [
                /* @__PURE__ */ I(
                  "a",
                  {
                    href: `tel:${St(r)}`,
                    className: "bg-primary-500 flex flex-row justify-center items-center gap-3  py-3 h-fit w-full",
                    children: [
                      /* @__PURE__ */ h("div", { className: "text-base font-medium text-white font-inter", children: "Call us now!" }),
                      /* @__PURE__ */ h(
                        "svg",
                        {
                          width: "7",
                          height: "6",
                          viewBox: "0 0 7 6",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                          className: "max-sm:hidden",
                          children: /* @__PURE__ */ h("circle", { cx: "3.5", cy: "3", r: "3", fill: "white" })
                        }
                      ),
                      /* @__PURE__ */ I("div", { className: "flex justify-center items-center gap-1", children: [
                        /* @__PURE__ */ h(
                          "svg",
                          {
                            width: "21",
                            height: "20",
                            viewBox: "0 0 21 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /* @__PURE__ */ h(
                              "path",
                              {
                                d: "M2.5 3C2.5 2.73478 2.60536 2.48043 2.79289 2.29289C2.98043 2.10536 3.23478 2 3.5 2H5.653C5.88971 2.00011 6.1187 2.08418 6.29924 2.23726C6.47979 2.39034 6.60018 2.6025 6.639 2.836L7.379 7.271C7.41436 7.48222 7.38097 7.69921 7.28376 7.89003C7.18655 8.08085 7.03065 8.23543 6.839 8.331L5.291 9.104C5.84611 10.4797 6.67283 11.7293 7.72178 12.7782C8.77072 13.8272 10.0203 14.6539 11.396 15.209L12.17 13.661C12.2655 13.4695 12.4199 13.3138 12.6106 13.2166C12.8012 13.1194 13.0179 13.0859 13.229 13.121L17.664 13.861C17.8975 13.8998 18.1097 14.0202 18.2627 14.2008C18.4158 14.3813 18.4999 14.6103 18.5 14.847V17C18.5 17.2652 18.3946 17.5196 18.2071 17.7071C18.0196 17.8946 17.7652 18 17.5 18H15.5C8.32 18 2.5 12.18 2.5 5V3Z",
                                fill: "white"
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ h("div", { className: "text-base font-medium text-white font-inter", children: St(r) })
                      ] })
                    ]
                  }
                ),
                /* @__PURE__ */ I("div", { className: "px-5 pt-3 pb-6 max-h-[calc(85vh-35px)] h-full", children: [
                  /* @__PURE__ */ I("div", { className: "flex items-center justify-between py-2", children: [
                    n ? /* @__PURE__ */ h(
                      Xe,
                      {
                        className: "w-6 h-6",
                        alt: "logoImageHeaderTwo",
                        src: Ze(t == null ? void 0 : t.url),
                        cldImg: He(t == null ? void 0 : t.url),
                        plugins: [st()]
                      }
                    ) : /* @__PURE__ */ h("div", { className: "w-6 h-6 bg-neutral-700 rounded-full" }),
                    /* @__PURE__ */ h("div", { className: "-mr-1 mt-1", children: /* @__PURE__ */ h(jn.Button, { className: "inline-flex items-center rounded-md justify-center bg-white p-1 text-gray-600 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 font-inter", children: /* @__PURE__ */ h(sy, { className: "h-7 w-7", "aria-hidden": "true" }) }) })
                  ] }),
                  /* @__PURE__ */ I("div", { className: "flex flex-col h-full justify-between", children: [
                    /* @__PURE__ */ I("div", { className: "flex gap-8 flex-col py-6", children: [
                      /* @__PURE__ */ h(
                        "a",
                        {
                          href: "/",
                          className: "flex  items-center   font-medium text-heading6 hover:text-primary-600 font-inter",
                          children: "Home"
                        }
                      ),
                      /* @__PURE__ */ h(
                        "a",
                        {
                          href: "#about-us",
                          className: "flex  items-center   font-medium text-heading6 hover:text-primary-600 font-inter",
                          children: "About us"
                        }
                      ),
                      /* @__PURE__ */ h(
                        "a",
                        {
                          href: "#services",
                          className: "flex  items-center   font-medium text-heading6 hover:text-primary-600 font-inter",
                          children: "Services"
                        }
                      ),
                      /* @__PURE__ */ h(
                        "a",
                        {
                          href: "#faq",
                          className: "flex  items-center   font-medium text-heading6 hover:text-primary-600 font-inter",
                          children: "FAQs"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ h(
                      "a",
                      {
                        href: `tel:${St(r)}`,
                        className: "text-button flex w-full justify-center rounded-xl hover:bg-primary-100  text-primary-600 active:ring-primary-500 active:ring-1 active:bg-primary-100 bg-primary-50 focus:outline-none  font-medium  px-5 py-2.5 text-center font-inter",
                        children: e
                      }
                    )
                  ] })
                ] })
              ] }) })
            }
          )
        ] })
      ] })
    ] }) })
  ] }) }) });
}, Z1 = ({
  headline: t,
  subHeadline: e,
  businessName: r,
  coverImage: n,
  requestQuote: i = {
    actionButtonText: "Request a Quote Now!",
    sectionDescription: "With our passion for creativity and industry-leading technologies, we're ready to help you unleash the power of innovation and achieve great results!",
    sectionHeader: "Elevate Your Experience, Start Your Project With Us."
  },
  businessEmail: o
}) => {
  const { isHorizontal: s } = n, { isLoading: a, isSuccess: u, handleChange: c, onSubmit: d, isError: f } = du({
    businessEmail: o,
    businessName: r
  });
  return /* @__PURE__ */ h("div", { "data-testid": "hero", className: "w-full h-full relative", id: "hero", children: s ? /* @__PURE__ */ I(os, { children: [
    /* @__PURE__ */ h("div", { className: "absolute w-full z-[-1]  h-full", children: /* @__PURE__ */ h("div", { className: "flex justify-start items-start flex-col h-full", children: /* @__PURE__ */ h(
      "div",
      {
        style: {
          backgroundImage: `url('${He(n.url).toURL()}')`
        },
        className: "w-full min-h-[25rem] md:min-h-[35rem] h-full  bg-cover bg-center",
        children: /* @__PURE__ */ h("div", { className: "w-full h-full flex  justify-center items-center backdrop-brightness-50" })
      }
    ) }) }),
    /* @__PURE__ */ I("div", { className: "flex flex-col lg:flex-row md:gap-4 gap-6 w-full md:min-h-[35rem] items-center px-5 py-6 lg:px-6 lg:py-10 xl:py-20 xl:px-24 2xl:pr-[23rem]", children: [
      /* @__PURE__ */ I("div", { className: "flex flex-col gap-2 lg:max-w-lg w-full h-full", children: [
        /* @__PURE__ */ h("span", { className: "text-white text-caption1 font-semibold font-inter", children: r }),
        /* @__PURE__ */ h("h1", { className: "text-white text-heading5 md:text-heading3 xl:text-heading1 font-medium font-inter", children: t }),
        /* @__PURE__ */ h("p", { className: "text-white text-body1 font-normal font-inter", children: e })
      ] }),
      /* @__PURE__ */ h("div", { className: "flex justify-center md:justify-end h-full w-full", children: /* @__PURE__ */ h("section", { className: "bg-white rounded-[1.25rem]  h-fit lg:max-w-md xl:max-w-sm w-full shadow-md", children: /* @__PURE__ */ h("div", { className: "flex flex-col items-center justify-center  py-2 mx-auto  lg:py-0", children: /* @__PURE__ */ h("div", { className: "w-full rounded-lg md:mt-0 lg:max-w-md xl:p-0  ", children: /* @__PURE__ */ I("div", { className: "px-6 py-4 flex flex-col gap-4  sm:p-8", children: [
        /* @__PURE__ */ h("h1", { className: "text-xl font-medium leading-tight tracking-tight text-primary-500 md:text-2xl font-inter", children: i == null ? void 0 : i.sectionHeader }),
        /* @__PURE__ */ h("p", { className: "text-neutral-600 text-base 2xl:max-w-[18rem] font-inter", children: i == null ? void 0 : i.sectionDescription }),
        /* @__PURE__ */ I("form", { onSubmit: d, className: "space-y-4", children: [
          u && /* @__PURE__ */ h("div", { className: "flex items-center w-full justify-center p-4 text-sm font-medium text-primary-800 bg-primary-100 rounded-md font-inter", children: "Message sent successfully" }),
          f && /* @__PURE__ */ h("div", { className: "flex items-center w-full justify-center p-4 text-sm font-medium text-error-800 bg-error-100 rounded-md font-inter", children: "Error sending message" }),
          /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
            "input",
            {
              className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
              name: "name",
              id: "name",
              type: "text",
              placeholder: "First Name",
              onChange: c,
              required: !0
            }
          ) }),
          /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
            "input",
            {
              type: "email",
              name: "email",
              id: "email",
              className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
              placeholder: "Email Address",
              onChange: c,
              required: !0
            }
          ) }),
          /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
            "input",
            {
              name: "phoneNumber",
              onChange: c,
              type: "text",
              placeholder: "Phone Number",
              className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
              required: !0
            }
          ) }),
          /* @__PURE__ */ h(
            "button",
            {
              disabled: a,
              type: "submit",
              className: "w-full disabled:opacity-70 disabled:pointer-events-none text-button rounded-xl hover:bg-primary-100  text-primary-600 active:ring-primary-500 active:ring-1 active:bg-primary-100 bg-primary-50 font-medium  px-5 py-2.5 text-center  :bg-primary-700 font-inter",
              children: i == null ? void 0 : i.actionButtonText
            }
          )
        ] })
      ] }) }) }) }) })
    ] })
  ] }) : /* @__PURE__ */ I("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ I("div", { className: "flex flex-col lg:flex-row md:gap-5    max-w-[90rem] w-full mx-auto  px-5 py-6 lg:px-6 lg:py-10 xl:py-20  xl:px-9 ", children: [
      /* @__PURE__ */ I("div", { className: "flex flex-col w-full gap-4", children: [
        /* @__PURE__ */ I("div", { className: "flex flex-col gap-2 lg:max-w-xl w-full ", children: [
          /* @__PURE__ */ h("span", { className: "text-white md:text-black text-caption1 font-semibold font-inter", children: r }),
          /* @__PURE__ */ h("h1", { className: "text-white md:text-black text-heading5 md:text-heading3 xl:text-heading2 font-medium font-inter", children: t }),
          /* @__PURE__ */ h("p", { className: "text-white md:text-black text-body1 font-normal font-inter", children: e })
        ] }),
        /* @__PURE__ */ h("div", { className: "flex h-full ", children: /* @__PURE__ */ h("section", { className: "bg-white rounded-[1.25rem]  h-fit   w-full shadow-xl ", children: /* @__PURE__ */ h("div", { className: "flex flex-col items-center justify-center  py-2 mx-auto  lg:py-0", children: /* @__PURE__ */ h("div", { className: "w-full rounded-lg md:mt-0  xl:p-0  ", children: /* @__PURE__ */ I("div", { className: "px-6 py-4 flex flex-col gap-4  sm:p-8", children: [
          /* @__PURE__ */ h("h1", { className: "text-xl font-medium leading-tight tracking-tight text-primary-500 md:text-2xl font-inter", children: i == null ? void 0 : i.sectionHeader }),
          /* @__PURE__ */ h("p", { className: "text-neutral-600 text-base ", children: i == null ? void 0 : i.sectionDescription }),
          /* @__PURE__ */ I("form", { onSubmit: d, className: "space-y-4", children: [
            u && /* @__PURE__ */ h("div", { className: "flex items-center w-full justify-center p-4 text-sm font-medium text-primary-800 bg-primary-100 rounded-md font-inter", children: "Message sent successfully" }),
            f && /* @__PURE__ */ h("div", { className: "flex items-center w-full justify-center p-4 text-sm font-medium text-error-800 bg-error-100 rounded-md font-inter", children: "Error sending message" }),
            /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
              "input",
              {
                className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
                name: "name",
                id: "name",
                type: "text",
                placeholder: "First Name",
                onChange: c,
                required: !0
              }
            ) }),
            /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
              "input",
              {
                type: "email",
                name: "email",
                id: "email",
                className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
                placeholder: "Email Address",
                onChange: c,
                required: !0
              }
            ) }),
            /* @__PURE__ */ h("div", { children: /* @__PURE__ */ h(
              "input",
              {
                name: "phoneNumber",
                onChange: c,
                type: "text",
                placeholder: "Phone Number",
                className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
                required: !0
              }
            ) }),
            /* @__PURE__ */ h(
              "button",
              {
                disabled: a,
                type: "submit",
                className: "w-full disabled:opacity-70 disabled:pointer-events-none text-button rounded-xl hover:bg-primary-100  text-primary-600 active:ring-primary-500 active:ring-1 active:bg-primary-100 bg-primary-50 font-medium  px-5 py-2.5 text-center  :bg-primary-700 font-inter",
                children: i == null ? void 0 : i.actionButtonText
              }
            )
          ] })
        ] }) }) }) }) })
      ] }),
      /* @__PURE__ */ h("div", { className: " w-full  max-md:hidden", children: /* @__PURE__ */ h("div", { className: "flex  items-center flex-col w-full max-md:hidden ", children: /* @__PURE__ */ h(
        Xe,
        {
          alt: "coverImage",
          className: "w-full h-[25rem] md:h-[43rem] xl:max-w-lg  object-cover  rounded-xl",
          src: Ze(n == null ? void 0 : n.url),
          cldImg: He(n == null ? void 0 : n.url),
          plugins: [st()]
        }
      ) }) })
    ] }),
    /* @__PURE__ */ h("div", { className: "absolute w-full z-[-1] md:hidden", children: /* @__PURE__ */ h("div", { className: "flex justify-start items-start flex-col", children: /* @__PURE__ */ h(
      "div",
      {
        style: {
          backgroundImage: `url('${He(n == null ? void 0 : n.url).toURL()}')`
        },
        className: "w-full h-[25rem] md:h-[35rem]  bg-cover bg-center",
        children: /* @__PURE__ */ h("div", { className: "w-full h-full flex  justify-center items-center backdrop-brightness-50" })
      }
    ) }) })
  ] }) });
}, ew = ({
  sectionHeader: t = "Our Standout Features",
  sectionDescription: e = "Discover how these features work in harmony to create projects that inspire and exceed expectations.",
  sectionImage: r,
  highlightedFeatures: n
}) => {
  if (!n || n.length === 0)
    return null;
  const i = !!(r != null && r.url);
  return /* @__PURE__ */ h("div", { "data-testid": "features", id: "features", children: /* @__PURE__ */ I("div", { className: "bg-white lg:flex-row flex-col flex justify-around items-start gap-5 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 mx-auto w-full justify-center", children: [
    /* @__PURE__ */ I("div", { className: "h-full w-full lg:w-1/2 flex-col flex items-start gap-6 font-medium", children: [
      /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-4", children: [
        /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
          /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "FEATURES" }),
          /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
        ] }),
        /* @__PURE__ */ h("p", { className: "text-body2 text-neutral-900 max-w-xl font-inter", children: e })
      ] }),
      i && /* @__PURE__ */ h("div", { className: "self-center w-full", children: /* @__PURE__ */ h(
        Xe,
        {
          alt: r == null ? void 0 : r.title,
          className: "max-h-[30rem] lg:max-h-[45rem] h-full max-w-4xl w-full rounded-xl object-cover",
          src: Ze(r == null ? void 0 : r.url),
          cldImg: He(r == null ? void 0 : r.url),
          plugins: [st()]
        }
      ) })
    ] }),
    /* @__PURE__ */ h("div", { className: "grid lg:grid-cols-1 sm:grid-cols-2 grid-cols-1 w-full gap-5 lg:max-w-sm", children: n.map((o, s) => /* @__PURE__ */ I(
      "div",
      {
        className: "flex-col w-full flex items-start gap-3 px-4 py-6 rounded-2xl border border-neutral-200 h-fit shadow-md",
        children: [
          /* @__PURE__ */ I("div", { className: "w-full flex items-center gap-2", children: [
            /* @__PURE__ */ h("div", { className: "flex-col flex items-center gap-2.5 rounded-full", children: /* @__PURE__ */ h("div", { className: "bg-primary-50 rounded-full w-full  flex-col flex justify-center items-center gap-2.5 p-2.5", children: /* @__PURE__ */ h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ h(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.52038 4.14622C8.29229 4.08459 9.02507 3.78098 9.61438 3.27862C10.28 2.71173 11.1257 2.40039 12 2.40039C12.8743 2.40039 13.72 2.71173 14.3856 3.27862C14.9749 3.78098 15.7077 4.08459 16.4796 4.14622C17.3513 4.21589 18.1697 4.59378 18.7881 5.21214C19.4064 5.8305 19.7843 6.6489 19.854 7.52062C19.9152 8.29222 20.2188 9.02542 20.7216 9.61462C21.2885 10.2802 21.5998 11.1259 21.5998 12.0002C21.5998 12.8745 21.2885 13.7202 20.7216 14.3858C20.2192 14.9751 19.9156 15.7079 19.854 16.4798C19.7843 17.3515 19.4064 18.1699 18.7881 18.7883C18.1697 19.4067 17.3513 19.7846 16.4796 19.8542C15.7077 19.9159 14.9749 20.2195 14.3856 20.7218C13.72 21.2887 12.8743 21.6001 12 21.6001C11.1257 21.6001 10.28 21.2887 9.61438 20.7218C9.02507 20.2195 8.29229 19.9159 7.52038 19.8542C6.64866 19.7846 5.83026 19.4067 5.2119 18.7883C4.59353 18.1699 4.21565 17.3515 4.14598 16.4798C4.08435 15.7079 3.78074 14.9751 3.27838 14.3858C2.71149 13.7202 2.40015 12.8745 2.40015 12.0002C2.40015 11.1259 2.71149 10.2802 3.27838 9.61462C3.78074 9.02532 4.08435 8.29253 4.14598 7.52062C4.21565 6.6489 4.59353 5.8305 5.2119 5.21214C5.83026 4.59378 6.64866 4.21589 7.52038 4.14622ZM16.4484 10.4486C16.667 10.2223 16.7879 9.91918 16.7852 9.60454C16.7825 9.28991 16.6562 8.98893 16.4338 8.76644C16.2113 8.54395 15.9103 8.41775 15.5957 8.41501C15.281 8.41228 14.9779 8.53323 14.7516 8.75182L10.8 12.7034L9.24838 11.1518C9.02206 10.9332 8.71893 10.8123 8.4043 10.815C8.08966 10.8177 7.78869 10.9439 7.5662 11.1664C7.34371 11.3889 7.2175 11.6899 7.21477 12.0045C7.21203 12.3192 7.33299 12.6223 7.55158 12.8486L9.95158 15.2486C10.1766 15.4736 10.4818 15.6 10.8 15.6C11.1182 15.6 11.4233 15.4736 11.6484 15.2486L16.4484 10.4486Z",
                fill: "#64C575"
              }
            ) }) }) }),
            /* @__PURE__ */ h("span", { className: "h-full flex-col flex items-center gap-1 text-xl font-medium text-primary-500 font-inter", children: o.title })
          ] }),
          /* @__PURE__ */ h("p", { className: "text-base text-[#6b7280] font-inter", children: o.description })
        ]
      },
      `feature-${s}`
    )) })
  ] }) });
}, tw = ({
  sectionHeader: t = "Our Specialized Services",
  sectionDescription: e = "Explore our specialized services that make dreams come.",
  highlightedServices: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ h("div", { "data-testid": "services", id: "services", children: /* @__PURE__ */ h("div", { className: "bg-white flex items-start gap-5 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 mx-auto w-full  h-fit", children: /* @__PURE__ */ I("div", { className: "h-full flex-1 flex-col flex items-start gap-5", children: [
  /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-4 font-medium", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
      /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "SERVICES" }),
      /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
    ] }),
    /* @__PURE__ */ h("p", { className: "text-body2 text-neutral-900 max-w-xl font-inter", children: e })
  ] }),
  /* @__PURE__ */ h("div", { className: "flex justify-center flex-wrap items-start gap-5 w-full", children: r.map((n, i) => {
    var o, s, a;
    return /* @__PURE__ */ I(
      "div",
      {
        className: ht(
          r.length >= 3 && "w-full md:w-[48%] xl:w-[31%]",
          r.length === 2 && "w-full md:w-[48%]",
          "bg-white flex-col flex items-start rounded-2xl h-full border border-neutral-200 shadow-md overflow-hidden"
        ),
        children: [
          /* @__PURE__ */ h("div", { className: "h-72 w-full bg-primary-500", children: ((o = n.image) == null ? void 0 : o.url) && /* @__PURE__ */ h(
            Xe,
            {
              alt: "",
              className: "h-full max-h-72 w-full object-cover",
              src: Ze((s = n.image) == null ? void 0 : s.url),
              cldImg: He((a = n.image) == null ? void 0 : a.url),
              plugins: [st()]
            }
          ) }),
          /* @__PURE__ */ I("div", { className: "w-full flex-col flex justify-center items-start gap-2 px-6 py-4", children: [
            /* @__PURE__ */ h("span", { className: "text-heading5 font-medium text-primary-500 font-inter", children: n.name }),
            /* @__PURE__ */ h("p", { className: "text-body1  text-neutral-900 font-inter", children: n.description })
          ] })
        ]
      },
      `service-${i}`
    );
  }) })
] }) }) }), rw = ({ sectionHeader: t = "Our Process", sectionImages: e, ourProcess: r }) => !r || (r == null ? void 0 : r.ourProcessSteps.length) === 0 ? null : /* @__PURE__ */ h("div", { "data-testid": "our-process", id: "our-process", children: /* @__PURE__ */ I(
  "div",
  {
    className: ht(
      e && e.length > 0 ? "flex-col" : "lg:flex-row  flex-col",
      "bg-white  w-full flex items-start px-6 xl:px-24 py-14 md:py-16 xl:py-20 gap-8  h-fit"
    ),
    children: [
      /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-4 font-medium ", children: [
        /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
          /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "OUR PROCESS" }),
          /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
        ] }),
        /* @__PURE__ */ h("span", { className: "text-body2 text-neutral-900 font-inter", children: r.title })
      ] }),
      /* @__PURE__ */ I("div", { className: "flex items-start gap-6 flex-col lg:flex-row", children: [
        e && e.length > 0 && /* @__PURE__ */ h("div", { className: " grid grid-cols-2  items-start gap-4 w-full", children: e == null ? void 0 : e.map((n, i) => /* @__PURE__ */ h(
          Xe,
          {
            alt: n.title,
            className: ht(
              n != null && n.url ? "" : "hidden",
              i < 2 ? "max-h-[214px] h-full w-full rounded-xl object-cover" : "max-h-[214px] h-full object-cover w-full col-span-2 rounded-xl"
            ),
            src: Ze(n.url),
            cldImg: He(n.url),
            plugins: [st()]
          },
          `image-process-${i}`
        )) }),
        /* @__PURE__ */ h("div", { className: "flex-col flex items-start gap-5", children: r.ourProcessSteps.sort((n) => n.stepOrder).map((n, i) => /* @__PURE__ */ h("div", { className: "w-full flex items-start gap-2 h-fit", children: /* @__PURE__ */ h("div", { className: "flex-1 flex-col flex items-start gap-2", children: /* @__PURE__ */ I("div", { className: "w-full flex items-start gap-2", children: [
          /* @__PURE__ */ h("div", { className: "bg-primary-50 flex-col px-4 py-2 rounded-full flex justify-center items-center gap-2.5   text-xl font-medium text-primary-500 font-inter", children: n.stepOrder }),
          /* @__PURE__ */ I("div", { className: "flex-1 flex-col flex justify-center items-start gap-1 ", children: [
            /* @__PURE__ */ h("div", { className: "text-base font-medium text-neutral-700 font-inter", children: n.title }),
            /* @__PURE__ */ h("div", { className: "text-caption1 text-neutral-600 font-inter", children: n.description })
          ] })
        ] }) }) }, `step-${i}`)) })
      ] })
    ]
  }
) }), nw = ({
  sectionHeader: t = "Our Team",
  sectionDescription: e = "Meet our team of experts",
  ourPros: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ h("div", { "data-testid": "our-team", id: "our team", children: /* @__PURE__ */ I("div", { className: "bg-white flex-col  flex items-start gap-6 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 mx-auto w-full h-fit", children: [
  /* @__PURE__ */ I("div", { className: "flex-col flex items-start gap-4 font-medium font-Inter", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
      /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "OUR TEAM" }),
      /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
    ] }),
    /* @__PURE__ */ h("p", { className: "text-body2 text-neutral-900 max-w-xl font-inter", children: e })
  ] }),
  /* @__PURE__ */ h("div", { className: "w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5", children: r.map((n, i) => {
    var o, s, a, u;
    return /* @__PURE__ */ I(
      "div",
      {
        className: "flex-col shadow-md flex items-start gap-4 px-4 py-6 rounded-2xl border border-neutral-200 h-fit font-Inter",
        children: [
          (o = n == null ? void 0 : n.image) != null && o.url && ((s = n == null ? void 0 : n.image) == null ? void 0 : s.url.length) > 0 ? /* @__PURE__ */ h(
            Xe,
            {
              alt: "",
              className: "h-[228px] w-full rounded-lg object-cover",
              src: Ze((a = n.image) == null ? void 0 : a.url),
              cldImg: He((u = n.image) == null ? void 0 : u.url),
              plugins: [st()]
            }
          ) : /* @__PURE__ */ h("div", { className: "h-[228px] w-full rounded-lg bg-primary-400 flex items-center justify-center", children: /* @__PURE__ */ h("div", { className: "h-16 w-16 flex items-center justify-center bg-primary-50 p-4 rounded-full", children: /* @__PURE__ */ h("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M28.8002 16.0002C28.8002 19.395 27.4516 22.6507 25.0512 25.0512C22.6507 27.4516 19.395 28.8002 16.0002 28.8002C12.6054 28.8002 9.34969 27.4516 6.94923 25.0512C4.54876 22.6507 3.2002 19.395 3.2002 16.0002C3.2002 12.6054 4.54876 9.34969 6.94923 6.94923C9.34969 4.54876 12.6054 3.2002 16.0002 3.2002C19.395 3.2002 22.6507 4.54876 25.0512 6.94923C27.4516 9.34969 28.8002 12.6054 28.8002 16.0002ZM19.2002 11.2002C19.2002 12.0489 18.8631 12.8628 18.2629 13.4629C17.6628 14.0631 16.8489 14.4002 16.0002 14.4002C15.1515 14.4002 14.3376 14.0631 13.7375 13.4629C13.1373 12.8628 12.8002 12.0489 12.8002 11.2002C12.8002 10.3515 13.1373 9.53757 13.7375 8.93745C14.3376 8.33734 15.1515 8.0002 16.0002 8.0002C16.8489 8.0002 17.6628 8.33734 18.2629 8.93745C18.8631 9.53757 19.2002 10.3515 19.2002 11.2002ZM16.0002 17.6002C14.4684 17.5999 12.9686 18.0394 11.6793 18.8664C10.3899 19.6935 9.36506 20.8734 8.72659 22.2658C9.62688 23.3132 10.743 24.1534 11.9985 24.729C13.254 25.3045 14.6191 25.6017 16.0002 25.6002C17.3813 25.6017 18.7464 25.3045 20.0019 24.729C21.2574 24.1534 22.3735 23.3132 23.2738 22.2658C22.6353 20.8734 21.6105 19.6935 20.3211 18.8664C19.0318 18.0394 17.532 17.5999 16.0002 17.6002Z",
              fill: "#5BC26E"
            }
          ) }) }) }),
          /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-2", children: [
            /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-1 font-medium", children: [
              /* @__PURE__ */ h("div", { className: "text-2xl text-neutral-900 font-inter", children: n.name }),
              /* @__PURE__ */ h("div", { className: "text-base text-primary-500 font-inter", children: n.title })
            ] }),
            /* @__PURE__ */ h("div", { className: "text-sm leading-[24px] text-black font-inter", children: n.bio })
          ] })
        ]
      },
      `our-pro-${i}`
    );
  }) })
] }) });
var dc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, fc = {}, to = {}, Js = {}, _o = {}, li = { exports: {} }, ui = { exports: {} }, we = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $a;
function ay() {
  if ($a)
    return we;
  $a = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, E = t ? Symbol.for("react.block") : 60121, S = t ? Symbol.for("react.fundamental") : 60117, _ = t ? Symbol.for("react.responder") : 60118, O = t ? Symbol.for("react.scope") : 60119;
  function T(x) {
    if (typeof x == "object" && x !== null) {
      var M = x.$$typeof;
      switch (M) {
        case e:
          switch (x = x.type, x) {
            case u:
            case c:
            case n:
            case o:
            case i:
            case f:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case a:
                case d:
                case y:
                case g:
                case s:
                  return x;
                default:
                  return M;
              }
          }
        case r:
          return M;
      }
    }
  }
  function P(x) {
    return T(x) === c;
  }
  return we.AsyncMode = u, we.ConcurrentMode = c, we.ContextConsumer = a, we.ContextProvider = s, we.Element = e, we.ForwardRef = d, we.Fragment = n, we.Lazy = y, we.Memo = g, we.Portal = r, we.Profiler = o, we.StrictMode = i, we.Suspense = f, we.isAsyncMode = function(x) {
    return P(x) || T(x) === u;
  }, we.isConcurrentMode = P, we.isContextConsumer = function(x) {
    return T(x) === a;
  }, we.isContextProvider = function(x) {
    return T(x) === s;
  }, we.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === e;
  }, we.isForwardRef = function(x) {
    return T(x) === d;
  }, we.isFragment = function(x) {
    return T(x) === n;
  }, we.isLazy = function(x) {
    return T(x) === y;
  }, we.isMemo = function(x) {
    return T(x) === g;
  }, we.isPortal = function(x) {
    return T(x) === r;
  }, we.isProfiler = function(x) {
    return T(x) === o;
  }, we.isStrictMode = function(x) {
    return T(x) === i;
  }, we.isSuspense = function(x) {
    return T(x) === f;
  }, we.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === n || x === c || x === o || x === i || x === f || x === v || typeof x == "object" && x !== null && (x.$$typeof === y || x.$$typeof === g || x.$$typeof === s || x.$$typeof === a || x.$$typeof === d || x.$$typeof === S || x.$$typeof === _ || x.$$typeof === O || x.$$typeof === E);
  }, we.typeOf = T, we;
}
var be = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ia;
function ly() {
  return Ia || (Ia = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, v = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, y = t ? Symbol.for("react.lazy") : 60116, E = t ? Symbol.for("react.block") : 60121, S = t ? Symbol.for("react.fundamental") : 60117, _ = t ? Symbol.for("react.responder") : 60118, O = t ? Symbol.for("react.scope") : 60119;
    function T(B) {
      return typeof B == "string" || typeof B == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      B === n || B === c || B === o || B === i || B === f || B === v || typeof B == "object" && B !== null && (B.$$typeof === y || B.$$typeof === g || B.$$typeof === s || B.$$typeof === a || B.$$typeof === d || B.$$typeof === S || B.$$typeof === _ || B.$$typeof === O || B.$$typeof === E);
    }
    function P(B) {
      if (typeof B == "object" && B !== null) {
        var je = B.$$typeof;
        switch (je) {
          case e:
            var Qe = B.type;
            switch (Qe) {
              case u:
              case c:
              case n:
              case o:
              case i:
              case f:
                return Qe;
              default:
                var ct = Qe && Qe.$$typeof;
                switch (ct) {
                  case a:
                  case d:
                  case y:
                  case g:
                  case s:
                    return ct;
                  default:
                    return je;
                }
            }
          case r:
            return je;
        }
      }
    }
    var x = u, M = c, H = a, R = s, q = e, K = d, k = n, V = y, Q = g, re = r, ve = o, Y = i, le = f, j = !1;
    function N(B) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), w(B) || P(B) === u;
    }
    function w(B) {
      return P(B) === c;
    }
    function $(B) {
      return P(B) === a;
    }
    function F(B) {
      return P(B) === s;
    }
    function z(B) {
      return typeof B == "object" && B !== null && B.$$typeof === e;
    }
    function G(B) {
      return P(B) === d;
    }
    function X(B) {
      return P(B) === n;
    }
    function J(B) {
      return P(B) === y;
    }
    function te(B) {
      return P(B) === g;
    }
    function ae(B) {
      return P(B) === r;
    }
    function oe(B) {
      return P(B) === o;
    }
    function ie(B) {
      return P(B) === i;
    }
    function Ne(B) {
      return P(B) === f;
    }
    be.AsyncMode = x, be.ConcurrentMode = M, be.ContextConsumer = H, be.ContextProvider = R, be.Element = q, be.ForwardRef = K, be.Fragment = k, be.Lazy = V, be.Memo = Q, be.Portal = re, be.Profiler = ve, be.StrictMode = Y, be.Suspense = le, be.isAsyncMode = N, be.isConcurrentMode = w, be.isContextConsumer = $, be.isContextProvider = F, be.isElement = z, be.isForwardRef = G, be.isFragment = X, be.isLazy = J, be.isMemo = te, be.isPortal = ae, be.isProfiler = oe, be.isStrictMode = ie, be.isSuspense = Ne, be.isValidElementType = T, be.typeOf = P;
  }()), be;
}
var ka;
function pc() {
  return ka || (ka = 1, process.env.NODE_ENV === "production" ? ui.exports = ay() : ui.exports = ly()), ui.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var So, ja;
function uy() {
  if (ja)
    return So;
  ja = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return So = i() ? Object.assign : function(o, s) {
    for (var a, u = n(o), c, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var f in a)
        e.call(a, f) && (u[f] = a[f]);
      if (t) {
        c = t(a);
        for (var v = 0; v < c.length; v++)
          r.call(a, c[v]) && (u[c[v]] = a[c[v]]);
      }
    }
    return u;
  }, So;
}
var Eo, Da;
function Ks() {
  if (Da)
    return Eo;
  Da = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Eo = t, Eo;
}
var To, Fa;
function hc() {
  return Fa || (Fa = 1, To = Function.call.bind(Object.prototype.hasOwnProperty)), To;
}
var Co, za;
function cy() {
  if (za)
    return Co;
  za = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Ks(), r = {}, n = hc();
    t = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in o)
        if (n(o, d)) {
          var f;
          try {
            if (typeof o[d] != "function") {
              var v = Error(
                (u || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            f = o[d](s, d, u, a, null, e);
          } catch (y) {
            f = y;
          }
          if (f && !(f instanceof Error) && t(
            (u || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var g = c ? c() : "";
            t(
              "Failed " + a + " type: " + f.message + (g ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Co = i, Co;
}
var Oo, Va;
function dy() {
  if (Va)
    return Oo;
  Va = 1;
  var t = pc(), e = uy(), r = Ks(), n = hc(), i = cy(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var u = "Warning: " + a;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Oo = function(a, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(w) {
      var $ = w && (c && w[c] || w[d]);
      if (typeof $ == "function")
        return $;
    }
    var v = "<<anonymous>>", g = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: O(),
      arrayOf: T,
      element: P(),
      elementType: x(),
      instanceOf: M,
      node: K(),
      objectOf: R,
      oneOf: H,
      oneOfType: q,
      shape: V,
      exact: Q
    };
    function y(w, $) {
      return w === $ ? w !== 0 || 1 / w === 1 / $ : w !== w && $ !== $;
    }
    function E(w, $) {
      this.message = w, this.data = $ && typeof $ == "object" ? $ : {}, this.stack = "";
    }
    E.prototype = Error.prototype;
    function S(w) {
      if (process.env.NODE_ENV !== "production")
        var $ = {}, F = 0;
      function z(X, J, te, ae, oe, ie, Ne) {
        if (ae = ae || v, ie = ie || te, Ne !== r) {
          if (u) {
            var B = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw B.name = "Invariant Violation", B;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var je = ae + ":" + te;
            !$[je] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ie + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), $[je] = !0, F++);
          }
        }
        return J[te] == null ? X ? J[te] === null ? new E("The " + oe + " `" + ie + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new E("The " + oe + " `" + ie + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : w(J, te, ae, oe, ie);
      }
      var G = z.bind(null, !1);
      return G.isRequired = z.bind(null, !0), G;
    }
    function _(w) {
      function $(F, z, G, X, J, te) {
        var ae = F[z], oe = Y(ae);
        if (oe !== w) {
          var ie = le(ae);
          return new E(
            "Invalid " + X + " `" + J + "` of type " + ("`" + ie + "` supplied to `" + G + "`, expected ") + ("`" + w + "`."),
            { expectedType: w }
          );
        }
        return null;
      }
      return S($);
    }
    function O() {
      return S(s);
    }
    function T(w) {
      function $(F, z, G, X, J) {
        if (typeof w != "function")
          return new E("Property `" + J + "` of component `" + G + "` has invalid PropType notation inside arrayOf.");
        var te = F[z];
        if (!Array.isArray(te)) {
          var ae = Y(te);
          return new E("Invalid " + X + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + G + "`, expected an array."));
        }
        for (var oe = 0; oe < te.length; oe++) {
          var ie = w(te, oe, G, X, J + "[" + oe + "]", r);
          if (ie instanceof Error)
            return ie;
        }
        return null;
      }
      return S($);
    }
    function P() {
      function w($, F, z, G, X) {
        var J = $[F];
        if (!a(J)) {
          var te = Y(J);
          return new E("Invalid " + G + " `" + X + "` of type " + ("`" + te + "` supplied to `" + z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S(w);
    }
    function x() {
      function w($, F, z, G, X) {
        var J = $[F];
        if (!t.isValidElementType(J)) {
          var te = Y(J);
          return new E("Invalid " + G + " `" + X + "` of type " + ("`" + te + "` supplied to `" + z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S(w);
    }
    function M(w) {
      function $(F, z, G, X, J) {
        if (!(F[z] instanceof w)) {
          var te = w.name || v, ae = N(F[z]);
          return new E("Invalid " + X + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + G + "`, expected ") + ("instance of `" + te + "`."));
        }
        return null;
      }
      return S($);
    }
    function H(w) {
      if (!Array.isArray(w))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function $(F, z, G, X, J) {
        for (var te = F[z], ae = 0; ae < w.length; ae++)
          if (y(te, w[ae]))
            return null;
        var oe = JSON.stringify(w, function(Ne, B) {
          var je = le(B);
          return je === "symbol" ? String(B) : B;
        });
        return new E("Invalid " + X + " `" + J + "` of value `" + String(te) + "` " + ("supplied to `" + G + "`, expected one of " + oe + "."));
      }
      return S($);
    }
    function R(w) {
      function $(F, z, G, X, J) {
        if (typeof w != "function")
          return new E("Property `" + J + "` of component `" + G + "` has invalid PropType notation inside objectOf.");
        var te = F[z], ae = Y(te);
        if (ae !== "object")
          return new E("Invalid " + X + " `" + J + "` of type " + ("`" + ae + "` supplied to `" + G + "`, expected an object."));
        for (var oe in te)
          if (n(te, oe)) {
            var ie = w(te, oe, G, X, J + "." + oe, r);
            if (ie instanceof Error)
              return ie;
          }
        return null;
      }
      return S($);
    }
    function q(w) {
      if (!Array.isArray(w))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var $ = 0; $ < w.length; $++) {
        var F = w[$];
        if (typeof F != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + j(F) + " at index " + $ + "."
          ), s;
      }
      function z(G, X, J, te, ae) {
        for (var oe = [], ie = 0; ie < w.length; ie++) {
          var Ne = w[ie], B = Ne(G, X, J, te, ae, r);
          if (B == null)
            return null;
          B.data && n(B.data, "expectedType") && oe.push(B.data.expectedType);
        }
        var je = oe.length > 0 ? ", expected one of type [" + oe.join(", ") + "]" : "";
        return new E("Invalid " + te + " `" + ae + "` supplied to " + ("`" + J + "`" + je + "."));
      }
      return S(z);
    }
    function K() {
      function w($, F, z, G, X) {
        return re($[F]) ? null : new E("Invalid " + G + " `" + X + "` supplied to " + ("`" + z + "`, expected a ReactNode."));
      }
      return S(w);
    }
    function k(w, $, F, z, G) {
      return new E(
        (w || "React class") + ": " + $ + " type `" + F + "." + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + G + "`."
      );
    }
    function V(w) {
      function $(F, z, G, X, J) {
        var te = F[z], ae = Y(te);
        if (ae !== "object")
          return new E("Invalid " + X + " `" + J + "` of type `" + ae + "` " + ("supplied to `" + G + "`, expected `object`."));
        for (var oe in w) {
          var ie = w[oe];
          if (typeof ie != "function")
            return k(G, X, J, oe, le(ie));
          var Ne = ie(te, oe, G, X, J + "." + oe, r);
          if (Ne)
            return Ne;
        }
        return null;
      }
      return S($);
    }
    function Q(w) {
      function $(F, z, G, X, J) {
        var te = F[z], ae = Y(te);
        if (ae !== "object")
          return new E("Invalid " + X + " `" + J + "` of type `" + ae + "` " + ("supplied to `" + G + "`, expected `object`."));
        var oe = e({}, F[z], w);
        for (var ie in oe) {
          var Ne = w[ie];
          if (n(w, ie) && typeof Ne != "function")
            return k(G, X, J, ie, le(Ne));
          if (!Ne)
            return new E(
              "Invalid " + X + " `" + J + "` key `" + ie + "` supplied to `" + G + "`.\nBad object: " + JSON.stringify(F[z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(w), null, "  ")
            );
          var B = Ne(te, ie, G, X, J + "." + ie, r);
          if (B)
            return B;
        }
        return null;
      }
      return S($);
    }
    function re(w) {
      switch (typeof w) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !w;
        case "object":
          if (Array.isArray(w))
            return w.every(re);
          if (w === null || a(w))
            return !0;
          var $ = f(w);
          if ($) {
            var F = $.call(w), z;
            if ($ !== w.entries) {
              for (; !(z = F.next()).done; )
                if (!re(z.value))
                  return !1;
            } else
              for (; !(z = F.next()).done; ) {
                var G = z.value;
                if (G && !re(G[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ve(w, $) {
      return w === "symbol" ? !0 : $ ? $["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $ instanceof Symbol : !1;
    }
    function Y(w) {
      var $ = typeof w;
      return Array.isArray(w) ? "array" : w instanceof RegExp ? "object" : ve($, w) ? "symbol" : $;
    }
    function le(w) {
      if (typeof w > "u" || w === null)
        return "" + w;
      var $ = Y(w);
      if ($ === "object") {
        if (w instanceof Date)
          return "date";
        if (w instanceof RegExp)
          return "regexp";
      }
      return $;
    }
    function j(w) {
      var $ = le(w);
      switch ($) {
        case "array":
        case "object":
          return "an " + $;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + $;
        default:
          return $;
      }
    }
    function N(w) {
      return !w.constructor || !w.constructor.name ? v : w.constructor.name;
    }
    return g.checkPropTypes = i, g.resetWarningCache = i.resetWarningCache, g.PropTypes = g, g;
  }, Oo;
}
var Po, Ha;
function fy() {
  if (Ha)
    return Po;
  Ha = 1;
  var t = Ks();
  function e() {
  }
  function r() {
  }
  return r.resetWarningCache = e, Po = function() {
    function n(s, a, u, c, d, f) {
      if (f !== t) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, Po;
}
var Ba;
function py() {
  if (Ba)
    return li.exports;
  if (Ba = 1, process.env.NODE_ENV !== "production") {
    var t = pc(), e = !0;
    li.exports = dy()(t.isElement, e);
  } else
    li.exports = fy()();
  return li.exports;
}
var Wa;
function hy() {
  return Wa || (Wa = 1, function(t) {
    (function(e, r) {
      r(t, W, py());
    })(dc, function(e, r, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.setHasSupportToCaptureOption = y;
      var i = s(r), o = s(n);
      function s(O) {
        return O && O.__esModule ? O : {
          default: O
        };
      }
      var a = Object.assign || function(O) {
        for (var T = 1; T < arguments.length; T++) {
          var P = arguments[T];
          for (var x in P)
            Object.prototype.hasOwnProperty.call(P, x) && (O[x] = P[x]);
        }
        return O;
      };
      function u(O, T) {
        var P = {};
        for (var x in O)
          T.indexOf(x) >= 0 || Object.prototype.hasOwnProperty.call(O, x) && (P[x] = O[x]);
        return P;
      }
      function c(O, T) {
        if (!(O instanceof T))
          throw new TypeError("Cannot call a class as a function");
      }
      var d = function() {
        function O(T, P) {
          for (var x = 0; x < P.length; x++) {
            var M = P[x];
            M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(T, M.key, M);
          }
        }
        return function(T, P, x) {
          return P && O(T.prototype, P), x && O(T, x), T;
        };
      }();
      function f(O, T) {
        if (!O)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return T && (typeof T == "object" || typeof T == "function") ? T : O;
      }
      function v(O, T) {
        if (typeof T != "function" && T !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof T);
        O.prototype = Object.create(T && T.prototype, {
          constructor: {
            value: O,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), T && (Object.setPrototypeOf ? Object.setPrototypeOf(O, T) : O.__proto__ = T);
      }
      var g = !1;
      function y(O) {
        g = O;
      }
      try {
        addEventListener("test", null, Object.defineProperty({}, "capture", { get: function() {
          y(!0);
        } }));
      } catch {
      }
      function E() {
        var O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { capture: !0 };
        return g ? O : O.capture;
      }
      function S(O) {
        if ("touches" in O) {
          var T = O.touches[0], P = T.pageX, x = T.pageY;
          return { x: P, y: x };
        }
        var M = O.screenX, H = O.screenY;
        return { x: M, y: H };
      }
      var _ = function(O) {
        v(T, O);
        function T() {
          var P;
          c(this, T);
          for (var x = arguments.length, M = Array(x), H = 0; H < x; H++)
            M[H] = arguments[H];
          var R = f(this, (P = T.__proto__ || Object.getPrototypeOf(T)).call.apply(P, [this].concat(M)));
          return R._handleSwipeStart = R._handleSwipeStart.bind(R), R._handleSwipeMove = R._handleSwipeMove.bind(R), R._handleSwipeEnd = R._handleSwipeEnd.bind(R), R._onMouseDown = R._onMouseDown.bind(R), R._onMouseMove = R._onMouseMove.bind(R), R._onMouseUp = R._onMouseUp.bind(R), R._setSwiperRef = R._setSwiperRef.bind(R), R;
        }
        return d(T, [{
          key: "componentDidMount",
          value: function() {
            this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, E({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, E({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "_onMouseDown",
          value: function(x) {
            this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(x));
          }
        }, {
          key: "_onMouseMove",
          value: function(x) {
            this.mouseDown && this._handleSwipeMove(x);
          }
        }, {
          key: "_onMouseUp",
          value: function(x) {
            this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(x);
          }
        }, {
          key: "_handleSwipeStart",
          value: function(x) {
            var M = S(x), H = M.x, R = M.y;
            this.moveStart = { x: H, y: R }, this.props.onSwipeStart(x);
          }
        }, {
          key: "_handleSwipeMove",
          value: function(x) {
            if (this.moveStart) {
              var M = S(x), H = M.x, R = M.y, q = H - this.moveStart.x, K = R - this.moveStart.y;
              this.moving = !0;
              var k = this.props.onSwipeMove({
                x: q,
                y: K
              }, x);
              k && x.cancelable && x.preventDefault(), this.movePosition = { deltaX: q, deltaY: K };
            }
          }
        }, {
          key: "_handleSwipeEnd",
          value: function(x) {
            this.props.onSwipeEnd(x);
            var M = this.props.tolerance;
            this.moving && this.movePosition && (this.movePosition.deltaX < -M ? this.props.onSwipeLeft(1, x) : this.movePosition.deltaX > M && this.props.onSwipeRight(1, x), this.movePosition.deltaY < -M ? this.props.onSwipeUp(1, x) : this.movePosition.deltaY > M && this.props.onSwipeDown(1, x)), this.moveStart = null, this.moving = !1, this.movePosition = null;
          }
        }, {
          key: "_setSwiperRef",
          value: function(x) {
            this.swiper = x, this.props.innerRef(x);
          }
        }, {
          key: "render",
          value: function() {
            var x = this.props;
            x.tagName;
            var M = x.className, H = x.style, R = x.children;
            x.allowMouseEvents, x.onSwipeUp, x.onSwipeDown, x.onSwipeLeft, x.onSwipeRight, x.onSwipeStart, x.onSwipeMove, x.onSwipeEnd, x.innerRef, x.tolerance;
            var q = u(x, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]);
            return i.default.createElement(
              this.props.tagName,
              a({
                ref: this._setSwiperRef,
                onMouseDown: this._onMouseDown,
                onTouchStart: this._handleSwipeStart,
                onTouchEnd: this._handleSwipeEnd,
                className: M,
                style: H
              }, q),
              R
            );
          }
        }]), T;
      }(r.Component);
      _.displayName = "ReactSwipe", _.propTypes = {
        tagName: o.default.string,
        className: o.default.string,
        style: o.default.object,
        children: o.default.node,
        allowMouseEvents: o.default.bool,
        onSwipeUp: o.default.func,
        onSwipeDown: o.default.func,
        onSwipeLeft: o.default.func,
        onSwipeRight: o.default.func,
        onSwipeStart: o.default.func,
        onSwipeMove: o.default.func,
        onSwipeEnd: o.default.func,
        innerRef: o.default.func,
        tolerance: o.default.number.isRequired
      }, _.defaultProps = {
        tagName: "div",
        allowMouseEvents: !1,
        onSwipeUp: function() {
        },
        onSwipeDown: function() {
        },
        onSwipeLeft: function() {
        },
        onSwipeRight: function() {
        },
        onSwipeStart: function() {
        },
        onSwipeMove: function() {
        },
        onSwipeEnd: function() {
        },
        innerRef: function() {
        },
        tolerance: 0
      }, e.default = _;
    });
  }(_o)), _o;
}
(function(t) {
  (function(e, r) {
    r(t, hy());
  })(dc, function(e, r) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = i(r);
    function i(o) {
      return o && o.__esModule ? o : {
        default: o
      };
    }
    e.default = n.default;
  });
})(Js);
var ri = {}, mc = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var o = "", s = 0; s < arguments.length; s++) {
        var a = arguments[s];
        a && (o = i(o, n(a)));
      }
      return o;
    }
    function n(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return r.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var s = "";
      for (var a in o)
        e.call(o, a) && o[a] && (s = i(s, a));
      return s;
    }
    function i(o, s) {
      return s ? o ? o + " " + s : o + s : o;
    }
    t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
  })();
})(mc);
var my = mc.exports;
Object.defineProperty(ri, "__esModule", {
  value: !0
});
ri.default = void 0;
var ir = vy(my);
function vy(t) {
  return t && t.__esModule ? t : { default: t };
}
function gy(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var yy = {
  ROOT: function(e) {
    return (0, ir.default)(gy({
      "carousel-root": !0
    }, e || "", !!e));
  },
  CAROUSEL: function(e) {
    return (0, ir.default)({
      carousel: !0,
      "carousel-slider": e
    });
  },
  WRAPPER: function(e, r) {
    return (0, ir.default)({
      "thumbs-wrapper": !e,
      "slider-wrapper": e,
      "axis-horizontal": r === "horizontal",
      "axis-vertical": r !== "horizontal"
    });
  },
  SLIDER: function(e, r) {
    return (0, ir.default)({
      thumbs: !e,
      slider: e,
      animated: !r
    });
  },
  ITEM: function(e, r, n) {
    return (0, ir.default)({
      thumb: !e,
      slide: e,
      selected: r,
      previous: n
    });
  },
  ARROW_PREV: function(e) {
    return (0, ir.default)({
      "control-arrow control-prev": !0,
      "control-disabled": e
    });
  },
  ARROW_NEXT: function(e) {
    return (0, ir.default)({
      "control-arrow control-next": !0,
      "control-disabled": e
    });
  },
  DOT: function(e) {
    return (0, ir.default)({
      dot: !0,
      selected: e
    });
  }
};
ri.default = yy;
var ni = {}, ro = {};
Object.defineProperty(ro, "__esModule", {
  value: !0
});
ro.outerWidth = void 0;
var wy = function(e) {
  var r = e.offsetWidth, n = getComputedStyle(e);
  return r += parseInt(n.marginLeft) + parseInt(n.marginRight), r;
};
ro.outerWidth = wy;
var Jr = {};
Object.defineProperty(Jr, "__esModule", {
  value: !0
});
Jr.default = void 0;
var by = function(e, r, n) {
  var i = e === 0 ? e : e + r, o = n === "horizontal" ? [i, 0, 0] : [0, i, 0], s = "translate3d", a = "(" + o.join(",") + ")";
  return s + a;
};
Jr.default = by;
var ii = {};
Object.defineProperty(ii, "__esModule", {
  value: !0
});
ii.default = void 0;
var xy = function() {
  return window;
};
ii.default = xy;
Object.defineProperty(ni, "__esModule", {
  value: !0
});
ni.default = void 0;
var xt = Ey(W), Sr = no(ri), _y = ro, Ga = no(Jr), Sy = no(Js), ci = no(ii);
function no(t) {
  return t && t.__esModule ? t : { default: t };
}
function vc() {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap();
  return vc = function() {
    return t;
  }, t;
}
function Ey(t) {
  if (t && t.__esModule)
    return t;
  if (t === null || Fn(t) !== "object" && typeof t != "function")
    return { default: t };
  var e = vc();
  if (e && e.has(t))
    return e.get(t);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      var o = n ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, e && e.set(t, r), r;
}
function Fn(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Fn = function(r) {
    return typeof r;
  } : Fn = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Fn(t);
}
function Ko() {
  return Ko = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Ko.apply(this, arguments);
}
function Ty(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ua(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function Cy(t, e, r) {
  return e && Ua(t.prototype, e), r && Ua(t, r), t;
}
function Oy(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Xo(t, e);
}
function Xo(t, e) {
  return Xo = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, Xo(t, e);
}
function Py(t) {
  var e = Ay();
  return function() {
    var n = Ci(t), i;
    if (e) {
      var o = Ci(this).constructor;
      i = Reflect.construct(n, arguments, o);
    } else
      i = n.apply(this, arguments);
    return My(this, i);
  };
}
function My(t, e) {
  return e && (Fn(e) === "object" || typeof e == "function") ? e : qe(t);
}
function qe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ay() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ci(t) {
  return Ci = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ci(t);
}
function Ve(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var Ny = function(e) {
  return e.hasOwnProperty("key");
}, Xs = /* @__PURE__ */ function(t) {
  Oy(r, t);
  var e = Py(r);
  function r(n) {
    var i;
    return Ty(this, r), i = e.call(this, n), Ve(qe(i), "itemsWrapperRef", void 0), Ve(qe(i), "itemsListRef", void 0), Ve(qe(i), "thumbsRef", void 0), Ve(qe(i), "setItemsWrapperRef", function(o) {
      i.itemsWrapperRef = o;
    }), Ve(qe(i), "setItemsListRef", function(o) {
      i.itemsListRef = o;
    }), Ve(qe(i), "setThumbsRef", function(o, s) {
      i.thumbsRef || (i.thumbsRef = []), i.thumbsRef[s] = o;
    }), Ve(qe(i), "updateSizes", function() {
      if (!(!i.props.children || !i.itemsWrapperRef || !i.thumbsRef)) {
        var o = xt.Children.count(i.props.children), s = i.itemsWrapperRef.clientWidth, a = i.props.thumbWidth ? i.props.thumbWidth : (0, _y.outerWidth)(i.thumbsRef[0]), u = Math.floor(s / a), c = u < o, d = c ? o - u : 0;
        i.setState(function(f, v) {
          return {
            itemSize: a,
            visibleItems: u,
            firstItem: c ? i.getFirstItem(v.selectedItem) : 0,
            lastPosition: d,
            showArrows: c
          };
        });
      }
    }), Ve(qe(i), "handleClickItem", function(o, s, a) {
      if (!Ny(a) || a.key === "Enter") {
        var u = i.props.onSelectItem;
        typeof u == "function" && u(o, s);
      }
    }), Ve(qe(i), "onSwipeStart", function() {
      i.setState({
        swiping: !0
      });
    }), Ve(qe(i), "onSwipeEnd", function() {
      i.setState({
        swiping: !1
      });
    }), Ve(qe(i), "onSwipeMove", function(o) {
      var s = o.x;
      if (!i.state.itemSize || !i.itemsWrapperRef || !i.state.visibleItems)
        return !1;
      var a = 0, u = xt.Children.count(i.props.children), c = -(i.state.firstItem * 100) / i.state.visibleItems, d = Math.max(u - i.state.visibleItems, 0), f = -d * 100 / i.state.visibleItems;
      c === a && s > 0 && (s = 0), c === f && s < 0 && (s = 0);
      var v = i.itemsWrapperRef.clientWidth, g = c + 100 / (v / s);
      return i.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(y) {
        i.itemsListRef.style[y] = (0, Ga.default)(g, "%", i.props.axis);
      }), !0;
    }), Ve(qe(i), "slideRight", function(o) {
      i.moveTo(i.state.firstItem - (typeof o == "number" ? o : 1));
    }), Ve(qe(i), "slideLeft", function(o) {
      i.moveTo(i.state.firstItem + (typeof o == "number" ? o : 1));
    }), Ve(qe(i), "moveTo", function(o) {
      o = o < 0 ? 0 : o, o = o >= i.state.lastPosition ? i.state.lastPosition : o, i.setState({
        firstItem: o
      });
    }), i.state = {
      selectedItem: n.selectedItem,
      swiping: !1,
      showArrows: !1,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    }, i;
  }
  return Cy(r, [{
    key: "componentDidMount",
    value: function() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      this.props.selectedItem !== this.state.selectedItem && this.setState({
        selectedItem: this.props.selectedItem,
        firstItem: this.getFirstItem(this.props.selectedItem)
      }), this.props.children !== i.children && this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function() {
      (0, ci.default)().addEventListener("resize", this.updateSizes), (0, ci.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function() {
      (0, ci.default)().removeEventListener("resize", this.updateSizes), (0, ci.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function(i) {
      var o = i;
      return i >= this.state.lastPosition && (o = this.state.lastPosition), i < this.state.firstItem + this.state.visibleItems && (o = this.state.firstItem), i < this.state.firstItem && (o = i), o;
    }
  }, {
    key: "renderItems",
    value: function() {
      var i = this;
      return this.props.children.map(function(o, s) {
        var a = Sr.default.ITEM(!1, s === i.state.selectedItem), u = {
          key: s,
          ref: function(d) {
            return i.setThumbsRef(d, s);
          },
          className: a,
          onClick: i.handleClickItem.bind(i, s, i.props.children[s]),
          onKeyDown: i.handleClickItem.bind(i, s, i.props.children[s]),
          "aria-label": "".concat(i.props.labels.item, " ").concat(s + 1),
          style: {
            width: i.props.thumbWidth
          }
        };
        return /* @__PURE__ */ xt.default.createElement("li", Ko({}, u, {
          role: "button",
          tabIndex: 0
        }), o);
      });
    }
  }, {
    key: "render",
    value: function() {
      var i = this;
      if (!this.props.children)
        return null;
      var o = xt.Children.count(this.props.children) > 1, s = this.state.showArrows && this.state.firstItem > 0, a = this.state.showArrows && this.state.firstItem < this.state.lastPosition, u = {}, c = -this.state.firstItem * (this.state.itemSize || 0), d = (0, Ga.default)(c, "px", this.props.axis), f = this.props.transitionTime + "ms";
      return u = {
        WebkitTransform: d,
        MozTransform: d,
        MsTransform: d,
        OTransform: d,
        transform: d,
        msTransform: d,
        WebkitTransitionDuration: f,
        MozTransitionDuration: f,
        MsTransitionDuration: f,
        OTransitionDuration: f,
        transitionDuration: f,
        msTransitionDuration: f
      }, /* @__PURE__ */ xt.default.createElement("div", {
        className: Sr.default.CAROUSEL(!1)
      }, /* @__PURE__ */ xt.default.createElement("div", {
        className: Sr.default.WRAPPER(!1),
        ref: this.setItemsWrapperRef
      }, /* @__PURE__ */ xt.default.createElement("button", {
        type: "button",
        className: Sr.default.ARROW_PREV(!s),
        onClick: function() {
          return i.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), o ? /* @__PURE__ */ xt.default.createElement(Sy.default, {
        tagName: "ul",
        className: Sr.default.SLIDER(!1, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: u,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /* @__PURE__ */ xt.default.createElement("ul", {
        className: Sr.default.SLIDER(!1, this.state.swiping),
        ref: function(g) {
          return i.setItemsListRef(g);
        },
        style: u
      }, this.renderItems()), /* @__PURE__ */ xt.default.createElement("button", {
        type: "button",
        className: Sr.default.ARROW_NEXT(!a),
        onClick: function() {
          return i.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]), r;
}(xt.Component);
ni.default = Xs;
Ve(Xs, "displayName", "Thumbs");
Ve(Xs, "defaultProps", {
  axis: "horizontal",
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});
var io = {};
Object.defineProperty(io, "__esModule", {
  value: !0
});
io.default = void 0;
var Ry = function() {
  return document;
};
io.default = Ry;
var ot = {};
Object.defineProperty(ot, "__esModule", {
  value: !0
});
ot.setPosition = ot.getPosition = ot.isKeyboardEvent = ot.defaultStatusFormatter = ot.noop = void 0;
var Ly = W, $y = Iy(Jr);
function Iy(t) {
  return t && t.__esModule ? t : { default: t };
}
var ky = function() {
};
ot.noop = ky;
var jy = function(e, r) {
  return "".concat(e, " of ").concat(r);
};
ot.defaultStatusFormatter = jy;
var Dy = function(e) {
  return e ? e.hasOwnProperty("key") : !1;
};
ot.isKeyboardEvent = Dy;
var Fy = function(e, r) {
  if (r.infiniteLoop && ++e, e === 0)
    return 0;
  var n = Ly.Children.count(r.children);
  if (r.centerMode && r.axis === "horizontal") {
    var i = -e * r.centerSlidePercentage, o = n - 1;
    return e && (e !== o || r.infiniteLoop) ? i += (100 - r.centerSlidePercentage) / 2 : e === o && (i += 100 - r.centerSlidePercentage), i;
  }
  return -e * 100;
};
ot.getPosition = Fy;
var zy = function(e, r) {
  var n = {};
  return ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(i) {
    n[i] = (0, $y.default)(e, "%", r);
  }), n;
};
ot.setPosition = zy;
var Lt = {};
Object.defineProperty(Lt, "__esModule", {
  value: !0
});
Lt.fadeAnimationHandler = Lt.slideStopSwipingHandler = Lt.slideSwipeAnimationHandler = Lt.slideAnimationHandler = void 0;
var gc = W, Vy = Hy(Jr), $t = ot;
function Hy(t) {
  return t && t.__esModule ? t : { default: t };
}
function qa(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Er(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qa(Object(r), !0).forEach(function(n) {
      By(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qa(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function By(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var Wy = function(e, r) {
  var n = {}, i = r.selectedItem, o = i, s = gc.Children.count(e.children) - 1, a = e.infiniteLoop && (i < 0 || i > s);
  if (a)
    return o < 0 ? e.centerMode && e.centerSlidePercentage && e.axis === "horizontal" ? n.itemListStyle = (0, $t.setPosition)(-(s + 2) * e.centerSlidePercentage - (100 - e.centerSlidePercentage) / 2, e.axis) : n.itemListStyle = (0, $t.setPosition)(-(s + 2) * 100, e.axis) : o > s && (n.itemListStyle = (0, $t.setPosition)(0, e.axis)), n;
  var u = (0, $t.getPosition)(i, e), c = (0, Vy.default)(u, "%", e.axis), d = e.transitionTime + "ms";
  return n.itemListStyle = {
    WebkitTransform: c,
    msTransform: c,
    OTransform: c,
    transform: c
  }, r.swiping || (n.itemListStyle = Er(Er({}, n.itemListStyle), {}, {
    WebkitTransitionDuration: d,
    MozTransitionDuration: d,
    OTransitionDuration: d,
    transitionDuration: d,
    msTransitionDuration: d
  })), n;
};
Lt.slideAnimationHandler = Wy;
var Gy = function(e, r, n, i) {
  var o = {}, s = r.axis === "horizontal", a = gc.Children.count(r.children), u = 0, c = (0, $t.getPosition)(n.selectedItem, r), d = r.infiniteLoop ? (0, $t.getPosition)(a - 1, r) - 100 : (0, $t.getPosition)(a - 1, r), f = s ? e.x : e.y, v = f;
  c === u && f > 0 && (v = 0), c === d && f < 0 && (v = 0);
  var g = c + 100 / (n.itemSize / v), y = Math.abs(f) > r.swipeScrollTolerance;
  return r.infiniteLoop && y && (n.selectedItem === 0 && g > -100 ? g -= a * 100 : n.selectedItem === a - 1 && g < -a * 100 && (g += a * 100)), (!r.preventMovementUntilSwipeScrollTolerance || y || n.swipeMovementStarted) && (n.swipeMovementStarted || i({
    swipeMovementStarted: !0
  }), o.itemListStyle = (0, $t.setPosition)(g, r.axis)), y && !n.cancelClick && i({
    cancelClick: !0
  }), o;
};
Lt.slideSwipeAnimationHandler = Gy;
var Uy = function(e, r) {
  var n = (0, $t.getPosition)(r.selectedItem, e), i = (0, $t.setPosition)(n, e.axis);
  return {
    itemListStyle: i
  };
};
Lt.slideStopSwipingHandler = Uy;
var qy = function(e, r) {
  var n = e.transitionTime + "ms", i = "ease-in-out", o = {
    position: "absolute",
    display: "block",
    zIndex: -2,
    minHeight: "100%",
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: i,
    msTransitionTimingFunction: i,
    MozTransitionTimingFunction: i,
    WebkitTransitionTimingFunction: i,
    OTransitionTimingFunction: i
  };
  return r.swiping || (o = Er(Er({}, o), {}, {
    WebkitTransitionDuration: n,
    MozTransitionDuration: n,
    OTransitionDuration: n,
    transitionDuration: n,
    msTransitionDuration: n
  })), {
    slideStyle: o,
    selectedStyle: Er(Er({}, o), {}, {
      opacity: 1,
      position: "relative"
    }),
    prevStyle: Er({}, o)
  };
};
Lt.fadeAnimationHandler = qy;
Object.defineProperty(to, "__esModule", {
  value: !0
});
to.default = void 0;
var Ee = Jy(W), Yy = oi(Js), Wt = oi(ri), Qy = oi(ni), di = oi(io), fi = oi(ii), Dn = ot, Oi = Lt;
function oi(t) {
  return t && t.__esModule ? t : { default: t };
}
function yc() {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap();
  return yc = function() {
    return t;
  }, t;
}
function Jy(t) {
  if (t && t.__esModule)
    return t;
  if (t === null || zn(t) !== "object" && typeof t != "function")
    return { default: t };
  var e = yc();
  if (e && e.has(t))
    return e.get(t);
  var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      var o = n ? Object.getOwnPropertyDescriptor(t, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = t[i];
    }
  return r.default = t, e && e.set(t, r), r;
}
function zn(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? zn = function(r) {
    return typeof r;
  } : zn = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, zn(t);
}
function Zo() {
  return Zo = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Zo.apply(this, arguments);
}
function Ya(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _t(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ya(Object(r), !0).forEach(function(n) {
      fe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ya(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Ky(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Qa(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function Xy(t, e, r) {
  return e && Qa(t.prototype, e), r && Qa(t, r), t;
}
function Zy(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && es(t, e);
}
function es(t, e) {
  return es = Object.setPrototypeOf || function(n, i) {
    return n.__proto__ = i, n;
  }, es(t, e);
}
function e0(t) {
  var e = r0();
  return function() {
    var n = Pi(t), i;
    if (e) {
      var o = Pi(this).constructor;
      i = Reflect.construct(n, arguments, o);
    } else
      i = n.apply(this, arguments);
    return t0(this, i);
  };
}
function t0(t, e) {
  return e && (zn(e) === "object" || typeof e == "function") ? e : pe(t);
}
function pe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function r0() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Pi(t) {
  return Pi = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Pi(t);
}
function fe(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var Zs = /* @__PURE__ */ function(t) {
  Zy(r, t);
  var e = e0(r);
  function r(n) {
    var i;
    Ky(this, r), i = e.call(this, n), fe(pe(i), "thumbsRef", void 0), fe(pe(i), "carouselWrapperRef", void 0), fe(pe(i), "listRef", void 0), fe(pe(i), "itemsRef", void 0), fe(pe(i), "timer", void 0), fe(pe(i), "animationHandler", void 0), fe(pe(i), "setThumbsRef", function(s) {
      i.thumbsRef = s;
    }), fe(pe(i), "setCarouselWrapperRef", function(s) {
      i.carouselWrapperRef = s;
    }), fe(pe(i), "setListRef", function(s) {
      i.listRef = s;
    }), fe(pe(i), "setItemsRef", function(s, a) {
      i.itemsRef || (i.itemsRef = []), i.itemsRef[a] = s;
    }), fe(pe(i), "autoPlay", function() {
      Ee.Children.count(i.props.children) <= 1 || (i.clearAutoPlay(), i.props.autoPlay && (i.timer = setTimeout(function() {
        i.increment();
      }, i.props.interval)));
    }), fe(pe(i), "clearAutoPlay", function() {
      i.timer && clearTimeout(i.timer);
    }), fe(pe(i), "resetAutoPlay", function() {
      i.clearAutoPlay(), i.autoPlay();
    }), fe(pe(i), "stopOnHover", function() {
      i.setState({
        isMouseEntered: !0
      }, i.clearAutoPlay);
    }), fe(pe(i), "startOnLeave", function() {
      i.setState({
        isMouseEntered: !1
      }, i.autoPlay);
    }), fe(pe(i), "isFocusWithinTheCarousel", function() {
      return i.carouselWrapperRef ? !!((0, di.default)().activeElement === i.carouselWrapperRef || i.carouselWrapperRef.contains((0, di.default)().activeElement)) : !1;
    }), fe(pe(i), "navigateWithKeyboard", function(s) {
      if (i.isFocusWithinTheCarousel()) {
        var a = i.props.axis, u = a === "horizontal", c = {
          ArrowUp: 38,
          ArrowRight: 39,
          ArrowDown: 40,
          ArrowLeft: 37
        }, d = u ? c.ArrowRight : c.ArrowDown, f = u ? c.ArrowLeft : c.ArrowUp;
        d === s.keyCode ? i.increment() : f === s.keyCode && i.decrement();
      }
    }), fe(pe(i), "updateSizes", function() {
      if (!(!i.state.initialized || !i.itemsRef || i.itemsRef.length === 0)) {
        var s = i.props.axis === "horizontal", a = i.itemsRef[0];
        if (a) {
          var u = s ? a.clientWidth : a.clientHeight;
          i.setState({
            itemSize: u
          }), i.thumbsRef && i.thumbsRef.updateSizes();
        }
      }
    }), fe(pe(i), "setMountState", function() {
      i.setState({
        hasMount: !0
      }), i.updateSizes();
    }), fe(pe(i), "handleClickItem", function(s, a) {
      if (Ee.Children.count(i.props.children) !== 0) {
        if (i.state.cancelClick) {
          i.setState({
            cancelClick: !1
          });
          return;
        }
        i.props.onClickItem(s, a), s !== i.state.selectedItem && i.setState({
          selectedItem: s
        });
      }
    }), fe(pe(i), "handleOnChange", function(s, a) {
      Ee.Children.count(i.props.children) <= 1 || i.props.onChange(s, a);
    }), fe(pe(i), "handleClickThumb", function(s, a) {
      i.props.onClickThumb(s, a), i.moveTo(s);
    }), fe(pe(i), "onSwipeStart", function(s) {
      i.setState({
        swiping: !0
      }), i.props.onSwipeStart(s);
    }), fe(pe(i), "onSwipeEnd", function(s) {
      i.setState({
        swiping: !1,
        cancelClick: !1,
        swipeMovementStarted: !1
      }), i.props.onSwipeEnd(s), i.clearAutoPlay(), i.state.autoPlay && i.autoPlay();
    }), fe(pe(i), "onSwipeMove", function(s, a) {
      i.props.onSwipeMove(a);
      var u = i.props.swipeAnimationHandler(s, i.props, i.state, i.setState.bind(pe(i)));
      return i.setState(_t({}, u)), !!Object.keys(u).length;
    }), fe(pe(i), "decrement", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      i.moveTo(i.state.selectedItem - (typeof s == "number" ? s : 1));
    }), fe(pe(i), "increment", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      i.moveTo(i.state.selectedItem + (typeof s == "number" ? s : 1));
    }), fe(pe(i), "moveTo", function(s) {
      if (typeof s == "number") {
        var a = Ee.Children.count(i.props.children) - 1;
        s < 0 && (s = i.props.infiniteLoop ? a : 0), s > a && (s = i.props.infiniteLoop ? 0 : a), i.selectItem({
          // if it's not a slider, we don't need to set position here
          selectedItem: s
        }), i.state.autoPlay && i.state.isMouseEntered === !1 && i.resetAutoPlay();
      }
    }), fe(pe(i), "onClickNext", function() {
      i.increment(1);
    }), fe(pe(i), "onClickPrev", function() {
      i.decrement(1);
    }), fe(pe(i), "onSwipeForward", function() {
      i.increment(1), i.props.emulateTouch && i.setState({
        cancelClick: !0
      });
    }), fe(pe(i), "onSwipeBackwards", function() {
      i.decrement(1), i.props.emulateTouch && i.setState({
        cancelClick: !0
      });
    }), fe(pe(i), "changeItem", function(s) {
      return function(a) {
        (!(0, Dn.isKeyboardEvent)(a) || a.key === "Enter") && i.moveTo(s);
      };
    }), fe(pe(i), "selectItem", function(s) {
      i.setState(_t({
        previousItem: i.state.selectedItem
      }, s), function() {
        i.setState(i.animationHandler(i.props, i.state));
      }), i.handleOnChange(s.selectedItem, Ee.Children.toArray(i.props.children)[s.selectedItem]);
    }), fe(pe(i), "getInitialImage", function() {
      var s = i.props.selectedItem, a = i.itemsRef && i.itemsRef[s], u = a && a.getElementsByTagName("img") || [];
      return u[0];
    }), fe(pe(i), "getVariableItemHeight", function(s) {
      var a = i.itemsRef && i.itemsRef[s];
      if (i.state.hasMount && a && a.children.length) {
        var u = a.children[0].getElementsByTagName("img") || [];
        if (u.length > 0) {
          var c = u[0];
          if (!c.complete) {
            var d = function g() {
              i.forceUpdate(), c.removeEventListener("load", g);
            };
            c.addEventListener("load", d);
          }
        }
        var f = u[0] || a.children[0], v = f.clientHeight;
        return v > 0 ? v : null;
      }
      return null;
    });
    var o = {
      initialized: !1,
      previousItem: n.selectedItem,
      selectedItem: n.selectedItem,
      hasMount: !1,
      isMouseEntered: !1,
      autoPlay: n.autoPlay,
      swiping: !1,
      swipeMovementStarted: !1,
      cancelClick: !1,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    return i.animationHandler = typeof n.animationHandler == "function" && n.animationHandler || n.animationHandler === "fade" && Oi.fadeAnimationHandler || Oi.slideAnimationHandler, i.state = _t(_t({}, o), i.animationHandler(n, o)), i;
  }
  return Xy(r, [{
    key: "componentDidMount",
    value: function() {
      this.props.children && this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i, o) {
      !i.children && this.props.children && !this.state.initialized && this.setupCarousel(), !i.autoFocus && this.props.autoFocus && this.forceFocus(), o.swiping && !this.state.swiping && this.setState(_t({}, this.props.stopSwipingHandler(this.props, this.state))), (i.selectedItem !== this.props.selectedItem || i.centerMode !== this.props.centerMode) && (this.updateSizes(), this.moveTo(this.props.selectedItem)), i.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
        autoPlay: this.props.autoPlay
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function() {
      var i = this;
      this.bindEvents(), this.state.autoPlay && Ee.Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.props.autoFocus && this.forceFocus(), this.setState({
        initialized: !0
      }, function() {
        var o = i.getInitialImage();
        o && !o.complete ? o.addEventListener("load", i.setMountState) : i.setMountState();
      });
    }
  }, {
    key: "destroyCarousel",
    value: function() {
      this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
    }
  }, {
    key: "setupAutoPlay",
    value: function() {
      this.autoPlay();
      var i = this.carouselWrapperRef;
      this.props.stopOnHover && i && (i.addEventListener("mouseenter", this.stopOnHover), i.addEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "destroyAutoPlay",
    value: function() {
      this.clearAutoPlay();
      var i = this.carouselWrapperRef;
      this.props.stopOnHover && i && (i.removeEventListener("mouseenter", this.stopOnHover), i.removeEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "bindEvents",
    value: function() {
      (0, fi.default)().addEventListener("resize", this.updateSizes), (0, fi.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && (0, di.default)().addEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "unbindEvents",
    value: function() {
      (0, fi.default)().removeEventListener("resize", this.updateSizes), (0, fi.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
      var i = this.getInitialImage();
      i && i.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && (0, di.default)().removeEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "forceFocus",
    value: function() {
      var i;
      (i = this.carouselWrapperRef) === null || i === void 0 || i.focus();
    }
  }, {
    key: "renderItems",
    value: function(i) {
      var o = this;
      return this.props.children ? Ee.Children.map(this.props.children, function(s, a) {
        var u = a === o.state.selectedItem, c = a === o.state.previousItem, d = u && o.state.selectedStyle || c && o.state.prevStyle || o.state.slideStyle || {};
        o.props.centerMode && o.props.axis === "horizontal" && (d = _t(_t({}, d), {}, {
          minWidth: o.props.centerSlidePercentage + "%"
        })), o.state.swiping && o.state.swipeMovementStarted && (d = _t(_t({}, d), {}, {
          pointerEvents: "none"
        }));
        var f = {
          ref: function(g) {
            return o.setItemsRef(g, a);
          },
          key: "itemKey" + a + (i ? "clone" : ""),
          className: Wt.default.ITEM(!0, a === o.state.selectedItem, a === o.state.previousItem),
          onClick: o.handleClickItem.bind(o, a, s),
          style: d
        };
        return /* @__PURE__ */ Ee.default.createElement("li", f, o.props.renderItem(s, {
          isSelected: a === o.state.selectedItem,
          isPrevious: a === o.state.previousItem
        }));
      }) : [];
    }
  }, {
    key: "renderControls",
    value: function() {
      var i = this, o = this.props, s = o.showIndicators, a = o.labels, u = o.renderIndicator, c = o.children;
      return s ? /* @__PURE__ */ Ee.default.createElement("ul", {
        className: "control-dots"
      }, Ee.Children.map(c, function(d, f) {
        return u && u(i.changeItem(f), f === i.state.selectedItem, f, a.item);
      })) : null;
    }
  }, {
    key: "renderStatus",
    value: function() {
      return this.props.showStatus ? /* @__PURE__ */ Ee.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, Ee.Children.count(this.props.children))) : null;
    }
  }, {
    key: "renderThumbs",
    value: function() {
      return !this.props.showThumbs || !this.props.children || Ee.Children.count(this.props.children) === 0 ? null : /* @__PURE__ */ Ee.default.createElement(Qy.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function() {
      var i = this;
      if (!this.props.children || Ee.Children.count(this.props.children) === 0)
        return null;
      var o = this.props.swipeable && Ee.Children.count(this.props.children) > 1, s = this.props.axis === "horizontal", a = this.props.showArrows && Ee.Children.count(this.props.children) > 1, u = a && (this.state.selectedItem > 0 || this.props.infiniteLoop) || !1, c = a && (this.state.selectedItem < Ee.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || !1, d = this.renderItems(!0), f = d.shift(), v = d.pop(), g = {
        className: Wt.default.SLIDER(!0, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      }, y = {};
      if (s) {
        if (g.onSwipeLeft = this.onSwipeForward, g.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
          var E = this.getVariableItemHeight(this.state.selectedItem);
          y.height = E || "auto";
        }
      } else
        g.onSwipeUp = this.props.verticalSwipe === "natural" ? this.onSwipeBackwards : this.onSwipeForward, g.onSwipeDown = this.props.verticalSwipe === "natural" ? this.onSwipeForward : this.onSwipeBackwards, g.style = _t(_t({}, g.style), {}, {
          height: this.state.itemSize
        }), y.height = this.state.itemSize;
      return /* @__PURE__ */ Ee.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: Wt.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : void 0
      }, /* @__PURE__ */ Ee.default.createElement("div", {
        className: Wt.default.CAROUSEL(!0),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, u, this.props.labels.leftArrow), /* @__PURE__ */ Ee.default.createElement("div", {
        className: Wt.default.WRAPPER(!0, this.props.axis),
        style: y
      }, o ? /* @__PURE__ */ Ee.default.createElement(Yy.default, Zo({
        tagName: "ul",
        innerRef: this.setListRef
      }, g, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && v, this.renderItems(), this.props.infiniteLoop && f) : /* @__PURE__ */ Ee.default.createElement("ul", {
        className: Wt.default.SLIDER(!0, this.state.swiping),
        ref: function(_) {
          return i.setListRef(_);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && v, this.renderItems(), this.props.infiniteLoop && f)), this.props.renderArrowNext(this.onClickNext, c, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]), r;
}(Ee.default.Component);
to.default = Zs;
fe(Zs, "displayName", "Carousel");
fe(Zs, "defaultProps", {
  ariaLabel: void 0,
  axis: "horizontal",
  centerSlidePercentage: 80,
  interval: 3e3,
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  onClickItem: Dn.noop,
  onClickThumb: Dn.noop,
  onChange: Dn.noop,
  onSwipeStart: function() {
  },
  onSwipeEnd: function() {
  },
  onSwipeMove: function() {
    return !1;
  },
  preventMovementUntilSwipeScrollTolerance: !1,
  renderArrowPrev: function(e, r, n) {
    return /* @__PURE__ */ Ee.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: Wt.default.ARROW_PREV(!r),
      onClick: e
    });
  },
  renderArrowNext: function(e, r, n) {
    return /* @__PURE__ */ Ee.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: Wt.default.ARROW_NEXT(!r),
      onClick: e
    });
  },
  renderIndicator: function(e, r, n, i) {
    return /* @__PURE__ */ Ee.default.createElement("li", {
      className: Wt.default.DOT(r),
      onClick: e,
      onKeyDown: e,
      value: n,
      key: n,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(i, " ").concat(n + 1)
    });
  },
  renderItem: function(e) {
    return e;
  },
  renderThumbs: function(e) {
    var r = Ee.Children.map(e, function(n) {
      var i = n;
      if (n.type !== "img" && (i = Ee.Children.toArray(n.props.children).find(function(o) {
        return o.type === "img";
      })), !!i)
        return i;
    });
    return r.filter(function(n) {
      return n;
    }).length === 0 ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : r;
  },
  statusFormatter: Dn.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: !0,
  showIndicators: !0,
  showStatus: !0,
  showThumbs: !0,
  stopOnHover: !0,
  swipeScrollTolerance: 5,
  swipeable: !0,
  transitionTime: 350,
  verticalSwipe: "standard",
  width: "100%",
  animationHandler: "slide",
  swipeAnimationHandler: Oi.slideSwipeAnimationHandler,
  stopSwipingHandler: Oi.slideStopSwipingHandler
});
var n0 = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "Carousel", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  }), Object.defineProperty(t, "CarouselProps", {
    enumerable: !0,
    get: function() {
      return r.CarouselProps;
    }
  }), Object.defineProperty(t, "Thumbs", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  });
  var e = i(to), r = n0, n = i(ni);
  function i(o) {
    return o && o.__esModule ? o : { default: o };
  }
})(fc);
const iw = ({ sectionHeader: t = "Our Projects", ourProjects: e }) => {
  var u, c, d, f, v, g, y, E;
  const [r, n] = ye(0), [i, o] = ye(0);
  if (!e || e.length === 0)
    return null;
  const s = e.length === 1, a = ((f = (d = (c = (u = e[r]) == null ? void 0 : u.completedProjectImages) == null ? void 0 : c[i]) == null ? void 0 : d.image) == null ? void 0 : f.caption) && ((E = (y = (g = (v = e[r]) == null ? void 0 : v.completedProjectImages) == null ? void 0 : g[i]) == null ? void 0 : y.image) == null ? void 0 : E.description);
  return /* @__PURE__ */ h("div", { "data-testid": "our-work", id: "our-work", children: /* @__PURE__ */ I("div", { className: "bg-white flex-col flex items-center gap-8 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 mx-auto", children: [
    /* @__PURE__ */ h("div", { className: "w-full flex-col flex items-start gap-4 font-medium ", children: /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
      /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "OUR WORK" }),
      /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3 text-neutral-900 font-inter", children: s ? e[0].name : t })
    ] }) }),
    /* @__PURE__ */ I("div", { className: "flex-col flex items-center gap-4 w-full h-full ", children: [
      /* @__PURE__ */ h(
        fc.Carousel,
        {
          selectedItem: i,
          showThumbs: !1,
          showStatus: !1,
          className: "w-full",
          showIndicators: !0,
          renderIndicator: (S, _) => /* @__PURE__ */ h(
            "button",
            {
              className: `inline-block h-2.5 w-2.5 border cursor-pointer rounded-full mr-3 ${_ ? "bg-neutral-300" : "bg-primary-500"}`,
              onClick: S
            }
          ),
          showArrows: !1,
          onChange: (S) => {
            o(S);
          },
          children: e[r].completedProjectImages.length === 0 ? /* @__PURE__ */ h("div", { className: "bg-sucess-500 w-full rounded-xl", children: /* @__PURE__ */ h("div", { className: "flex flex-col justify-center gap-4 min-h-[24rem] px-5 w-full h-full max-w-2xl mx-auto bg-sucess-500" }) }) : e[r].completedProjectImages.map((S, _) => /* @__PURE__ */ h("div", { className: "flex-col flex items-start gap-4 h-fit  ", children: /* @__PURE__ */ h(
            Xe,
            {
              alt: "",
              className: "w-96 h-64 md:h-96  rounded-xl object-cover",
              src: Ze(S.image.url),
              cldImg: He(S.image.url),
              plugins: [st()]
            }
          ) }, `ourProjects-image-${_}`))
        }
      ),
      a && /* @__PURE__ */ I("div", { className: "w-full flex-row flex items-start gap-6", children: [
        /* @__PURE__ */ h("span", { className: "font-medium text-neutral-500 text-body1 font-inter", children: e[r].completedProjectImages[i].image.caption }),
        /* @__PURE__ */ h("p", { className: "text-neutral-500 text-body1 text-left font-inter", children: e[r].completedProjectImages[i].image.description })
      ] }),
      /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-2", children: [
        /* @__PURE__ */ h("span", { className: " text-neutral-600 text-body1 font-inter", children: e[r].name }),
        /* @__PURE__ */ h("p", { className: "text-neutral-600 text-body1 text-left font-inter", children: e[r].description })
      ] }),
      !s && /* @__PURE__ */ h("div", { className: "flex flex-row gap-2 mt-6", children: Array.from(Array(e.length).keys()).map((S) => /* @__PURE__ */ h(
        "button",
        {
          className: ht(
            S === r ? "bg-primary-600 text-white" : "text-primary-500 bg-primary-50",
            "text-white p-1.5 rounded-full font-inter"
          ),
          onClick: () => {
            n(S), o(0);
          }
        },
        `ourProjects-button-${S}`
      )) })
    ] })
  ] }) });
}, ow = ({
  sectionHeader: t = "Certified Expertise",
  sectionDescription: e = "Explore our qualifications and discover why we're the trusted choice for your project needs",
  qualifications: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ h("div", { "data-testid": "qualifications", id: "qualifications", children: /* @__PURE__ */ I("div", { className: "bg-white flex-col flex items-start gap-8 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 w-full  h-fit", children: [
  /* @__PURE__ */ I("div", { className: "flex-col  flex items-start gap-4 font-medium ", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
      /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "QUALIFICATIONS" }),
      /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
    ] }),
    /* @__PURE__ */ h("p", { className: "text-body2 text-neutral-900 max-w-2xl font-inter", children: e })
  ] }),
  /* @__PURE__ */ h("div", { className: "flex justify-center flex-wrap items-start gap-5 w-full", children: r.map((n, i) => {
    var o, s, a;
    return /* @__PURE__ */ I(
      "div",
      {
        className: ht(
          r.length >= 3 ? "w-full md:w-[48%] xl:w-[31%]" : "w-full lg:flex-grow lg:w-auto",
          "bg-white h-full flex-col flex items-center gap-4 px-8 py-6 rounded-2xl border border-neutral-200 shadow-md"
        ),
        children: [
          /* @__PURE__ */ h("div", { className: "flex-col h-16 w-16 flex items-center gap-2.5 rounded-full", children: /* @__PURE__ */ h("div", { className: "bg-primary-50 w-full flex-1 flex-col flex justify-center items-center gap-2.5 px-4 py-3 rounded-full", children: /* @__PURE__ */ h("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.0272 5.52797C11.0564 5.4458 12.0334 5.04098 12.8192 4.37117C13.7066 3.61532 14.8343 3.2002 16 3.2002C17.1657 3.2002 18.2933 3.61532 19.1808 4.37117C19.9665 5.04098 20.9436 5.4458 21.9728 5.52797C23.1351 5.62086 24.2263 6.12471 25.0507 6.9492C25.8752 7.77368 26.3791 8.86488 26.472 10.0272C26.5536 11.056 26.9584 12.0336 27.6288 12.8192C28.3846 13.7066 28.7997 14.8343 28.7997 16C28.7997 17.1657 28.3846 18.2933 27.6288 19.1808C26.959 19.9665 26.5541 20.9436 26.472 21.9728C26.3791 23.1351 25.8752 24.2263 25.0507 25.0507C24.2263 25.8752 23.1351 26.3791 21.9728 26.472C20.9436 26.5541 19.9665 26.959 19.1808 27.6288C18.2933 28.3846 17.1657 28.7997 16 28.7997C14.8343 28.7997 13.7066 28.3846 12.8192 27.6288C12.0334 26.959 11.0564 26.5541 10.0272 26.472C8.86488 26.3791 7.77368 25.8752 6.9492 25.0507C6.12471 24.2263 5.62086 23.1351 5.52797 21.9728C5.4458 20.9436 5.04098 19.9665 4.37117 19.1808C3.61532 18.2933 3.2002 17.1657 3.2002 16C3.2002 14.8343 3.61532 13.7066 4.37117 12.8192C5.04098 12.0334 5.4458 11.0564 5.52797 10.0272C5.62086 8.86488 6.12471 7.77368 6.9492 6.9492C7.77368 6.12471 8.86488 5.62086 10.0272 5.52797ZM21.9312 13.9312C22.2226 13.6294 22.3839 13.2252 22.3802 12.8057C22.3766 12.3862 22.2083 11.9849 21.9117 11.6883C21.615 11.3916 21.2137 11.2233 20.7942 11.2197C20.3747 11.216 19.9705 11.3773 19.6688 11.6688L14.4 16.9376L12.3312 14.8688C12.0294 14.5773 11.6252 14.416 11.2057 14.4197C10.7862 14.4233 10.3849 14.5916 10.0883 14.8883C9.79161 15.1849 9.62334 15.5862 9.61969 16.0057C9.61605 16.4252 9.77732 16.8294 10.0688 17.1312L13.2688 20.3312C13.5688 20.6311 13.9757 20.7996 14.4 20.7996C14.8242 20.7996 15.2311 20.6311 15.5312 20.3312L21.9312 13.9312Z",
              fill: "#64C575"
            }
          ) }) }) }),
          /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-center gap-2 text-center font-inter", children: [
            /* @__PURE__ */ h("span", { className: "text-heading6 font-medium text-neutral-600 font-inter", children: n.title }),
            /* @__PURE__ */ h("p", { className: "text-caption1  text-neutral-600 font-inter", children: n.description })
          ] }),
          /* @__PURE__ */ h("div", { className: "flex-col flex items-start py-1 rounded-full h-fit", children: ((o = n.link) == null ? void 0 : o.url) && /* @__PURE__ */ I(os, { children: [
            /* @__PURE__ */ h(
              "a",
              {
                href: (s = n.link) == null ? void 0 : s.url,
                target: "_blank",
                rel: "noreferrer",
                className: "text-body2  font-medium text-center  text-neutral-900 font-inter",
                children: ((a = n.link) == null ? void 0 : a.label) || "Learn More"
              }
            ),
            /* @__PURE__ */ h("div", { className: "h-0.5 w-full bg-neutral-900" })
          ] }) })
        ]
      },
      `qualification-${i}`
    );
  }) })
] }) }), sw = ({
  sectionHeader: t = "Get Your Project Started!",
  headline: e,
  actionButtonText: r = "Request a Quote",
  businessEmail: n,
  businessName: i
}) => {
  const { isLoading: o, isSuccess: s, handleChange: a, onSubmit: u, isError: c } = du({
    businessEmail: n,
    businessName: i
  });
  return /* @__PURE__ */ h("div", { "data-testid": "request-quote", id: "request-quote", children: /* @__PURE__ */ I("div", { className: "bg-white  flex items-start gap-5 flex-col md:flex-row px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 mx-auto  h-fit", children: [
    /* @__PURE__ */ I("div", { className: "flex-1 flex-col flex items-start gap-4 font-medium ", children: [
      /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
        /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "REQUEST A QUOTE" }),
        /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3 text-neutral-900 font-inter", children: t })
      ] }),
      /* @__PURE__ */ h("div", { className: "text-body2 text-neutral-900 max-w-xl font-inter", children: e })
    ] }),
    /* @__PURE__ */ I("div", { className: "bg-white flex-col md:h-[351px] shadow-md w-full md:max-w-md flex justify-center items-center gap-4 p-5 rounded-[1.25rem] border border-neutral-200", children: [
      /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-2 ", children: [
        /* @__PURE__ */ h("div", { className: "text-heading6 font-medium text-primary-500 font-inter", children: "Request a quote" }),
        /* @__PURE__ */ h("div", { className: "text-caption1  text-neutral-600 font-inter", children: "Request a quote now and get a discount" })
      ] }),
      /* @__PURE__ */ I("form", { onSubmit: u, className: "w-full flex-col flex items-start gap-6", children: [
        s && /* @__PURE__ */ h("div", { className: "flex items-center w-full justify-center p-4 text-sm font-medium text-primary-800 bg-primary-100 rounded-md font-inter", children: "Message sent successfully" }),
        c && /* @__PURE__ */ h("div", { className: "flex items-center w-full  justify-center p-4 text-sm font-medium text-error-800 bg-error-100 rounded-md font-inter", children: "Error sending message" }),
        /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-4", children: [
          /* @__PURE__ */ h(
            "input",
            {
              name: "name",
              id: "name",
              type: "text",
              className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
              placeholder: "First Name",
              onChange: a,
              required: !0
            }
          ),
          /* @__PURE__ */ h(
            "input",
            {
              className: "bg-white border outline-none border-neutral-200  placeholder:text-neutral-600 text-gray-900 text-caption1 rounded-md focus:border-2 hover:border-primary-500 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 font-inter",
              name: "phoneNumber",
              id: "phoneNumber",
              type: "text",
              placeholder: "Phone Number",
              onChange: a,
              required: !0
            }
          )
        ] }),
        /* @__PURE__ */ h(
          "button",
          {
            disabled: o,
            type: "submit",
            className: "w-full text-button disabled:opacity-70 disabled:pointer-events-none rounded-xl hover:bg-primary-100  text-primary-600 active:ring-primary-500 active:ring-1 active:bg-primary-100 bg-primary-50 font-medium  px-5 py-2.5 text-center font-inter",
            children: r
          }
        )
      ] })
    ] })
  ] }) });
}, aw = ({
  sectionHeader: t = "Our Service Area",
  phones: e,
  emails: r,
  locations: n,
  hideLocation: i,
  serviceArea: o
}) => n && n.length === 0 ? null : /* @__PURE__ */ h("div", { "data-testid": "service-area", id: "service-area", children: /* @__PURE__ */ I("div", { className: "bg-white flex-col flex items-start gap-6 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20 w-full  mx-auto h-fit", children: [
  /* @__PURE__ */ h("div", { className: "flex-col flex items-start gap-4 font-medium ", children: /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
    /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "SERVICE AREA" }),
    /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
  ] }) }),
  /* @__PURE__ */ I("div", { className: "flex-col flex items-start gap-5 w-full", children: [
    /* @__PURE__ */ h(
      Jp,
      {
        containerStyle: {
          width: "100%"
        },
        className: "rounded-xl",
        hideLocation: i,
        locations: n,
        serviceArea: o
      }
    ),
    /* @__PURE__ */ I(
      "div",
      {
        className: ht(
          i ? "sm:grid-cols-2 grid-cols-1 lg:grid-cols-2" : "sm:grid-cols-2 grid-cols-1 lg:grid-cols-3",
          "grid  gap-4 w-full"
        ),
        children: [
          e && e.length > 0 && /* @__PURE__ */ I("div", { className: "flex-col  shadow-md  flex items-start gap-9 p-6 rounded-2xl text-heading5 border border-neutral-200 bg-white font-inter", children: [
            /* @__PURE__ */ h("div", { className: "bg-neutral-100 flex justify-center items-center gap-0.5 px-2.5 py-2 rounded-md", children: /* @__PURE__ */ I("svg", { width: "44", height: "40", viewBox: "0 0 44 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
              /* @__PURE__ */ h("rect", { width: "44", height: "40", rx: "6", fill: "#F3F4F5" }),
              /* @__PURE__ */ h(
                "path",
                {
                  d: "M12.4 11.5999C12.4 11.2816 12.5264 10.9764 12.7515 10.7514C12.9765 10.5263 13.2817 10.3999 13.6 10.3999H16.1836C16.4676 10.4 16.7424 10.5009 16.9591 10.6846C17.1757 10.8683 17.3202 11.1229 17.3668 11.4031L18.2548 16.7251C18.2972 16.9786 18.2572 17.239 18.1405 17.4679C18.0239 17.6969 17.8368 17.8824 17.6068 17.9971L15.7492 18.9247C16.4153 20.5755 17.4074 22.075 18.6661 23.3338C19.9249 24.5925 21.4244 25.5846 23.0752 26.2507L24.004 24.3931C24.1186 24.1633 24.3039 23.9764 24.5327 23.8598C24.7614 23.7431 25.0215 23.7029 25.2748 23.7451L30.5968 24.6331C30.877 24.6797 31.1316 24.8242 31.3153 25.0408C31.499 25.2575 31.5999 25.5323 31.6 25.8163V28.3999C31.6 28.7182 31.4736 29.0234 31.2485 29.2484C31.0235 29.4735 30.7183 29.5999 30.4 29.5999H28C19.384 29.5999 12.4 22.6159 12.4 13.9999V11.5999Z",
                  fill: "#64C575"
                }
              )
            ] }) }),
            /* @__PURE__ */ I("div", { className: "w-full flex-col flex justify-center items-start gap-2", children: [
              /* @__PURE__ */ h("span", { className: "text-heading5 font-medium text-neutral-900 font-inter", children: "Call us" }),
              /* @__PURE__ */ h("span", { className: "text-body1  text-neutral-900 font-inter", children: "Get in contact." }),
              e == null ? void 0 : e.map((s, a) => /* @__PURE__ */ h("div", { className: "flex-col flex items-start py-1 rounded-full h-fit", children: /* @__PURE__ */ h(
                "a",
                {
                  href: `tel:${St(s.phoneNumber)}`,
                  className: "text-button  font-medium text-center font-Inter text-neutral-900 transition-colors hover:text-primary-900 hover:border-primary-900 border-b-2 border-neutral-900 font-inter",
                  children: St(s.phoneNumber)
                }
              ) }, `phone-service-${a}`))
            ] })
          ] }),
          !i && n && n.length > 0 && /* @__PURE__ */ I("div", { className: "flex-col  shadow-md  flex items-start gap-9 p-6 rounded-2xl text-heading5 border border-neutral-200 bg-white font-inter", children: [
            /* @__PURE__ */ h("div", { className: "bg-neutral-100 flex justify-center items-center gap-0.5 px-2.5 py-2 rounded-md", children: /* @__PURE__ */ I("svg", { width: "44", height: "40", viewBox: "0 0 44 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
              /* @__PURE__ */ h("rect", { width: "44", height: "40", rx: "6", fill: "#F3F4F5" }),
              /* @__PURE__ */ h(
                "path",
                {
                  fillRule: "evenodd",
                  clipRule: "evenodd",
                  d: "M16.06 12.8598C17.6354 11.2845 19.7721 10.3994 22 10.3994C24.2279 10.3994 26.3646 11.2845 27.94 12.8598C29.5154 14.4352 30.4004 16.5719 30.4004 18.7998C30.4004 21.0278 29.5154 23.1645 27.94 24.7398L22 30.6798L16.06 24.7398C15.2799 23.9598 14.6611 23.0338 14.2389 22.0146C13.8167 20.9954 13.5994 19.903 13.5994 18.7998C13.5994 17.6967 13.8167 16.6043 14.2389 15.5851C14.6611 14.5659 15.2799 13.6399 16.06 12.8598ZM22 21.1998C22.6365 21.1998 23.247 20.947 23.6971 20.4969C24.1471 20.0468 24.4 19.4364 24.4 18.7998C24.4 18.1633 24.1471 17.5529 23.6971 17.1028C23.247 16.6527 22.6365 16.3998 22 16.3998C21.3635 16.3998 20.753 16.6527 20.3029 17.1028C19.8529 17.5529 19.6 18.1633 19.6 18.7998C19.6 19.4364 19.8529 20.0468 20.3029 20.4969C20.753 20.947 21.3635 21.1998 22 21.1998Z",
                  fill: "#64C575"
                }
              )
            ] }) }),
            /* @__PURE__ */ I("div", { className: "w-full flex-col flex justify-center items-start gap-2", children: [
              /* @__PURE__ */ h("span", { className: "text-heading5 font-medium text-neutral-900 font-inter", children: "Visit us" }),
              n == null ? void 0 : n.map(({ streetAddress: s, city: a, state: u, postalCode: c }, d) => /* @__PURE__ */ I("div", { children: [
                /* @__PURE__ */ h("span", { className: "text-body1  text-neutral-900 font-inter", children: Ju({ streetAddress: s, city: a, state: u, postalCode: c }) }),
                /* @__PURE__ */ h("div", { className: "flex-col flex items-start py-1 rounded-full h-fit", children: /* @__PURE__ */ h(
                  "a",
                  {
                    href: Qu({ streetAddress: s, city: a, state: u, postalCode: c }),
                    className: "text-button transition-colors hover:text-primary-900 hover:border-primary-900 border-b-2 border-neutral-900  font-medium text-center font-Inter text-neutral-900 font-inter",
                    children: "View on Google Maps"
                  }
                ) })
              ] }, `locations-service-${d}`))
            ] })
          ] }),
          r && r.length > 0 && /* @__PURE__ */ I("div", { className: "flex-col  shadow-md  flex items-start gap-9 p-6 rounded-2xl text-heading5 border border-neutral-200 bg-white font-inter", children: [
            /* @__PURE__ */ h("div", { className: "bg-neutral-100 flex justify-center items-center gap-0.5 px-2.5 py-2 rounded-md", children: /* @__PURE__ */ I("svg", { width: "44", height: "40", viewBox: "0 0 44 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
              /* @__PURE__ */ h("rect", { width: "44", height: "40", rx: "6", fill: "#F3F4F5" }),
              /* @__PURE__ */ h(
                "path",
                {
                  d: "M12.4 14.0001C12.4 13.3636 12.6529 12.7531 13.1029 12.303C13.553 11.853 14.1635 11.6001 14.8 11.6001H23.2C23.8365 11.6001 24.447 11.853 24.897 12.303C25.3471 12.7531 25.6 13.3636 25.6 14.0001V18.8001C25.6 19.4366 25.3471 20.0471 24.897 20.4972C24.447 20.9472 23.8365 21.2001 23.2 21.2001H20.8L17.2 24.8001V21.2001H14.8C14.1635 21.2001 13.553 20.9472 13.1029 20.4972C12.6529 20.0471 12.4 19.4366 12.4 18.8001V14.0001Z",
                  fill: "#64C575"
                }
              ),
              /* @__PURE__ */ h(
                "path",
                {
                  d: "M28 16.3999V18.7999C28 20.0729 27.4943 21.2938 26.5941 22.194C25.6939 23.0942 24.473 23.5999 23.2 23.5999H21.7936L19.6744 25.7203C20.0104 25.8991 20.3932 25.9999 20.8 25.9999H23.2L26.8 29.5999V25.9999H29.2C29.8365 25.9999 30.447 25.747 30.8971 25.297C31.3472 24.8469 31.6 24.2364 31.6 23.5999V18.7999C31.6 18.1634 31.3472 17.5529 30.8971 17.1028C30.447 16.6528 29.8365 16.3999 29.2 16.3999H28Z",
                  fill: "#64C575"
                }
              )
            ] }) }),
            /* @__PURE__ */ I("div", { className: "w-full flex-col flex justify-center items-start gap-2", children: [
              /* @__PURE__ */ h("span", { className: "text-heading5 font-medium text-neutral-900 font-inter", children: "Chat with us" }),
              /* @__PURE__ */ h("span", { className: "text-body1  text-neutral-900 font-inter", children: "We're here to help" }),
              r == null ? void 0 : r.map((s, a) => /* @__PURE__ */ h("div", { className: "flex-col flex items-start py-1 rounded-full h-fit", children: /* @__PURE__ */ h(
                "a",
                {
                  href: `mailto:${s.email}`,
                  className: "text-button transition-colors hover:text-primary-900 hover:border-primary-900 border-b-2 border-neutral-900 font-medium text-center font-Inter text-neutral-900 font-inter",
                  children: s.email
                }
              ) }, `email-service-${a}`))
            ] })
          ] })
        ]
      }
    )
  ] })
] }) });
function Ja(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function ea(t = {}, e = {}) {
  Object.keys(e).forEach((r) => {
    typeof t[r] > "u" ? t[r] = e[r] : Ja(e[r]) && Ja(t[r]) && Object.keys(e[r]).length > 0 && ea(t[r], e[r]);
  });
}
const wc = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Rr() {
  const t = typeof document < "u" ? document : {};
  return ea(t, wc), t;
}
const i0 = {
  document: wc,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function ut() {
  const t = typeof window < "u" ? window : {};
  return ea(t, i0), t;
}
function o0(t) {
  const e = t;
  Object.keys(e).forEach((r) => {
    try {
      e[r] = null;
    } catch {
    }
    try {
      delete e[r];
    } catch {
    }
  });
}
function ts(t, e = 0) {
  return setTimeout(t, e);
}
function Mi() {
  return Date.now();
}
function s0(t) {
  const e = ut();
  let r;
  return e.getComputedStyle && (r = e.getComputedStyle(t, null)), !r && t.currentStyle && (r = t.currentStyle), r || (r = t.style), r;
}
function a0(t, e = "x") {
  const r = ut();
  let n, i, o;
  const s = s0(t);
  return r.WebKitCSSMatrix ? (i = s.transform || s.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((a) => a.replace(",", ".")).join(", ")), o = new r.WebKitCSSMatrix(i === "none" ? "" : i)) : (o = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = o.toString().split(",")), e === "x" && (r.WebKitCSSMatrix ? i = o.m41 : n.length === 16 ? i = parseFloat(n[12]) : i = parseFloat(n[4])), e === "y" && (r.WebKitCSSMatrix ? i = o.m42 : n.length === 16 ? i = parseFloat(n[13]) : i = parseFloat(n[5])), i || 0;
}
function pi(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function l0(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function nt(...t) {
  const e = Object(t[0]), r = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < t.length; n += 1) {
    const i = t[n];
    if (i != null && !l0(i)) {
      const o = Object.keys(Object(i)).filter((s) => r.indexOf(s) < 0);
      for (let s = 0, a = o.length; s < a; s += 1) {
        const u = o[s], c = Object.getOwnPropertyDescriptor(i, u);
        c !== void 0 && c.enumerable && (pi(e[u]) && pi(i[u]) ? i[u].__swiper__ ? e[u] = i[u] : nt(e[u], i[u]) : !pi(e[u]) && pi(i[u]) ? (e[u] = {}, i[u].__swiper__ ? e[u] = i[u] : nt(e[u], i[u])) : e[u] = i[u]);
      }
    }
  }
  return e;
}
function hi(t, e, r) {
  t.style.setProperty(e, r);
}
function bc({
  swiper: t,
  targetPosition: e,
  side: r
}) {
  const n = ut(), i = -t.translate;
  let o = null, s;
  const a = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(t.cssModeFrameID);
  const u = e > i ? "next" : "prev", c = (f, v) => u === "next" && f >= v || u === "prev" && f <= v, d = () => {
    s = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = s);
    const f = Math.max(Math.min((s - o) / a, 1), 0), v = 0.5 - Math.cos(f * Math.PI) / 2;
    let g = i + v * (e - i);
    if (c(g, e) && (g = e), t.wrapperEl.scrollTo({
      [r]: g
    }), c(g, e)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [r]: g
        });
      }), n.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = n.requestAnimationFrame(d);
  };
  d();
}
function Yt(t, e = "") {
  return [...t.children].filter((r) => r.matches(e));
}
function u0(t, e = []) {
  const r = document.createElement(t);
  return r.classList.add(...Array.isArray(e) ? e : [e]), r;
}
function c0(t, e) {
  const r = [];
  for (; t.previousElementSibling; ) {
    const n = t.previousElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function d0(t, e) {
  const r = [];
  for (; t.nextElementSibling; ) {
    const n = t.nextElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function lr(t, e) {
  return ut().getComputedStyle(t, null).getPropertyValue(e);
}
function Ka(t) {
  let e = t, r;
  if (e) {
    for (r = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (r += 1);
    return r;
  }
}
function f0(t, e) {
  const r = [];
  let n = t.parentElement;
  for (; n; )
    e ? n.matches(e) && r.push(n) : r.push(n), n = n.parentElement;
  return r;
}
function Xa(t, e, r) {
  const n = ut();
  return r ? t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom")) : t.offsetWidth;
}
let Mo;
function p0() {
  const t = ut(), e = Rr();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function xc() {
  return Mo || (Mo = p0()), Mo;
}
let Ao;
function h0({
  userAgent: t
} = {}) {
  const e = xc(), r = ut(), n = r.navigator.platform, i = t || r.navigator.userAgent, o = {
    ios: !1,
    android: !1
  }, s = r.screen.width, a = r.screen.height, u = i.match(/(Android);?[\s\/]+([\d.]+)?/);
  let c = i.match(/(iPad).*OS\s([\d_]+)/);
  const d = i.match(/(iPod)(.*OS\s([\d_]+))?/), f = !c && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), v = n === "Win32";
  let g = n === "MacIntel";
  const y = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !c && g && e.touch && y.indexOf(`${s}x${a}`) >= 0 && (c = i.match(/(Version)\/([\d.]+)/), c || (c = [0, 1, "13_0_0"]), g = !1), u && !v && (o.os = "android", o.android = !0), (c || f || d) && (o.os = "ios", o.ios = !0), o;
}
function m0(t = {}) {
  return Ao || (Ao = h0(t)), Ao;
}
let No;
function v0() {
  const t = ut();
  let e = !1;
  function r() {
    const n = t.navigator.userAgent.toLowerCase();
    return n.indexOf("safari") >= 0 && n.indexOf("chrome") < 0 && n.indexOf("android") < 0;
  }
  if (r()) {
    const n = String(t.navigator.userAgent);
    if (n.includes("Version/")) {
      const [i, o] = n.split("Version/")[1].split(" ")[0].split(".").map((s) => Number(s));
      e = i < 16 || i === 16 && o < 2;
    }
  }
  return {
    isSafari: e || r(),
    needPerspectiveFix: e,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
  };
}
function g0() {
  return No || (No = v0()), No;
}
function y0({
  swiper: t,
  on: e,
  emit: r
}) {
  const n = ut();
  let i = null, o = null;
  const s = () => {
    !t || t.destroyed || !t.initialized || (r("beforeResize"), r("resize"));
  }, a = () => {
    !t || t.destroyed || !t.initialized || (i = new ResizeObserver((d) => {
      o = n.requestAnimationFrame(() => {
        const {
          width: f,
          height: v
        } = t;
        let g = f, y = v;
        d.forEach(({
          contentBoxSize: E,
          contentRect: S,
          target: _
        }) => {
          _ && _ !== t.el || (g = S ? S.width : (E[0] || E).inlineSize, y = S ? S.height : (E[0] || E).blockSize);
        }), (g !== f || y !== v) && s();
      });
    }), i.observe(t.el));
  }, u = () => {
    o && n.cancelAnimationFrame(o), i && i.unobserve && t.el && (i.unobserve(t.el), i = null);
  }, c = () => {
    !t || t.destroyed || !t.initialized || r("orientationchange");
  };
  e("init", () => {
    if (t.params.resizeObserver && typeof n.ResizeObserver < "u") {
      a();
      return;
    }
    n.addEventListener("resize", s), n.addEventListener("orientationchange", c);
  }), e("destroy", () => {
    u(), n.removeEventListener("resize", s), n.removeEventListener("orientationchange", c);
  });
}
function w0({
  swiper: t,
  extendParams: e,
  on: r,
  emit: n
}) {
  const i = [], o = ut(), s = (c, d = {}) => {
    const f = o.MutationObserver || o.WebkitMutationObserver, v = new f((g) => {
      if (t.__preventObserver__)
        return;
      if (g.length === 1) {
        n("observerUpdate", g[0]);
        return;
      }
      const y = function() {
        n("observerUpdate", g[0]);
      };
      o.requestAnimationFrame ? o.requestAnimationFrame(y) : o.setTimeout(y, 0);
    });
    v.observe(c, {
      attributes: typeof d.attributes > "u" ? !0 : d.attributes,
      childList: typeof d.childList > "u" ? !0 : d.childList,
      characterData: typeof d.characterData > "u" ? !0 : d.characterData
    }), i.push(v);
  }, a = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const c = f0(t.el);
        for (let d = 0; d < c.length; d += 1)
          s(c[d]);
      }
      s(t.el, {
        childList: t.params.observeSlideChildren
      }), s(t.wrapperEl, {
        attributes: !1
      });
    }
  }, u = () => {
    i.forEach((c) => {
      c.disconnect();
    }), i.splice(0, i.length);
  };
  e({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", a), r("destroy", u);
}
const b0 = {
  on(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    const i = r ? "unshift" : "push";
    return t.split(" ").forEach((o) => {
      n.eventsListeners[o] || (n.eventsListeners[o] = []), n.eventsListeners[o][i](e);
    }), n;
  },
  once(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    function i(...o) {
      n.off(t, i), i.__emitterProxy && delete i.__emitterProxy, e.apply(n, o);
    }
    return i.__emitterProxy = e, n.on(t, i, r);
  },
  onAny(t, e) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function")
      return r;
    const n = e ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(t) < 0 && r.eventsAnyListeners[n](t), r;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners)
      return e;
    const r = e.eventsAnyListeners.indexOf(t);
    return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
  },
  off(t, e) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || t.split(" ").forEach((n) => {
      typeof e > "u" ? r.eventsListeners[n] = [] : r.eventsListeners[n] && r.eventsListeners[n].forEach((i, o) => {
        (i === e || i.__emitterProxy && i.__emitterProxy === e) && r.eventsListeners[n].splice(o, 1);
      });
    }), r;
  },
  emit(...t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners)
      return e;
    let r, n, i;
    return typeof t[0] == "string" || Array.isArray(t[0]) ? (r = t[0], n = t.slice(1, t.length), i = e) : (r = t[0].events, n = t[0].data, i = t[0].context || e), n.unshift(i), (Array.isArray(r) ? r : r.split(" ")).forEach((s) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((a) => {
        a.apply(i, [s, ...n]);
      }), e.eventsListeners && e.eventsListeners[s] && e.eventsListeners[s].forEach((a) => {
        a.apply(i, n);
      });
    }), e;
  }
};
function x0() {
  const t = this;
  let e, r;
  const n = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = n.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? r = t.params.height : r = n.clientHeight, !(e === 0 && t.isHorizontal() || r === 0 && t.isVertical()) && (e = e - parseInt(lr(n, "padding-left") || 0, 10) - parseInt(lr(n, "padding-right") || 0, 10), r = r - parseInt(lr(n, "padding-top") || 0, 10) - parseInt(lr(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(r) && (r = 0), Object.assign(t, {
    width: e,
    height: r,
    size: t.isHorizontal() ? e : r
  }));
}
function _0() {
  const t = this;
  function e(k) {
    return t.isHorizontal() ? k : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[k];
  }
  function r(k, V) {
    return parseFloat(k.getPropertyValue(e(V)) || 0);
  }
  const n = t.params, {
    wrapperEl: i,
    slidesEl: o,
    size: s,
    rtlTranslate: a,
    wrongRTL: u
  } = t, c = t.virtual && n.virtual.enabled, d = c ? t.virtual.slides.length : t.slides.length, f = Yt(o, `.${t.params.slideClass}, swiper-slide`), v = c ? t.virtual.slides.length : f.length;
  let g = [];
  const y = [], E = [];
  let S = n.slidesOffsetBefore;
  typeof S == "function" && (S = n.slidesOffsetBefore.call(t));
  let _ = n.slidesOffsetAfter;
  typeof _ == "function" && (_ = n.slidesOffsetAfter.call(t));
  const O = t.snapGrid.length, T = t.slidesGrid.length;
  let P = n.spaceBetween, x = -S, M = 0, H = 0;
  if (typeof s > "u")
    return;
  typeof P == "string" && P.indexOf("%") >= 0 ? P = parseFloat(P.replace("%", "")) / 100 * s : typeof P == "string" && (P = parseFloat(P)), t.virtualSize = -P, f.forEach((k) => {
    a ? k.style.marginLeft = "" : k.style.marginRight = "", k.style.marginBottom = "", k.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (hi(i, "--swiper-centered-offset-before", ""), hi(i, "--swiper-centered-offset-after", ""));
  const R = n.grid && n.grid.rows > 1 && t.grid;
  R && t.grid.initSlides(v);
  let q;
  const K = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((k) => typeof n.breakpoints[k].slidesPerView < "u").length > 0;
  for (let k = 0; k < v; k += 1) {
    q = 0;
    let V;
    if (f[k] && (V = f[k]), R && t.grid.updateSlide(k, V, v, e), !(f[k] && lr(V, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        K && (f[k].style[e("width")] = "");
        const Q = getComputedStyle(V), re = V.style.transform, ve = V.style.webkitTransform;
        if (re && (V.style.transform = "none"), ve && (V.style.webkitTransform = "none"), n.roundLengths)
          q = t.isHorizontal() ? Xa(V, "width", !0) : Xa(V, "height", !0);
        else {
          const Y = r(Q, "width"), le = r(Q, "padding-left"), j = r(Q, "padding-right"), N = r(Q, "margin-left"), w = r(Q, "margin-right"), $ = Q.getPropertyValue("box-sizing");
          if ($ && $ === "border-box")
            q = Y + N + w;
          else {
            const {
              clientWidth: F,
              offsetWidth: z
            } = V;
            q = Y + le + j + N + w + (z - F);
          }
        }
        re && (V.style.transform = re), ve && (V.style.webkitTransform = ve), n.roundLengths && (q = Math.floor(q));
      } else
        q = (s - (n.slidesPerView - 1) * P) / n.slidesPerView, n.roundLengths && (q = Math.floor(q)), f[k] && (f[k].style[e("width")] = `${q}px`);
      f[k] && (f[k].swiperSlideSize = q), E.push(q), n.centeredSlides ? (x = x + q / 2 + M / 2 + P, M === 0 && k !== 0 && (x = x - s / 2 - P), k === 0 && (x = x - s / 2 - P), Math.abs(x) < 1 / 1e3 && (x = 0), n.roundLengths && (x = Math.floor(x)), H % n.slidesPerGroup === 0 && g.push(x), y.push(x)) : (n.roundLengths && (x = Math.floor(x)), (H - Math.min(t.params.slidesPerGroupSkip, H)) % t.params.slidesPerGroup === 0 && g.push(x), y.push(x), x = x + q + P), t.virtualSize += q + P, M = q, H += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, s) + _, a && u && (n.effect === "slide" || n.effect === "coverflow") && (i.style.width = `${t.virtualSize + P}px`), n.setWrapperSize && (i.style[e("width")] = `${t.virtualSize + P}px`), R && t.grid.updateWrapperSize(q, g, e), !n.centeredSlides) {
    const k = [];
    for (let V = 0; V < g.length; V += 1) {
      let Q = g[V];
      n.roundLengths && (Q = Math.floor(Q)), g[V] <= t.virtualSize - s && k.push(Q);
    }
    g = k, Math.floor(t.virtualSize - s) - Math.floor(g[g.length - 1]) > 1 && g.push(t.virtualSize - s);
  }
  if (c && n.loop) {
    const k = E[0] + P;
    if (n.slidesPerGroup > 1) {
      const V = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / n.slidesPerGroup), Q = k * n.slidesPerGroup;
      for (let re = 0; re < V; re += 1)
        g.push(g[g.length - 1] + Q);
    }
    for (let V = 0; V < t.virtual.slidesBefore + t.virtual.slidesAfter; V += 1)
      n.slidesPerGroup === 1 && g.push(g[g.length - 1] + k), y.push(y[y.length - 1] + k), t.virtualSize += k;
  }
  if (g.length === 0 && (g = [0]), P !== 0) {
    const k = t.isHorizontal() && a ? "marginLeft" : e("marginRight");
    f.filter((V, Q) => !n.cssMode || n.loop ? !0 : Q !== f.length - 1).forEach((V) => {
      V.style[k] = `${P}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let k = 0;
    E.forEach((Q) => {
      k += Q + (P || 0);
    }), k -= P;
    const V = k - s;
    g = g.map((Q) => Q < 0 ? -S : Q > V ? V + _ : Q);
  }
  if (n.centerInsufficientSlides) {
    let k = 0;
    if (E.forEach((V) => {
      k += V + (P || 0);
    }), k -= P, k < s) {
      const V = (s - k) / 2;
      g.forEach((Q, re) => {
        g[re] = Q - V;
      }), y.forEach((Q, re) => {
        y[re] = Q + V;
      });
    }
  }
  if (Object.assign(t, {
    slides: f,
    snapGrid: g,
    slidesGrid: y,
    slidesSizesGrid: E
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    hi(i, "--swiper-centered-offset-before", `${-g[0]}px`), hi(i, "--swiper-centered-offset-after", `${t.size / 2 - E[E.length - 1] / 2}px`);
    const k = -t.snapGrid[0], V = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((Q) => Q + k), t.slidesGrid = t.slidesGrid.map((Q) => Q + V);
  }
  if (v !== d && t.emit("slidesLengthChange"), g.length !== O && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), y.length !== T && t.emit("slidesGridLengthChange"), n.watchSlidesProgress && t.updateSlidesOffset(), !c && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const k = `${n.containerModifierClass}backface-hidden`, V = t.el.classList.contains(k);
    v <= n.maxBackfaceHiddenSlides ? V || t.el.classList.add(k) : V && t.el.classList.remove(k);
  }
}
function S0(t) {
  const e = this, r = [], n = e.virtual && e.params.virtual.enabled;
  let i = 0, o;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const s = (a) => n ? e.slides[e.getSlideIndexByData(a)] : e.slides[a];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((a) => {
        r.push(a);
      });
    else
      for (o = 0; o < Math.ceil(e.params.slidesPerView); o += 1) {
        const a = e.activeIndex + o;
        if (a > e.slides.length && !n)
          break;
        r.push(s(a));
      }
  else
    r.push(s(e.activeIndex));
  for (o = 0; o < r.length; o += 1)
    if (typeof r[o] < "u") {
      const a = r[o].offsetHeight;
      i = a > i ? a : i;
    }
  (i || i === 0) && (e.wrapperEl.style.height = `${i}px`);
}
function E0() {
  const t = this, e = t.slides, r = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let n = 0; n < e.length; n += 1)
    e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - r - t.cssOverflowAdjustment();
}
function T0(t = this && this.translate || 0) {
  const e = this, r = e.params, {
    slides: n,
    rtlTranslate: i,
    snapGrid: o
  } = e;
  if (n.length === 0)
    return;
  typeof n[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let s = -t;
  i && (s = t), n.forEach((u) => {
    u.classList.remove(r.slideVisibleClass);
  }), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let a = r.spaceBetween;
  typeof a == "string" && a.indexOf("%") >= 0 ? a = parseFloat(a.replace("%", "")) / 100 * e.size : typeof a == "string" && (a = parseFloat(a));
  for (let u = 0; u < n.length; u += 1) {
    const c = n[u];
    let d = c.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (d -= n[0].swiperSlideOffset);
    const f = (s + (r.centeredSlides ? e.minTranslate() : 0) - d) / (c.swiperSlideSize + a), v = (s - o[0] + (r.centeredSlides ? e.minTranslate() : 0) - d) / (c.swiperSlideSize + a), g = -(s - d), y = g + e.slidesSizesGrid[u];
    (g >= 0 && g < e.size - 1 || y > 1 && y <= e.size || g <= 0 && y >= e.size) && (e.visibleSlides.push(c), e.visibleSlidesIndexes.push(u), n[u].classList.add(r.slideVisibleClass)), c.progress = i ? -f : f, c.originalProgress = i ? -v : v;
  }
}
function C0(t) {
  const e = this;
  if (typeof t > "u") {
    const d = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * d || 0;
  }
  const r = e.params, n = e.maxTranslate() - e.minTranslate();
  let {
    progress: i,
    isBeginning: o,
    isEnd: s,
    progressLoop: a
  } = e;
  const u = o, c = s;
  if (n === 0)
    i = 0, o = !0, s = !0;
  else {
    i = (t - e.minTranslate()) / n;
    const d = Math.abs(t - e.minTranslate()) < 1, f = Math.abs(t - e.maxTranslate()) < 1;
    o = d || i <= 0, s = f || i >= 1, d && (i = 0), f && (i = 1);
  }
  if (r.loop) {
    const d = e.getSlideIndexByData(0), f = e.getSlideIndexByData(e.slides.length - 1), v = e.slidesGrid[d], g = e.slidesGrid[f], y = e.slidesGrid[e.slidesGrid.length - 1], E = Math.abs(t);
    E >= v ? a = (E - v) / y : a = (E + y - g) / y, a > 1 && (a -= 1);
  }
  Object.assign(e, {
    progress: i,
    progressLoop: a,
    isBeginning: o,
    isEnd: s
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && e.updateSlidesProgress(t), o && !u && e.emit("reachBeginning toEdge"), s && !c && e.emit("reachEnd toEdge"), (u && !o || c && !s) && e.emit("fromEdge"), e.emit("progress", i);
}
function O0() {
  const t = this, {
    slides: e,
    params: r,
    slidesEl: n,
    activeIndex: i
  } = t, o = t.virtual && r.virtual.enabled, s = (u) => Yt(n, `.${r.slideClass}${u}, swiper-slide${u}`)[0];
  e.forEach((u) => {
    u.classList.remove(r.slideActiveClass, r.slideNextClass, r.slidePrevClass);
  });
  let a;
  if (o)
    if (r.loop) {
      let u = i - t.virtual.slidesBefore;
      u < 0 && (u = t.virtual.slides.length + u), u >= t.virtual.slides.length && (u -= t.virtual.slides.length), a = s(`[data-swiper-slide-index="${u}"]`);
    } else
      a = s(`[data-swiper-slide-index="${i}"]`);
  else
    a = e[i];
  if (a) {
    a.classList.add(r.slideActiveClass);
    let u = d0(a, `.${r.slideClass}, swiper-slide`)[0];
    r.loop && !u && (u = e[0]), u && u.classList.add(r.slideNextClass);
    let c = c0(a, `.${r.slideClass}, swiper-slide`)[0];
    r.loop && !c === 0 && (c = e[e.length - 1]), c && c.classList.add(r.slidePrevClass);
  }
  t.emitSlidesClasses();
}
const vi = (t, e) => {
  if (!t || t.destroyed || !t.params)
    return;
  const r = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, n = e.closest(r());
  if (n) {
    const i = n.querySelector(`.${t.params.lazyPreloaderClass}`);
    i && i.remove();
  }
}, Za = (t, e) => {
  if (!t.slides[e])
    return;
  const r = t.slides[e].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, rs = (t) => {
  if (!t || t.destroyed || !t.params)
    return;
  let e = t.params.lazyPreloadPrevNext;
  const r = t.slides.length;
  if (!r || !e || e < 0)
    return;
  e = Math.min(e, r);
  const n = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), i = t.activeIndex, o = i + n - 1;
  if (t.params.rewind)
    for (let s = i - e; s <= o + e; s += 1) {
      const a = (s % r + r) % r;
      a !== i && a > o && Za(t, a);
    }
  else
    for (let s = Math.max(o - e, 0); s <= Math.min(o + e, r - 1); s += 1)
      s !== i && s > o && Za(t, s);
};
function P0(t) {
  const {
    slidesGrid: e,
    params: r
  } = t, n = t.rtlTranslate ? t.translate : -t.translate;
  let i;
  for (let o = 0; o < e.length; o += 1)
    typeof e[o + 1] < "u" ? n >= e[o] && n < e[o + 1] - (e[o + 1] - e[o]) / 2 ? i = o : n >= e[o] && n < e[o + 1] && (i = o + 1) : n >= e[o] && (i = o);
  return r.normalizeSlideIndex && (i < 0 || typeof i > "u") && (i = 0), i;
}
function M0(t) {
  const e = this, r = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: n,
    params: i,
    activeIndex: o,
    realIndex: s,
    snapIndex: a
  } = e;
  let u = t, c;
  const d = (v) => {
    let g = v - e.virtual.slidesBefore;
    return g < 0 && (g = e.virtual.slides.length + g), g >= e.virtual.slides.length && (g -= e.virtual.slides.length), g;
  };
  if (typeof u > "u" && (u = P0(e)), n.indexOf(r) >= 0)
    c = n.indexOf(r);
  else {
    const v = Math.min(i.slidesPerGroupSkip, u);
    c = v + Math.floor((u - v) / i.slidesPerGroup);
  }
  if (c >= n.length && (c = n.length - 1), u === o) {
    c !== a && (e.snapIndex = c, e.emit("snapIndexChange")), e.params.loop && e.virtual && e.params.virtual.enabled && (e.realIndex = d(u));
    return;
  }
  let f;
  e.virtual && i.virtual.enabled && i.loop ? f = d(u) : e.slides[u] ? f = parseInt(e.slides[u].getAttribute("data-swiper-slide-index") || u, 10) : f = u, Object.assign(e, {
    previousSnapIndex: a,
    snapIndex: c,
    previousRealIndex: s,
    realIndex: f,
    previousIndex: o,
    activeIndex: u
  }), e.initialized && rs(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), s !== f && e.emit("realIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && e.emit("slideChange");
}
function A0(t) {
  const e = this, r = e.params, n = t.closest(`.${r.slideClass}, swiper-slide`);
  let i = !1, o;
  if (n) {
    for (let s = 0; s < e.slides.length; s += 1)
      if (e.slides[s] === n) {
        i = !0, o = s;
        break;
      }
  }
  if (n && i)
    e.clickedSlide = n, e.virtual && e.params.virtual.enabled ? e.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : e.clickedIndex = o;
  else {
    e.clickedSlide = void 0, e.clickedIndex = void 0;
    return;
  }
  r.slideToClickedSlide && e.clickedIndex !== void 0 && e.clickedIndex !== e.activeIndex && e.slideToClickedSlide();
}
const N0 = {
  updateSize: x0,
  updateSlides: _0,
  updateAutoHeight: S0,
  updateSlidesOffset: E0,
  updateSlidesProgress: T0,
  updateProgress: C0,
  updateSlidesClasses: O0,
  updateActiveIndex: M0,
  updateClickedSlide: A0
};
function R0(t = this.isHorizontal() ? "x" : "y") {
  const e = this, {
    params: r,
    rtlTranslate: n,
    translate: i,
    wrapperEl: o
  } = e;
  if (r.virtualTranslate)
    return n ? -i : i;
  if (r.cssMode)
    return i;
  let s = a0(o, t);
  return s += e.cssOverflowAdjustment(), n && (s = -s), s || 0;
}
function L0(t, e) {
  const r = this, {
    rtlTranslate: n,
    params: i,
    wrapperEl: o,
    progress: s
  } = r;
  let a = 0, u = 0;
  const c = 0;
  r.isHorizontal() ? a = n ? -t : t : u = t, i.roundLengths && (a = Math.floor(a), u = Math.floor(u)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? a : u, i.cssMode ? o[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -a : -u : i.virtualTranslate || (r.isHorizontal() ? a -= r.cssOverflowAdjustment() : u -= r.cssOverflowAdjustment(), o.style.transform = `translate3d(${a}px, ${u}px, ${c}px)`);
  let d;
  const f = r.maxTranslate() - r.minTranslate();
  f === 0 ? d = 0 : d = (t - r.minTranslate()) / f, d !== s && r.updateProgress(t), r.emit("setTranslate", r.translate, e);
}
function $0() {
  return -this.snapGrid[0];
}
function I0() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function k0(t = 0, e = this.params.speed, r = !0, n = !0, i) {
  const o = this, {
    params: s,
    wrapperEl: a
  } = o;
  if (o.animating && s.preventInteractionOnTransition)
    return !1;
  const u = o.minTranslate(), c = o.maxTranslate();
  let d;
  if (n && t > u ? d = u : n && t < c ? d = c : d = t, o.updateProgress(d), s.cssMode) {
    const f = o.isHorizontal();
    if (e === 0)
      a[f ? "scrollLeft" : "scrollTop"] = -d;
    else {
      if (!o.support.smoothScroll)
        return bc({
          swiper: o,
          targetPosition: -d,
          side: f ? "left" : "top"
        }), !0;
      a.scrollTo({
        [f ? "left" : "top"]: -d,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (o.setTransition(0), o.setTranslate(d), r && (o.emit("beforeTransitionStart", e, i), o.emit("transitionEnd"))) : (o.setTransition(e), o.setTranslate(d), r && (o.emit("beforeTransitionStart", e, i), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(v) {
    !o || o.destroyed || v.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, r && o.emit("transitionEnd"));
  }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), !0;
}
const j0 = {
  getTranslate: R0,
  setTranslate: L0,
  minTranslate: $0,
  maxTranslate: I0,
  translateTo: k0
};
function D0(t, e) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${t}ms`), r.emit("setTransition", t, e);
}
function _c({
  swiper: t,
  runCallbacks: e,
  direction: r,
  step: n
}) {
  const {
    activeIndex: i,
    previousIndex: o
  } = t;
  let s = r;
  if (s || (i > o ? s = "next" : i < o ? s = "prev" : s = "reset"), t.emit(`transition${n}`), e && i !== o) {
    if (s === "reset") {
      t.emit(`slideResetTransition${n}`);
      return;
    }
    t.emit(`slideChangeTransition${n}`), s === "next" ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`);
  }
}
function F0(t = !0, e) {
  const r = this, {
    params: n
  } = r;
  n.cssMode || (n.autoHeight && r.updateAutoHeight(), _c({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function z0(t = !0, e) {
  const r = this, {
    params: n
  } = r;
  r.animating = !1, !n.cssMode && (r.setTransition(0), _c({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
const V0 = {
  setTransition: D0,
  transitionStart: F0,
  transitionEnd: z0
};
function H0(t = 0, e = this.params.speed, r = !0, n, i) {
  typeof t == "string" && (t = parseInt(t, 10));
  const o = this;
  let s = t;
  s < 0 && (s = 0);
  const {
    params: a,
    snapGrid: u,
    slidesGrid: c,
    previousIndex: d,
    activeIndex: f,
    rtlTranslate: v,
    wrapperEl: g,
    enabled: y
  } = o;
  if (o.animating && a.preventInteractionOnTransition || !y && !n && !i)
    return !1;
  const E = Math.min(o.params.slidesPerGroupSkip, s);
  let S = E + Math.floor((s - E) / o.params.slidesPerGroup);
  S >= u.length && (S = u.length - 1);
  const _ = -u[S];
  if (a.normalizeSlideIndex)
    for (let T = 0; T < c.length; T += 1) {
      const P = -Math.floor(_ * 100), x = Math.floor(c[T] * 100), M = Math.floor(c[T + 1] * 100);
      typeof c[T + 1] < "u" ? P >= x && P < M - (M - x) / 2 ? s = T : P >= x && P < M && (s = T + 1) : P >= x && (s = T);
    }
  if (o.initialized && s !== f && (!o.allowSlideNext && _ < o.translate && _ < o.minTranslate() || !o.allowSlidePrev && _ > o.translate && _ > o.maxTranslate() && (f || 0) !== s))
    return !1;
  s !== (d || 0) && r && o.emit("beforeSlideChangeStart"), o.updateProgress(_);
  let O;
  if (s > f ? O = "next" : s < f ? O = "prev" : O = "reset", v && -_ === o.translate || !v && _ === o.translate)
    return o.updateActiveIndex(s), a.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), a.effect !== "slide" && o.setTranslate(_), O !== "reset" && (o.transitionStart(r, O), o.transitionEnd(r, O)), !1;
  if (a.cssMode) {
    const T = o.isHorizontal(), P = v ? _ : -_;
    if (e === 0) {
      const x = o.virtual && o.params.virtual.enabled;
      x && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), x && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        g[T ? "scrollLeft" : "scrollTop"] = P;
      })) : g[T ? "scrollLeft" : "scrollTop"] = P, x && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = !1;
      });
    } else {
      if (!o.support.smoothScroll)
        return bc({
          swiper: o,
          targetPosition: P,
          side: T ? "left" : "top"
        }), !0;
      g.scrollTo({
        [T ? "left" : "top"]: P,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return o.setTransition(e), o.setTranslate(_), o.updateActiveIndex(s), o.updateSlidesClasses(), o.emit("beforeTransitionStart", e, n), o.transitionStart(r, O), e === 0 ? o.transitionEnd(r, O) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(P) {
    !o || o.destroyed || P.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(r, O));
  }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), !0;
}
function B0(t = 0, e = this.params.speed, r = !0, n) {
  typeof t == "string" && (t = parseInt(t, 10));
  const i = this;
  let o = t;
  return i.params.loop && (i.virtual && i.params.virtual.enabled ? o = o + i.virtual.slidesBefore : o = i.getSlideIndexByData(o)), i.slideTo(o, e, r, n);
}
function W0(t = this.params.speed, e = !0, r) {
  const n = this, {
    enabled: i,
    params: o,
    animating: s
  } = n;
  if (!i)
    return n;
  let a = o.slidesPerGroup;
  o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (a = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const u = n.activeIndex < o.slidesPerGroupSkip ? 1 : a, c = n.virtual && o.virtual.enabled;
  if (o.loop) {
    if (s && !c && o.loopPreventsSliding)
      return !1;
    n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  return o.rewind && n.isEnd ? n.slideTo(0, t, e, r) : n.slideTo(n.activeIndex + u, t, e, r);
}
function G0(t = this.params.speed, e = !0, r) {
  const n = this, {
    params: i,
    snapGrid: o,
    slidesGrid: s,
    rtlTranslate: a,
    enabled: u,
    animating: c
  } = n;
  if (!u)
    return n;
  const d = n.virtual && i.virtual.enabled;
  if (i.loop) {
    if (c && !d && i.loopPreventsSliding)
      return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const f = a ? n.translate : -n.translate;
  function v(_) {
    return _ < 0 ? -Math.floor(Math.abs(_)) : Math.floor(_);
  }
  const g = v(f), y = o.map((_) => v(_));
  let E = o[y.indexOf(g) - 1];
  if (typeof E > "u" && i.cssMode) {
    let _;
    o.forEach((O, T) => {
      g >= O && (_ = T);
    }), typeof _ < "u" && (E = o[_ > 0 ? _ - 1 : _]);
  }
  let S = 0;
  if (typeof E < "u" && (S = s.indexOf(E), S < 0 && (S = n.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (S = S - n.slidesPerViewDynamic("previous", !0) + 1, S = Math.max(S, 0))), i.rewind && n.isBeginning) {
    const _ = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(_, t, e, r);
  }
  return n.slideTo(S, t, e, r);
}
function U0(t = this.params.speed, e = !0, r) {
  const n = this;
  return n.slideTo(n.activeIndex, t, e, r);
}
function q0(t = this.params.speed, e = !0, r, n = 0.5) {
  const i = this;
  let o = i.activeIndex;
  const s = Math.min(i.params.slidesPerGroupSkip, o), a = s + Math.floor((o - s) / i.params.slidesPerGroup), u = i.rtlTranslate ? i.translate : -i.translate;
  if (u >= i.snapGrid[a]) {
    const c = i.snapGrid[a], d = i.snapGrid[a + 1];
    u - c > (d - c) * n && (o += i.params.slidesPerGroup);
  } else {
    const c = i.snapGrid[a - 1], d = i.snapGrid[a];
    u - c <= (d - c) * n && (o -= i.params.slidesPerGroup);
  }
  return o = Math.max(o, 0), o = Math.min(o, i.slidesGrid.length - 1), i.slideTo(o, t, e, r);
}
function Y0() {
  const t = this, {
    params: e,
    slidesEl: r
  } = t, n = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let i = t.clickedIndex, o;
  const s = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (t.animating)
      return;
    o = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? i < t.loopedSlides - n / 2 || i > t.slides.length - t.loopedSlides + n / 2 ? (t.loopFix(), i = t.getSlideIndex(Yt(r, `${s}[data-swiper-slide-index="${o}"]`)[0]), ts(() => {
      t.slideTo(i);
    })) : t.slideTo(i) : i > t.slides.length - n ? (t.loopFix(), i = t.getSlideIndex(Yt(r, `${s}[data-swiper-slide-index="${o}"]`)[0]), ts(() => {
      t.slideTo(i);
    })) : t.slideTo(i);
  } else
    t.slideTo(i);
}
const Q0 = {
  slideTo: H0,
  slideToLoop: B0,
  slideNext: W0,
  slidePrev: G0,
  slideReset: U0,
  slideToClosest: q0,
  slideToClickedSlide: Y0
};
function J0(t) {
  const e = this, {
    params: r,
    slidesEl: n
  } = e;
  if (!r.loop || e.virtual && e.params.virtual.enabled)
    return;
  Yt(n, `.${r.slideClass}, swiper-slide`).forEach((o, s) => {
    o.setAttribute("data-swiper-slide-index", s);
  }), e.loopFix({
    slideRealIndex: t,
    direction: r.centeredSlides ? void 0 : "next"
  });
}
function K0({
  slideRealIndex: t,
  slideTo: e = !0,
  direction: r,
  setTranslate: n,
  activeSlideIndex: i,
  byController: o,
  byMousewheel: s
} = {}) {
  const a = this;
  if (!a.params.loop)
    return;
  a.emit("beforeLoopFix");
  const {
    slides: u,
    allowSlidePrev: c,
    allowSlideNext: d,
    slidesEl: f,
    params: v
  } = a;
  if (a.allowSlidePrev = !0, a.allowSlideNext = !0, a.virtual && v.virtual.enabled) {
    e && (!v.centeredSlides && a.snapIndex === 0 ? a.slideTo(a.virtual.slides.length, 0, !1, !0) : v.centeredSlides && a.snapIndex < v.slidesPerView ? a.slideTo(a.virtual.slides.length + a.snapIndex, 0, !1, !0) : a.snapIndex === a.snapGrid.length - 1 && a.slideTo(a.virtual.slidesBefore, 0, !1, !0)), a.allowSlidePrev = c, a.allowSlideNext = d, a.emit("loopFix");
    return;
  }
  const g = v.slidesPerView === "auto" ? a.slidesPerViewDynamic() : Math.ceil(parseFloat(v.slidesPerView, 10));
  let y = v.loopedSlides || g;
  y % v.slidesPerGroup !== 0 && (y += v.slidesPerGroup - y % v.slidesPerGroup), a.loopedSlides = y;
  const E = [], S = [];
  let _ = a.activeIndex;
  typeof i > "u" ? i = a.getSlideIndex(a.slides.filter((M) => M.classList.contains(v.slideActiveClass))[0]) : _ = i;
  const O = r === "next" || !r, T = r === "prev" || !r;
  let P = 0, x = 0;
  if (i < y) {
    P = Math.max(y - i, v.slidesPerGroup);
    for (let M = 0; M < y - i; M += 1) {
      const H = M - Math.floor(M / u.length) * u.length;
      E.push(u.length - H - 1);
    }
  } else if (i > a.slides.length - y * 2) {
    x = Math.max(i - (a.slides.length - y * 2), v.slidesPerGroup);
    for (let M = 0; M < x; M += 1) {
      const H = M - Math.floor(M / u.length) * u.length;
      S.push(H);
    }
  }
  if (T && E.forEach((M) => {
    a.slides[M].swiperLoopMoveDOM = !0, f.prepend(a.slides[M]), a.slides[M].swiperLoopMoveDOM = !1;
  }), O && S.forEach((M) => {
    a.slides[M].swiperLoopMoveDOM = !0, f.append(a.slides[M]), a.slides[M].swiperLoopMoveDOM = !1;
  }), a.recalcSlides(), v.slidesPerView === "auto" && a.updateSlides(), v.watchSlidesProgress && a.updateSlidesOffset(), e) {
    if (E.length > 0 && T)
      if (typeof t > "u") {
        const M = a.slidesGrid[_], R = a.slidesGrid[_ + P] - M;
        s ? a.setTranslate(a.translate - R) : (a.slideTo(_ + P, 0, !1, !0), n && (a.touches[a.isHorizontal() ? "startX" : "startY"] += R));
      } else
        n && a.slideToLoop(t, 0, !1, !0);
    else if (S.length > 0 && O)
      if (typeof t > "u") {
        const M = a.slidesGrid[_], R = a.slidesGrid[_ - x] - M;
        s ? a.setTranslate(a.translate - R) : (a.slideTo(_ - x, 0, !1, !0), n && (a.touches[a.isHorizontal() ? "startX" : "startY"] += R));
      } else
        a.slideToLoop(t, 0, !1, !0);
  }
  if (a.allowSlidePrev = c, a.allowSlideNext = d, a.controller && a.controller.control && !o) {
    const M = {
      slideRealIndex: t,
      slideTo: !1,
      direction: r,
      setTranslate: n,
      activeSlideIndex: i,
      byController: !0
    };
    Array.isArray(a.controller.control) ? a.controller.control.forEach((H) => {
      !H.destroyed && H.params.loop && H.loopFix(M);
    }) : a.controller.control instanceof a.constructor && a.controller.control.params.loop && a.controller.control.loopFix(M);
  }
  a.emit("loopFix");
}
function X0() {
  const t = this, {
    params: e,
    slidesEl: r
  } = t;
  if (!e.loop || t.virtual && t.params.virtual.enabled)
    return;
  t.recalcSlides();
  const n = [];
  t.slides.forEach((i) => {
    const o = typeof i.swiperSlideIndex > "u" ? i.getAttribute("data-swiper-slide-index") * 1 : i.swiperSlideIndex;
    n[o] = i;
  }), t.slides.forEach((i) => {
    i.removeAttribute("data-swiper-slide-index");
  }), n.forEach((i) => {
    r.append(i);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
const Z0 = {
  loopCreate: J0,
  loopFix: K0,
  loopDestroy: X0
};
function e1(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode)
    return;
  const r = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function t1() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
const r1 = {
  setGrabCursor: e1,
  unsetGrabCursor: t1
};
function n1(t, e = this) {
  function r(n) {
    if (!n || n === Rr() || n === ut())
      return null;
    n.assignedSlot && (n = n.assignedSlot);
    const i = n.closest(t);
    return !i && !n.getRootNode ? null : i || r(n.getRootNode().host);
  }
  return r(e);
}
function i1(t) {
  const e = this, r = Rr(), n = ut(), i = e.touchEventsData;
  i.evCache.push(t);
  const {
    params: o,
    touches: s,
    enabled: a
  } = e;
  if (!a || !o.simulateTouch && t.pointerType === "mouse" || e.animating && o.preventInteractionOnTransition)
    return;
  !e.animating && o.cssMode && o.loop && e.loopFix();
  let u = t;
  u.originalEvent && (u = u.originalEvent);
  let c = u.target;
  if (o.touchEventsTarget === "wrapper" && !e.wrapperEl.contains(c) || "which" in u && u.which === 3 || "button" in u && u.button > 0 || i.isTouched && i.isMoved)
    return;
  const d = !!o.noSwipingClass && o.noSwipingClass !== "", f = t.composedPath ? t.composedPath() : t.path;
  d && u.target && u.target.shadowRoot && f && (c = f[0]);
  const v = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, g = !!(u.target && u.target.shadowRoot);
  if (o.noSwiping && (g ? n1(v, c) : c.closest(v))) {
    e.allowClick = !0;
    return;
  }
  if (o.swipeHandler && !c.closest(o.swipeHandler))
    return;
  s.currentX = u.pageX, s.currentY = u.pageY;
  const y = s.currentX, E = s.currentY, S = o.edgeSwipeDetection || o.iOSEdgeSwipeDetection, _ = o.edgeSwipeThreshold || o.iOSEdgeSwipeThreshold;
  if (S && (y <= _ || y >= n.innerWidth - _))
    if (S === "prevent")
      t.preventDefault();
    else
      return;
  Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), s.startX = y, s.startY = E, i.touchStartTime = Mi(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, o.threshold > 0 && (i.allowThresholdMove = !1);
  let O = !0;
  c.matches(i.focusableElements) && (O = !1, c.nodeName === "SELECT" && (i.isTouched = !1)), r.activeElement && r.activeElement.matches(i.focusableElements) && r.activeElement !== c && r.activeElement.blur();
  const T = O && e.allowTouchMove && o.touchStartPreventDefault;
  (o.touchStartForcePreventDefault || T) && !c.isContentEditable && u.preventDefault(), e.params.freeMode && e.params.freeMode.enabled && e.freeMode && e.animating && !o.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", u);
}
function o1(t) {
  const e = Rr(), r = this, n = r.touchEventsData, {
    params: i,
    touches: o,
    rtlTranslate: s,
    enabled: a
  } = r;
  if (!a || !i.simulateTouch && t.pointerType === "mouse")
    return;
  let u = t;
  if (u.originalEvent && (u = u.originalEvent), !n.isTouched) {
    n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", u);
    return;
  }
  const c = n.evCache.findIndex((M) => M.pointerId === u.pointerId);
  c >= 0 && (n.evCache[c] = u);
  const d = n.evCache.length > 1 ? n.evCache[0] : u, f = d.pageX, v = d.pageY;
  if (u.preventedByNestedSwiper) {
    o.startX = f, o.startY = v;
    return;
  }
  if (!r.allowTouchMove) {
    u.target.matches(n.focusableElements) || (r.allowClick = !1), n.isTouched && (Object.assign(o, {
      startX: f,
      startY: v,
      prevX: r.touches.currentX,
      prevY: r.touches.currentY,
      currentX: f,
      currentY: v
    }), n.touchStartTime = Mi());
    return;
  }
  if (i.touchReleaseOnEdges && !i.loop) {
    if (r.isVertical()) {
      if (v < o.startY && r.translate <= r.maxTranslate() || v > o.startY && r.translate >= r.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else if (f < o.startX && r.translate <= r.maxTranslate() || f > o.startX && r.translate >= r.minTranslate())
      return;
  }
  if (e.activeElement && u.target === e.activeElement && u.target.matches(n.focusableElements)) {
    n.isMoved = !0, r.allowClick = !1;
    return;
  }
  if (n.allowTouchCallbacks && r.emit("touchMove", u), u.targetTouches && u.targetTouches.length > 1)
    return;
  o.currentX = f, o.currentY = v;
  const g = o.currentX - o.startX, y = o.currentY - o.startY;
  if (r.params.threshold && Math.sqrt(g ** 2 + y ** 2) < r.params.threshold)
    return;
  if (typeof n.isScrolling > "u") {
    let M;
    r.isHorizontal() && o.currentY === o.startY || r.isVertical() && o.currentX === o.startX ? n.isScrolling = !1 : g * g + y * y >= 25 && (M = Math.atan2(Math.abs(y), Math.abs(g)) * 180 / Math.PI, n.isScrolling = r.isHorizontal() ? M > i.touchAngle : 90 - M > i.touchAngle);
  }
  if (n.isScrolling && r.emit("touchMoveOpposite", u), typeof n.startMoving > "u" && (o.currentX !== o.startX || o.currentY !== o.startY) && (n.startMoving = !0), n.isScrolling || r.zoom && r.params.zoom && r.params.zoom.enabled && n.evCache.length > 1) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  r.allowClick = !1, !i.cssMode && u.cancelable && u.preventDefault(), i.touchMoveStopPropagation && !i.nested && u.stopPropagation();
  let E = r.isHorizontal() ? g : y, S = r.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
  i.oneWayMovement && (E = Math.abs(E) * (s ? 1 : -1), S = Math.abs(S) * (s ? 1 : -1)), o.diff = E, E *= i.touchRatio, s && (E = -E, S = -S);
  const _ = r.touchesDirection;
  r.swipeDirection = E > 0 ? "prev" : "next", r.touchesDirection = S > 0 ? "prev" : "next";
  const O = r.params.loop && !i.cssMode;
  if (!n.isMoved) {
    if (O && r.loopFix({
      direction: r.swipeDirection
    }), n.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const M = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      r.wrapperEl.dispatchEvent(M);
    }
    n.allowMomentumBounce = !1, i.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", u);
  }
  let T;
  n.isMoved && _ !== r.touchesDirection && O && Math.abs(E) >= 1 && (r.loopFix({
    direction: r.swipeDirection,
    setTranslate: !0
  }), T = !0), r.emit("sliderMove", u), n.isMoved = !0, n.currentTranslate = E + n.startTranslate;
  let P = !0, x = i.resistanceRatio;
  if (i.touchReleaseOnEdges && (x = 0), E > 0 ? (O && !T && n.currentTranslate > (i.centeredSlides ? r.minTranslate() - r.size / 2 : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > r.minTranslate() && (P = !1, i.resistance && (n.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + n.startTranslate + E) ** x))) : E < 0 && (O && !T && n.currentTranslate < (i.centeredSlides ? r.maxTranslate() + r.size / 2 : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (i.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
  }), n.currentTranslate < r.maxTranslate() && (P = !1, i.resistance && (n.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - n.startTranslate - E) ** x))), P && (u.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (n.currentTranslate = n.startTranslate), i.threshold > 0)
    if (Math.abs(E) > i.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, n.currentTranslate = n.startTranslate, o.diff = r.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && r.freeMode || i.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), r.params.freeMode && i.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(n.currentTranslate), r.setTranslate(n.currentTranslate));
}
function s1(t) {
  const e = this, r = e.touchEventsData, n = r.evCache.findIndex((T) => T.pointerId === t.pointerId);
  if (n >= 0 && r.evCache.splice(n, 1), ["pointercancel", "pointerout", "pointerleave"].includes(t.type) && !(t.type === "pointercancel" && (e.browser.isSafari || e.browser.isWebView)))
    return;
  const {
    params: i,
    touches: o,
    rtlTranslate: s,
    slidesGrid: a,
    enabled: u
  } = e;
  if (!u || !i.simulateTouch && t.pointerType === "mouse")
    return;
  let c = t;
  if (c.originalEvent && (c = c.originalEvent), r.allowTouchCallbacks && e.emit("touchEnd", c), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && i.grabCursor && e.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  i.grabCursor && r.isMoved && r.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const d = Mi(), f = d - r.touchStartTime;
  if (e.allowClick) {
    const T = c.path || c.composedPath && c.composedPath();
    e.updateClickedSlide(T && T[0] || c.target), e.emit("tap click", c), f < 300 && d - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", c);
  }
  if (r.lastClickTime = Mi(), ts(() => {
    e.destroyed || (e.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !e.swipeDirection || o.diff === 0 || r.currentTranslate === r.startTranslate) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let v;
  if (i.followFinger ? v = s ? e.translate : -e.translate : v = -r.currentTranslate, i.cssMode)
    return;
  if (e.params.freeMode && i.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: v
    });
    return;
  }
  let g = 0, y = e.slidesSizesGrid[0];
  for (let T = 0; T < a.length; T += T < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
    const P = T < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    typeof a[T + P] < "u" ? v >= a[T] && v < a[T + P] && (g = T, y = a[T + P] - a[T]) : v >= a[T] && (g = T, y = a[a.length - 1] - a[a.length - 2]);
  }
  let E = null, S = null;
  i.rewind && (e.isBeginning ? S = e.params.virtual && e.params.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (E = 0));
  const _ = (v - a[g]) / y, O = g < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
  if (f > i.longSwipesMs) {
    if (!i.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (_ >= i.longSwipesRatio ? e.slideTo(i.rewind && e.isEnd ? E : g + O) : e.slideTo(g)), e.swipeDirection === "prev" && (_ > 1 - i.longSwipesRatio ? e.slideTo(g + O) : S !== null && _ < 0 && Math.abs(_) > i.longSwipesRatio ? e.slideTo(S) : e.slideTo(g));
  } else {
    if (!i.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (c.target === e.navigation.nextEl || c.target === e.navigation.prevEl) ? c.target === e.navigation.nextEl ? e.slideTo(g + O) : e.slideTo(g) : (e.swipeDirection === "next" && e.slideTo(E !== null ? E : g + O), e.swipeDirection === "prev" && e.slideTo(S !== null ? S : g));
  }
}
function el() {
  const t = this, {
    params: e,
    el: r
  } = t;
  if (r && r.offsetWidth === 0)
    return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: i,
    snapGrid: o
  } = t, s = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const a = s && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !a ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !s ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = i, t.allowSlideNext = n, t.params.watchOverflow && o !== t.snapGrid && t.checkOverflow();
}
function a1(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function l1() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: r,
    enabled: n
  } = t;
  if (!n)
    return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let i;
  const o = t.maxTranslate() - t.minTranslate();
  o === 0 ? i = 0 : i = (t.translate - t.minTranslate()) / o, i !== t.progress && t.updateProgress(r ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function u1(t) {
  const e = this;
  vi(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
let tl = !1;
function c1() {
}
const Sc = (t, e) => {
  const r = Rr(), {
    params: n,
    el: i,
    wrapperEl: o,
    device: s
  } = t, a = !!n.nested, u = e === "on" ? "addEventListener" : "removeEventListener", c = e;
  i[u]("pointerdown", t.onTouchStart, {
    passive: !1
  }), r[u]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: a
  }), r[u]("pointerup", t.onTouchEnd, {
    passive: !0
  }), r[u]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), r[u]("pointerout", t.onTouchEnd, {
    passive: !0
  }), r[u]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && i[u]("click", t.onClick, !0), n.cssMode && o[u]("scroll", t.onScroll), n.updateOnWindowResize ? t[c](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", el, !0) : t[c]("observerUpdate", el, !0), i[u]("load", t.onLoad, {
    capture: !0
  });
};
function d1() {
  const t = this, e = Rr(), {
    params: r
  } = t;
  t.onTouchStart = i1.bind(t), t.onTouchMove = o1.bind(t), t.onTouchEnd = s1.bind(t), r.cssMode && (t.onScroll = l1.bind(t)), t.onClick = a1.bind(t), t.onLoad = u1.bind(t), tl || (e.addEventListener("touchstart", c1), tl = !0), Sc(t, "on");
}
function f1() {
  Sc(this, "off");
}
const p1 = {
  attachEvents: d1,
  detachEvents: f1
}, rl = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function h1() {
  const t = this, {
    realIndex: e,
    initialized: r,
    params: n,
    el: i
  } = t, o = n.breakpoints;
  if (!o || o && Object.keys(o).length === 0)
    return;
  const s = t.getBreakpoint(o, t.params.breakpointsBase, t.el);
  if (!s || t.currentBreakpoint === s)
    return;
  const u = (s in o ? o[s] : void 0) || t.originalParams, c = rl(t, n), d = rl(t, u), f = n.enabled;
  c && !d ? (i.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !c && d && (i.classList.add(`${n.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && n.grid.fill === "column") && i.classList.add(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((E) => {
    const S = n[E] && n[E].enabled, _ = u[E] && u[E].enabled;
    S && !_ && t[E].disable(), !S && _ && t[E].enable();
  });
  const v = u.direction && u.direction !== n.direction, g = n.loop && (u.slidesPerView !== n.slidesPerView || v);
  v && r && t.changeDirection(), nt(t.params, u);
  const y = t.params.enabled;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), f && !y ? t.disable() : !f && y && t.enable(), t.currentBreakpoint = s, t.emit("_beforeBreakpoint", u), g && r && (t.loopDestroy(), t.loopCreate(e), t.updateSlides()), t.emit("breakpoint", u);
}
function m1(t, e = "window", r) {
  if (!t || e === "container" && !r)
    return;
  let n = !1;
  const i = ut(), o = e === "window" ? i.innerHeight : r.clientHeight, s = Object.keys(t).map((a) => {
    if (typeof a == "string" && a.indexOf("@") === 0) {
      const u = parseFloat(a.substr(1));
      return {
        value: o * u,
        point: a
      };
    }
    return {
      value: a,
      point: a
    };
  });
  s.sort((a, u) => parseInt(a.value, 10) - parseInt(u.value, 10));
  for (let a = 0; a < s.length; a += 1) {
    const {
      point: u,
      value: c
    } = s[a];
    e === "window" ? i.matchMedia(`(min-width: ${c}px)`).matches && (n = u) : c <= r.clientWidth && (n = u);
  }
  return n || "max";
}
const v1 = {
  setBreakpoint: h1,
  getBreakpoint: m1
};
function g1(t, e) {
  const r = [];
  return t.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((i) => {
      n[i] && r.push(e + i);
    }) : typeof n == "string" && r.push(e + n);
  }), r;
}
function y1() {
  const t = this, {
    classNames: e,
    params: r,
    rtl: n,
    el: i,
    device: o
  } = t, s = g1(["initialized", r.direction, {
    "free-mode": t.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: n
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: o.android
  }, {
    ios: o.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  e.push(...s), i.classList.add(...e), t.emitContainerClasses();
}
function w1() {
  const t = this, {
    el: e,
    classNames: r
  } = t;
  e.classList.remove(...r), t.emitContainerClasses();
}
const b1 = {
  addClasses: y1,
  removeClasses: w1
};
function x1() {
  const t = this, {
    isLocked: e,
    params: r
  } = t, {
    slidesOffsetBefore: n
  } = r;
  if (n) {
    const i = t.slides.length - 1, o = t.slidesGrid[i] + t.slidesSizesGrid[i] + n * 2;
    t.isLocked = t.size > o;
  } else
    t.isLocked = t.snapGrid.length === 1;
  r.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), r.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
const _1 = {
  checkOverflow: x1
}, nl = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopedSlides: null,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function S1(t, e) {
  return function(n = {}) {
    const i = Object.keys(n)[0], o = n[i];
    if (typeof o != "object" || o === null) {
      nt(e, n);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && t[i] === !0 && (t[i] = {
      auto: !0
    }), !(i in t && "enabled" in o)) {
      nt(e, n);
      return;
    }
    t[i] === !0 && (t[i] = {
      enabled: !0
    }), typeof t[i] == "object" && !("enabled" in t[i]) && (t[i].enabled = !0), t[i] || (t[i] = {
      enabled: !1
    }), nt(e, n);
  };
}
const Ro = {
  eventsEmitter: b0,
  update: N0,
  translate: j0,
  transition: V0,
  slide: Q0,
  loop: Z0,
  grabCursor: r1,
  events: p1,
  breakpoints: v1,
  checkOverflow: _1,
  classes: b1
}, Lo = {};
let qn = class Bt {
  constructor(...e) {
    let r, n;
    e.length === 1 && e[0].constructor && Object.prototype.toString.call(e[0]).slice(8, -1) === "Object" ? n = e[0] : [r, n] = e, n || (n = {}), n = nt({}, n), r && !n.el && (n.el = r);
    const i = Rr();
    if (n.el && typeof n.el == "string" && i.querySelectorAll(n.el).length > 1) {
      const u = [];
      return i.querySelectorAll(n.el).forEach((c) => {
        const d = nt({}, n, {
          el: c
        });
        u.push(new Bt(d));
      }), u;
    }
    const o = this;
    o.__swiper__ = !0, o.support = xc(), o.device = m0({
      userAgent: n.userAgent
    }), o.browser = g0(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], n.modules && Array.isArray(n.modules) && o.modules.push(...n.modules);
    const s = {};
    o.modules.forEach((u) => {
      u({
        params: n,
        swiper: o,
        extendParams: S1(n, s),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const a = nt({}, nl, s);
    return o.params = nt({}, a, Lo, n), o.originalParams = nt({}, o.params), o.passedParams = nt({}, n), o.params && o.params.on && Object.keys(o.params.on).forEach((u) => {
      o.on(u, o.params.on[u]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: r,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getSlideIndex(e) {
    const {
      slidesEl: r,
      params: n
    } = this, i = Yt(r, `.${n.slideClass}, swiper-slide`), o = Ka(i[0]);
    return Ka(e) - o;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter((r) => r.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
  }
  recalcSlides() {
    const e = this, {
      slidesEl: r,
      params: n
    } = e;
    e.slides = Yt(r, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, r) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const i = n.minTranslate(), s = (n.maxTranslate() - i) * e + i;
    n.translateTo(s, typeof r > "u" ? 0 : r), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const r = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(e) {
    const r = this;
    return r.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const r = [];
    e.slides.forEach((n) => {
      const i = e.getSlideClasses(n);
      r.push({
        slideEl: n,
        classNames: i
      }), e.emit("_slideClass", n, i);
    }), e.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(e = "current", r = !1) {
    const n = this, {
      params: i,
      slides: o,
      slidesGrid: s,
      slidesSizesGrid: a,
      size: u,
      activeIndex: c
    } = n;
    let d = 1;
    if (i.centeredSlides) {
      let f = o[c].swiperSlideSize, v;
      for (let g = c + 1; g < o.length; g += 1)
        o[g] && !v && (f += o[g].swiperSlideSize, d += 1, f > u && (v = !0));
      for (let g = c - 1; g >= 0; g -= 1)
        o[g] && !v && (f += o[g].swiperSlideSize, d += 1, f > u && (v = !0));
    } else if (e === "current")
      for (let f = c + 1; f < o.length; f += 1)
        (r ? s[f] + a[f] - s[c] < u : s[f] - s[c] < u) && (d += 1);
    else
      for (let f = c - 1; f >= 0; f -= 1)
        s[c] - s[f] < u && (d += 1);
    return d;
  }
  update() {
    const e = this;
    if (!e || e.destroyed)
      return;
    const {
      snapGrid: r,
      params: n
    } = e;
    n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((s) => {
      s.complete && vi(e, s);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function i() {
      const s = e.rtlTranslate ? e.translate * -1 : e.translate, a = Math.min(Math.max(s, e.maxTranslate()), e.minTranslate());
      e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let o;
    if (e.params.freeMode && e.params.freeMode.enabled)
      i(), e.params.autoHeight && e.updateAutoHeight();
    else {
      if ((e.params.slidesPerView === "auto" || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides) {
        const s = e.virtual && e.params.virtual.enabled ? e.virtual.slides : e.slides;
        o = e.slideTo(s.length - 1, 0, !1, !0);
      } else
        o = e.slideTo(e.activeIndex, 0, !1, !0);
      o || i();
    }
    n.watchOverflow && r !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, r = !0) {
    const n = this, i = n.params.direction;
    return e || (e = i === "horizontal" ? "vertical" : "horizontal"), e === i || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${i}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((o) => {
      e === "vertical" ? o.style.width = "" : o.style.height = "";
    }), n.emit("changeDirection"), r && n.update()), n;
  }
  changeLanguageDirection(e) {
    const r = this;
    r.rtl && e === "rtl" || !r.rtl && e === "ltr" || (r.rtl = e === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(e) {
    const r = this;
    if (r.mounted)
      return !0;
    let n = e || r.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = r, n.shadowEl && (r.isElement = !0);
    const i = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let s = (() => n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(i()) : Yt(n, i())[0])();
    return !s && r.params.createElements && (s = u0("div", r.params.wrapperClass), n.append(s), Yt(n, `.${r.params.slideClass}`).forEach((a) => {
      s.append(a);
    })), Object.assign(r, {
      el: n,
      wrapperEl: s,
      slidesEl: r.isElement ? n : s,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || lr(n, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || lr(n, "direction") === "rtl"),
      wrongRTL: lr(s, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const r = this;
    return r.initialized || r.mount(e) === !1 || (r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(), r.attachEvents(), [...r.el.querySelectorAll('[loading="lazy"]')].forEach((i) => {
      i.complete ? vi(r, i) : i.addEventListener("load", (o) => {
        vi(r, o.target);
      });
    }), rs(r), r.initialized = !0, rs(r), r.emit("init"), r.emit("afterInit")), r;
  }
  destroy(e = !0, r = !0) {
    const n = this, {
      params: i,
      el: o,
      wrapperEl: s,
      slides: a
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), i.loop && n.loopDestroy(), r && (n.removeClasses(), o.removeAttribute("style"), s.removeAttribute("style"), a && a.length && a.forEach((u) => {
      u.classList.remove(i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass), u.removeAttribute("style"), u.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((u) => {
      n.off(u);
    }), e !== !1 && (n.el.swiper = null, o0(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    nt(Lo, e);
  }
  static get extendedDefaults() {
    return Lo;
  }
  static get defaults() {
    return nl;
  }
  static installModule(e) {
    Bt.prototype.__modules__ || (Bt.prototype.__modules__ = []);
    const r = Bt.prototype.__modules__;
    typeof e == "function" && r.indexOf(e) < 0 && r.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((r) => Bt.installModule(r)), Bt) : (Bt.installModule(e), Bt);
  }
};
Object.keys(Ro).forEach((t) => {
  Object.keys(Ro[t]).forEach((e) => {
    qn.prototype[e] = Ro[t][e];
  });
});
qn.use([y0, w0]);
function Pr(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function ur(t, e) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => r.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : Pr(e[n]) && Pr(t[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? t[n] = e[n] : ur(t[n], e[n]) : t[n] = e[n];
  });
}
function Ec(t = {}) {
  return t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function Tc(t = {}) {
  return t.pagination && typeof t.pagination.el > "u";
}
function Cc(t = {}) {
  return t.scrollbar && typeof t.scrollbar.el > "u";
}
function Oc(t = "") {
  const e = t.split(" ").map((n) => n.trim()).filter((n) => !!n), r = [];
  return e.forEach((n) => {
    r.indexOf(n) < 0 && r.push(n);
  }), r.join(" ");
}
function E1(t = "") {
  return t ? t.includes("swiper-wrapper") ? t : `swiper-wrapper ${t}` : "swiper-wrapper";
}
const Pc = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopedSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function T1(t = {}, e = !0) {
  const r = {
    on: {}
  }, n = {}, i = {};
  ur(r, qn.defaults), ur(r, qn.extendedDefaults), r._emitClasses = !0, r.init = !1;
  const o = {}, s = Pc.map((u) => u.replace(/_/, "")), a = Object.assign({}, t);
  return Object.keys(a).forEach((u) => {
    typeof t[u] > "u" || (s.indexOf(u) >= 0 ? Pr(t[u]) ? (r[u] = {}, i[u] = {}, ur(r[u], t[u]), ur(i[u], t[u])) : (r[u] = t[u], i[u] = t[u]) : u.search(/on[A-Z]/) === 0 && typeof t[u] == "function" ? e ? n[`${u[2].toLowerCase()}${u.substr(3)}`] = t[u] : r.on[`${u[2].toLowerCase()}${u.substr(3)}`] = t[u] : o[u] = t[u]);
  }), ["navigation", "pagination", "scrollbar"].forEach((u) => {
    r[u] === !0 && (r[u] = {}), r[u] === !1 && delete r[u];
  }), {
    params: r,
    passedParams: i,
    rest: o,
    events: n
  };
}
function C1({
  el: t,
  nextEl: e,
  prevEl: r,
  paginationEl: n,
  scrollbarEl: i,
  swiper: o
}, s) {
  Ec(s) && e && r && (o.params.navigation.nextEl = e, o.originalParams.navigation.nextEl = e, o.params.navigation.prevEl = r, o.originalParams.navigation.prevEl = r), Tc(s) && n && (o.params.pagination.el = n, o.originalParams.pagination.el = n), Cc(s) && i && (o.params.scrollbar.el = i, o.originalParams.scrollbar.el = i), o.init(t);
}
function O1(t, e, r, n, i) {
  const o = [];
  if (!e)
    return o;
  const s = (u) => {
    o.indexOf(u) < 0 && o.push(u);
  };
  if (r && n) {
    const u = n.map(i), c = r.map(i);
    u.join("") !== c.join("") && s("children"), n.length !== r.length && s("children");
  }
  return Pc.filter((u) => u[0] === "_").map((u) => u.replace(/_/, "")).forEach((u) => {
    if (u in t && u in e)
      if (Pr(t[u]) && Pr(e[u])) {
        const c = Object.keys(t[u]), d = Object.keys(e[u]);
        c.length !== d.length ? s(u) : (c.forEach((f) => {
          t[u][f] !== e[u][f] && s(u);
        }), d.forEach((f) => {
          t[u][f] !== e[u][f] && s(u);
        }));
      } else
        t[u] !== e[u] && s(u);
  }), o;
}
function Mc(t) {
  return t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide");
}
function Ac(t) {
  const e = [];
  return W.Children.toArray(t).forEach((r) => {
    Mc(r) ? e.push(r) : r.props && r.props.children && Ac(r.props.children).forEach((n) => e.push(n));
  }), e;
}
function P1(t) {
  const e = [], r = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return W.Children.toArray(t).forEach((n) => {
    if (Mc(n))
      e.push(n);
    else if (n.props && n.props.slot && r[n.props.slot])
      r[n.props.slot].push(n);
    else if (n.props && n.props.children) {
      const i = Ac(n.props.children);
      i.length > 0 ? i.forEach((o) => e.push(o)) : r["container-end"].push(n);
    } else
      r["container-end"].push(n);
  }), {
    slides: e,
    slots: r
  };
}
function M1({
  swiper: t,
  slides: e,
  passedParams: r,
  changedParams: n,
  nextEl: i,
  prevEl: o,
  scrollbarEl: s,
  paginationEl: a
}) {
  const u = n.filter((R) => R !== "children" && R !== "direction" && R !== "wrapperClass"), {
    params: c,
    pagination: d,
    navigation: f,
    scrollbar: v,
    virtual: g,
    thumbs: y
  } = t;
  let E, S, _, O, T, P, x, M;
  n.includes("thumbs") && r.thumbs && r.thumbs.swiper && c.thumbs && !c.thumbs.swiper && (E = !0), n.includes("controller") && r.controller && r.controller.control && c.controller && !c.controller.control && (S = !0), n.includes("pagination") && r.pagination && (r.pagination.el || a) && (c.pagination || c.pagination === !1) && d && !d.el && (_ = !0), n.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || s) && (c.scrollbar || c.scrollbar === !1) && v && !v.el && (O = !0), n.includes("navigation") && r.navigation && (r.navigation.prevEl || o) && (r.navigation.nextEl || i) && (c.navigation || c.navigation === !1) && f && !f.prevEl && !f.nextEl && (T = !0);
  const H = (R) => {
    t[R] && (t[R].destroy(), R === "navigation" ? (t.isElement && (t[R].prevEl.remove(), t[R].nextEl.remove()), c[R].prevEl = void 0, c[R].nextEl = void 0, t[R].prevEl = void 0, t[R].nextEl = void 0) : (t.isElement && t[R].el.remove(), c[R].el = void 0, t[R].el = void 0));
  };
  n.includes("loop") && t.isElement && (c.loop && !r.loop ? P = !0 : !c.loop && r.loop ? x = !0 : M = !0), u.forEach((R) => {
    if (Pr(c[R]) && Pr(r[R]))
      ur(c[R], r[R]), (R === "navigation" || R === "pagination" || R === "scrollbar") && "enabled" in r[R] && !r[R].enabled && H(R);
    else {
      const q = r[R];
      (q === !0 || q === !1) && (R === "navigation" || R === "pagination" || R === "scrollbar") ? q === !1 && H(R) : c[R] = r[R];
    }
  }), u.includes("controller") && !S && t.controller && t.controller.control && c.controller && c.controller.control && (t.controller.control = c.controller.control), n.includes("children") && e && g && c.virtual.enabled && (g.slides = e, g.update(!0)), n.includes("children") && e && c.loop && (M = !0), E && y.init() && y.update(!0), S && (t.controller.control = c.controller.control), _ && (t.isElement && (!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-pagination"), t.el.shadowEl.appendChild(a)), a && (c.pagination.el = a), d.init(), d.render(), d.update()), O && (t.isElement && (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-scrollbar"), t.el.shadowEl.appendChild(s)), s && (c.scrollbar.el = s), v.init(), v.updateSize(), v.setTranslate()), T && (t.isElement && ((!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-button-next"), t.el.shadowEl.appendChild(i)), (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-prev"), t.el.shadowEl.appendChild(o))), i && (c.navigation.nextEl = i), o && (c.navigation.prevEl = o), f.init(), f.update()), n.includes("allowSlideNext") && (t.allowSlideNext = r.allowSlideNext), n.includes("allowSlidePrev") && (t.allowSlidePrev = r.allowSlidePrev), n.includes("direction") && t.changeDirection(r.direction, !1), (P || M) && t.loopDestroy(), (x || M) && t.loopCreate(), t.update();
}
function A1(t, e, r) {
  if (!r)
    return null;
  const n = (d) => {
    let f = d;
    return d < 0 ? f = e.length + d : f >= e.length && (f = f - e.length), f;
  }, i = t.isHorizontal() ? {
    [t.rtlTranslate ? "right" : "left"]: `${r.offset}px`
  } : {
    top: `${r.offset}px`
  }, {
    from: o,
    to: s
  } = r, a = t.params.loop ? -e.length : 0, u = t.params.loop ? e.length * 2 : e.length, c = [];
  for (let d = a; d < u; d += 1)
    d >= o && d <= s && c.push(e[n(d)]);
  return c.map((d, f) => /* @__PURE__ */ W.cloneElement(d, {
    swiper: t,
    style: i,
    key: `slide-${f}`
  }));
}
const N1 = (t) => {
  !t || t.destroyed || !t.params.virtual || t.params.virtual && !t.params.virtual.enabled || (t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.parallax && t.params.parallax && t.params.parallax.enabled && t.parallax.setTranslate());
};
function Vn(t, e) {
  return typeof window > "u" ? ne(t, e) : Yn(t, e);
}
const il = /* @__PURE__ */ Ye(null), R1 = /* @__PURE__ */ Ye(null);
function ns() {
  return ns = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ns.apply(this, arguments);
}
const Nc = /* @__PURE__ */ Ur(function(t, e) {
  let {
    className: r,
    tag: n = "div",
    wrapperTag: i = "div",
    children: o,
    onSwiper: s,
    ...a
  } = t === void 0 ? {} : t, u = !1;
  const [c, d] = ye("swiper"), [f, v] = ye(null), [g, y] = ye(!1), E = se(!1), S = se(null), _ = se(null), O = se(null), T = se(null), P = se(null), x = se(null), M = se(null), H = se(null), {
    params: R,
    passedParams: q,
    rest: K,
    events: k
  } = T1(a), {
    slides: V,
    slots: Q
  } = P1(o), re = () => {
    y(!g);
  };
  Object.assign(R.on, {
    _containerClasses(N, w) {
      d(w);
    }
  });
  const ve = () => {
    Object.assign(R.on, k), u = !0;
    const N = {
      ...R
    };
    if (delete N.wrapperClass, _.current = new qn(N), _.current.virtual && _.current.params.virtual.enabled) {
      _.current.virtual.slides = V;
      const w = {
        cache: !1,
        slides: V,
        renderExternal: v,
        renderExternalUpdate: !1
      };
      ur(_.current.params.virtual, w), ur(_.current.originalParams.virtual, w);
    }
  };
  S.current || ve(), _.current && _.current.on("_beforeBreakpoint", re);
  const Y = () => {
    u || !k || !_.current || Object.keys(k).forEach((N) => {
      _.current.on(N, k[N]);
    });
  }, le = () => {
    !k || !_.current || Object.keys(k).forEach((N) => {
      _.current.off(N, k[N]);
    });
  };
  ne(() => () => {
    _.current && _.current.off("_beforeBreakpoint", re);
  }), ne(() => {
    !E.current && _.current && (_.current.emitSlidesClasses(), E.current = !0);
  }), Vn(() => {
    if (e && (e.current = S.current), !!S.current)
      return _.current.destroyed && ve(), C1({
        el: S.current,
        nextEl: P.current,
        prevEl: x.current,
        paginationEl: M.current,
        scrollbarEl: H.current,
        swiper: _.current
      }, R), s && s(_.current), () => {
        _.current && !_.current.destroyed && _.current.destroy(!0, !1);
      };
  }, []), Vn(() => {
    Y();
    const N = O1(q, O.current, V, T.current, (w) => w.key);
    return O.current = q, T.current = V, N.length && _.current && !_.current.destroyed && M1({
      swiper: _.current,
      slides: V,
      passedParams: q,
      changedParams: N,
      nextEl: P.current,
      prevEl: x.current,
      scrollbarEl: H.current,
      paginationEl: M.current
    }), () => {
      le();
    };
  }), Vn(() => {
    N1(_.current);
  }, [f]);
  function j() {
    return R.virtual ? A1(_.current, V, f) : V.map((N, w) => /* @__PURE__ */ W.cloneElement(N, {
      swiper: _.current,
      swiperSlideIndex: w
    }));
  }
  return /* @__PURE__ */ W.createElement(n, ns({
    ref: S,
    className: Oc(`${c}${r ? ` ${r}` : ""}`)
  }, K), /* @__PURE__ */ W.createElement(R1.Provider, {
    value: _.current
  }, Q["container-start"], /* @__PURE__ */ W.createElement(i, {
    className: E1(R.wrapperClass)
  }, Q["wrapper-start"], j(), Q["wrapper-end"]), Ec(R) && /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement("div", {
    ref: x,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ W.createElement("div", {
    ref: P,
    className: "swiper-button-next"
  })), Cc(R) && /* @__PURE__ */ W.createElement("div", {
    ref: H,
    className: "swiper-scrollbar"
  }), Tc(R) && /* @__PURE__ */ W.createElement("div", {
    ref: M,
    className: "swiper-pagination"
  }), Q["container-end"]));
});
Nc.displayName = "Swiper";
function is() {
  return is = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, is.apply(this, arguments);
}
const Rc = /* @__PURE__ */ Ur(function(t, e) {
  let {
    tag: r = "div",
    children: n,
    className: i = "",
    swiper: o,
    zoom: s,
    lazy: a,
    virtualIndex: u,
    swiperSlideIndex: c,
    ...d
  } = t === void 0 ? {} : t;
  const f = se(null), [v, g] = ye("swiper-slide"), [y, E] = ye(!1);
  function S(P, x, M) {
    x === f.current && g(M);
  }
  Vn(() => {
    if (typeof c < "u" && (f.current.swiperSlideIndex = c), e && (e.current = f.current), !(!f.current || !o)) {
      if (o.destroyed) {
        v !== "swiper-slide" && g("swiper-slide");
        return;
      }
      return o.on("_slideClass", S), () => {
        o && o.off("_slideClass", S);
      };
    }
  }), Vn(() => {
    o && f.current && !o.destroyed && g(o.getSlideClasses(f.current));
  }, [o]);
  const _ = {
    isActive: v.indexOf("swiper-slide-active") >= 0,
    isVisible: v.indexOf("swiper-slide-visible") >= 0,
    isPrev: v.indexOf("swiper-slide-prev") >= 0,
    isNext: v.indexOf("swiper-slide-next") >= 0
  }, O = () => typeof n == "function" ? n(_) : n, T = () => {
    E(!0);
  };
  return /* @__PURE__ */ W.createElement(r, is({
    ref: f,
    className: Oc(`${v}${i ? ` ${i}` : ""}`),
    "data-swiper-slide-index": u,
    onLoad: T
  }, d), s && /* @__PURE__ */ W.createElement(il.Provider, {
    value: _
  }, /* @__PURE__ */ W.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof s == "number" ? s : void 0
  }, O(), a && !y && /* @__PURE__ */ W.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !s && /* @__PURE__ */ W.createElement(il.Provider, {
    value: _
  }, O(), a && !y && /* @__PURE__ */ W.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
Rc.displayName = "SwiperSlide";
const lw = ({
  sectionHeader: t = "What Our Clients Say",
  sectionDescription: e = "Discover the experiences of our valued clients and their satisfaction with our services.",
  testimonials: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ h("div", { "data-testid": "testimonials", id: "testimonials", children: /* @__PURE__ */ I("div", { className: "bg-white flex-col flex items-start gap-8 px-5 sm:px-6 xl:px-24 py-14 md:py-16 xl:py-20", children: [
  /* @__PURE__ */ I("div", { className: "flex-col  flex items-start gap-4 font-medium  w-full mx-auto ", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
      /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "TESTIMONIALS" }),
      /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
    ] }),
    /* @__PURE__ */ h("span", { className: "text-body2 text-neutral-900 max-w-xl font-inter", children: e })
  ] }),
  /* @__PURE__ */ h("div", { className: "w-full mx-auto", children: /* @__PURE__ */ h(
    Nc,
    {
      spaceBetween: 15,
      slidesPerView: 1.5,
      autoplay: !0,
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 15
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 15
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 15
        }
      },
      className: " h-full  [-webkit-mask-image:linear-gradient(to_right,_transparent_0%,_rgb(0,_0,_0)_15px,_rgb(0,_0,_0)_90%,_transparent_100%)] md:[-webkit-mask-image:linear-gradient(to_right,_transparent_0%,_rgb(0,_0,_0)_100px,_rgb(0,_0,_0)_90%,_transparent_100%)]",
      children: r.map((n, i) => {
        var s, a, u;
        const o = ((s = n.authorImage) == null ? void 0 : s.url) !== void 0;
        return /* @__PURE__ */ h(Rc, { children: /* @__PURE__ */ I("div", { className: "flex-col max-w-full  w-full flex items-start gap-6 px-5 py-3 rounded-2xl border border-neutral-200 h-fit bg-white shadow-md", children: [
          /* @__PURE__ */ h("div", { className: "text-sm text-neutral-500 font-inter", children: n.text }),
          /* @__PURE__ */ I("div", { className: "w-full flex items-center gap-3", children: [
            /* @__PURE__ */ h("div", { className: "flex-col flex items-center h-20 w-20 gap-2.5 rounded-full", children: o ? /* @__PURE__ */ h(
              Xe,
              {
                alt: "authorImage",
                className: "rounded-full w-full h-full",
                src: Ze((a = n.authorImage) == null ? void 0 : a.url),
                cldImg: He((u = n.authorImage) == null ? void 0 : u.url),
                plugins: [st()]
              }
            ) : /* @__PURE__ */ h("span", { className: "bg-primary-50 text-heading5  flex items-center px-1 justify-center h-full w-full rounded-full text-primary-500 text-center font-inter", children: Zp(n.authorName) }) }),
            /* @__PURE__ */ h("div", { className: "flex-1 flex-col flex items-start", children: /* @__PURE__ */ h("div", { className: "text-xl font-medium text-primary-500 font-inter", children: n.authorName }) })
          ] })
        ] }) }, `testimonial-slide-${i}`);
      })
    }
  ) })
] }) }), uw = ({
  sectionHeader: t = "Trade Categories in Our Belt",
  sectionDescription: e = "Explore options for your project needs",
  categories: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ h("div", { "data-testid": "trade-categories", id: "trade-categories", children: /* @__PURE__ */ h("div", { className: "bg-white flex-col px-6 md:px-24 py-14 md:py-16 xl:py-20 flex items-start gap-2.5 mx-auto  h-fit", children: /* @__PURE__ */ I("div", { className: "flex-col w-full flex items-start gap-8", children: [
  /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-start gap-4 font-medium ", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-start", children: [
      /* @__PURE__ */ h("span", { className: "text-heading6 text-primary-500 font-inter", children: "TRADE CATEGORIES" }),
      /* @__PURE__ */ h("h3", { className: "text-heading5 md:text-heading3  text-neutral-900 font-inter", children: t })
    ] }),
    /* @__PURE__ */ h("div", { className: "text-body2 text-neutral-900 max-w-xl font-inter", children: e })
  ] }),
  /* @__PURE__ */ h("div", { className: "w-full items-start gap-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3", children: r.map((n, i) => /* @__PURE__ */ h(
    "div",
    {
      className: "flex-col max-w-md shadow-md w-full flex items-start gap-4 px-4 py-6 rounded-2xl border border-neutral-200 h-fit text-2xl font-medium text-primary-500  bg-white font-inter",
      children: /* @__PURE__ */ h("span", { className: "w-full text-center font-inter", children: n })
    },
    `category-${i}`
  )) })
] }) }) }), cw = ({
  sectionHeader: t = "Page Not Found",
  shortDescription: e = "The page you were looking for doesn’t exist.",
  actionButtonText: r = "Go to homepage"
}) => /* @__PURE__ */ I("div", { "data-testid": "error-page", id: "error-page", className: "w-full  h-full flex justify-center items-center", children: [
  /* @__PURE__ */ I("div", { className: "h-full w-full absolute min-h-[54rem]", children: [
    /* @__PURE__ */ h(
      Xe,
      {
        src: Ze(
          "https://res.cloudinary.com/trades-org/image/upload/v1711516499/waas-templates-placeholder/fdgdryxeaxnwj5jt6lx0.avif"
        ),
        cldImg: He(
          "https://res.cloudinary.com/trades-org/image/upload/v1711516499/waas-templates-placeholder/fdgdryxeaxnwj5jt6lx0.avif"
        ),
        className: "object-cover w-full h-full absolute inset-0",
        alt: ""
      }
    ),
    /* @__PURE__ */ h("div", { className: "w-full h-full flex  justify-center items-center backdrop-brightness-50" })
  ] }),
  /* @__PURE__ */ h("div", { className: "flex flex-col justify-center w-full  h-full z-20 min-h-[54rem] relative md:px-20", children: /* @__PURE__ */ I("div", { className: "flex flex-col justify-center items-center gap-6  h-full px-6 max-w-lg w-full mx-auto", children: [
    /* @__PURE__ */ h("div", { className: "flex flex-col justify-start items-center  gap-8 h-full", children: /* @__PURE__ */ h("p", { className: "text-heading4 md:text-heading2 xl:text-heading1 text-white font-medium text-center ", children: t }) }),
    /* @__PURE__ */ h("p", { className: "self-stretch text-body2 font-light text-center text-white", children: e }),
    /* @__PURE__ */ h(
      "a",
      {
        href: "/",
        className: "flex px-6 justify-center items-center rounded-2xl bg-primary-600 hover:bg-primary-700 focus:bg-primary-800 text-white font-medium",
        children: /* @__PURE__ */ h("p", { className: "flex w-full items-center justify-center gap-2.5 rounded-[15px]  bg-teal p-2.5 text-sm md:text-lg xl:text-xl", children: r })
      }
    )
  ] }) })
] });
export {
  U1 as AboutUs,
  q1 as CTA,
  cw as ErrorPage,
  Q1 as FAQs,
  J1 as Footer,
  K1 as Guarantees,
  X1 as Header,
  Z1 as Hero,
  ew as HighlightedFeatures,
  tw as HighlightedServices,
  rw as OurProcess,
  nw as OurTeam,
  iw as OurWork,
  ow as Qualifications,
  sw as RequestQuote,
  aw as ServiceArea,
  lw as Testimonials,
  uw as TradeCategories
};
